var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/lodash/_isPrototype.js
var require_isPrototype = __commonJS({
  "../../node_modules/lodash/_isPrototype.js"(exports, module) {
    "use strict";
    var objectProto3 = Object.prototype;
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto3;
      return value === proto;
    }
    module.exports = isPrototype;
  }
});

// ../../node_modules/lodash/_overArg.js
var require_overArg = __commonJS({
  "../../node_modules/lodash/_overArg.js"(exports, module) {
    "use strict";
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    module.exports = overArg;
  }
});

// ../../node_modules/lodash/_nativeKeys.js
var require_nativeKeys = __commonJS({
  "../../node_modules/lodash/_nativeKeys.js"(exports, module) {
    "use strict";
    var overArg = require_overArg();
    var nativeKeys = overArg(Object.keys, Object);
    module.exports = nativeKeys;
  }
});

// ../../node_modules/lodash/_baseKeys.js
var require_baseKeys = __commonJS({
  "../../node_modules/lodash/_baseKeys.js"(exports, module) {
    "use strict";
    var isPrototype = require_isPrototype();
    var nativeKeys = require_nativeKeys();
    var objectProto3 = Object.prototype;
    var hasOwnProperty2 = objectProto3.hasOwnProperty;
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty2.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = baseKeys;
  }
});

// ../../node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    "use strict";
    var freeGlobal2 = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal2;
  }
});

// ../../node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/lodash/_root.js"(exports, module) {
    "use strict";
    var freeGlobal2 = require_freeGlobal();
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    module.exports = root2;
  }
});

// ../../node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/lodash/_Symbol.js"(exports, module) {
    "use strict";
    var root2 = require_root();
    var Symbol3 = root2.Symbol;
    module.exports = Symbol3;
  }
});

// ../../node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/lodash/_getRawTag.js"(exports, module) {
    "use strict";
    var Symbol3 = require_Symbol();
    var objectProto3 = Object.prototype;
    var hasOwnProperty2 = objectProto3.hasOwnProperty;
    var nativeObjectToString3 = objectProto3.toString;
    var symToStringTag3 = Symbol3 ? Symbol3.toStringTag : void 0;
    function getRawTag2(value) {
      var isOwn = hasOwnProperty2.call(value, symToStringTag3), tag = value[symToStringTag3];
      try {
        value[symToStringTag3] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString3.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag3] = tag;
        } else {
          delete value[symToStringTag3];
        }
      }
      return result;
    }
    module.exports = getRawTag2;
  }
});

// ../../node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/lodash/_objectToString.js"(exports, module) {
    "use strict";
    var objectProto3 = Object.prototype;
    var nativeObjectToString3 = objectProto3.toString;
    function objectToString2(value) {
      return nativeObjectToString3.call(value);
    }
    module.exports = objectToString2;
  }
});

// ../../node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    "use strict";
    var Symbol3 = require_Symbol();
    var getRawTag2 = require_getRawTag();
    var objectToString2 = require_objectToString();
    var nullTag2 = "[object Null]";
    var undefinedTag2 = "[object Undefined]";
    var symToStringTag3 = Symbol3 ? Symbol3.toStringTag : void 0;
    function baseGetTag2(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag2 : nullTag2;
      }
      return symToStringTag3 && symToStringTag3 in Object(value) ? getRawTag2(value) : objectToString2(value);
    }
    module.exports = baseGetTag2;
  }
});

// ../../node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/lodash/isObject.js"(exports, module) {
    "use strict";
    function isObject2(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject2;
  }
});

// ../../node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "../../node_modules/lodash/isFunction.js"(exports, module) {
    "use strict";
    var baseGetTag2 = require_baseGetTag();
    var isObject2 = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction(value) {
      if (!isObject2(value)) {
        return false;
      }
      var tag = baseGetTag2(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module.exports = isFunction;
  }
});

// ../../node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "../../node_modules/lodash/_coreJsData.js"(exports, module) {
    "use strict";
    var root2 = require_root();
    var coreJsData = root2["__core-js_shared__"];
    module.exports = coreJsData;
  }
});

// ../../node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "../../node_modules/lodash/_isMasked.js"(exports, module) {
    "use strict";
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module.exports = isMasked;
  }
});

// ../../node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "../../node_modules/lodash/_toSource.js"(exports, module) {
    "use strict";
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    module.exports = toSource;
  }
});

// ../../node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "../../node_modules/lodash/_baseIsNative.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isMasked = require_isMasked();
    var isObject2 = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto3 = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty2 = objectProto3.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value) {
      if (!isObject2(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module.exports = baseIsNative;
  }
});

// ../../node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "../../node_modules/lodash/_getValue.js"(exports, module) {
    "use strict";
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    module.exports = getValue;
  }
});

// ../../node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "../../node_modules/lodash/_getNative.js"(exports, module) {
    "use strict";
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    module.exports = getNative;
  }
});

// ../../node_modules/lodash/_DataView.js
var require_DataView = __commonJS({
  "../../node_modules/lodash/_DataView.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root2 = require_root();
    var DataView = getNative(root2, "DataView");
    module.exports = DataView;
  }
});

// ../../node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "../../node_modules/lodash/_Map.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root2 = require_root();
    var Map2 = getNative(root2, "Map");
    module.exports = Map2;
  }
});

// ../../node_modules/lodash/_Promise.js
var require_Promise = __commonJS({
  "../../node_modules/lodash/_Promise.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root2 = require_root();
    var Promise2 = getNative(root2, "Promise");
    module.exports = Promise2;
  }
});

// ../../node_modules/lodash/_Set.js
var require_Set = __commonJS({
  "../../node_modules/lodash/_Set.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root2 = require_root();
    var Set2 = getNative(root2, "Set");
    module.exports = Set2;
  }
});

// ../../node_modules/lodash/_WeakMap.js
var require_WeakMap = __commonJS({
  "../../node_modules/lodash/_WeakMap.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root2 = require_root();
    var WeakMap2 = getNative(root2, "WeakMap");
    module.exports = WeakMap2;
  }
});

// ../../node_modules/lodash/_getTag.js
var require_getTag = __commonJS({
  "../../node_modules/lodash/_getTag.js"(exports, module) {
    "use strict";
    var DataView = require_DataView();
    var Map2 = require_Map();
    var Promise2 = require_Promise();
    var Set2 = require_Set();
    var WeakMap2 = require_WeakMap();
    var baseGetTag2 = require_baseGetTag();
    var toSource = require_toSource();
    var mapTag = "[object Map]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var setTag = "[object Set]";
    var weakMapTag = "[object WeakMap]";
    var dataViewTag = "[object DataView]";
    var dataViewCtorString = toSource(DataView);
    var mapCtorString = toSource(Map2);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set2);
    var weakMapCtorString = toSource(WeakMap2);
    var getTag = baseGetTag2;
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
      getTag = function(value) {
        var result = baseGetTag2(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    module.exports = getTag;
  }
});

// ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/lodash/isObjectLike.js"(exports, module) {
    "use strict";
    function isObjectLike2(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike2;
  }
});

// ../../node_modules/lodash/_baseIsArguments.js
var require_baseIsArguments = __commonJS({
  "../../node_modules/lodash/_baseIsArguments.js"(exports, module) {
    "use strict";
    var baseGetTag2 = require_baseGetTag();
    var isObjectLike2 = require_isObjectLike();
    var argsTag = "[object Arguments]";
    function baseIsArguments(value) {
      return isObjectLike2(value) && baseGetTag2(value) == argsTag;
    }
    module.exports = baseIsArguments;
  }
});

// ../../node_modules/lodash/isArguments.js
var require_isArguments = __commonJS({
  "../../node_modules/lodash/isArguments.js"(exports, module) {
    "use strict";
    var baseIsArguments = require_baseIsArguments();
    var isObjectLike2 = require_isObjectLike();
    var objectProto3 = Object.prototype;
    var hasOwnProperty2 = objectProto3.hasOwnProperty;
    var propertyIsEnumerable = objectProto3.propertyIsEnumerable;
    var isArguments = baseIsArguments(/* @__PURE__ */ function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    module.exports = isArguments;
  }
});

// ../../node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "../../node_modules/lodash/isArray.js"(exports, module) {
    "use strict";
    var isArray = Array.isArray;
    module.exports = isArray;
  }
});

// ../../node_modules/lodash/isLength.js
var require_isLength = __commonJS({
  "../../node_modules/lodash/isLength.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module.exports = isLength;
  }
});

// ../../node_modules/lodash/isArrayLike.js
var require_isArrayLike = __commonJS({
  "../../node_modules/lodash/isArrayLike.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isLength = require_isLength();
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    module.exports = isArrayLike;
  }
});

// ../../node_modules/lodash/stubFalse.js
var require_stubFalse = __commonJS({
  "../../node_modules/lodash/stubFalse.js"(exports, module) {
    "use strict";
    function stubFalse() {
      return false;
    }
    module.exports = stubFalse;
  }
});

// ../../node_modules/lodash/isBuffer.js
var require_isBuffer = __commonJS({
  "../../node_modules/lodash/isBuffer.js"(exports, module) {
    "use strict";
    var root2 = require_root();
    var stubFalse = require_stubFalse();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root2.Buffer : void 0;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
  }
});

// ../../node_modules/lodash/_baseIsTypedArray.js
var require_baseIsTypedArray = __commonJS({
  "../../node_modules/lodash/_baseIsTypedArray.js"(exports, module) {
    "use strict";
    var baseGetTag2 = require_baseGetTag();
    var isLength = require_isLength();
    var isObjectLike2 = require_isObjectLike();
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    function baseIsTypedArray(value) {
      return isObjectLike2(value) && isLength(value.length) && !!typedArrayTags[baseGetTag2(value)];
    }
    module.exports = baseIsTypedArray;
  }
});

// ../../node_modules/lodash/_baseUnary.js
var require_baseUnary = __commonJS({
  "../../node_modules/lodash/_baseUnary.js"(exports, module) {
    "use strict";
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    module.exports = baseUnary;
  }
});

// ../../node_modules/lodash/_nodeUtil.js
var require_nodeUtil = __commonJS({
  "../../node_modules/lodash/_nodeUtil.js"(exports, module) {
    "use strict";
    var freeGlobal2 = require_freeGlobal();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal2.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    module.exports = nodeUtil;
  }
});

// ../../node_modules/lodash/isTypedArray.js
var require_isTypedArray = __commonJS({
  "../../node_modules/lodash/isTypedArray.js"(exports, module) {
    "use strict";
    var baseIsTypedArray = require_baseIsTypedArray();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    module.exports = isTypedArray;
  }
});

// ../../node_modules/lodash/isEmpty.js
var require_isEmpty = __commonJS({
  "../../node_modules/lodash/isEmpty.js"(exports, module) {
    "use strict";
    var baseKeys = require_baseKeys();
    var getTag = require_getTag();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isArrayLike = require_isArrayLike();
    var isBuffer = require_isBuffer();
    var isPrototype = require_isPrototype();
    var isTypedArray = require_isTypedArray();
    var mapTag = "[object Map]";
    var setTag = "[object Set]";
    var objectProto3 = Object.prototype;
    var hasOwnProperty2 = objectProto3.hasOwnProperty;
    function isEmpty3(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty2.call(value, key)) {
          return false;
        }
      }
      return true;
    }
    module.exports = isEmpty3;
  }
});

// src/components/auditing/AuditFields.tsx
import { parseDate, timeAgo } from "shared-lib";
import { jsx, jsxs } from "react/jsx-runtime";
var AuditFields = ({ createdOn, updatedOn, classes }) => /* @__PURE__ */ jsxs("div", { className: `flex space-x-4 ${classes}`, children: [
  /* @__PURE__ */ jsxs("div", { className: "flex space-x-1", children: [
    /* @__PURE__ */ jsx("span", { className: "text-gray-600", children: "Created" }),
    /* @__PURE__ */ jsx("span", { className: "text-gray-900", children: timeAgo(parseDate(createdOn)) })
  ] }),
  updatedOn ? /* @__PURE__ */ jsxs("div", { className: "flex space-x-1", children: [
    /* @__PURE__ */ jsx("span", { className: "text-gray-600", children: "Updated" }),
    /* @__PURE__ */ jsx("span", { className: "text-gray-900", children: timeAgo(parseDate(updatedOn)) })
  ] }) : null
] });

// src/lib/layout/Size.ts
var Size = /* @__PURE__ */ ((Size5) => {
  Size5["sm"] = "sm";
  Size5["md"] = "md";
  Size5["lg"] = "lg";
  Size5["xl"] = "xl";
  return Size5;
})(Size || {});

// src/lib/models/ListItem.ts
function createEmptyListItem(label = "-- Select --") {
  return {
    id: "",
    name: label
  };
}
function isEmptyListItem(item) {
  return !item || item.id === "";
}
function enumerationToListItem(enumeration) {
  return {
    id: enumeration.key,
    name: enumeration.displayName
  };
}
function enumerationsToListItems(enumerations) {
  return enumerations.map(enumerationToListItem);
}

// src/lib/navigation/LinkState.ts
function createLinkState(location, name, to, icon, highlight, externalLink) {
  return {
    name,
    to,
    icon,
    highlight,
    externalLink: !!externalLink
  };
}
function createButtonLinkState(name, current, onClick, label) {
  return {
    name,
    current,
    onClick,
    label
  };
}

// src/lib/util/ClassNames.ts
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

// src/lib/HOC/WithParams.tsx
import { useParams } from "react-router-dom";
var WithParams = ({ children }) => {
  const params = useParams();
  return children({ params });
};

// src/lib/workflow/workflowLabelMap.ts
function workflowLabelMap(label) {
  switch (label) {
    case "Created":
      return "Incomplete";
    case "Submitted":
      return "Unapproved";
  }
  return label;
}

// src/components/cards/Card.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var EdCard = ({
  children,
  logo,
  title,
  description,
  link,
  className,
  onSelected
}) => {
  return /* @__PURE__ */ jsxs2(
    "div",
    {
      className: classNames(
        "flex flex-grow flex-col rounded border bg-white p-4",
        onSelected ? "cursor-pointer" : "",
        className ? className : ""
      ),
      onClick: () => {
        if (onSelected) {
          onSelected();
        }
      },
      children: [
        /* @__PURE__ */ jsxs2(
          "div",
          {
            className: classNames(
              "flex items-center justify-between",
              title || logo || link ? "mb-4 space-x-4 border-b border-gray-100 pb-4" : ""
            ),
            children: [
              /* @__PURE__ */ jsxs2("div", { className: "flex w-full items-center space-x-4", children: [
                title && /* @__PURE__ */ jsx2("div", { className: "text-lg text-gray-900", children: title }),
                logo && /* @__PURE__ */ jsx2("div", { children: logo })
              ] }),
              /* @__PURE__ */ jsx2("div", { children: link && /* @__PURE__ */ jsx2("span", { children: link }) })
            ]
          }
        ),
        /* @__PURE__ */ jsxs2("div", { className: "flex w-full flex-col gap-2", children: [
          description && /* @__PURE__ */ jsx2("div", { children: description }),
          /* @__PURE__ */ jsx2("div", { children })
        ] })
      ]
    }
  );
};
var Card = (props) => /* @__PURE__ */ jsx2(
  "div",
  {
    ...props,
    className: classNames("rounded-2xl bg-white p-5", props.className || ""),
    children: props.children
  }
);

// src/components/charts/bar/BarChart.tsx
import { ResponsiveBar } from "@nivo/bar";
import { jsx as jsx3 } from "react/jsx-runtime";
var BarChart = ({ items }) => {
  return /* @__PURE__ */ jsx3("div", { children: /* @__PURE__ */ jsx3(
    ResponsiveBar,
    {
      data: items,
      keys: ["value"],
      indexBy: "label",
      margin: { top: 50, right: 130, bottom: 50, left: 60 },
      padding: 0.4,
      valueScale: { type: "linear" },
      colors: "#3182CE",
      animate: true,
      enableLabel: false,
      axisTop: null,
      axisRight: null,
      axisLeft: {
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "degrees",
        legendPosition: "middle",
        legendOffset: -40
      }
    }
  ) });
};

// src/components/charts/sunburst/SunburstChart.tsx
import { ResponsiveSunburst } from "@nivo/sunburst";
import { jsx as jsx4 } from "react/jsx-runtime";
var SunburstChart = ({ data }) => {
  return /* @__PURE__ */ jsx4(
    ResponsiveSunburst,
    {
      data,
      margin: { top: 10, right: 10, bottom: 10, left: 10 },
      id: "name",
      value: "loc",
      cornerRadius: 2,
      borderColor: { theme: "background" },
      colors: { scheme: "nivo" },
      childColor: {
        from: "color",
        modifiers: [["brighter", 0.1]]
      },
      enableArcLabels: true,
      arcLabelsSkipAngle: 10,
      arcLabelsTextColor: {
        from: "color",
        modifiers: [["darker", 1.4]]
      }
    }
  );
};

// src/components/charts/radar/ResponsiveRadar.tsx
import { ResponsiveRadar as NivoRadar } from "@nivo/radar";
import { jsx as jsx5 } from "react/jsx-runtime";
var ResponsiveRadar = ({
  data,
  indexBy
}) => /* @__PURE__ */ jsx5(
  NivoRadar,
  {
    data,
    keys: Object.keys(data),
    indexBy,
    valueFormat: ">-.2f",
    margin: { top: 70, right: 80, bottom: 40, left: 80 },
    borderColor: { from: "color" },
    gridLabelOffset: 36,
    dotSize: 10,
    dotColor: { theme: "background" },
    dotBorderWidth: 2,
    colors: { scheme: "nivo" },
    blendMode: "multiply",
    motionConfig: "wobbly",
    legends: [
      {
        anchor: "top-left",
        direction: "column",
        translateX: -50,
        translateY: -40,
        itemWidth: 80,
        itemHeight: 20,
        itemTextColor: "#999",
        symbolSize: 12,
        symbolShape: "circle",
        effects: [
          {
            on: "hover",
            style: {
              itemTextColor: "#000"
            }
          }
        ]
      }
    ]
  }
);

// src/components/cron/CronEditor.tsx
import { useState as useState19 } from "react";
import { formatDate as formatDate2, parseDate as parseDate2 } from "shared-lib";

// src/components/cron/CronSummary.tsx
import cronstrue from "cronstrue";
import { jsx as jsx6 } from "react/jsx-runtime";
var CronSummary = ({ cron }) => {
  let summary = "";
  if (cron) {
    try {
      summary = cronstrue.toString(cron);
    } catch (e) {
      summary = "Invalid Cron Expression";
    }
  }
  return /* @__PURE__ */ jsx6("div", { className: "text-info-500 text-sm font-medium", children: summary });
};

// src/components/dates/DayOfMonthSelector.tsx
import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { Fragment as Fragment2, jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
var DayMonthSelectorDays = [
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
  { id: 4, name: "4" },
  { id: 5, name: "5" },
  { id: 6, name: "6" },
  { id: 7, name: "7" },
  { id: 8, name: "8" },
  { id: 9, name: "9" },
  { id: 10, name: "10" },
  { id: 11, name: "11" },
  { id: 12, name: "12" },
  { id: 13, name: "13" },
  { id: 14, name: "14" },
  { id: 15, name: "15" },
  { id: 16, name: "16" },
  { id: 17, name: "17" },
  { id: 18, name: "18" },
  { id: 19, name: "19" },
  { id: 20, name: "20" },
  { id: 21, name: "21" },
  { id: 22, name: "22" },
  { id: 23, name: "23" },
  { id: 24, name: "24" },
  { id: 25, name: "25" },
  { id: 26, name: "26" },
  { id: 27, name: "27" },
  { id: 28, name: "28" },
  { id: 29, name: "29" },
  { id: 30, name: "30" },
  { id: 31, name: "31" }
];
var DayOfMonthSelector = ({
  initialSelected,
  onChanged
}) => {
  const [selected, setSelected] = useState(initialSelected);
  function changed(values) {
    setSelected(values);
    onChanged(values);
  }
  return /* @__PURE__ */ jsx7(Listbox, { value: selected, onChange: changed, multiple: true, children: /* @__PURE__ */ jsxs3("div", { className: "relative mt-1", children: [
    /* @__PURE__ */ jsxs3(Listbox.Button, { className: "focus-visible:border-info-500 relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm", children: [
      /* @__PURE__ */ jsx7("span", { className: "block truncate", children: selected.map((day) => day.name).join(", ") }),
      /* @__PURE__ */ jsx7("span", { className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2", children: /* @__PURE__ */ jsx7(
        ChevronUpDownIcon,
        {
          className: "h-5 w-5 text-gray-600",
          "aria-hidden": "true"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx7(
      Transition,
      {
        as: Fragment,
        leave: "transition ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /* @__PURE__ */ jsx7(Listbox.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: DayMonthSelectorDays.map((day) => /* @__PURE__ */ jsx7(
          Listbox.Option,
          {
            className: ({ active }) => classNames(
              active ? "bg-info-600 text-white" : "text-gray-900",
              "relative cursor-default select-none py-2 pl-8 pr-4"
            ),
            value: day,
            children: ({ selected: selected2 }) => /* @__PURE__ */ jsxs3(Fragment2, { children: [
              /* @__PURE__ */ jsx7(
                "span",
                {
                  className: classNames(
                    selected2 ? "font-semibold" : "font-normal",
                    "block truncate"
                  ),
                  children: day.name
                }
              ),
              selected2 ? /* @__PURE__ */ jsx7("span", { className: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600", children: /* @__PURE__ */ jsx7(CheckIcon, { className: "h-5 w-5", "aria-hidden": "true" }) }) : null
            ] })
          },
          day.id
        )) })
      }
    )
  ] }) });
};

// src/hooks/useTabs.ts
import { useCallback, useMemo, useState as useState2 } from "react";
var useTabs = (tabs, defaultTab) => {
  const defaultTabItem = tabs.find((t) => t.name === defaultTab) || tabs[0];
  const [tab, setTab] = useState2(defaultTabItem);
  const onSetTab = useCallback((t) => setTab(t), []);
  const tabLinks = useMemo(() => {
    return tabs.map(
      (t) => createButtonLinkState(
        t.name,
        tab.name === t.name,
        () => onSetTab(t),
        t.label
      )
    );
  }, [onSetTab, tab.name, tabs]);
  return [tab, tabLinks, onSetTab];
};

// src/hooks/useToast.ts
import * as React from "react";
var TOAST_LIMIT = 1;
var TOAST_REMOVE_DELAY = 1e6;
var count = 0;
function genId() {
  count = (count + 1) % Number.MAX_SAFE_INTEGER;
  return count.toString();
}
var toastTimeouts = /* @__PURE__ */ new Map();
var addToRemoveQueue = (toastId) => {
  if (toastTimeouts.has(toastId)) {
    return;
  }
  const timeout = setTimeout(() => {
    toastTimeouts.delete(toastId);
    dispatch({
      type: "REMOVE_TOAST",
      toastId
    });
  }, TOAST_REMOVE_DELAY);
  toastTimeouts.set(toastId, timeout);
};
var reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TOAST":
      return {
        ...state,
        toasts: [action.toast, ...state.toasts].slice(0, TOAST_LIMIT)
      };
    case "UPDATE_TOAST":
      return {
        ...state,
        toasts: state.toasts.map(
          (t) => t.id === action.toast.id ? { ...t, ...action.toast } : t
        )
      };
    case "DISMISS_TOAST": {
      const { toastId } = action;
      if (toastId) {
        addToRemoveQueue(toastId);
      } else {
        state.toasts.forEach((toast2) => {
          addToRemoveQueue(toast2.id);
        });
      }
      return {
        ...state,
        toasts: state.toasts.map(
          (t) => t.id === toastId || toastId === void 0 ? {
            ...t,
            open: false
          } : t
        )
      };
    }
    case "REMOVE_TOAST":
      if (action.toastId === void 0) {
        return {
          ...state,
          toasts: []
        };
      }
      return {
        ...state,
        toasts: state.toasts.filter((t) => t.id !== action.toastId)
      };
  }
};
var listeners = [];
var memoryState = { toasts: [] };
function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
}
function toast({ ...props }) {
  const id3 = genId();
  const update = (props2) => dispatch({
    type: "UPDATE_TOAST",
    toast: { ...props2, id: id3 }
  });
  const dismiss = () => dispatch({ type: "DISMISS_TOAST", toastId: id3 });
  dispatch({
    type: "ADD_TOAST",
    toast: {
      ...props,
      id: id3,
      open: true,
      onOpenChange: (open) => {
        if (!open)
          dismiss();
      }
    }
  });
  return {
    id: id3,
    dismiss,
    update
  };
}
function useToast() {
  const [state, setState] = React.useState(memoryState);
  React.useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  return {
    ...state,
    toast,
    dismiss: (toastId) => dispatch({ type: "DISMISS_TOAST", toastId })
  };
}

// src/components/forms/controls/dependent-select/DependentSelect.tsx
import {
  Fragment as Fragment6,
  useCallback as useCallback3,
  useEffect as useEffect2,
  useState as useState5
} from "react";

// src/components/forms/controls/selects/SelectMenu.tsx
import { Fragment as Fragment3, useCallback as useCallback2 } from "react";
import { Listbox as Listbox2, Transition as Transition2 } from "@headlessui/react";
import { CheckIcon as CheckIcon2, ChevronUpDownIcon as ChevronUpDownIcon2 } from "@heroicons/react/24/solid";
import { Fragment as Fragment4, jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var emptyItem = createEmptyListItem();
var SelectMenu = ({
  title,
  items,
  value: selected,
  onChange,
  showEmptyItem = false,
  className,
  widthClass,
  disabled,
  placeholder
}) => {
  const onChangeSelected = useCallback2(
    (value) => {
      onChange(value);
    },
    [onChange]
  );
  return /* @__PURE__ */ jsx8(
    "div",
    {
      "aria-label": placeholder || "Select Options",
      className: classNames(
        "xl:min-w-[200px]",
        widthClass ? widthClass : "w-full",
        className ? className : ""
      ),
      children: /* @__PURE__ */ jsx8(Listbox2, { disabled, value: selected, onChange: onChangeSelected, children: ({ open }) => /* @__PURE__ */ jsxs4(Fragment4, { children: [
        title ? /* @__PURE__ */ jsx8(Listbox2.Label, { className: "mt-5 block pb-2 text-sm font-medium text-gray-700", children: title }) : null,
        /* @__PURE__ */ jsxs4("div", { className: "relative", children: [
          /* @__PURE__ */ jsxs4(
            Listbox2.Button,
            {
              "aria-label": placeholder || "Select Option",
              className: classNames(
                isEmptyListItem(selected) ? "text-gray-500" : "text-gray-900",
                "focus:ring-info-500 focus:border-info-500 relative min-h-[38px] w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 sm:text-sm"
              ),
              children: [
                /* @__PURE__ */ jsx8("span", { className: "block truncate text-base font-normal text-gray-600", children: selected?.name }),
                /* @__PURE__ */ jsx8("span", { className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2", children: /* @__PURE__ */ jsx8(
                  ChevronUpDownIcon2,
                  {
                    className: "h-5 w-5 text-gray-600",
                    "aria-hidden": "true"
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ jsx8(
            Transition2,
            {
              show: open,
              as: Fragment3,
              leave: "transition ease-in duration-100",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              children: /* @__PURE__ */ jsxs4(
                Listbox2.Options,
                {
                  static: true,
                  className: classNames(
                    "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                    className ? className : ""
                  ),
                  children: [
                    showEmptyItem ? /* @__PURE__ */ jsx8(
                      Listbox2.Option,
                      {
                        className: "relative cursor-default select-none py-2 pl-3 pr-9 text-gray-500",
                        value: emptyItem,
                        children: () => /* @__PURE__ */ jsx8("span", { className: "block truncate font-normal", children: placeholder || " -- Select -- " })
                      },
                      ""
                    ) : null,
                    items.map((item) => /* @__PURE__ */ jsx8(
                      Listbox2.Option,
                      {
                        className: ({ active }) => classNames(
                          active ? "bg-info-600 text-white" : "text-gray-900",
                          "relative cursor-default select-none py-2 pl-3 pr-9"
                        ),
                        value: item,
                        children: ({ selected: selected2, active }) => /* @__PURE__ */ jsxs4(Fragment4, { children: [
                          /* @__PURE__ */ jsx8(
                            "span",
                            {
                              className: classNames(
                                selected2 ? "font-semibold" : "font-normal",
                                "block truncate"
                              ),
                              children: item.name
                            }
                          ),
                          selected2 ? /* @__PURE__ */ jsx8(
                            "span",
                            {
                              className: classNames(
                                active ? "text-white" : "text-info-600",
                                "absolute inset-y-0 right-0 flex items-center pr-4"
                              ),
                              children: /* @__PURE__ */ jsx8(
                                CheckIcon2,
                                {
                                  className: "h-5 w-5",
                                  "aria-hidden": "true"
                                }
                              )
                            }
                          ) : null
                        ] })
                      },
                      item.id
                    ))
                  ]
                }
              )
            }
          )
        ] })
      ] }) })
    }
  );
};

// src/components/forms/controls/selects/SelectMenuInput.tsx
import { Controller } from "react-hook-form";
import { jsx as jsx9 } from "react/jsx-runtime";
var SelectMenuInput = (props) => {
  const { name, control, items, selectedItem, disabled, title, placeholder } = props;
  return /* @__PURE__ */ jsx9(
    Controller,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange, value } }) => /* @__PURE__ */ jsx9("div", { children: /* @__PURE__ */ jsx9(
        SelectMenu,
        {
          disabled,
          showEmptyItem: true,
          title,
          items,
          placeholder,
          onChange: (item) => {
            onControllerChange(item.id);
          },
          value: selectedItem || { id: "", name: placeholder || "" }
        }
      ) })
    }
  );
};

// src/components/forms/controls/selects/FormMultiSelectWithTags.tsx
import { useState as useState4 } from "react";
import { Controller as Controller2 } from "react-hook-form";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { Fragment as Fragment5, jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
var FormMultiSelectWithTags = ({
  items,
  name,
  control,
  label,
  interactive,
  buttonLabel = "Add"
}) => {
  const [selectedItem, setSelectedItem] = useState4(null);
  return /* @__PURE__ */ jsx10(
    Controller2,
    {
      name,
      control,
      render: ({ field: { onChange, value } }) => {
        return /* @__PURE__ */ jsxs5(Fragment5, { children: [
          /* @__PURE__ */ jsxs5("div", { className: "flex flex-wrap gap-2", children: [
            value.map((x) => /* @__PURE__ */ jsxs5(Tag, { children: [
              x.name,
              " ",
              interactive && /* @__PURE__ */ jsx10(
                "div",
                {
                  className: "hover:cursor-pointer",
                  onClick: () => {
                    onChange(value.filter((item) => item.id !== x.id));
                  },
                  children: /* @__PURE__ */ jsx10(XMarkIcon, { className: "h-3 w-3" })
                }
              )
            ] }, x.id)),
            value.length === 0 && /* @__PURE__ */ jsx10("div", { className: "text-gray-600", children: "No Talent Pools Selected" })
          ] }),
          interactive && value.length !== items.length && /* @__PURE__ */ jsxs5("div", { className: "mt-5 flex gap-3", children: [
            /* @__PURE__ */ jsx10(
              SelectMenu,
              {
                title: label,
                disabled: false,
                value: selectedItem,
                items: items.filter((x) => {
                  return !value.find((pool) => pool.id === x.id);
                }),
                onChange: setSelectedItem
              }
            ),
            /* @__PURE__ */ jsx10(
              Button,
              {
                value: buttonLabel,
                color: "primary",
                size: "md" /* md */,
                onClick: () => {
                  setSelectedItem(null);
                  onChange([...value, selectedItem]);
                },
                children: "Add"
              }
            )
          ] })
        ] });
      }
    }
  );
};

// src/components/forms/controls/dependent-select/DependentSelect.tsx
import { Fragment as Fragment7, jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var emptyItem2 = createEmptyListItem();
var DependentSelect = ({
  parentTitle,
  parentItems,
  childTitle,
  childItems,
  initialParentId,
  initialChildId,
  onChange,
  className
}) => {
  const [parents] = useState5(parentItems);
  const [children, setChildren] = useState5([]);
  const [parent, setParent] = useState5(emptyItem2);
  const [child, setChild] = useState5(emptyItem2);
  function changeParent(parent2) {
    setParent(parent2);
    const items = childItems.get(parent2.id);
    setChildren(items || []);
    setChild(emptyItem2);
  }
  const onSetParent = useCallback3(
    (parent2) => {
      changeParent(parent2);
    },
    [parent, child, children]
  );
  const onSetChild = useCallback3(
    (child2) => {
      setChild(child2);
      if (parent) {
        onChange({
          parentId: parent.id,
          childId: child2.id
        });
      }
    },
    [parent, child]
  );
  useEffect2(() => {
    if (isEmptyListItem(child) && initialChildId && children && children.length > 0) {
      const initialChild = children.find((p) => p.id === initialChildId);
      if (initialChild) {
        setChild(initialChild);
      }
    }
  }, [children, child]);
  useEffect2(() => {
    if (isEmptyListItem(parent) && initialParentId && parents && parents.length > 0) {
      const initialParent = parents.find((p) => p.id === initialParentId);
      if (initialParent) {
        changeParent(initialParent);
      }
    }
  }, [parents]);
  let childMenu = /* @__PURE__ */ jsx11(Fragment7, {});
  if (children && children.length > 0) {
    childMenu = /* @__PURE__ */ jsx11("div", { className: "flex-1 sm:ml-2", children: /* @__PURE__ */ jsx11(
      SelectMenu,
      {
        showEmptyItem: true,
        title: childTitle,
        items: children,
        onChange: onSetChild,
        value: child
      }
    ) });
  }
  return /* @__PURE__ */ jsx11(Fragment6, { children: /* @__PURE__ */ jsxs6(
    "div",
    {
      className: classNames(
        "mb-2 flex items-center justify-between",
        className ? className : ""
      ),
      children: [
        /* @__PURE__ */ jsx11("div", { className: "flex-1", children: /* @__PURE__ */ jsx11(
          SelectMenu,
          {
            showEmptyItem: true,
            title: parentTitle,
            items: parents,
            onChange: onSetParent,
            value: parent
          }
        ) }),
        childMenu ? childMenu : null
      ]
    }
  ) });
};

// src/components/forms/controls/dependent-select/DependentSelectField.tsx
import { Fragment as Fragment8 } from "react";
import { Controller as Controller3 } from "react-hook-form";
import { jsx as jsx12 } from "react/jsx-runtime";
var DependentSelectField = ({
  name,
  control,
  parentTitle,
  parentItems,
  childTitle,
  childItems,
  initialParentId,
  initialChildId,
  onNotifyChange,
  className
}) => {
  return /* @__PURE__ */ jsx12(Fragment8, { children: /* @__PURE__ */ jsx12(
    Controller3,
    {
      control,
      name,
      render: ({ field: { onChange } }) => /* @__PURE__ */ jsx12(
        DependentSelect,
        {
          className,
          parentTitle,
          childTitle,
          parentItems,
          childItems,
          initialParentId,
          initialChildId,
          onChange: (data) => {
            onChange(data);
            if (onNotifyChange) {
              onNotifyChange(data);
            }
          }
        }
      )
    }
  ) });
};

// src/components/forms/controls/errors/ErrorField.tsx
import { Fragment as Fragment9, jsx as jsx13, jsxs as jsxs7 } from "react/jsx-runtime";
var ErrorField = ({ field, message, validations }) => {
  if (!field) {
    return /* @__PURE__ */ jsx13(Fragment9, {});
  }
  if (typeof field === "string") {
    return /* @__PURE__ */ jsxs7(Error2, { children: [
      field,
      /* @__PURE__ */ jsx13("ul", { className: "list-inside list-disc", children: validations?.map((validation) => /* @__PURE__ */ jsx13("li", { className: `pl-2 text-xs`, children: validation }, validation)) })
    ] });
  }
  if (field?.message !== null) {
    return /* @__PURE__ */ jsx13(Error2, { children: field["message"]?.toString() });
  }
  return /* @__PURE__ */ jsx13("div", { children: message });
};
var Error2 = ({ children }) => /* @__PURE__ */ jsx13("div", { className: "text-danger-400 mt-1 text-sm font-bold", children });

// src/components/forms/controls/inline-text-edit/InlineTextEdit.tsx
import { useState as useState6 } from "react";
import { PencilIcon } from "@heroicons/react/24/solid";
import { useFocus } from "shared-lib";
import { jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
var InlineEdit = ({
  label,
  value,
  setValue,
  classes
}) => {
  const [editingValue, setEditingValue] = useState6(value);
  const onChange = (event) => setEditingValue(event.target.value);
  const onKeyDown = (event) => {
    if (event.key === "Enter" || event.key === "Escape") {
      event.target.blur();
    }
  };
  const onBlur = (event) => {
    if (event.target.value.trim() === "") {
      setEditingValue(value);
    } else {
      setValue(event.target.value);
    }
  };
  const [inputRef, setInputFocus] = useFocus();
  const className = `flex items-center space-x-4 border p-2 bg-white ${classes}`;
  return /* @__PURE__ */ jsxs8("div", { className, children: [
    /* @__PURE__ */ jsx14(
      "input",
      {
        className: "focus:ring-info-500 focus:border-info-500 block w-full max-w-lg rounded-md border-gray-300 p-1 shadow-sm sm:max-w-xs sm:text-sm",
        ref: inputRef,
        type: "text",
        "aria-label": label,
        value: editingValue,
        onChange,
        onKeyDown,
        onBlur
      }
    ),
    /* @__PURE__ */ jsx14(
      PencilIcon,
      {
        onClick: setInputFocus,
        className: classNames(
          editingValue ? "text-info-500" : "text-gray-600 group-hover:text-gray-500",
          "-ml-0.5 mr-2 h-5 w-5"
        ),
        "aria-hidden": "true"
      }
    )
  ] });
};

// src/components/forms/controls/inputs/CheckBox.tsx
import {
  isValidElement,
  useState as useState7
} from "react";
import { Switch } from "@headlessui/react";
import { jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
var CheckBox = ({ title, checked, onChanged, readonly }) => {
  const [enabled, setEnabled] = useState7(checked);
  function change(checked2) {
    if (!readonly) {
      setEnabled(checked2);
      if (onChanged) {
        onChanged(checked2);
      }
    }
  }
  const titleIsReactElement = isValidElement(title);
  return /* @__PURE__ */ jsx15(Switch.Group, { children: /* @__PURE__ */ jsxs9("div", { className: "flex items-center", children: [
    titleIsReactElement && /* @__PURE__ */ jsx15(Switch.Label, { className: "mr-3 flex-grow", children: title }),
    /* @__PURE__ */ jsxs9(
      Switch,
      {
        checked: enabled,
        onChange: change,
        "aria-label": `Toggle ${title} ${!enabled ? "on" : "off"}`,
        className: `${enabled ? "bg-primary-600" : "bg-gray-200"} relative mr-2 inline-flex h-6 w-11 items-center rounded-full border-r`,
        children: [
          title && /* @__PURE__ */ jsx15("span", { className: "sr-only", children: title }),
          /* @__PURE__ */ jsx15(
            "span",
            {
              className: `${enabled ? "translate-x-6" : "translate-x-1"} inline-block h-4 w-4 transform rounded-full bg-white`
            }
          )
        ]
      }
    )
  ] }) });
};

// src/components/forms/controls/inputs/CheckBoxList.tsx
import { useState as useState8 } from "react";
import { replaceItemInList } from "shared-lib";
import { jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
function toggleItem(item, items) {
  return replaceItemInList(items, item, {
    ...item,
    checked: !item.checked
  });
}
var CheckBoxList = ({
  title,
  horizontal,
  initialItems,
  onChanged
  // onError,
}) => {
  const [items, setItems] = useState8(initialItems);
  function toggle(item) {
    const updatedItems = toggleItem(item, items);
    setItems(updatedItems);
    onChanged(updatedItems);
  }
  const itemControls = items.map((i) => {
    return /* @__PURE__ */ jsx16(
      CheckBox,
      {
        checked: i.checked,
        title: i.title,
        onChanged: () => toggle(i)
      },
      i.id
    );
  });
  const classes = horizontal ? "flex items-center gap-1 flex-wrap text-xs" : "flex flex-col gap-1 flex-wrap";
  return /* @__PURE__ */ jsxs10("div", { className: "flex flex-col", children: [
    title ? /* @__PURE__ */ jsx16("div", { children: title }) : null,
    /* @__PURE__ */ jsx16("div", { className: classes, children: itemControls })
  ] });
};

// src/components/forms/controls/inputs/CheckBoxListControl.tsx
import { rankWith, optionIs } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { jsx as jsx17 } from "react/jsx-runtime";
var CustomControl = ({
  data,
  handleChange,
  path
}) => /* @__PURE__ */ jsx17(
  CheckBoxList,
  {
    initialItems: data,
    onChanged: (changedItems) => handleChange(path, changedItems)
  }
);
var CheckBoxListControl = withJsonFormsControlProps(CustomControl);
var CheckBoxListControlTester = rankWith(
  3,
  optionIs("checkBoxList", true)
);

// src/components/forms/controls/inputs/FormInput.tsx
import { useState as useState9 } from "react";
import { jsx as jsx18, jsxs as jsxs11 } from "react/jsx-runtime";
var FormInput = (props) => {
  const {
    type,
    onValueChange,
    onValueBlur,
    className,
    disabled,
    register,
    label,
    name,
    required,
    maxLength,
    minLength,
    width,
    ...rest
  } = props;
  const [inputType, setInputType] = useState9(type);
  let layoutWidth = inputType == "checkbox" ? "" : "flex-1 w-full";
  if (width && width !== "full") {
    if (typeof width === "string") {
      layoutWidth = width;
    }
  }
  const requiredConfig = required ? {
    required: label ? `${label} is required` : "required",
    maxLength,
    minLength
  } : false;
  return /* @__PURE__ */ jsxs11("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ jsxs11("div", { className: "flex w-full justify-between", children: [
      label && /* @__PURE__ */ jsx18("label", { className: "text-xs", children: label }),
      type === "password" && /* @__PURE__ */ jsxs11(
        "div",
        {
          className: "cursor-pointer text-xs",
          onClick: () => {
            setInputType(inputType === "password" ? "text" : "password");
          },
          children: [
            inputType === "password" ? "Show" : "Hide",
            " password"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx18(
      "input",
      {
        type: inputType || "text",
        disabled,
        className: classNames(
          `focus:border-primary-500 focus:ring-primary-500 block rounded-md border border-gray-300 p-2 placeholder-gray-400 sm:text-sm ${layoutWidth}`,
          type === "checkbox" ? "" : "w-full flex-1",
          className ? className : ""
        ),
        onChange: (e) => {
          if (onValueChange) {
            onValueChange(
              type == "number" ? e.target.valueAsNumber : e.target.value
            );
          }
        },
        onBlur: (e) => {
          if (onValueBlur) {
            onValueBlur(
              type == "number" ? e.target.valueAsNumber : e.target.value
            );
          }
        },
        ...rest,
        ...register(name, {
          required: requiredConfig,
          valueAsNumber: type == "number"
        })
      }
    )
  ] });
};

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// ../../node_modules/@radix-ui/react-slider/dist/index.mjs
import { forwardRef as $g1Vy2$forwardRef, useState as $g1Vy2$useState, useRef as $g1Vy2$useRef, createElement as $g1Vy2$createElement, useMemo as $g1Vy2$useMemo, useEffect as $g1Vy2$useEffect } from "react";

// ../../node_modules/@radix-ui/number/dist/index.mjs
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, [min, max]) {
  return Math.min(max, Math.max(min, value));
}

// ../../node_modules/@radix-ui/primitive/dist/index.mjs
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented)
      return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

// ../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
import { useCallback as $3vqmr$useCallback } from "react";
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function")
    ref(value);
  else if (ref !== null && ref !== void 0)
    ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
  return (node4) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef(ref, node4)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
  return $3vqmr$useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}

// ../../node_modules/@radix-ui/react-context/dist/index.mjs
import { createContext as $3bkAK$createContext, useMemo as $3bkAK$useMemo, createElement as $3bkAK$createElement, useContext as $3bkAK$useContext } from "react";
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ $3bkAK$createContext(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider3(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      const value = $3bkAK$useMemo(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ $3bkAK$createElement(Context.Provider, {
        value
      }, children);
    }
    function useContext10(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      const context = $3bkAK$useContext(Context);
      if (context)
        return context;
      if (defaultContext !== void 0)
        return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider3.displayName = rootComponentName + "Provider";
    return [
      Provider3,
      useContext10
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ $3bkAK$createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1)
    return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return $3bkAK$useMemo(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

// ../../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
import { useCallback as $bnPw9$useCallback, useState as $bnPw9$useState, useRef as $bnPw9$useRef, useEffect as $bnPw9$useEffect } from "react";

// ../../node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
import { useRef as $lwiWj$useRef, useEffect as $lwiWj$useEffect, useMemo as $lwiWj$useMemo } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
  const callbackRef = $lwiWj$useRef(callback);
  $lwiWj$useEffect(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop, defaultProp, onChange = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
    defaultProp,
    onChange
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
  const setValue = $bnPw9$useCallback((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop)
        handleChange(value);
    } else
      setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp, onChange }) {
  const uncontrolledState = $bnPw9$useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = $bnPw9$useRef(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
  $bnPw9$useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}

// ../../node_modules/@radix-ui/react-direction/dist/index.mjs
import { createContext as $7Gjcd$createContext, createElement as $7Gjcd$createElement, useContext as $7Gjcd$useContext } from "react";
var $f631663db3294ace$var$DirectionContext = /* @__PURE__ */ $7Gjcd$createContext(void 0);
function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
  const globalDir = $7Gjcd$useContext($f631663db3294ace$var$DirectionContext);
  return localDir || globalDir || "ltr";
}

// ../../node_modules/@radix-ui/react-use-previous/dist/index.mjs
import { useRef as $8LvvK$useRef, useMemo as $8LvvK$useMemo } from "react";
function $010c2913dbd2fe3d$export$5cae361ad82dce8b(value) {
  const ref = $8LvvK$useRef({
    value,
    previous: value
  });
  return $8LvvK$useMemo(() => {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [
    value
  ]);
}

// ../../node_modules/@radix-ui/react-use-size/dist/index.mjs
import { useState as $9gyGR$useState } from "react";

// ../../node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
import { useLayoutEffect as $dxlwH$useLayoutEffect } from "react";
var $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? $dxlwH$useLayoutEffect : () => {
};

// ../../node_modules/@radix-ui/react-use-size/dist/index.mjs
function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
  const [size, setSize] = $9gyGR$useState(void 0);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (element) {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries))
          return;
        if (!entries.length)
          return;
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({
          width,
          height
        });
      });
      resizeObserver.observe(element, {
        box: "border-box"
      });
      return () => resizeObserver.unobserve(element);
    } else
      setSize(void 0);
  }, [
    element
  ]);
  return size;
}

// ../../node_modules/@radix-ui/react-primitive/dist/index.mjs
import { forwardRef as $4q5Fq$forwardRef, useEffect as $4q5Fq$useEffect, createElement as $4q5Fq$createElement } from "react";
import { flushSync as $4q5Fq$flushSync } from "react-dom";
import { Slot as $4q5Fq$Slot } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node4) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot : node4;
    $4q5Fq$useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node4}`;
  return {
    ...primitive,
    [node4]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-collection/dist/index.mjs
import $6vYhU$react from "react";
import { Slot as $6vYhU$Slot } from "@radix-ui/react-slot";
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c1(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  });
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = $6vYhU$react.useRef(null);
    const itemMap = $6vYhU$react.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ $6vYhU$react.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  /* @__PURE__ */ Object.assign(CollectionProvider, {
    displayName: PROVIDER_NAME
  });
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */ $6vYhU$react.forwardRef((props, forwardedRef) => {
    const { scope, children } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
    return /* @__PURE__ */ $6vYhU$react.createElement($6vYhU$Slot, {
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionSlot, {
    displayName: COLLECTION_SLOT_NAME
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */ $6vYhU$react.forwardRef((props, forwardedRef) => {
    const { scope, children, ...itemData } = props;
    const ref = $6vYhU$react.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    $6vYhU$react.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */ $6vYhU$react.createElement($6vYhU$Slot, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionItemSlot, {
    displayName: ITEM_SLOT_NAME
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = $6vYhU$react.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode)
        return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a, b) => orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
      );
      return orderedItems;
    }, [
      context.collectionRef,
      context.itemMap
    ]);
    return getItems;
  }
  return [
    {
      Provider: CollectionProvider,
      Slot: CollectionSlot,
      ItemSlot: CollectionItemSlot
    },
    useCollection,
    createCollectionScope
  ];
}

// ../../node_modules/@radix-ui/react-slider/dist/index.mjs
var $faa2e61a3361514f$var$PAGE_KEYS = [
  "PageUp",
  "PageDown"
];
var $faa2e61a3361514f$var$ARROW_KEYS = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
];
var $faa2e61a3361514f$var$BACK_KEYS = {
  "from-left": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-right": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowRight"
  ],
  "from-bottom": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-top": [
    "Home",
    "PageDown",
    "ArrowUp",
    "ArrowLeft"
  ]
};
var $faa2e61a3361514f$var$SLIDER_NAME = "Slider";
var [$faa2e61a3361514f$var$Collection, $faa2e61a3361514f$var$useCollection, $faa2e61a3361514f$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($faa2e61a3361514f$var$SLIDER_NAME);
var [$faa2e61a3361514f$var$createSliderContext, $faa2e61a3361514f$export$ef72632d7b901f97] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($faa2e61a3361514f$var$SLIDER_NAME, [
  $faa2e61a3361514f$var$createCollectionScope
]);
var [$faa2e61a3361514f$var$SliderProvider, $faa2e61a3361514f$var$useSliderContext] = $faa2e61a3361514f$var$createSliderContext($faa2e61a3361514f$var$SLIDER_NAME);
var $faa2e61a3361514f$export$472062a354075cee = /* @__PURE__ */ $g1Vy2$forwardRef((props, forwardedRef) => {
  const { name, min = 0, max = 100, step = 1, orientation = "horizontal", disabled = false, minStepsBetweenThumbs = 0, defaultValue = [
    min
  ], value: value1, onValueChange = () => {
  }, onValueCommit = () => {
  }, inverted = false, ...sliderProps } = props;
  const [slider, setSlider] = $g1Vy2$useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    forwardedRef,
    (node4) => setSlider(node4)
  );
  const thumbRefs = $g1Vy2$useRef(/* @__PURE__ */ new Set());
  const valueIndexToChangeRef = $g1Vy2$useRef(0);
  const isHorizontal = orientation === "horizontal";
  const isFormControl = slider ? Boolean(slider.closest("form")) : true;
  const SliderOrientation = isHorizontal ? $faa2e61a3361514f$var$SliderHorizontal : $faa2e61a3361514f$var$SliderVertical;
  const [values = [], setValues] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: value1,
    defaultProp: defaultValue,
    onChange: (value) => {
      var _thumbs$valueIndexToC;
      const thumbs = [
        ...thumbRefs.current
      ];
      (_thumbs$valueIndexToC = thumbs[valueIndexToChangeRef.current]) === null || _thumbs$valueIndexToC === void 0 || _thumbs$valueIndexToC.focus();
      onValueChange(value);
    }
  });
  const valuesBeforeSlideStartRef = $g1Vy2$useRef(values);
  function handleSlideStart(value) {
    const closestIndex = $faa2e61a3361514f$var$getClosestValueIndex(values, value);
    updateValues(value, closestIndex);
  }
  function handleSlideMove(value) {
    updateValues(value, valueIndexToChangeRef.current);
  }
  function handleSlideEnd() {
    const prevValue = valuesBeforeSlideStartRef.current[valueIndexToChangeRef.current];
    const nextValue = values[valueIndexToChangeRef.current];
    const hasChanged = nextValue !== prevValue;
    if (hasChanged)
      onValueCommit(values);
  }
  function updateValues(value, atIndex, { commit } = {
    commit: false
  }) {
    const decimalCount = $faa2e61a3361514f$var$getDecimalCount(step);
    const snapToStep = $faa2e61a3361514f$var$roundValue(Math.round((value - min) / step) * step + min, decimalCount);
    const nextValue = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(snapToStep, [
      min,
      max
    ]);
    setValues((prevValues = []) => {
      const nextValues = $faa2e61a3361514f$var$getNextSortedValues(prevValues, nextValue, atIndex);
      if ($faa2e61a3361514f$var$hasMinStepsBetweenValues(nextValues, minStepsBetweenThumbs * step)) {
        valueIndexToChangeRef.current = nextValues.indexOf(nextValue);
        const hasChanged = String(nextValues) !== String(prevValues);
        if (hasChanged && commit)
          onValueCommit(nextValues);
        return hasChanged ? nextValues : prevValues;
      } else
        return prevValues;
    });
  }
  return /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$SliderProvider, {
    scope: props.__scopeSlider,
    disabled,
    min,
    max,
    valueIndexToChangeRef,
    thumbs: thumbRefs.current,
    values,
    orientation
  }, /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$Collection.Provider, {
    scope: props.__scopeSlider
  }, /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$Collection.Slot, {
    scope: props.__scopeSlider
  }, /* @__PURE__ */ $g1Vy2$createElement(SliderOrientation, _extends({
    "aria-disabled": disabled,
    "data-disabled": disabled ? "" : void 0
  }, sliderProps, {
    ref: composedRefs,
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(sliderProps.onPointerDown, () => {
      if (!disabled)
        valuesBeforeSlideStartRef.current = values;
    }),
    min,
    max,
    inverted,
    onSlideStart: disabled ? void 0 : handleSlideStart,
    onSlideMove: disabled ? void 0 : handleSlideMove,
    onSlideEnd: disabled ? void 0 : handleSlideEnd,
    onHomeKeyDown: () => !disabled && updateValues(min, 0, {
      commit: true
    }),
    onEndKeyDown: () => !disabled && updateValues(max, values.length - 1, {
      commit: true
    }),
    onStepKeyDown: ({ event, direction: stepDirection }) => {
      if (!disabled) {
        const isPageKey = $faa2e61a3361514f$var$PAGE_KEYS.includes(event.key);
        const isSkipKey = isPageKey || event.shiftKey && $faa2e61a3361514f$var$ARROW_KEYS.includes(event.key);
        const multiplier = isSkipKey ? 10 : 1;
        const atIndex = valueIndexToChangeRef.current;
        const value = values[atIndex];
        const stepInDirection = step * multiplier * stepDirection;
        updateValues(value + stepInDirection, atIndex, {
          commit: true
        });
      }
    }
  })))), isFormControl && values.map(
    (value, index) => /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$BubbleInput, {
      key: index,
      name: name ? name + (values.length > 1 ? "[]" : "") : void 0,
      value
    })
  ));
});
var [$faa2e61a3361514f$var$SliderOrientationProvider, $faa2e61a3361514f$var$useSliderOrientationContext] = $faa2e61a3361514f$var$createSliderContext($faa2e61a3361514f$var$SLIDER_NAME, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
});
var $faa2e61a3361514f$var$SliderHorizontal = /* @__PURE__ */ $g1Vy2$forwardRef((props, forwardedRef) => {
  const { min, max, dir, inverted, onSlideStart, onSlideMove, onSlideEnd, onStepKeyDown, ...sliderProps } = props;
  const [slider, setSlider] = $g1Vy2$useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    forwardedRef,
    (node4) => setSlider(node4)
  );
  const rectRef = $g1Vy2$useRef();
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const isDirectionLTR = direction === "ltr";
  const isSlidingFromLeft = isDirectionLTR && !inverted || !isDirectionLTR && inverted;
  function getValueFromPointer(pointerPosition) {
    const rect = rectRef.current || slider.getBoundingClientRect();
    const input = [
      0,
      rect.width
    ];
    const output = isSlidingFromLeft ? [
      min,
      max
    ] : [
      max,
      min
    ];
    const value = $faa2e61a3361514f$var$linearScale(input, output);
    rectRef.current = rect;
    return value(pointerPosition - rect.left);
  }
  return /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$SliderOrientationProvider, {
    scope: props.__scopeSlider,
    startEdge: isSlidingFromLeft ? "left" : "right",
    endEdge: isSlidingFromLeft ? "right" : "left",
    direction: isSlidingFromLeft ? 1 : -1,
    size: "width"
  }, /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$SliderImpl, _extends({
    dir: direction,
    "data-orientation": "horizontal"
  }, sliderProps, {
    ref: composedRefs,
    style: {
      ...sliderProps.style,
      ["--radix-slider-thumb-transform"]: "translateX(-50%)"
    },
    onSlideStart: (event) => {
      const value = getValueFromPointer(event.clientX);
      onSlideStart === null || onSlideStart === void 0 || onSlideStart(value);
    },
    onSlideMove: (event) => {
      const value = getValueFromPointer(event.clientX);
      onSlideMove === null || onSlideMove === void 0 || onSlideMove(value);
    },
    onSlideEnd: () => {
      rectRef.current = void 0;
      onSlideEnd === null || onSlideEnd === void 0 || onSlideEnd();
    },
    onStepKeyDown: (event) => {
      const slideDirection = isSlidingFromLeft ? "from-left" : "from-right";
      const isBackKey = $faa2e61a3361514f$var$BACK_KEYS[slideDirection].includes(event.key);
      onStepKeyDown === null || onStepKeyDown === void 0 || onStepKeyDown({
        event,
        direction: isBackKey ? -1 : 1
      });
    }
  })));
});
var $faa2e61a3361514f$var$SliderVertical = /* @__PURE__ */ $g1Vy2$forwardRef((props, forwardedRef) => {
  const { min, max, inverted, onSlideStart, onSlideMove, onSlideEnd, onStepKeyDown, ...sliderProps } = props;
  const sliderRef = $g1Vy2$useRef(null);
  const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, sliderRef);
  const rectRef = $g1Vy2$useRef();
  const isSlidingFromBottom = !inverted;
  function getValueFromPointer(pointerPosition) {
    const rect = rectRef.current || sliderRef.current.getBoundingClientRect();
    const input = [
      0,
      rect.height
    ];
    const output = isSlidingFromBottom ? [
      max,
      min
    ] : [
      min,
      max
    ];
    const value = $faa2e61a3361514f$var$linearScale(input, output);
    rectRef.current = rect;
    return value(pointerPosition - rect.top);
  }
  return /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$SliderOrientationProvider, {
    scope: props.__scopeSlider,
    startEdge: isSlidingFromBottom ? "bottom" : "top",
    endEdge: isSlidingFromBottom ? "top" : "bottom",
    size: "height",
    direction: isSlidingFromBottom ? 1 : -1
  }, /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$SliderImpl, _extends({
    "data-orientation": "vertical"
  }, sliderProps, {
    ref,
    style: {
      ...sliderProps.style,
      ["--radix-slider-thumb-transform"]: "translateY(50%)"
    },
    onSlideStart: (event) => {
      const value = getValueFromPointer(event.clientY);
      onSlideStart === null || onSlideStart === void 0 || onSlideStart(value);
    },
    onSlideMove: (event) => {
      const value = getValueFromPointer(event.clientY);
      onSlideMove === null || onSlideMove === void 0 || onSlideMove(value);
    },
    onSlideEnd: () => {
      rectRef.current = void 0;
      onSlideEnd === null || onSlideEnd === void 0 || onSlideEnd();
    },
    onStepKeyDown: (event) => {
      const slideDirection = isSlidingFromBottom ? "from-bottom" : "from-top";
      const isBackKey = $faa2e61a3361514f$var$BACK_KEYS[slideDirection].includes(event.key);
      onStepKeyDown === null || onStepKeyDown === void 0 || onStepKeyDown({
        event,
        direction: isBackKey ? -1 : 1
      });
    }
  })));
});
var $faa2e61a3361514f$var$SliderImpl = /* @__PURE__ */ $g1Vy2$forwardRef((props, forwardedRef) => {
  const { __scopeSlider, onSlideStart, onSlideMove, onSlideEnd, onHomeKeyDown, onEndKeyDown, onStepKeyDown, ...sliderProps } = props;
  const context = $faa2e61a3361514f$var$useSliderContext($faa2e61a3361514f$var$SLIDER_NAME, __scopeSlider);
  return /* @__PURE__ */ $g1Vy2$createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({}, sliderProps, {
    ref: forwardedRef,
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event) => {
      if (event.key === "Home") {
        onHomeKeyDown(event);
        event.preventDefault();
      } else if (event.key === "End") {
        onEndKeyDown(event);
        event.preventDefault();
      } else if ($faa2e61a3361514f$var$PAGE_KEYS.concat($faa2e61a3361514f$var$ARROW_KEYS).includes(event.key)) {
        onStepKeyDown(event);
        event.preventDefault();
      }
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, (event) => {
      const target = event.target;
      target.setPointerCapture(event.pointerId);
      event.preventDefault();
      if (context.thumbs.has(target))
        target.focus();
      else
        onSlideStart(event);
    }),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, (event) => {
      const target = event.target;
      if (target.hasPointerCapture(event.pointerId))
        onSlideMove(event);
    }),
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, (event) => {
      const target = event.target;
      if (target.hasPointerCapture(event.pointerId)) {
        target.releasePointerCapture(event.pointerId);
        onSlideEnd(event);
      }
    })
  }));
});
var $faa2e61a3361514f$var$TRACK_NAME = "SliderTrack";
var $faa2e61a3361514f$export$105594979f116971 = /* @__PURE__ */ $g1Vy2$forwardRef((props, forwardedRef) => {
  const { __scopeSlider, ...trackProps } = props;
  const context = $faa2e61a3361514f$var$useSliderContext($faa2e61a3361514f$var$TRACK_NAME, __scopeSlider);
  return /* @__PURE__ */ $g1Vy2$createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({
    "data-disabled": context.disabled ? "" : void 0,
    "data-orientation": context.orientation
  }, trackProps, {
    ref: forwardedRef
  }));
});
var $faa2e61a3361514f$var$RANGE_NAME = "SliderRange";
var $faa2e61a3361514f$export$a5cf38a7a000fe77 = /* @__PURE__ */ $g1Vy2$forwardRef((props, forwardedRef) => {
  const { __scopeSlider, ...rangeProps } = props;
  const context = $faa2e61a3361514f$var$useSliderContext($faa2e61a3361514f$var$RANGE_NAME, __scopeSlider);
  const orientation = $faa2e61a3361514f$var$useSliderOrientationContext($faa2e61a3361514f$var$RANGE_NAME, __scopeSlider);
  const ref = $g1Vy2$useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const valuesCount = context.values.length;
  const percentages = context.values.map(
    (value) => $faa2e61a3361514f$var$convertValueToPercentage(value, context.min, context.max)
  );
  const offsetStart = valuesCount > 1 ? Math.min(...percentages) : 0;
  const offsetEnd = 100 - Math.max(...percentages);
  return /* @__PURE__ */ $g1Vy2$createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({
    "data-orientation": context.orientation,
    "data-disabled": context.disabled ? "" : void 0
  }, rangeProps, {
    ref: composedRefs,
    style: {
      ...props.style,
      [orientation.startEdge]: offsetStart + "%",
      [orientation.endEdge]: offsetEnd + "%"
    }
  }));
});
var $faa2e61a3361514f$var$THUMB_NAME = "SliderThumb";
var $faa2e61a3361514f$export$2c1b491743890dec = /* @__PURE__ */ $g1Vy2$forwardRef((props, forwardedRef) => {
  const getItems = $faa2e61a3361514f$var$useCollection(props.__scopeSlider);
  const [thumb, setThumb] = $g1Vy2$useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    forwardedRef,
    (node4) => setThumb(node4)
  );
  const index = $g1Vy2$useMemo(
    () => thumb ? getItems().findIndex(
      (item) => item.ref.current === thumb
    ) : -1,
    [
      getItems,
      thumb
    ]
  );
  return /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$SliderThumbImpl, _extends({}, props, {
    ref: composedRefs,
    index
  }));
});
var $faa2e61a3361514f$var$SliderThumbImpl = /* @__PURE__ */ $g1Vy2$forwardRef((props, forwardedRef) => {
  const { __scopeSlider, index, ...thumbProps } = props;
  const context = $faa2e61a3361514f$var$useSliderContext($faa2e61a3361514f$var$THUMB_NAME, __scopeSlider);
  const orientation = $faa2e61a3361514f$var$useSliderOrientationContext($faa2e61a3361514f$var$THUMB_NAME, __scopeSlider);
  const [thumb, setThumb] = $g1Vy2$useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    forwardedRef,
    (node4) => setThumb(node4)
  );
  const size = $db6c3485150b8e66$export$1ab7ae714698c4b8(thumb);
  const value = context.values[index];
  const percent2 = value === void 0 ? 0 : $faa2e61a3361514f$var$convertValueToPercentage(value, context.min, context.max);
  const label = $faa2e61a3361514f$var$getLabel(index, context.values.length);
  const orientationSize = size === null || size === void 0 ? void 0 : size[orientation.size];
  const thumbInBoundsOffset = orientationSize ? $faa2e61a3361514f$var$getThumbInBoundsOffset(orientationSize, percent2, orientation.direction) : 0;
  $g1Vy2$useEffect(() => {
    if (thumb) {
      context.thumbs.add(thumb);
      return () => {
        context.thumbs.delete(thumb);
      };
    }
  }, [
    thumb,
    context.thumbs
  ]);
  return /* @__PURE__ */ $g1Vy2$createElement("span", {
    style: {
      transform: "var(--radix-slider-thumb-transform)",
      position: "absolute",
      [orientation.startEdge]: `calc(${percent2}% + ${thumbInBoundsOffset}px)`
    }
  }, /* @__PURE__ */ $g1Vy2$createElement($faa2e61a3361514f$var$Collection.ItemSlot, {
    scope: props.__scopeSlider
  }, /* @__PURE__ */ $g1Vy2$createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({
    role: "slider",
    "aria-label": props["aria-label"] || label,
    "aria-valuemin": context.min,
    "aria-valuenow": value,
    "aria-valuemax": context.max,
    "aria-orientation": context.orientation,
    "data-orientation": context.orientation,
    "data-disabled": context.disabled ? "" : void 0,
    tabIndex: context.disabled ? void 0 : 0
  }, thumbProps, {
    ref: composedRefs,
    style: value === void 0 ? {
      display: "none"
    } : props.style,
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, () => {
      context.valueIndexToChangeRef.current = index;
    })
  }))));
});
var $faa2e61a3361514f$var$BubbleInput = (props) => {
  const { value, ...inputProps } = props;
  const ref = $g1Vy2$useRef(null);
  const prevValue = $010c2913dbd2fe3d$export$5cae361ad82dce8b(value);
  $g1Vy2$useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(inputProto, "value");
    const setValue = descriptor.set;
    if (prevValue !== value && setValue) {
      const event = new Event("input", {
        bubbles: true
      });
      setValue.call(input, value);
      input.dispatchEvent(event);
    }
  }, [
    prevValue,
    value
  ]);
  return /* @__PURE__ */ $g1Vy2$createElement("input", _extends({
    style: {
      display: "none"
    }
  }, inputProps, {
    ref,
    defaultValue: value
  }));
};
function $faa2e61a3361514f$var$getNextSortedValues(prevValues = [], nextValue, atIndex) {
  const nextValues = [
    ...prevValues
  ];
  nextValues[atIndex] = nextValue;
  return nextValues.sort(
    (a, b) => a - b
  );
}
function $faa2e61a3361514f$var$convertValueToPercentage(value, min, max) {
  const maxSteps = max - min;
  const percentPerStep = 100 / maxSteps;
  const percentage = percentPerStep * (value - min);
  return $ae6933e535247d3d$export$7d15b64cf5a3a4c4(percentage, [
    0,
    100
  ]);
}
function $faa2e61a3361514f$var$getLabel(index, totalValues) {
  if (totalValues > 2)
    return `Value ${index + 1} of ${totalValues}`;
  else if (totalValues === 2)
    return [
      "Minimum",
      "Maximum"
    ][index];
  else
    return void 0;
}
function $faa2e61a3361514f$var$getClosestValueIndex(values, nextValue) {
  if (values.length === 1)
    return 0;
  const distances = values.map(
    (value) => Math.abs(value - nextValue)
  );
  const closestDistance = Math.min(...distances);
  return distances.indexOf(closestDistance);
}
function $faa2e61a3361514f$var$getThumbInBoundsOffset(width, left, direction) {
  const halfWidth = width / 2;
  const halfPercent = 50;
  const offset = $faa2e61a3361514f$var$linearScale([
    0,
    halfPercent
  ], [
    0,
    halfWidth
  ]);
  return (halfWidth - offset(left) * direction) * direction;
}
function $faa2e61a3361514f$var$getStepsBetweenValues(values) {
  return values.slice(0, -1).map(
    (value, index) => values[index + 1] - value
  );
}
function $faa2e61a3361514f$var$hasMinStepsBetweenValues(values, minStepsBetweenValues) {
  if (minStepsBetweenValues > 0) {
    const stepsBetweenValues = $faa2e61a3361514f$var$getStepsBetweenValues(values);
    const actualMinStepsBetweenValues = Math.min(...stepsBetweenValues);
    return actualMinStepsBetweenValues >= minStepsBetweenValues;
  }
  return true;
}
function $faa2e61a3361514f$var$linearScale(input, output) {
  return (value) => {
    if (input[0] === input[1] || output[0] === output[1])
      return output[0];
    const ratio = (output[1] - output[0]) / (input[1] - input[0]);
    return output[0] + ratio * (value - input[0]);
  };
}
function $faa2e61a3361514f$var$getDecimalCount(value) {
  return (String(value).split(".")[1] || "").length;
}
function $faa2e61a3361514f$var$roundValue(value, decimalCount) {
  const rounder = Math.pow(10, decimalCount);
  return Math.round(value * rounder) / rounder;
}
var $faa2e61a3361514f$export$be92b6f5f03c0fe9 = $faa2e61a3361514f$export$472062a354075cee;
var $faa2e61a3361514f$export$13921ac0cc260818 = $faa2e61a3361514f$export$105594979f116971;
var $faa2e61a3361514f$export$9a58ef0d7ad3278c = $faa2e61a3361514f$export$a5cf38a7a000fe77;
var $faa2e61a3361514f$export$6521433ed15a34db = $faa2e61a3361514f$export$2c1b491743890dec;

// src/components/forms/controls/inputs/Slider.tsx
import { jsx as jsx19, jsxs as jsxs12 } from "react/jsx-runtime";
var Slider = ({
  minLabel,
  maxLabel,
  max,
  step = 100,
  onChange,
  defaultValue = 0
}) => {
  return /* @__PURE__ */ jsxs12("div", { className: "flex items-center justify-between gap-5 text-xs", children: [
    /* @__PURE__ */ jsx19("div", { className: "whitespace-nowrap", children: minLabel }),
    /* @__PURE__ */ jsxs12(
      $faa2e61a3361514f$export$be92b6f5f03c0fe9,
      {
        defaultValue: [defaultValue],
        onValueChange: (values) => onChange(values[0]),
        max,
        step,
        "aria-label": "value",
        className: "relative flex h-5 w-64 grow touch-none items-center",
        children: [
          /* @__PURE__ */ jsx19($faa2e61a3361514f$export$13921ac0cc260818, { className: "relative h-1 w-full grow rounded-full bg-gray-200 dark:bg-gray-800", children: /* @__PURE__ */ jsx19($faa2e61a3361514f$export$9a58ef0d7ad3278c, { className: "bg-primary-600 absolute h-full rounded-full dark:bg-white" }) }),
          /* @__PURE__ */ jsx19(
            $faa2e61a3361514f$export$6521433ed15a34db,
            {
              className: classNames(
                "bg-primary-600 block h-5 w-5 rounded-full dark:bg-white",
                "focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75"
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx19("div", { children: maxLabel })
  ] });
};

// src/components/forms/controls/inputs/Input.tsx
import { createUUID } from "shared-lib";
import { jsx as jsx20, jsxs as jsxs13 } from "react/jsx-runtime";
var Input = (props) => {
  const {
    type,
    onValueChange,
    onValueBlur,
    className,
    disabled,
    label,
    width,
    ...rest
  } = props;
  let id3 = rest.id;
  if (!id3) {
    id3 = createUUID();
  }
  let layoutWidth = type == "checkbox" ? "" : "flex-1 w-full";
  if (width && width !== "full") {
    if (typeof width === "string") {
      layoutWidth = width;
    }
  }
  return /* @__PURE__ */ jsxs13("div", { className: "flex grow flex-col gap-1", children: [
    label && /* @__PURE__ */ jsx20("label", { htmlFor: id3, className: "block text-sm font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsx20(
      "input",
      {
        "aria-label": label,
        id: id3,
        type: type || "text",
        disabled,
        className: classNames(
          `focus:ring-secondary-500 focus:border-secondary-500 block rounded-lg border border-gray-300 p-2 text-gray-800 ${layoutWidth}`,
          className ? className : ""
        ),
        onChange: (e) => {
          if (onValueChange) {
            onValueChange(e.target.value);
          }
        },
        onBlur: (e) => {
          if (onValueBlur) {
            onValueBlur(e.target.value);
          }
        },
        ...rest
      }
    )
  ] });
};

// src/components/forms/controls/inputs/InputField.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var InputField = ({
  name,
  register,
  defaultValue,
  placeholder,
  interactive = true,
  required = true,
  type = "string",
  min = null,
  readOnly,
  ...props
}) => {
  return /* @__PURE__ */ jsx21(
    "input",
    {
      "aria-label": placeholder || "Input",
      min,
      type,
      readOnly,
      placeholder,
      className: classNames(
        interactive ? "focus:ring-info-500 block w-full flex-1 rounded-md border border-gray-300 p-2 focus:border-gray-500 sm:text-sm" : "m-0 border-none bg-transparent p-0 text-sm"
      ),
      disabled: !interactive,
      defaultValue,
      ...register(name, { required }),
      ...props
    }
  );
};

// src/components/forms/controls/inputs/OptionalCheckBox.tsx
import { useCallback as useCallback4, useState as useState10 } from "react";
import { jsx as jsx22, jsxs as jsxs14 } from "react/jsx-runtime";
var OptionalCheckBox = ({ title, value, onChanged }) => {
  const [current, setCurrent] = useState10(value);
  const onSetTrue = useCallback4(() => {
    setCurrent(true);
    onChanged(true);
  }, [setCurrent, onChanged]);
  const onSetFalse = useCallback4(() => {
    setCurrent(false);
    onChanged(false);
  }, [setCurrent, onChanged]);
  const onUnSet = useCallback4(() => {
    setCurrent(null);
    onChanged(void 0);
  }, [setCurrent, onChanged]);
  return /* @__PURE__ */ jsxs14("fieldset", { children: [
    /* @__PURE__ */ jsx22("legend", { className: "sr-only", children: title }),
    /* @__PURE__ */ jsxs14("div", { className: "flex items-center space-x-5", children: [
      /* @__PURE__ */ jsxs14("div", { className: "relative flex items-start", children: [
        /* @__PURE__ */ jsx22("div", { className: "flex h-6 items-center", children: /* @__PURE__ */ jsx22(
          "input",
          {
            className: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600",
            name: "settrue",
            type: "checkbox",
            checked: current === true,
            onChange: onSetTrue
          }
        ) }),
        /* @__PURE__ */ jsx22("div", { className: "ml-3 text-sm leading-6", children: /* @__PURE__ */ jsx22("label", { htmlFor: "settrue", className: "font-medium text-gray-900", children: "Yes" }) })
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "relative flex items-start", children: [
        /* @__PURE__ */ jsx22("div", { className: "flex h-6 items-center", children: /* @__PURE__ */ jsx22(
          "input",
          {
            className: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600",
            name: "setfalse",
            type: "checkbox",
            checked: current === false,
            onChange: onSetFalse
          }
        ) }),
        /* @__PURE__ */ jsx22("div", { className: "ml-3 text-sm leading-6", children: /* @__PURE__ */ jsx22("label", { htmlFor: "setfalse", className: "font-medium text-gray-900", children: "No" }) })
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "relative flex items-start", children: [
        /* @__PURE__ */ jsx22("div", { className: "flex h-6 items-center", children: /* @__PURE__ */ jsx22(
          "input",
          {
            className: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600",
            name: "unset",
            type: "checkbox",
            checked: current === null || current === void 0,
            onChange: onUnSet
          }
        ) }),
        /* @__PURE__ */ jsx22("div", { className: "ml-3 text-sm leading-6", children: /* @__PURE__ */ jsx22("label", { htmlFor: "unset", className: "font-medium text-gray-900", children: "Not Set" }) })
      ] })
    ] })
  ] });
};

// src/components/forms/controls/inputs/TextArea.tsx
import { forwardRef } from "react";
import { createUUID as createUUID2 } from "shared-lib";
import { jsx as jsx23, jsxs as jsxs15 } from "react/jsx-runtime";
var TextArea = forwardRef(function TextArea2(props, ref) {
  const {
    rows,
    onValueChange,
    onValueBlur,
    className,
    setRows,
    disabled,
    label,
    expandable,
    ...rest
  } = props;
  let id3 = props.id;
  if (!id3) {
    id3 = createUUID2();
  }
  return /* @__PURE__ */ jsxs15("div", { ref, className: "w-full", children: [
    label && /* @__PURE__ */ jsx23("label", { htmlFor: id3, className: "block text-sm font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsx23(
      "textarea",
      {
        id: id3,
        rows,
        disabled,
        className: classNames(
          "focus:ring-secondary-500 focus:border-secondary-500 block w-full flex-1 border border-gray-300 p-2 sm:text-sm",
          className ? className : ""
        ),
        onChange: (e) => {
          if (expandable && setRows) {
            setRows(e.target.value.split("\n").length);
          }
          if (onValueChange) {
            onValueChange(e.target.value);
          }
        },
        onBlur: (e) => {
          if (onValueBlur) {
            onValueBlur(e.target.value);
          }
        },
        ...rest
      }
    )
  ] });
});

// src/components/forms/controls/inputs/TimeSelector.tsx
import { useState as useState11 } from "react";
import { jsx as jsx24, jsxs as jsxs16 } from "react/jsx-runtime";
var TimeSelector = ({
  name,
  title,
  initialTime,
  onChanged
  // onError,
}) => {
  const [time2, setTime] = useState11(initialTime);
  function changed(event) {
    setTime(event.target.value);
    onChanged(event.target.value);
  }
  return /* @__PURE__ */ jsxs16("div", { children: [
    title ? /* @__PURE__ */ jsx24("div", { children: title }) : null,
    /* @__PURE__ */ jsxs16("div", { className: "flex flex-col justify-between", children: [
      /* @__PURE__ */ jsx24(
        "input",
        {
          name,
          type: "time",
          list: "timesList",
          value: time2,
          placeholder: "Enter time",
          onChange: changed
        }
      ),
      /* @__PURE__ */ jsxs16("datalist", { id: "timesList", children: [
        /* @__PURE__ */ jsx24("option", { value: "01:00" }),
        /* @__PURE__ */ jsx24("option", { value: "02:00" }),
        /* @__PURE__ */ jsx24("option", { value: "03:00" }),
        /* @__PURE__ */ jsx24("option", { value: "04:00" }),
        /* @__PURE__ */ jsx24("option", { value: "05:00" }),
        /* @__PURE__ */ jsx24("option", { value: "06:00" }),
        /* @__PURE__ */ jsx24("option", { value: "07:00" }),
        /* @__PURE__ */ jsx24("option", { value: "08:00" }),
        /* @__PURE__ */ jsx24("option", { value: "09:00" }),
        /* @__PURE__ */ jsx24("option", { value: "10:00" }),
        /* @__PURE__ */ jsx24("option", { value: "11:00" }),
        /* @__PURE__ */ jsx24("option", { value: "12:00" }),
        /* @__PURE__ */ jsx24("option", { value: "13:00" }),
        /* @__PURE__ */ jsx24("option", { value: "14:00" }),
        /* @__PURE__ */ jsx24("option", { value: "15:00" }),
        /* @__PURE__ */ jsx24("option", { value: "16:00" }),
        /* @__PURE__ */ jsx24("option", { value: "17:00" }),
        /* @__PURE__ */ jsx24("option", { value: "18:00" }),
        /* @__PURE__ */ jsx24("option", { value: "19:00" }),
        /* @__PURE__ */ jsx24("option", { value: "20:00" }),
        /* @__PURE__ */ jsx24("option", { value: "21:00" }),
        /* @__PURE__ */ jsx24("option", { value: "22:00" }),
        /* @__PURE__ */ jsx24("option", { value: "23:00" }),
        /* @__PURE__ */ jsx24("option", { value: "24:00" })
      ] })
    ] })
  ] });
};

// src/components/forms/controls/inputs/TimeSelectorControl.tsx
import { rankWith as rankWith2, optionIs as optionIs2 } from "@jsonforms/core";
import { withJsonFormsControlProps as withJsonFormsControlProps2 } from "@jsonforms/react";
import { jsx as jsx25 } from "react/jsx-runtime";
var CustomControl2 = ({
  id: id3,
  data,
  handleChange,
  path
}) => /* @__PURE__ */ jsx25(
  TimeSelector,
  {
    name: id3,
    initialTime: data,
    onChanged: (changedItems) => handleChange(path, changedItems)
  }
);
var TimeSelectorControl = withJsonFormsControlProps2(CustomControl2);
var TimeSelectorControlTester = rankWith2(
  3,
  optionIs2("timeControl", true)
);

// src/components/forms/controls/radios/RadioList.tsx
import { useState as useState12 } from "react";
import { RadioGroup as RadioGroup2 } from "@headlessui/react";
import { CheckIcon as CheckIcon3 } from "@heroicons/react/24/outline";

// src/components/@shadcn/components/ui/radio-group.tsx
import * as React2 from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle } from "lucide-react";

// src/components/@shadcn/lib/utils.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/components/@shadcn/components/ui/radio-group.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var RadioGroup = React2.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx26(
    RadioGroupPrimitive.Root,
    {
      className: cn("grid gap-2", className),
      ...props,
      ref
    }
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
var RadioGroupItem = React2.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx26(
    RadioGroupPrimitive.Item,
    {
      ref,
      className: cn(
        "aspect-square h-4 w-4 rounded-full border border-slate-200 border-slate-900 text-slate-900 ring-offset-white focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-800 dark:border-slate-50 dark:text-slate-50 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300",
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsx26(RadioGroupPrimitive.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx26(Circle, { className: "h-2.5 w-2.5 fill-current text-current" }) })
    }
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

// src/components/forms/controls/radios/RadioList.tsx
import { Fragment as Fragment10, jsx as jsx27, jsxs as jsxs17 } from "react/jsx-runtime";
var ListDirection = /* @__PURE__ */ ((ListDirection3) => {
  ListDirection3["Vertical"] = "Vertical";
  ListDirection3["Horizontal"] = "Horizontal";
  return ListDirection3;
})(ListDirection || {});
function initialize(list, value) {
  if (!value) {
    return null;
  }
  if (typeof value === "string") {
    const found = list.find((i) => i.id === value);
    if (found) {
      return found;
    }
    return null;
  }
  return value;
}
var RadioListOld = ({
  title,
  list,
  value,
  onChange,
  disabled,
  direction
}) => {
  const [selected, setSelected] = useState12(
    () => initialize(list, value)
  );
  const layoutDirection = direction ?? "Horizontal" /* Horizontal */;
  const listLayoutClass = layoutDirection === "Horizontal" /* Horizontal */ ? "flex flex-col sm:flex-row sm:items-center gap-2" : "flex flex-col gap-2";
  const itemLayoutClass = layoutDirection === "Horizontal" /* Horizontal */ ? "flex items-center justify-between w-full" : "flex items-center justify-between w-full";
  return /* @__PURE__ */ jsxs17(
    RadioGroup2,
    {
      disabled,
      value: selected,
      onChange: (v) => {
        setSelected(v);
        if (v) {
          onChange(v);
        }
      },
      children: [
        title && /* @__PURE__ */ jsx27(RadioGroup2.Label, { className: "sr-only", children: title }),
        /* @__PURE__ */ jsx27("div", { className: listLayoutClass, children: list.map((item) => {
          return /* @__PURE__ */ jsx27(
            RadioGroup2.Option,
            {
              value: item,
              className: ({ active, checked }) => `${active ? "ring-offset-primary-300 ring-2 ring-white ring-opacity-60 ring-offset-2" : ""}
                ${checked ? "bg-primary-500 bg-opacity-75" : "bg-white"}
                  relative flex cursor-pointer rounded-lg px-5 py-2 shadow focus:outline-none `,
              children: ({ checked }) => /* @__PURE__ */ jsx27(Fragment10, { children: /* @__PURE__ */ jsxs17("div", { className: itemLayoutClass, children: [
                checked && /* @__PURE__ */ jsx27("div", { className: "mr-2 flex-shrink-0 text-white", children: /* @__PURE__ */ jsx27(CheckIcon3, { className: "h-4 w-4" }) }),
                /* @__PURE__ */ jsx27("div", { className: "flex items-center", children: /* @__PURE__ */ jsx27("div", { className: "text-sm", children: /* @__PURE__ */ jsx27(
                  RadioGroup2.Label,
                  {
                    as: "p",
                    className: `font-medium ${checked ? "text-white" : "text-gray-900"}`,
                    children: item.label
                  }
                ) }) })
              ] }) })
            },
            item.id
          );
        }) })
      ]
    }
  );
};
var RadioList = ({
  title,
  list,
  value,
  onChange,
  disabled,
  direction = "Horizontal" /* Horizontal */,
  radioColor
}) => {
  if (value instanceof Object) {
    value = value.id;
  }
  return /* @__PURE__ */ jsxs17("div", { children: [
    /* @__PURE__ */ jsx27("p", { className: "text-sm text-gray-500", children: title }),
    /* @__PURE__ */ jsx27("form", { children: /* @__PURE__ */ jsx27("fieldset", { className: "", children: /* @__PURE__ */ jsx27(
      RadioGroup,
      {
        "aria-label": "Radio button",
        className: classNames(
          "flex",
          direction === "Horizontal" /* Horizontal */ ? "flex-row gap-2" : "flex-col"
        ),
        children: list.map((item) => /* @__PURE__ */ jsxs17("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx27(
            RadioGroupItem,
            {
              "aria-label": item?.label || "radio option",
              id: item.id,
              value: item.id,
              onClick: () => onChange(item),
              checked: item.id == value,
              className: classNames(
                "h-4 w-4 border-gray-500",
                radioColor ? radioColor : "text-indigo-600 checked:border-indigo-600"
              ),
              disabled
            }
          ),
          /* @__PURE__ */ jsx27(
            "label",
            {
              htmlFor: item.id,
              className: "block text-sm font-medium leading-6 text-gray-900",
              children: item.label
            }
          )
        ] }))
      }
    ) }) })
  ] });
};

// src/components/forms/controls/radios/RadioListInput.tsx
import { Controller as Controller4 } from "react-hook-form";
import { jsx as jsx28 } from "react/jsx-runtime";
var RadioListInput = (props) => {
  const { name, control, list, disabled, title, onChange, direction } = props;
  return /* @__PURE__ */ jsx28(
    Controller4,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange, value } }) => {
        return /* @__PURE__ */ jsx28(
          RadioList,
          {
            disabled,
            title,
            list,
            onChange: (item) => {
              onControllerChange(item.id);
              if (onChange) {
                onChange(item);
              }
            },
            value,
            direction
          }
        );
      }
    }
  );
};

// src/components/forms/hook-form/CheckBoxInput.tsx
import { isValidElement as isValidElement2, useCallback as useCallback5 } from "react";
import { useController } from "react-hook-form";
import { CheckIcon as CheckIcon4 } from "@heroicons/react/24/solid";
import { jsx as jsx29, jsxs as jsxs18 } from "react/jsx-runtime";
var CheckboxType = /* @__PURE__ */ ((CheckboxType2) => {
  CheckboxType2["checkbox"] = "checkbox";
  CheckboxType2["switch"] = "switch";
  return CheckboxType2;
})(CheckboxType || {});
var CheckboxInput = (props) => {
  if (props.type || props.type === "checkbox" /* checkbox */)
    return /* @__PURE__ */ jsx29(CheckboxInputComponent, { ...props });
  return /* @__PURE__ */ jsx29(SwitchInput, { ...props });
};
var SwitchInput = (props) => {
  const { name, control, defaultChecked, label, showLabel = true } = props;
  const {
    field: { value, onChange: onControllerChange }
  } = useController({ name, control, defaultValue: Boolean(defaultChecked) });
  const onChange = useCallback5(
    (val) => {
      onControllerChange(val);
    },
    [onControllerChange]
  );
  return /* @__PURE__ */ jsx29(
    SwitchInputComponent,
    {
      value,
      onChange,
      label,
      showLabel
    }
  );
};
var SwitchInputComponent = ({
  value,
  onChange,
  label,
  showLabel = true
}) => {
  const labelIsReactElement = isValidElement2(label);
  return /* @__PURE__ */ jsx29("div", { children: /* @__PURE__ */ jsxs18("div", { className: "flex items-center gap-3 pt-1", children: [
    showLabel && label && /* @__PURE__ */ jsx29("label", { className: `cursor-pointer`, children: /* @__PURE__ */ jsx29("span", { children: label }) }),
    /* @__PURE__ */ jsx29(
      "input",
      {
        type: "checkbox",
        className: "text-primary-500 h-6 w-6 rounded",
        checked: Boolean(value),
        "aria-label": label || "Select",
        onChange: () => onChange(!value)
      }
    ),
    showLabel && /* @__PURE__ */ jsx29("div", { className: "ml-3", children: labelIsReactElement && label })
  ] }) });
};
var CheckboxInputComponent = (props) => {
  const { name, control, defaultChecked, disabled, label } = props;
  const {
    field: { value, onChange: onControllerChange }
  } = useController({ name, control, defaultValue: Boolean(defaultChecked) });
  const onChange = useCallback5(
    (val) => {
      if (disabled) {
        return;
      }
      onControllerChange(val);
    },
    [onControllerChange]
  );
  return /* @__PURE__ */ jsxs18("div", { className: "item-center flex gap-2", onClick: () => onChange(!value), children: [
    /* @__PURE__ */ jsx29(
      "div",
      {
        className: classNames(
          "flex h-5 w-5 items-center justify-center self-center rounded border",
          value && "bg-primary-400 text-white"
        ),
        children: value && /* @__PURE__ */ jsx29(CheckIcon4, { className: "h-5 w-5" })
      }
    ),
    label && /* @__PURE__ */ jsx29("label", { children: label })
  ] });
};

// src/components/forms/hook-form/DateInput.tsx
import { useState as useState13 } from "react";

// src/components/@shadcn/components/ui/calendar.tsx
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";

// src/components/@shadcn/components/ui/button.tsx
import * as React3 from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { jsx as jsx30 } from "react/jsx-runtime";
var buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300",
  {
    variants: {
      variant: {
        default: "bg-white text-slate-900 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-50/90",
        destructive: "bg-red-500 text-slate-50 hover:bg-red-500/90 dark:bg-red-900 dark:text-slate-50 dark:hover:bg-red-900/90",
        outline: "border border-slate-200 bg-white hover:bg-slate-100 dark:border-slate-800 dark:bg-slate-950 dark:hover:bg-slate-800 dark:hover:text-slate-50",
        secondary: "bg-slate-100 text-slate-900 hover:bg-slate-100/80 dark:bg-slate-800 dark:text-slate-50 dark:hover:bg-slate-800/80",
        ghost: "hover:bg-slate-100  dark:hover:bg-slate-800 dark:hover:text-slate-50",
        link: "text-slate-900 underline-offset-4 hover:underline dark:text-slate-50"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
var Button2 = React3.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return /* @__PURE__ */ jsx30(
      Comp,
      {
        className: cn(buttonVariants({ variant, size, className })),
        ref,
        ...props
      }
    );
  }
);
Button2.displayName = "Button";

// src/components/@shadcn/components/ui/calendar.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
function Calendar({
  className,
  classNames: classNames2,
  showOutsideDays = true,
  ...props
}) {
  return /* @__PURE__ */ jsx31(
    DayPicker,
    {
      showOutsideDays,
      className: cn("p-3", className),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-slate-500 rounded-md w-9 font-normal text-[0.8rem] dark:text-slate-400",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-slate-100/50 [&:has([aria-selected])]:bg-slate-100 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20 dark:[&:has([aria-selected].day-outside)]:bg-slate-800/50 dark:[&:has([aria-selected])]:bg-slate-800",
        day: cn(
          buttonVariants({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100"
        ),
        day_range_end: "day-range-end",
        day_selected: "bg-slate-900 text-slate-50 hover:bg-slate-900 hover:text-slate-50 focus:bg-slate-900 focus:text-slate-50 hover:text-slate-50",
        day_today: "bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-50",
        day_outside: "day-outside text-slate-500 opacity-50 aria-selected:bg-slate-100/50 aria-selected:text-slate-500 aria-selected:opacity-30 dark:text-slate-400 dark:aria-selected:bg-slate-800/50 dark:aria-selected:text-slate-400",
        day_disabled: "text-slate-500 opacity-50 dark:text-slate-400",
        day_range_middle: "aria-selected:bg-slate-100 aria-selected:text-slate-900 dark:aria-selected:bg-slate-800 dark:aria-selected:text-slate-50",
        day_hidden: "invisible",
        ...classNames2
      },
      components: {
        IconLeft: ({ ...props2 }) => /* @__PURE__ */ jsx31(ChevronLeft, { className: "h-4 w-4" }),
        IconRight: ({ ...props2 }) => /* @__PURE__ */ jsx31(ChevronRight, { className: "h-4 w-4" })
      },
      ...props
    }
  );
}
Calendar.displayName = "Calendar";

// src/components/forms/hook-form/DateInput.tsx
import { PopoverContent as PopoverContent2, PopoverTrigger } from "@radix-ui/react-popover";
import { CalendarIcon } from "lucide-react";

// src/components/@shadcn/components/ui/popover.tsx
import * as React4 from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { jsx as jsx32 } from "react/jsx-runtime";
var Popover = PopoverPrimitive.Root;
var PopoverContent = React4.forwardRef(({ className, align = "center", sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx32(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx32(
  PopoverPrimitive.Content,
  {
    ref,
    align,
    sideOffset,
    className: cn(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border border-slate-200 bg-white p-4 text-slate-950 shadow-md outline-none dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      className
    ),
    ...props
  }
) }));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

// src/components/forms/hook-form/DateInput.tsx
import { createUUID as createUUID3, formatDate } from "shared-lib";

// src/components/@chadcn/lib/utils.ts
import { clsx as clsx2 } from "clsx";
import { twMerge as twMerge2 } from "tailwind-merge";
function cn2(...inputs) {
  return twMerge2(clsx2(inputs));
}

// src/components/forms/hook-form/DateInput.tsx
import { jsx as jsx33, jsxs as jsxs19 } from "react/jsx-runtime";
var DateInput = ({
  name,
  initialDate,
  onChanged,
  label,
  id: id3,
  minDate
  // onError,
}) => {
  if (!id3) {
    id3 = createUUID3();
  }
  const [date, setDate] = useState13(() => {
    if (initialDate === void 0) {
      return null;
    }
    return initialDate;
  });
  function changed(event) {
    if (!event || !event.target || !event.target.value) {
      return;
    }
    setDate(event.target.value);
    onChanged(event.target.value);
  }
  return /* @__PURE__ */ jsxs19("div", { className: "flex flex-grow flex-col", children: [
    label && /* @__PURE__ */ jsx33("label", { htmlFor: id3, className: "block text-sm font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsx33(
      "input",
      {
        id: id3,
        type: "date",
        min: minDate?.toString(),
        name,
        value: date?.toString() || "",
        onChange: changed,
        className: "focus:border-info-500 focus:ring-info-500 block w-full min-w-0 flex-1 rounded-md border-gray-300 shadow-sm sm:text-sm"
      }
    )
  ] });
};
var UncontrolledDateInput = ({
  label,
  id: id3,
  minDate,
  name,
  value,
  onChanged
}) => {
  const formatDateValue = (date) => {
    const formattedDate = date && `${date?.getFullYear()}-${(date?.getMonth() + 1).toString().padStart(2, "0")}-${date?.getDate().toString().padStart(2, "0")}T00:00:00.000Z`;
    return formattedDate;
  };
  return /* @__PURE__ */ jsxs19("div", { className: "flex flex-grow flex-col", children: [
    label && /* @__PURE__ */ jsx33("label", { htmlFor: id3, className: "block text-sm font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsxs19(Popover, { children: [
      /* @__PURE__ */ jsx33(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs19(
        Button2,
        {
          "aria-label": "Pick a date",
          variant: "default",
          className: cn2(
            " w-[240px] justify-start  border border-gray-300 text-left font-normal",
            !value && "text-muted-foreground"
          ),
          children: [
            /* @__PURE__ */ jsx33(CalendarIcon, { className: "mr-2 h-4 w-4" }),
            value ? formatDate(value) : /* @__PURE__ */ jsx33("span", { children: "Pick a date" })
          ]
        }
      ) }),
      /* @__PURE__ */ jsx33(PopoverContent2, { className: "w-auto bg-white p-0", align: "start", children: /* @__PURE__ */ jsx33(
        Calendar,
        {
          fromDate: minDate ? new Date(minDate) : void 0,
          mode: "single",
          selected: value ? new Date(value) : /* @__PURE__ */ new Date(),
          onSelect: (x) => {
            onChanged(formatDateValue(x) || (/* @__PURE__ */ new Date())?.toISOString());
          },
          className: "rounded-md border"
        }
      ) })
    ] })
  ] });
};

// src/components/forms/hook-form/FormDateInput.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var FormDateInput = (props) => {
  const {
    type,
    onValueChange,
    onValueBlur,
    className,
    disabled,
    register,
    name,
    required,
    width,
    ...rest
  } = props;
  let layoutWidth = "flex-1 w-full";
  if (width && width !== "full") {
    if (typeof width === "string") {
      layoutWidth = width;
    }
  }
  const {
    onChange,
    onBlur,
    name: inputName,
    ref
  } = register(name, {
    required,
    onChange: (e) => {
      if (onValueChange) {
        onValueChange(e.target.value);
      }
    },
    onBlur: (e) => {
      if (onValueBlur) {
        onValueBlur(e.target.value);
      }
    }
  });
  return /* @__PURE__ */ jsx34(
    "input",
    {
      type: "date",
      disabled,
      className: classNames(
        `focus:border-primary-500 focus:ring-primary-500 block w-full flex-1 rounded-md border border-gray-300 p-2 sm:text-sm ${layoutWidth}`,
        className ? className : ""
      ),
      onChange,
      onBlur,
      name: inputName,
      ref,
      ...rest
    }
  );
};

// src/components/forms/hook-form/FormTextAreaInput.tsx
import { createUUID as createUUID4 } from "shared-lib";
import { Fragment as Fragment11, jsx as jsx35, jsxs as jsxs20 } from "react/jsx-runtime";
var FormTextAreaInput = (props) => {
  const {
    name,
    rows,
    onValueChange,
    onValueBlur,
    className,
    disabled,
    label,
    register,
    required,
    interactive = true,
    ...rest
  } = props;
  let id3 = props.id;
  if (!id3) {
    id3 = createUUID4();
  }
  return /* @__PURE__ */ jsxs20(Fragment11, { children: [
    label && /* @__PURE__ */ jsx35("label", { htmlFor: id3, className: "block text-xs font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsx35(
      "textarea",
      {
        id: id3,
        rows,
        disabled: disabled || !interactive,
        className: classNames(
          "focus:ring-secondary-500 focus:border-secondary-500 block w-full flex-1 rounded-md rounded-none border border-gray-300 p-2 sm:text-sm",
          className ? className : ""
        ),
        onChange: (e) => {
          if (onValueChange) {
            onValueChange(e.target.value);
          }
        },
        onBlur: (e) => {
          if (onValueBlur) {
            onValueBlur(e.target.value);
          }
        },
        ...rest,
        ...register(name, { required })
      }
    )
  ] });
};

// src/components/forms/layout/FieldLabel.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var FieldLabel = ({
  label,
  htmlFor,
  color: color2,
  size
}) => {
  let textSize = "text-sm";
  switch (size) {
    case "sm": {
      textSize = "text-sm";
      break;
    }
    case "md": {
      textSize = "text-md";
      break;
    }
    case "lg": {
      textSize = "text-lg";
      break;
    }
    case "xl": {
      textSize = "text-xl";
      break;
    }
  }
  let textColor = "text-gray-700";
  switch (color2) {
    case "primary": {
      textColor = "text-info-700 hover:text-info-800";
      break;
    }
    case "gray": {
      textColor = "text-gray-700 hover:text-gray-800";
      break;
    }
  }
  return /* @__PURE__ */ jsx36(
    "label",
    {
      htmlFor,
      className: classNames("block font-medium", textColor, textSize),
      children: label
    }
  );
};

// src/components/forms/layout/FormInputRow.tsx
import { QuestionMarkCircleIcon } from "@heroicons/react/24/solid";
import { useToggle } from "shared-lib";
import { jsx as jsx37, jsxs as jsxs21 } from "react/jsx-runtime";
var FormInputRow = ({
  name,
  title,
  children,
  description
}) => {
  const [showDescription, toggleShowDescription] = useToggle();
  return /* @__PURE__ */ jsxs21("div", { className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4", children: [
    /* @__PURE__ */ jsxs21("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsxs21("div", { className: "flex items-end gap-2", children: [
        /* @__PURE__ */ jsx37(
          "label",
          {
            htmlFor: name,
            className: "block text-sm font-bold text-gray-600 sm:mt-px sm:pt-2",
            children: title
          }
        ),
        description && /* @__PURE__ */ jsx37(
          "div",
          {
            onClick: toggleShowDescription,
            className: "cursor-pointer lg:hidden",
            children: /* @__PURE__ */ jsx37(QuestionMarkCircleIcon, { className: "h-5 w-5 fill-gray-300 hover:fill-gray-800" })
          }
        )
      ] }),
      /* @__PURE__ */ jsx37(
        "div",
        {
          className: classNames(
            `pr-2 text-xs lg:block`,
            showDescription ? "" : "hidden"
          ),
          children: description
        }
      )
    ] }),
    /* @__PURE__ */ jsx37("div", { className: "mt-1 sm:col-span-2 sm:mt-0", children: /* @__PURE__ */ jsx37("div", { className: "max-w-lg", children }) })
  ] });
};

// src/components/forms/layout/FormRow.tsx
import { jsx as jsx38, jsxs as jsxs22 } from "react/jsx-runtime";
var FormRow = ({
  label,
  children,
  classes
}) => {
  return /* @__PURE__ */ jsxs22("div", { className: classNames("mb-2", classes ? classes : ""), children: [
    /* @__PURE__ */ jsx38("div", { children: label }),
    /* @__PURE__ */ jsx38("div", { className: "mt-2 flex space-x-2", children })
  ] });
};

// src/components/forms/lib/FormHelpers.ts
var allListObject = {
  id: "ALL",
  name: "All"
};
var withAll = (list) => [
  {
    ...allListObject
  },
  ...list
];

// src/components/forms/FormBuilder.tsx
import { createElement, useEffect as useEffect3, useReducer } from "react";
import { useNavigate } from "react-router-dom";

// src/components/elements/Button.tsx
import { useToggle as useToggle2 } from "shared-lib";
import { Fragment as Fragment12, jsx as jsx39 } from "react/jsx-runtime";
var sizes = {
  sm: "px-2.5 py-1 text-sm",
  md: "px-3 py-1 text-md",
  lg: "px-3 py-2 text-lg",
  xl: "px-3 py-2 text-xl"
};
var Button = (props) => {
  const [hasConfirmed, toggleHasConfirmed] = useToggle2();
  const {
    color: color2,
    size,
    customSize,
    clicked,
    children,
    className,
    disabled,
    type,
    confirmMessage,
    outline,
    ...rest
  } = props;
  const rounded = className?.split(" ").find((x) => x.match(/^rounded-(.*)$/)) || "rounded-full";
  const buttonSize = size ?? "sm";
  const standardClasses = classNames(
    `inline-flex justify-center items-center font-medium l focus:outline-none focus:ring-2 focus:ring-offset-2`,
    customSize || sizes[buttonSize],
    rounded,
    buttonSize,
    className || ""
  );
  let themeClasses = "";
  if (!disabled) {
    switch (color2) {
      case "primary": {
        if (outline) {
          themeClasses = "text-primary-900 bg-white border-primary-300 hover:text-primary-800 focus:text-primary-700";
        } else {
          themeClasses = "text-white bg-primary-900 border-transparent hover:bg-primary-800 focus:ring-primary-700";
        }
        break;
      }
      case "warning": {
        if (outline) {
          themeClasses = "text-warning-500 bg-white border-warning-200 hover:text-white hover:bg-warning-500 focus:ring-warning-400";
        } else {
          themeClasses = "text-white bg-warning-700 border-transparent hover:bg-warning-800 focus:ring-warning-700";
        }
        break;
      }
      case "danger": {
        if (outline) {
          themeClasses = "text-danger-500 bg-white border-danger-200 hover:text-white hover:bg-danger-500 focus:ring-danger-400";
        } else {
          themeClasses = "text-white bg-danger-500 border-transparent hover:bg-danger-800 focus:ring-danger-700";
        }
        break;
      }
      case "secondary": {
        themeClasses = "text-secondary-700 bg-white border-secondary-300 hover:text-white hover:bg-secondary-500 focus:ring-secondary-400";
        break;
      }
      case "success": {
        if (outline) {
          themeClasses = "text-success-500 bg-white border-success-200 hover:text-white hover:bg-success-500 focus:ring-success-400";
        } else {
          themeClasses = "text-white bg-success-500 border-transparent hover:bg-success-800 focus:ring-success-700";
        }
        break;
      }
      case "gray": {
        themeClasses = "text-gray-900 bg-gray-200 border-gray-300 focus:ring-gray-500";
        break;
      }
      case "transparent": {
        themeClasses = "bg-white hover:bg-gray-50 hover:border-gray-300";
        break;
      }
      case "white": {
        themeClasses = "text-primary-900 bg-white border-gray-800 hover:text-primary-800 focus:text-primary-700";
        if (outline) {
          themeClasses += " border";
        }
        break;
      }
      case "deemphasize": {
        themeClasses = "text-black border-none text-md shadow-none";
        break;
      }
      case "green": {
        themeClasses = "bg-sulu-500 border-sulu-500 hover:bg-sulu-600 font-medium text-black";
        break;
      }
    }
  }
  const disabledClasses = disabled ? "bg-gray-200 border-gray-300 text-gray-500 cursor-default" : "";
  if (!confirmMessage) {
    return /* @__PURE__ */ jsx39(
      "button",
      {
        disabled,
        type,
        className: classNames(standardClasses, themeClasses, disabledClasses),
        onClick: () => {
          if (!disabled && clicked) {
            clicked();
          }
        },
        ...rest,
        children
      }
    );
  }
  return /* @__PURE__ */ jsx39(Fragment12, { children: !hasConfirmed ? /* @__PURE__ */ jsx39(
    "button",
    {
      disabled,
      type,
      className: classNames(standardClasses, themeClasses, disabledClasses),
      onClick: () => {
        if (!disabled && clicked) {
          toggleHasConfirmed();
        }
      },
      ...rest,
      children
    }
  ) : /* @__PURE__ */ jsx39(
    "button",
    {
      disabled,
      type,
      className: classNames(standardClasses, themeClasses, disabledClasses),
      onClick: () => {
        if (!disabled && clicked) {
          clicked();
        }
      },
      ...rest,
      children: confirmMessage
    }
  ) });
};

// src/components/elements/ButtonList.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var ButtonList = ({ justify, children }) => {
  let className = "";
  if (!justify || justify === "END") {
    className = "flex flex-wrap gap-2 sm:justify-end";
  } else if (justify === "START") {
    className = "flex flex-wrap gap-2 sm:justify-start";
  } else if (justify === "GRID") {
    className = "grid grid-cols-2 gap-2";
  }
  return /* @__PURE__ */ jsx40("div", { className, children });
};

// src/components/icons/Icon.tsx
import {
  BarsArrowDownIcon,
  BarsArrowUpIcon,
  PlusCircleIcon,
  AdjustmentsHorizontalIcon
} from "@heroicons/react/24/solid";
import { Fragment as Fragment13, jsx as jsx41 } from "react/jsx-runtime";
var Icons = /* @__PURE__ */ ((Icons3) => {
  Icons3["PlusCircle"] = "PlusCircle";
  Icons3["BarsArrowDown"] = "BarsArrowDown";
  Icons3["BarsArrowUp"] = "BarsArrowUp";
  Icons3["FilterHorizontal"] = "FilterHorizontal";
  return Icons3;
})(Icons || {});
var Icon = ({ icon, height, theme }) => {
  const color2 = theme ?? "primary";
  const css = `fill-${color2}-700 h-${height || 4} w-${height || 4}`;
  switch (icon) {
    case "PlusCircle" /* PlusCircle */:
      return /* @__PURE__ */ jsx41(PlusCircleIcon, { className: css });
    case "BarsArrowDown" /* BarsArrowDown */:
      return /* @__PURE__ */ jsx41(BarsArrowDownIcon, { className: css });
    case "BarsArrowUp" /* BarsArrowUp */:
      return /* @__PURE__ */ jsx41(BarsArrowUpIcon, { className: css });
    case "FilterHorizontal" /* FilterHorizontal */:
      return /* @__PURE__ */ jsx41(AdjustmentsHorizontalIcon, { className: css });
  }
  return /* @__PURE__ */ jsx41(Fragment13, {});
};

// src/components/icons/SignalBar.tsx
import { StarIcon } from "@heroicons/react/24/outline";
import { StarIcon as SolidStarIcon } from "@heroicons/react/24/solid";
import { Fragment as Fragment14, jsx as jsx42, jsxs as jsxs23 } from "react/jsx-runtime";
var SignalBarSize = /* @__PURE__ */ ((SignalBarSize2) => {
  SignalBarSize2[SignalBarSize2["signalBar5"] = 0] = "signalBar5";
  SignalBarSize2[SignalBarSize2["signalBar4"] = 1] = "signalBar4";
  SignalBarSize2[SignalBarSize2["signalBar3"] = 2] = "signalBar3";
  SignalBarSize2[SignalBarSize2["signalBar2"] = 3] = "signalBar2";
  SignalBarSize2[SignalBarSize2["signalBar1"] = 4] = "signalBar1";
  SignalBarSize2[SignalBarSize2["signalBar0"] = 5] = "signalBar0";
  return SignalBarSize2;
})(SignalBarSize || {});
function sizeClass(iconSize) {
  switch (iconSize) {
    case "lg": {
      return "h-4 w-4";
    }
    case "sm": {
      return "h-6 w-6";
    }
    case "md": {
      return "h-8 w-8";
    }
    case "xs": {
      return "h-12 w-12";
    }
  }
}
var SignalBar = ({ signalSize, iconSize }) => {
  const iconSizeClass = sizeClass(iconSize);
  let signalIcon = /* @__PURE__ */ jsx42(Fragment14, {});
  switch (signalSize) {
    case 0 /* signalBar5 */: {
      signalIcon = /* @__PURE__ */ jsxs23("div", { className: "flex gap-1 ", children: [
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" })
      ] });
      break;
    }
    case 1 /* signalBar4 */: {
      signalIcon = /* @__PURE__ */ jsxs23("div", { className: "flex gap-1 ", children: [
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" })
      ] });
      break;
    }
    case 2 /* signalBar3 */: {
      signalIcon = /* @__PURE__ */ jsxs23("div", { className: "flex gap-1 ", children: [
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" })
      ] });
      break;
    }
    case 3 /* signalBar2 */: {
      signalIcon = /* @__PURE__ */ jsxs23("div", { className: "flex gap-1 ", children: [
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" })
      ] });
      break;
    }
    case 4 /* signalBar1 */: {
      signalIcon = /* @__PURE__ */ jsxs23("div", { className: "flex gap-1 ", children: [
        /* @__PURE__ */ jsx42(SolidStarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" })
      ] });
      break;
    }
    case 5 /* signalBar0 */: {
      signalIcon = /* @__PURE__ */ jsxs23("div", { className: "flex gap-1 ", children: [
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx42(StarIcon, { className: "h-4 w-4" })
      ] });
      break;
    }
  }
  return /* @__PURE__ */ jsx42("div", { className: "h-4 w-full", children: signalIcon });
};

// src/components/elements/IconText.tsx
import { jsx as jsx43, jsxs as jsxs24 } from "react/jsx-runtime";
var IconText = ({ icon, text, theme }) => {
  return /* @__PURE__ */ jsxs24("div", { className: "flex items-center space-x-2", children: [
    /* @__PURE__ */ jsx43(Icon, { icon, theme }),
    /* @__PURE__ */ jsx43("div", { children: text })
  ] });
};

// src/components/elements/Info.tsx
import { Fragment as Fragment15, jsx as jsx44, jsxs as jsxs25 } from "react/jsx-runtime";
var Info = ({
  icon: Icon2,
  label,
  value,
  border,
  color: color2,
  iconColor,
  showLabel = true
}) => {
  return /* @__PURE__ */ jsx44(Fragment15, { children: /* @__PURE__ */ jsxs25("div", { className: "flex items-center", children: [
    Icon2 && /* @__PURE__ */ jsx44(
      Icon2,
      {
        "aria-hidden": true,
        className: classNames(
          "h-8 w-8",
          iconColor ? iconColor : "stroke-secondary-600"
        )
      }
    ),
    /* @__PURE__ */ jsxs25(
      "div",
      {
        className: classNames(
          "flex flex-col gap-1",
          Icon2 ? "pl-2" : "",
          "w-full"
        ),
        role: "note",
        children: [
          showLabel && label && /* @__PURE__ */ jsx44("div", { className: "px-1 text-sm text-gray-800", children: label }),
          /* @__PURE__ */ jsx44(
            "div",
            {
              "aria-label": label,
              className: classNames(
                "flex  w-full text-sm",
                border ? "border-b-2 border-gray-200 pb-2" : "",
                color2 ? color2 : "text-gray-600"
              ),
              children: value
            }
          )
        ]
      }
    )
  ] }) });
};

// src/components/elements/Progress.tsx
import { jsx as jsx45, jsxs as jsxs26 } from "react/jsx-runtime";
var Progress = ({
  count: count2,
  total,
  completedText,
  progressText
}) => {
  if (!completedText) {
    completedText = "All done!";
  }
  if (!progressText) {
    progressText = `${count2} of ${total} Matched`;
  } else {
    if (typeof progressText === "function") {
      progressText = progressText({ count: count2, total });
    }
  }
  return /* @__PURE__ */ jsxs26("div", { className: "flex flex-grow flex-col", children: [
    /* @__PURE__ */ jsx45("div", { className: "pb-1 pr-2 text-right text-sm text-gray-500", children: count2 === total ? completedText : progressText }),
    /* @__PURE__ */ jsxs26("div", { className: "relative h-1 w-full", children: [
      /* @__PURE__ */ jsx45("div", { className: "absolute h-1 w-full bg-gray-200" }),
      /* @__PURE__ */ jsx45(
        "div",
        {
          className: "bg-secondary-400 absolute h-1 transition-[width] duration-700",
          style: { width: count2 / total * 100 + "%" }
        }
      )
    ] })
  ] });
};

// src/components/elements/Section.tsx
import { jsx as jsx46, jsxs as jsxs27 } from "react/jsx-runtime";
var Section = ({
  title,
  children,
  actions
}) => /* @__PURE__ */ jsxs27("div", { className: "pb-2 pt-3", children: [
  /* @__PURE__ */ jsxs27("div", { className: "mb-4 flex place-content-between items-center border-b-2 border-gray-100 pb-2", children: [
    title && /* @__PURE__ */ jsx46("h2", { className: "text-lg font-medium text-gray-800", children: title }),
    actions && /* @__PURE__ */ jsx46(ButtonList, { children: actions })
  ] }),
  /* @__PURE__ */ jsx46("div", { children })
] });

// src/components/elements/Spinner.tsx
import { jsx as jsx47, jsxs as jsxs28 } from "react/jsx-runtime";
var Spinner = () => /* @__PURE__ */ jsxs28(
  "svg",
  {
    className: "text-primary-400 h-5 w-5 animate-spin",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    children: [
      /* @__PURE__ */ jsx47(
        "circle",
        {
          className: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          strokeWidth: "4"
        }
      ),
      /* @__PURE__ */ jsx47(
        "path",
        {
          className: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }
      )
    ]
  }
);

// src/components/elements/Saving.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
var Saving = () => /* @__PURE__ */ jsx48("div", { className: "flex h-1/3 items-center justify-center", children: /* @__PURE__ */ jsx48(Spinner, {}) });

// src/components/forms/FormBuilder.tsx
import { Fragment as Fragment16, jsx as jsx49, jsxs as jsxs29 } from "react/jsx-runtime";
var FormBuilderElement = ({
  layout: layout2,
  onSave,
  onCancel,
  saveLabel,
  onChange,
  hideSaveCancel
}) => {
  const reducer2 = (state2, action) => {
    return {
      ...state2,
      [action.key]: {
        ...state2[action.key],
        props: {
          ...state2[action.key]["props"],
          ...action.payload
        }
      }
    };
  };
  const [state, dispatch2] = useReducer(reducer2, layout2);
  useEffect3(() => {
    if (onChange) {
      onChange(state);
    }
  }, [state, onChange]);
  return /* @__PURE__ */ jsxs29(Fragment16, { children: [
    /* @__PURE__ */ jsx49("div", { className: "flex flex-col gap-6", children: Object.values(state).map((x) => {
      return createElement(x.component, {
        ...x.props,
        onChange: (y) => {
          dispatch2({
            key: x.key,
            payload: {
              value: y?.currentTarget?.value || y
            }
          });
        },
        onSelected: (y) => {
          dispatch2({
            key: x.key,
            payload: {
              selected: y
            }
          });
        }
      });
    }) }),
    !hideSaveCancel && /* @__PURE__ */ jsxs29("div", { className: "mt-5 flex justify-end gap-2", children: [
      /* @__PURE__ */ jsx49(Button, { onClick: onCancel, children: "Cancel" }),
      /* @__PURE__ */ jsx49(Button, { color: "primary", onClick: () => onSave && onSave(state), children: saveLabel || "Save" })
    ] })
  ] });
};
var FormBuilder = ({
  headerTitle,
  headerDescription,
  sectionTitle,
  layout: layout2,
  saveLabel,
  onSave,
  onCancel,
  onChange
}) => {
  const navigate = useNavigate();
  const cancelEvent = () => {
    if (onCancel) {
      return onCancel();
    }
    return navigate(-1);
  };
  return /* @__PURE__ */ jsx49(
    FormBuilderElement,
    {
      layout: layout2,
      onSave,
      onCancel: cancelEvent,
      saveLabel,
      onChange
    }
  );
};

// src/components/navigation/BreadcrumbLink.tsx
import { Link } from "react-router-dom";
import { jsx as jsx50 } from "react/jsx-runtime";
var BreadcrumbLink = ({ to, label }) => {
  return /* @__PURE__ */ jsx50(Link, { className: "text-sm underline-offset-4", to, children: label });
};

// src/components/navigation/Links.tsx
import { Fragment as Fragment17 } from "react";
import { NavLink } from "react-router-dom";

// src/components/notifications/Pulse.tsx
import { jsx as jsx51, jsxs as jsxs30 } from "react/jsx-runtime";
function Pulse({
  pulseColor = "bg-sky-400",
  dotColor = "bg-sky-500"
}) {
  return /* @__PURE__ */ jsxs30("span", { className: "relative flex h-3 w-3", children: [
    /* @__PURE__ */ jsx51(
      "span",
      {
        className: classNames(
          "absolute inline-flex h-full w-full animate-ping rounded-full opacity-75",
          pulseColor
        )
      }
    ),
    /* @__PURE__ */ jsx51(
      "span",
      {
        className: classNames(
          "relative inline-flex h-3 w-3 rounded-full",
          dotColor
        )
      }
    )
  ] });
}

// src/components/navigation/Links.tsx
import { Fragment as Fragment18, jsx as jsx52, jsxs as jsxs31 } from "react/jsx-runtime";
var EdLink = ({
  children,
  name,
  href,
  className,
  onClick
}) => {
  return /* @__PURE__ */ jsx52(NavLink, { id: name, to: href, className, onClick, children });
};
var EdBreadcrumbLink = ({ state }) => {
  const activeClasses = `text-sm font-bold text-gray-500 hover:text-gray-700`;
  const inActiveClasses = `text-sm text-gray-500 hover:text-gray-700`;
  return /* @__PURE__ */ jsx52(
    NavLink,
    {
      to: state.href,
      className: ({ isActive }) => isActive ? activeClasses : inActiveClasses,
      children: /* @__PURE__ */ jsx52("span", { children: state.name })
    }
  );
};
var EdTextLink = ({ id: id3, to, label }) => {
  const classes = "whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm";
  const activeClasses = `border-info-700 text-info-800 font-medium ${classes}`;
  const inActiveClasses = `underline underline-offset-4 border-transparent text-gray-700 hover:text-info-700 ${classes}`;
  return /* @__PURE__ */ jsx52(
    NavLink,
    {
      id: id3,
      to,
      className: ({ isActive }) => isActive ? activeClasses : inActiveClasses,
      children: label
    }
  );
};
var sizes2 = {
  sm: "px-4 py-2 text-sm",
  md: "px-5 py-2 text-md",
  lg: "px-5 py-2.5 text-lg",
  xl: "px-6 py-2.5 text-xl"
};
var EdTabLink = ({
  id: id3,
  to,
  size,
  label,
  isFirst,
  isLast,
  externalLink,
  onClick,
  activeClassName
}) => {
  const buttonSize = size ?? "sm";
  let classes = "whitespace-nowrap border-b-2 font-medium border";
  if (isFirst) {
    classes += " rounded-tl-md rounded-bl-md";
  }
  if (isLast) {
    classes += " rounded-tr-md rounded-br-md";
  }
  const activeClasses = classNames(
    activeClassName || `text-info-800 font-medium border-info-800 ${classes}`,
    sizes2[buttonSize]
  );
  const inActiveClasses = classNames(
    `text-info-800 hover:text-info-800 ${classes}`,
    sizes2[buttonSize]
  );
  return /* @__PURE__ */ jsx52(
    NavLink,
    {
      id: id3,
      to,
      className: ({ isActive }) => isActive ? activeClasses : inActiveClasses,
      target: externalLink ? "_blank" : void 0,
      onClick,
      children: label
    }
  );
};
var EdIconLink = ({
  name,
  link
}) => {
  const classes = "group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm";
  const activeClasses = `border-info-500 text-info-800 ${classes}`;
  const inActiveClasses = `border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 ${classes}`;
  return /* @__PURE__ */ jsx52(
    NavLink,
    {
      id: name,
      to: link.to,
      className: ({ isActive }) => isActive ? activeClasses : inActiveClasses,
      children: ({ isActive }) => /* @__PURE__ */ jsxs31(Fragment18, { children: [
        link.icon && /* @__PURE__ */ jsx52(
          link.icon,
          {
            className: classNames(
              isActive ? "text-info-800" : "text-gray-600 group-hover:text-gray-500",
              "-ml-0.5 mr-2 h-5 w-5"
            ),
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ jsx52("span", { children: link.name })
      ] })
    }
  );
};
var EdSidebarLink = ({
  name,
  link,
  highlight
}) => {
  const classes = "group w-full flex flex-col font-medium";
  const activeClasses = `bg-gray-600 text-white stroke-white ${classes}`;
  return /* @__PURE__ */ jsx52(
    NavLink,
    {
      id: name + " -sidebar",
      to: link.to,
      className: ({ isActive }) => classNames(
        isActive ? activeClasses : "stroke-white text-white hover:bg-gray-600",
        "flex w-full items-center justify-center "
      ),
      children: ({ isActive }) => /* @__PURE__ */ jsxs31(
        "div",
        {
          className: classNames(
            "z-0 flex grow items-center justify-center text-gray-500 hover:z-20 hover:text-white",
            isActive ? "border-primary-400" : "border-transparent"
          ),
          children: [
            /* @__PURE__ */ jsxs31("div", { className: "relative my-4 flex w-8 items-center justify-center", children: [
              link.icon && /* @__PURE__ */ jsx52(
                link.icon,
                {
                  className: classNames(
                    isActive ? "text-white " : "",
                    link.name == "" ? "w-8" : "h-6 w-6"
                  ),
                  "aria-hidden": "true"
                }
              ),
              highlight && /* @__PURE__ */ jsx52("div", { className: classNames("absolute -right-1 -top-1"), children: /* @__PURE__ */ jsx52(Pulse, { pulseColor: "bg-sky-200", dotColor: "bg-sky-300" }) })
            ] }),
            /* @__PURE__ */ jsx52("span", { className: "hidden", children: link.name }),
            /* @__PURE__ */ jsx52("div", { className: "absolute left-11 flex ", children: /* @__PURE__ */ jsx52(
              "span",
              {
                className: `mx-4 flex rounded-r-lg  bg-gray-600 px-10 py-4 font-bold text-white`,
                children: link.name
              }
            ) })
          ]
        }
      )
    }
  );
};
var EdMobileLink = ({ link, onClick, highlight }) => {
  const classes = "group py-2 px-3 rounded-md flex items-center text-sm font-medium";
  const activeClasses = `bg-gray-600 text-white ${classes}`;
  const inActiveClasses = `text-primary-800 hover:bg-primary-400 hover:text-white ${classes}`;
  return /* @__PURE__ */ jsx52(
    NavLink,
    {
      id: link.name,
      onClick: () => onClick(link),
      to: link.to,
      className: ({ isActive }) => isActive ? activeClasses : inActiveClasses,
      children: ({ isActive }) => /* @__PURE__ */ jsxs31("div", { className: "flex", children: [
        /* @__PURE__ */ jsxs31("div", { className: "relative h-6 w-6", children: [
          link.icon && /* @__PURE__ */ jsx52(
            link.icon,
            {
              className: classNames(
                isActive ? "text-white" : "text-primary-800 group-hover:text-white",
                "h-6 w-6"
              ),
              "aria-hidden": "true"
            }
          ),
          highlight && /* @__PURE__ */ jsx52("div", { className: "absolute -right-1 -top-1", children: /* @__PURE__ */ jsx52(Pulse, {}) })
        ] }),
        /* @__PURE__ */ jsx52("span", { className: "pl-2", children: link.name })
      ] })
    }
  );
};
var IconJustify = /* @__PURE__ */ ((IconJustify2) => {
  IconJustify2[IconJustify2["Left"] = 0] = "Left";
  IconJustify2[IconJustify2["Right"] = 1] = "Right";
  return IconJustify2;
})(IconJustify || {});
var EdMenuLink = ({ name, to }) => {
  const classes = "block px-4 py-2 text-sm text-gray-700";
  const activeClasses = `bg-gray-100 ${classes}`;
  return /* @__PURE__ */ jsx52(
    NavLink,
    {
      id: name,
      to,
      className: ({ isActive }) => isActive ? activeClasses : classes,
      children: () => /* @__PURE__ */ jsx52("span", { children: name })
    }
  );
};
var EdButtonLink = (props) => {
  let themeClasses = "text-white bg-primary-800 hover:bg-primary-900 focus:ring-primary-900";
  switch (props.color) {
    case "warning": {
      themeClasses = "text-danger-500 bg-white border-danger-200 hover:text-white hover:bg-danger-500 focus:ring-danger-400";
      break;
    }
    case "gray": {
      themeClasses = "text-white bg-gray-500 border-transparent hover:bg-gray-700 focus:ring-gray-500";
      break;
    }
    case "transparent": {
      themeClasses = "bg-white hover:bg-gray-50 hover:border-gray-300";
      break;
    }
  }
  const classes = `flex grow justify-center inline-flex items-center rounded-md border border-transparent px-4 py-2 text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 ${themeClasses}`;
  const activeClasses = `${classes} bg-gray-100`;
  const iconJustify = props.iconJustify || 0 /* Left */;
  return /* @__PURE__ */ jsx52(
    NavLink,
    {
      "aria-label": props.label || props.name,
      id: props.name + " " + props.to,
      to: props.to,
      className: ({ isActive }) => isActive ? activeClasses : classes,
      children: ({ isActive }) => /* @__PURE__ */ jsxs31(Fragment17, { children: [
        props.icon && iconJustify === 0 /* Left */ && /* @__PURE__ */ jsx52(
          props.icon,
          {
            className: classNames(
              isActive ? "text-white" : "group-hover:text-white",
              "mr-3 h-6 w-6"
            ),
            "aria-hidden": "true"
          }
        ),
        props.label || props.name,
        props.icon && iconJustify === 1 /* Right */ && /* @__PURE__ */ jsx52(
          props.icon,
          {
            className: classNames(
              isActive ? "text-white" : "group-hover:text-white",
              "ml-3 h-6 w-6"
            ),
            "aria-hidden": "true"
          }
        )
      ] })
    }
  );
};

// src/components/navigation/Breadcrumbs.tsx
import { jsx as jsx53, jsxs as jsxs32 } from "react/jsx-runtime";
var Breadcrumbs = ({
  homeText,
  homeHref,
  links
}) => {
  return /* @__PURE__ */ jsx53(
    "ol",
    {
      className: "flex min-h-[45px] grow gap-5 border-b bg-white",
      "aria-label": "Breadcrumb",
      children: links.map((crumb, index) => /* @__PURE__ */ jsx53("li", { className: "flex items-center justify-center ", children: /* @__PURE__ */ jsxs32("div", { className: "flex items-center", children: [
        index > 0 && /* @__PURE__ */ jsx53(
          "svg",
          {
            className: "h-full w-3 flex-shrink-0 text-gray-500",
            viewBox: "0 0 24 44",
            preserveAspectRatio: "none",
            fill: "currentColor",
            "aria-hidden": "true",
            children: /* @__PURE__ */ jsx53("path", { d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" })
          }
        ),
        /* @__PURE__ */ jsx53(EdLink, { name: crumb.name, href: crumb.href, children: /* @__PURE__ */ jsx53(
          "div",
          {
            className: `pl-5 text-sm ${index !== links.length - 1 ? "text-primary-700 " : "text-gray-500"}`,
            children: crumb.name
          }
        ) })
      ] }) }, index))
    }
  );
};

// src/components/navigation/SelectLinks.tsx
import {
  matchPath,
  useNavigate as useNavigate2,
  useLocation
} from "react-router-dom";
import { jsx as jsx54, jsxs as jsxs33 } from "react/jsx-runtime";
function isButtonLink(state) {
  return state.onClick !== void 0;
}
function isCurrent(location, tab) {
  if (isButtonLink(tab)) {
    return tab.current;
  } else {
    return matchPath(location.pathname, tab.to) !== null;
  }
}
var SelectLinks = ({ tabs }) => {
  const navigate = useNavigate2();
  const location = useLocation();
  if (!tabs || tabs.length === 0) {
    return /* @__PURE__ */ jsx54("div", {});
  }
  const current = tabs.find((t) => isCurrent(location, t));
  function onSelect(name) {
    const tab = tabs.find((tab2) => tab2 && tab2.name === name);
    if (tab && isButtonLink(tab)) {
      tab.onClick();
    } else if (tab && !isButtonLink(tab)) {
      navigate(tab.to);
    }
  }
  return /* @__PURE__ */ jsxs33("div", { className: "w-full py-2", children: [
    /* @__PURE__ */ jsx54("label", { htmlFor: "tabs", className: "sr-only", children: "Select a tab" }),
    /* @__PURE__ */ jsx54(
      "select",
      {
        "aria-label": current ? current.name : "Select tab",
        id: "tabs",
        name: "tabs",
        className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
        defaultValue: current ? current.name : "",
        onChange: (e) => onSelect(e.target.value),
        children: tabs.map((tab) => /* @__PURE__ */ jsx54("option", { children: tab.name }, tab.name))
      }
    )
  ] });
};

// src/components/navigation/TabButton.tsx
import { jsx as jsx55 } from "react/jsx-runtime";
var TabButton = ({
  name,
  current,
  onClick
}) => {
  const label = current ? /* @__PURE__ */ jsx55("div", { children: name }) : /* @__PURE__ */ jsx55("div", { children: name });
  const color2 = current ? "primary" : "transparent";
  return /* @__PURE__ */ jsx55(Button, { "aria-label": name, clicked: onClick, color: color2, children: /* @__PURE__ */ jsx55(
    "div",
    {
      className: classNames(
        current ? "" : "text-info-800 hover:text-info-900",
        "rounded-md px-2 text-sm font-medium"
      ),
      children: label
    }
  ) }, name);
};

// src/components/navigation/ButtonTabPills.tsx
import { jsx as jsx56, jsxs as jsxs34 } from "react/jsx-runtime";
var ButtonTabPills = ({ tabs }) => {
  if (!tabs || tabs.length === 0) {
    return /* @__PURE__ */ jsx56("div", {});
  }
  return /* @__PURE__ */ jsxs34("div", { children: [
    /* @__PURE__ */ jsx56("div", { className: "sm:hidden", children: /* @__PURE__ */ jsx56(SelectLinks, { tabs }) }),
    /* @__PURE__ */ jsx56("div", { className: "hidden sm:block", children: /* @__PURE__ */ jsx56("nav", { className: "flex space-x-4", "aria-label": "Tabs", children: tabs.map((tab) => /* @__PURE__ */ jsx56("div", { children: /* @__PURE__ */ jsx56(
      TabButton,
      {
        name: tab.name,
        onClick: tab.onClick,
        current: tab.current
      }
    ) }, tab.name)) }) })
  ] });
};

// src/components/navigation/LinkButton.tsx
import { jsx as jsx57, jsxs as jsxs35 } from "react/jsx-runtime";
var sizes3 = {
  sm: "px-2.5 py-1 text-sm",
  md: "px-3 py-1 text-md",
  lg: "px-3 py-2 text-lg",
  xl: "px-3 py-3 text-xl"
};
var LinkButton = ({
  name,
  current,
  clicked,
  label,
  classes,
  size,
  children
}) => {
  const text = label ? label : name;
  let display = null;
  if (text) {
    display = current ? /* @__PURE__ */ jsx57("div", { className: "font-medium text-blue-600", children: text }) : /* @__PURE__ */ jsx57("div", { children: text });
  }
  const buttonSize = size ?? "sm";
  return /* @__PURE__ */ jsxs35(
    "button",
    {
      onClick: clicked,
      className: classNames(
        current ? "border-info-600 text-info-600" : "border-transparent text-gray-600 hover:border-gray-200 hover:text-gray-700",
        `flex cursor-pointer justify-center whitespace-nowrap border-b-2 font-medium ${sizes3[buttonSize]} ${classes ?? ""}`
      ),
      "aria-current": current ? "page" : void 0,
      children: [
        display,
        " ",
        children
      ]
    },
    name
  );
};

// src/components/navigation/ButtonTabUnderline.tsx
import { jsx as jsx58, jsxs as jsxs36 } from "react/jsx-runtime";
var ButtonTabUnderline = ({ tabs }) => {
  if (!tabs || tabs.length === 0) {
    return /* @__PURE__ */ jsx58("div", {});
  }
  return /* @__PURE__ */ jsxs36("div", { children: [
    /* @__PURE__ */ jsx58("div", { className: "sm:hidden", children: /* @__PURE__ */ jsx58(SelectLinks, { tabs }) }),
    /* @__PURE__ */ jsx58("div", { className: "hidden sm:block", children: /* @__PURE__ */ jsx58("div", { className: "border-b border-gray-200 pb-2", children: /* @__PURE__ */ jsx58("nav", { className: "-mb-px flex space-x-8", "aria-label": "Tabs", children: tabs.map((tab) => /* @__PURE__ */ jsx58(
      LinkButton,
      {
        name: tab.name,
        label: tab.label,
        clicked: tab.onClick,
        current: tab.current
      },
      tab.name
    )) }) }) })
  ] });
};

// src/components/navigation/DynamicBreadcrumb.tsx
import { useMatches } from "react-router-dom";
import { jsx as jsx59, jsxs as jsxs37 } from "react/jsx-runtime";
function isCrumbRoute(item) {
  if (item === null || item === void 0) {
    return false;
  }
  const handle = item.handle;
  return handle?.crumb;
}
var DynamicBreadcrumb = ({ links }) => {
  const matches = useMatches();
  const crumbs = matches.filter(isCrumbRoute).filter((match) => Boolean(match.handle?.crumb)).map((match) => {
    return match.handle.crumb(match.data);
  });
  return /* @__PURE__ */ jsxs37(
    "ol",
    {
      className: "flex hidden h-[45px] grow gap-5 bg-white md:flex",
      "aria-label": "Breadcrumb",
      children: [
        links && links,
        crumbs.map((crumb, index) => /* @__PURE__ */ jsx59("li", { className: "flex items-center justify-center ", children: /* @__PURE__ */ jsxs37("div", { className: "flex items-center", children: [
          index > 0 && /* @__PURE__ */ jsx59(
            "svg",
            {
              className: "h-full w-3 flex-shrink-0 text-gray-500",
              viewBox: "0 0 24 44",
              preserveAspectRatio: "none",
              fill: "currentColor",
              "aria-hidden": "true",
              children: /* @__PURE__ */ jsx59("path", { d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" })
            }
          ),
          /* @__PURE__ */ jsx59(
            "div",
            {
              className: `pl-5 text-sm ${index !== crumbs.length - 1 ? "text-primary-700 " : "text-gray-500"}`,
              children: crumb
            }
          )
        ] }) }, index))
      ]
    }
  );
};

// src/components/navigation/ExpandButton.tsx
import { useCallback as useCallback6 } from "react";
import { useNavigate as useNavigate3 } from "react-router-dom";

// src/components/@shadcn/components/ui/tooltip.tsx
import * as React5 from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { jsx as jsx60 } from "react/jsx-runtime";
var TooltipProvider = TooltipPrimitive.Provider;
var Tooltip = TooltipPrimitive.Root;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = React5.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx60(
  TooltipPrimitive.Content,
  {
    ref,
    sideOffset,
    className: cn(
      "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 overflow-hidden rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-950 shadow-md dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      className
    ),
    ...props
  }
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

// src/components/tooltips/Tooltip.tsx
import { jsx as jsx61, jsxs as jsxs38 } from "react/jsx-runtime";
var ToolTipMessage = ({
  children,
  tooltip,
  styles
}) => {
  return /* @__PURE__ */ jsx61(TooltipProvider, { delayDuration: 200, children: /* @__PURE__ */ jsxs38(Tooltip, { children: [
    /* @__PURE__ */ jsx61(TooltipTrigger, { children }),
    /* @__PURE__ */ jsx61(TooltipContent, { style: styles, children: tooltip })
  ] }) });
};

// src/components/navigation/ExpandButton.tsx
import { jsx as jsx62, jsxs as jsxs39 } from "react/jsx-runtime";
var ExpandButton = ({ to, label }) => {
  const navigate = useNavigate3();
  const toDetail = useCallback6(() => {
    navigate(to);
  }, [navigate, to]);
  return /* @__PURE__ */ jsx62(ToolTipMessage, { tooltip: label, children: /* @__PURE__ */ jsxs39(
    "div",
    {
      className: "cursor-pointer rounded-lg bg-gray-500 p-2 text-white",
      onClick: toDetail,
      children: [
        /* @__PURE__ */ jsx62("div", { className: "sr-only", children: label }),
        /* @__PURE__ */ jsxs39(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg ",
            fill: "none",
            viewBox: "0 0 24 24",
            strokeWidth: 1.5,
            stroke: "currentColor",
            className: "h-6 w-6",
            children: [
              /* @__PURE__ */ jsx62(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                }
              ),
              /* @__PURE__ */ jsx62(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                }
              )
            ]
          }
        )
      ]
    }
  ) });
};

// src/components/navigation/Tabs.tsx
import { Fragment as Fragment19, jsx as jsx63, jsxs as jsxs40 } from "react/jsx-runtime";
var Tabs = ({ tabs, vertical }) => {
  if (!tabs || tabs.length === 0) {
    return /* @__PURE__ */ jsx63("div", {});
  }
  const classes = classNames("flex", vertical ? "flex-col" : "flex-row");
  return /* @__PURE__ */ jsxs40(Fragment19, { children: [
    /* @__PURE__ */ jsx63("div", { className: "@5xl:hidden w-full", children: /* @__PURE__ */ jsx63(SelectLinks, { tabs }) }),
    /* @__PURE__ */ jsx63("div", { className: "@5xl:block hidden", children: /* @__PURE__ */ jsx63("nav", { className: classes, "aria-label": "Tabs", children: tabs.map((tab, i) => {
      return /* @__PURE__ */ jsx63(
        EdTabLink,
        {
          id: tab.id || tab.name,
          to: tab.to,
          externalLink: tab.externalLink,
          label: tab.name,
          isFirst: i === 0,
          isLast: i === tabs.length - 1,
          onClick: tab.onClick
        },
        tab.name
      );
    }) }) })
  ] });
};

// src/components/navigation/TabPills.tsx
import { jsx as jsx64, jsxs as jsxs41 } from "react/jsx-runtime";
var TabPills = ({ tabs }) => {
  if (!tabs || tabs.length === 0) {
    return /* @__PURE__ */ jsx64("div", {});
  }
  return /* @__PURE__ */ jsxs41("div", { children: [
    /* @__PURE__ */ jsx64("div", { className: "sm:hidden", children: /* @__PURE__ */ jsx64(SelectLinks, { tabs }) }),
    /* @__PURE__ */ jsx64("div", { className: "hidden sm:block", children: /* @__PURE__ */ jsx64("nav", { className: "flex space-x-4", "aria-label": "Tabs", children: tabs.map((tab) => /* @__PURE__ */ jsx64(
      EdTextLink,
      {
        id: tab.name,
        to: tab.to,
        label: tab.name
      },
      tab.name
    )) }) })
  ] });
};

// src/components/navigation/TabUnderline.tsx
import { jsx as jsx65, jsxs as jsxs42 } from "react/jsx-runtime";
var TabUnderline = ({
  classes,
  disableResponsive,
  tabs,
  children
}) => {
  if (!tabs || tabs.length === 0) {
    return /* @__PURE__ */ jsx65("div", {});
  }
  const TabbedLinks = () => /* @__PURE__ */ jsx65("div", { className: `flex w-full grow justify-between ${classes}`, children: /* @__PURE__ */ jsxs42(
    "nav",
    {
      className: "-mb-px flex w-full grow justify-between space-x-8",
      "aria-label": "Tabs",
      children: [
        /* @__PURE__ */ jsx65("div", { className: "flex gap-5", children: tabs.map(
          (tab) => tab.icon === void 0 ? /* @__PURE__ */ jsx65(
            EdTextLink,
            {
              id: tab.name + " " + tab.to,
              to: tab.to,
              label: tab.name
            },
            tab.name
          ) : /* @__PURE__ */ jsx65(EdIconLink, { name: tab.name, link: tab }, tab.name)
        ) }),
        children
      ]
    }
  ) });
  if (disableResponsive) {
    return /* @__PURE__ */ jsx65(TabbedLinks, {});
  }
  return /* @__PURE__ */ jsxs42("div", { children: [
    /* @__PURE__ */ jsxs42("div", { className: "sm:hidden", children: [
      /* @__PURE__ */ jsx65(SelectLinks, { tabs }),
      children
    ] }),
    /* @__PURE__ */ jsx65("div", { className: "hidden sm:block", children: /* @__PURE__ */ jsx65(TabbedLinks, {}) })
  ] });
};

// src/components/navigation/linkHOC.tsx
import { jsx as jsx66 } from "react/jsx-runtime";
var linkHOC = (Element2, { link, name }) => function component(props) {
  return /* @__PURE__ */ jsx66(EdLink, { href: link, name, children: /* @__PURE__ */ jsx66(Element2, { ...props }) });
};

// src/components/navigation/Navigation.tsx
import { Fragment as Fragment29 } from "react";
import { Dialog as Dialog2, Transition as Transition5 } from "@headlessui/react";
import { XCircleIcon as XCircleIcon4 } from "@heroicons/react/24/outline";
import { Link as Link3, NavLink as NavLink2 } from "react-router-dom";
import { UserCircleIcon } from "@heroicons/react/24/outline";
import { atom as atom2, useAtom as useAtom2, useSetAtom as useSetAtom2 } from "jotai";

// src/components/logo/Myn.tsx
import { jsx as jsx67, jsxs as jsxs43 } from "react/jsx-runtime";
function Logo({ color: color2 = "#120740" }) {
  return /* @__PURE__ */ jsxs43(
    "svg",
    {
      width: "87",
      height: "50",
      viewBox: "0 0 87 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxs43("g", { filter: "url(#filter0_i_728_361)", children: [
          /* @__PURE__ */ jsx67(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.915 17.8387C9.26276 17.8387 6.83905 20.1787 6.83905 23.4135V33.9786C6.83905 35.4054 5.68234 36.5621 4.25546 36.5621C2.82859 36.5621 1.67188 35.4054 1.67188 33.9786V23.4135C1.67188 17.6369 6.10678 12.6716 11.915 12.6716C15.0143 12.6716 17.7225 14.0853 19.5746 16.2817C21.4267 14.0853 24.1349 12.6716 27.2342 12.6716C33.0424 12.6716 37.4773 17.6369 37.4773 23.4135V33.9786C37.4773 35.4054 36.3206 36.5621 34.8938 36.5621C33.4669 36.5621 32.3102 35.4054 32.3102 33.9786V23.4135C32.3102 20.1787 29.8865 17.8387 27.2342 17.8387C24.5819 17.8387 22.1582 20.1787 22.1582 23.4135V33.9786C22.1582 35.4054 21.0015 36.5621 19.5746 36.5621C18.1477 36.5621 16.991 35.4054 16.991 33.9786V23.4135C16.991 20.1787 14.5673 17.8387 11.915 17.8387Z",
              fill: "url(#paint0_linear_728_361)"
            }
          ),
          /* @__PURE__ */ jsx67(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M74.894 17.8387C72.2417 17.8387 69.818 20.1787 69.818 23.4135V33.9786C69.818 35.4054 68.6613 36.5621 67.2344 36.5621C65.8075 36.5621 64.6508 35.4054 64.6508 33.9786V23.4135C64.6508 17.6369 69.0857 12.6716 74.894 12.6716C80.7023 12.6716 85.1372 17.6369 85.1372 23.4135V33.9786C85.1372 35.4054 83.9804 36.5621 82.5536 36.5621C81.1267 36.5621 79.97 35.4054 79.97 33.9786V23.4135C79.97 20.1787 77.5463 17.8387 74.894 17.8387Z",
              fill: "url(#paint1_linear_728_361)"
            }
          ),
          /* @__PURE__ */ jsx67(
            "path",
            {
              d: "M56.1399 25.8205C56.1399 29.0553 53.7162 31.3952 51.0639 31.3952C48.4116 31.3952 45.9879 29.0553 45.9879 25.8205L45.9879 15.2554C45.9879 13.8285 44.8312 12.6718 43.4043 12.6718C41.9774 12.6718 40.8207 13.8285 40.8207 15.2554V25.8205C40.8207 31.5971 45.2556 36.5624 51.0639 36.5624C52.9319 36.5624 54.6578 36.0488 56.1399 35.1599V38.5712C56.1399 41.8587 53.7286 44.1611 51.1837 44.1611C49.6367 44.1611 48.1891 43.3513 47.2442 41.9591C46.4429 40.7784 44.8363 40.4709 43.6556 41.2722C42.475 42.0734 42.1674 43.6801 42.9687 44.8607C44.7689 47.5133 47.7432 49.3283 51.1837 49.3283C56.967 49.3283 61.3071 44.3119 61.3071 38.5712V26.3192C61.3071 26.2646 61.3054 26.2105 61.302 26.1568C61.3054 26.045 61.3071 25.9329 61.3071 25.8205V15.2554C61.3071 13.8285 60.1503 12.6718 58.7235 12.6718C57.2966 12.6718 56.1399 13.8285 56.1399 15.2554V25.8205Z",
              fill: "url(#paint2_linear_728_361)"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs43("defs", { children: [
          /* @__PURE__ */ jsxs43(
            "filter",
            {
              id: "filter0_i_728_361",
              x: "1.67188",
              y: "12.6716",
              width: "84.4653",
              height: "37.6567",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ jsx67("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx67(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ jsx67(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ jsx67("feOffset", { dx: "1", dy: "2" }),
                /* @__PURE__ */ jsx67("feGaussianBlur", { stdDeviation: "0.5" }),
                /* @__PURE__ */ jsx67("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ jsx67(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                  }
                ),
                /* @__PURE__ */ jsx67(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_728_361"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs43(
            "linearGradient",
            {
              id: "paint0_linear_728_361",
              x1: "117.5",
              y1: "-1.58624e-06",
              x2: "-26",
              y2: "41.5",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx67("stop", { offset: "0.0539898", stopColor: "#CFB8FF" }),
                /* @__PURE__ */ jsx67("stop", { offset: "0.317815", stopColor: "#9569F3" }),
                /* @__PURE__ */ jsx67("stop", { offset: "0.789589", stopColor: "#2C0F68" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs43(
            "linearGradient",
            {
              id: "paint1_linear_728_361",
              x1: "117.5",
              y1: "-1.58624e-06",
              x2: "-26",
              y2: "41.5",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx67("stop", { offset: "0.0539898", stopColor: "#CFB8FF" }),
                /* @__PURE__ */ jsx67("stop", { offset: "0.317815", stopColor: "#9569F3" }),
                /* @__PURE__ */ jsx67("stop", { offset: "0.789589", stopColor: "#2C0F68" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs43(
            "linearGradient",
            {
              id: "paint2_linear_728_361",
              x1: "117.5",
              y1: "-1.58624e-06",
              x2: "-26",
              y2: "41.5",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx67("stop", { offset: "0.0539898", stopColor: "#CFB8FF" }),
                /* @__PURE__ */ jsx67("stop", { offset: "0.317815", stopColor: "#9569F3" }),
                /* @__PURE__ */ jsx67("stop", { offset: "0.789589", stopColor: "#2C0F68" })
              ]
            }
          )
        ] })
      ]
    }
  );
}

// src/components/logo/Elevate.tsx
import { jsx as jsx68 } from "react/jsx-runtime";
function Logo2({ color: color2 = "#120740" }) {
  return /* @__PURE__ */ jsx68(
    "svg",
    {
      width: "82",
      height: "16",
      viewBox: "0 0 125 28",
      fill: color2,
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx68("path", { d: "M10.071 27.3835C8.10227 27.3835 6.40199 26.9744 4.97017 26.1562C3.54688 25.3295 2.4517 24.1619 1.68466 22.6534C0.917614 21.1364 0.534091 19.3509 0.534091 17.2969C0.534091 15.277 0.917614 13.5043 1.68466 11.9787C2.46023 10.4446 3.54261 9.25142 4.93182 8.39915C6.32102 7.53835 7.95312 7.10795 9.82812 7.10795C11.0384 7.10795 12.1804 7.30398 13.2543 7.69602C14.3366 8.07954 15.2912 8.67614 16.1179 9.4858C16.9531 10.2955 17.6094 11.3267 18.0866 12.5795C18.5639 13.8239 18.8026 15.3068 18.8026 17.0284V18.4474H2.70739V15.3281H14.3665C14.358 14.4418 14.1662 13.6534 13.7912 12.9631C13.4162 12.2642 12.892 11.7145 12.2188 11.3139C11.554 10.9134 10.7784 10.7131 9.89205 10.7131C8.94602 10.7131 8.11506 10.9432 7.39915 11.4034C6.68324 11.8551 6.125 12.4517 5.72443 13.1932C5.33239 13.9261 5.1321 14.7315 5.12358 15.6094V18.3324C5.12358 19.4744 5.33239 20.4545 5.75 21.2727C6.16761 22.0824 6.75142 22.7045 7.50142 23.1392C8.25142 23.5653 9.12926 23.7784 10.1349 23.7784C10.8082 23.7784 11.4176 23.6847 11.9631 23.4972C12.5085 23.3011 12.9815 23.0156 13.3821 22.6406C13.7827 22.2656 14.0852 21.8011 14.2898 21.2472L18.6108 21.733C18.3381 22.875 17.8182 23.8722 17.0511 24.7244C16.2926 25.5682 15.321 26.2244 14.1364 26.6932C12.9517 27.1534 11.5966 27.3835 10.071 27.3835ZM27.3455 0.818181V27H22.7177V0.818181H27.3455ZM40.7976 27.3835C38.8288 27.3835 37.1286 26.9744 35.6967 26.1562C34.2734 25.3295 33.1783 24.1619 32.4112 22.6534C31.6442 21.1364 31.2607 19.3509 31.2607 17.2969C31.2607 15.277 31.6442 13.5043 32.4112 11.9787C33.1868 10.4446 34.2692 9.25142 35.6584 8.39915C37.0476 7.53835 38.6797 7.10795 40.5547 7.10795C41.7649 7.10795 42.907 7.30398 43.9808 7.69602C45.0632 8.07954 46.0178 8.67614 46.8445 9.4858C47.6797 10.2955 48.3359 11.3267 48.8132 12.5795C49.2905 13.8239 49.5291 15.3068 49.5291 17.0284V18.4474H33.4339V15.3281H45.093C45.0845 14.4418 44.8928 13.6534 44.5178 12.9631C44.1428 12.2642 43.6186 11.7145 42.9453 11.3139C42.2805 10.9134 41.505 10.7131 40.6186 10.7131C39.6726 10.7131 38.8416 10.9432 38.1257 11.4034C37.4098 11.8551 36.8516 12.4517 36.451 13.1932C36.0589 13.9261 35.8587 14.7315 35.8501 15.6094V18.3324C35.8501 19.4744 36.0589 20.4545 36.4766 21.2727C36.8942 22.0824 37.478 22.7045 38.228 23.1392C38.978 23.5653 39.8558 23.7784 40.8615 23.7784C41.5348 23.7784 42.1442 23.6847 42.6896 23.4972C43.2351 23.3011 43.7081 23.0156 44.1087 22.6406C44.5092 22.2656 44.8118 21.8011 45.0163 21.2472L49.3374 21.733C49.0646 22.875 48.5447 23.8722 47.7777 24.7244C47.0192 25.5682 46.0476 26.2244 44.8629 26.6932C43.6783 27.1534 42.3232 27.3835 40.7976 27.3835ZM70.4215 7.36364L63.4286 27H58.315L51.3221 7.36364H56.2567L60.7695 21.9503H60.9741L65.4996 7.36364H70.4215ZM78.712 27.3963C77.4677 27.3963 76.3469 27.1747 75.3498 26.7315C74.3612 26.2798 73.5771 25.6151 72.9975 24.7372C72.4265 23.8594 72.141 22.777 72.141 21.4901C72.141 20.3821 72.3455 19.4659 72.7546 18.7415C73.1637 18.017 73.7219 17.4375 74.4293 17.0028C75.1367 16.5682 75.9336 16.2401 76.82 16.0185C77.7148 15.7884 78.6396 15.6222 79.5941 15.5199C80.7447 15.4006 81.6779 15.294 82.3938 15.2003C83.1097 15.098 83.6296 14.9446 83.9535 14.7401C84.2859 14.527 84.4521 14.1989 84.4521 13.7557V13.679C84.4521 12.7159 84.1665 11.9702 83.5955 11.4418C83.0245 10.9134 82.2021 10.6491 81.1282 10.6491C79.9947 10.6491 79.0955 10.8963 78.4308 11.3906C77.7745 11.8849 77.3313 12.4687 77.1012 13.142L72.7802 12.5284C73.1211 11.3352 73.6836 10.3381 74.4677 9.53693C75.2518 8.72727 76.2106 8.12216 77.3441 7.72159C78.4776 7.3125 79.7305 7.10795 81.1026 7.10795C82.0487 7.10795 82.9904 7.21875 83.9279 7.44034C84.8654 7.66193 85.7219 8.02841 86.4975 8.53977C87.2731 9.04261 87.8952 9.72869 88.364 10.598C88.8413 11.4673 89.0799 12.554 89.0799 13.858V27H84.631V24.3026H84.4776C84.1964 24.848 83.8001 25.3594 83.2887 25.8366C82.7859 26.3054 82.1509 26.6847 81.3839 26.9744C80.6254 27.2557 79.7347 27.3963 78.712 27.3963ZM79.9137 23.9957C80.8427 23.9957 81.6481 23.8125 82.3299 23.446C83.0117 23.071 83.5359 22.5767 83.9023 21.9631C84.2773 21.3494 84.4648 20.6804 84.4648 19.956V17.642C84.32 17.7614 84.0728 17.8722 83.7234 17.9744C83.3825 18.0767 82.9989 18.1662 82.5728 18.2429C82.1467 18.3196 81.7248 18.3878 81.3072 18.4474C80.8896 18.5071 80.5273 18.5582 80.2205 18.6009C79.5302 18.6946 78.9123 18.848 78.3668 19.0611C77.8214 19.2741 77.391 19.5724 77.0756 19.956C76.7603 20.331 76.6026 20.8168 76.6026 21.4134C76.6026 22.2656 76.9137 22.9091 77.5359 23.3438C78.158 23.7784 78.9506 23.9957 79.9137 23.9957ZM103.539 7.36364V10.9432H92.2504V7.36364H103.539ZM95.0373 2.65909H99.6651V21.0938C99.6651 21.7159 99.7589 22.1932 99.9464 22.5256C100.142 22.8494 100.398 23.071 100.713 23.1903C101.029 23.3097 101.378 23.3693 101.762 23.3693C102.051 23.3693 102.316 23.348 102.554 23.3054C102.801 23.2628 102.989 23.2244 103.117 23.1903L103.897 26.8082C103.65 26.8935 103.296 26.9872 102.836 27.0895C102.384 27.1918 101.83 27.2514 101.174 27.2685C100.015 27.3026 98.9705 27.1278 98.0415 26.7443C97.1126 26.3523 96.3754 25.7472 95.8299 24.929C95.293 24.1108 95.0288 23.0881 95.0373 21.8608V2.65909ZM115.891 27.3835C113.923 27.3835 112.222 26.9744 110.79 26.1562C109.367 25.3295 108.272 24.1619 107.505 22.6534C106.738 21.1364 106.354 19.3509 106.354 17.2969C106.354 15.277 106.738 13.5043 107.505 11.9787C108.281 10.4446 109.363 9.25142 110.752 8.39915C112.141 7.53835 113.773 7.10795 115.648 7.10795C116.859 7.10795 118.001 7.30398 119.075 7.69602C120.157 8.07954 121.112 8.67614 121.938 9.4858C122.773 10.2955 123.43 11.3267 123.907 12.5795C124.384 13.8239 124.623 15.3068 124.623 17.0284V18.4474H108.528V15.3281H120.187C120.178 14.4418 119.987 13.6534 119.612 12.9631C119.237 12.2642 118.712 11.7145 118.039 11.3139C117.374 10.9134 116.599 10.7131 115.712 10.7131C114.766 10.7131 113.935 10.9432 113.219 11.4034C112.504 11.8551 111.945 12.4517 111.545 13.1932C111.153 13.9261 110.952 14.7315 110.944 15.6094V18.3324C110.944 19.4744 111.153 20.4545 111.57 21.2727C111.988 22.0824 112.572 22.7045 113.322 23.1392C114.072 23.5653 114.95 23.7784 115.955 23.7784C116.629 23.7784 117.238 23.6847 117.783 23.4972C118.329 23.3011 118.802 23.0156 119.202 22.6406C119.603 22.2656 119.906 21.8011 120.11 21.2472L124.431 21.733C124.158 22.875 123.638 23.8722 122.871 24.7244C122.113 25.5682 121.141 26.2244 119.957 26.6932C118.772 27.1534 117.417 27.3835 115.891 27.3835Z" })
    }
  );
}

// src/components/logo/AppSvg.tsx
import { jsx as jsx69 } from "react/jsx-runtime";
var AppSvg = (props) => {
  const url = window.location.href;
  if (url.includes("myn")) {
    return /* @__PURE__ */ jsx69(Logo, { ...props });
  }
  return /* @__PURE__ */ jsx69(Logo2, { ...props });
};

// src/components/layouts/ElevateBox.tsx
import { jsx as jsx70 } from "react/jsx-runtime";
var ElevateBox = ({
  size,
  children,
  classes
}) => {
  const className = `bg-white px-6 py-4 pt-5 pb-10 border sm:shadow ${classes}`;
  return /* @__PURE__ */ jsx70("div", { className, children });
};

// src/components/layouts/ElevateCentered.tsx
import { jsx as jsx71 } from "react/jsx-runtime";
var ElevateCentered = ({
  size,
  children
}) => {
  return /* @__PURE__ */ jsx71("div", { className: "flex items-center justify-center", children });
};

// src/components/layouts/ElevateHeader.tsx
import { jsx as jsx72, jsxs as jsxs44 } from "react/jsx-runtime";
var ElevateHeader = ({
  title,
  subTitle,
  size
}) => {
  return /* @__PURE__ */ jsxs44("div", { className: "border-b p-2", children: [
    /* @__PURE__ */ jsx72("h1", { className: "text-info-700 pb-2 text-2xl", children: title }),
    /* @__PURE__ */ jsx72("h1", { className: "text-info-900 pb-4 text-lg", children: subTitle })
  ] });
};

// src/components/layouts/ListLayout.tsx
import {
  isValidElement as isValidElement3,
  createContext,
  useCallback as useCallback10,
  useContext,
  useEffect as useEffect5,
  useRef as useRef2,
  useState as useState16
} from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import { FunnelIcon as FunnelIconOutline } from "@heroicons/react/24/outline";
import { FunnelIcon as FunnelIconSolid } from "@heroicons/react/24/solid";
import { atom, useAtom } from "jotai";
import { noop, useDebounce as useDebounce2 } from "shared-lib";

// src/components/lists/grids/GridLayout.tsx
import { jsx as jsx73 } from "react/jsx-runtime";
var EdGridLayout = ({ children, ...props }) => /* @__PURE__ */ jsx73(
  "div",
  {
    className: "grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
    ...props,
    children
  }
);

// src/components/lists/grids/Grid.tsx
import { useMemo as useMemo2 } from "react";
import { useTable } from "react-table";
import { jsx as jsx74 } from "react/jsx-runtime";
var EdGrid = ({ columns, data }) => {
  const tableColumns = useMemo2(() => columns, []);
  const tableData = useMemo2(() => data, [data]);
  const tableInstance = useTable({ columns: tableColumns, data: tableData });
  return /* @__PURE__ */ jsx74("div", {});
};

// src/components/lists/lists/Lists.tsx
import { isNotNullOrUndefinedOrEmpty } from "shared-lib";
import { jsxs as jsxs45 } from "react/jsx-runtime";
function displayList(list) {
  return listElementMap(list, ({ item, index, isLast }) => /* @__PURE__ */ jsxs45("span", { className: "mr-1", children: [
    item,
    !isLast && ","
  ] }, index));
}
function listElementMap(list, factory) {
  if (list == void 0 || list.length == 0) {
    return [];
  }
  const elements = list.filter(
    isNotNullOrUndefinedOrEmpty
  );
  return elements.map(
    (e, i) => factory({
      item: e,
      index: i,
      isFirst: i == 0,
      isLast: i == elements.length - 1
    })
  );
}

// src/components/lists/tables/EdColumnCell.tsx
import { jsx as jsx75 } from "react/jsx-runtime";
var EdColumnCell = ({
  wrap,
  children,
  className = ""
}) => {
  return /* @__PURE__ */ jsx75(
    "td",
    {
      className: classNames(
        "px-6 py-4",
        wrap ? "" : "whitespace-nowrap",
        className
      ),
      children
    }
  );
};
var EdActionCell = ({
  children
}) => {
  return /* @__PURE__ */ jsx75("td", { className: "whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children });
};

// src/components/lists/tables/EdColumnSort.tsx
import { useCallback as useCallback7 } from "react";
import {
  ChevronDoubleUpIcon,
  ChevronDoubleDownIcon,
  XCircleIcon
} from "@heroicons/react/24/solid";

// src/components/lists/tables/lib.ts
import { replaceItemInList as replaceItemInList2 } from "shared-lib";
var SortDir = /* @__PURE__ */ ((SortDir2) => {
  SortDir2["Asc"] = "ASC";
  SortDir2["Desc"] = "DESC";
  return SortDir2;
})(SortDir || {});
function selectColumn(id3, columns) {
  const column = columns.find((c) => c.id === id3);
  if (!column) {
    return null;
  }
  if (column.sort && column.sortValue) {
    return column.sortValue;
  } else {
    return null;
  }
}
function updateTableColumnSort(id3, sortDir, columns) {
  const existingColumn = columns.find((c) => c.id === id3);
  if (!existingColumn) {
    return columns;
  }
  const newColumn = {
    ...existingColumn,
    sortValue: sortDir
  };
  const updateColumns = replaceItemInList2(
    columns,
    existingColumn,
    newColumn
  );
  return updateColumns;
}
function removeTableColumnSort(id3, columns) {
  const existingColumn = columns.find((c) => c.id === id3);
  if (!existingColumn) {
    return columns;
  }
  const newColumn = {
    ...existingColumn,
    sortValue: void 0
  };
  const updateColumns = replaceItemInList2(
    columns,
    existingColumn,
    newColumn
  );
  return updateColumns;
}

// src/components/lists/tables/EdColumnSort.tsx
import { jsx as jsx76, jsxs as jsxs46 } from "react/jsx-runtime";
var EdColumnSort = ({
  column,
  onSortChanged,
  onSortCleared
}) => {
  const sortChanged = useCallback7((sortDir) => {
    onSortChanged({ id: column.id, sortDir });
  }, []);
  const sortCleared = useCallback7(() => {
    onSortCleared(column.id);
  }, []);
  if (!column.sort) {
    return null;
  }
  if (!column.sortValue) {
    return /* @__PURE__ */ jsxs46("div", { className: "flex", children: [
      /* @__PURE__ */ jsx76(
        ChevronDoubleUpIcon,
        {
          className: "ml-2 h-5 w-5",
          "aria-hidden": "true",
          onClick: () => {
            sortChanged("ASC" /* Asc */);
          }
        }
      ),
      /* @__PURE__ */ jsx76(
        ChevronDoubleDownIcon,
        {
          className: "h-5 w-5",
          "aria-hidden": "true",
          onClick: () => {
            sortChanged("DESC" /* Desc */);
          }
        }
      )
    ] });
  }
  if (column.sortValue === "DESC" /* Desc */) {
    return /* @__PURE__ */ jsxs46("div", { className: "flex", children: [
      /* @__PURE__ */ jsx76(
        ChevronDoubleDownIcon,
        {
          className: "ml-2 h-5 w-5",
          "aria-hidden": "true",
          onClick: () => {
            sortChanged("ASC" /* Asc */);
          }
        }
      ),
      /* @__PURE__ */ jsx76(
        XCircleIcon,
        {
          className: "h-5 w-5",
          "aria-hidden": "true",
          onClick: () => {
            sortCleared();
          }
        }
      )
    ] });
  }
  if (column.sortValue === "ASC" /* Asc */) {
    return /* @__PURE__ */ jsxs46("div", { className: "flex", children: [
      /* @__PURE__ */ jsx76(
        ChevronDoubleUpIcon,
        {
          className: "ml-2 h-5 w-5",
          "aria-hidden": "true",
          onClick: () => {
            sortChanged("DESC" /* Desc */);
          }
        }
      ),
      /* @__PURE__ */ jsx76(
        XCircleIcon,
        {
          className: "h-5 w-5",
          "aria-hidden": "true",
          onClick: () => {
            sortCleared();
          }
        }
      )
    ] });
  }
  return null;
};

// src/components/lists/tables/EdRow.tsx
import { jsx as jsx77 } from "react/jsx-runtime";
var EdRow = ({
  children,
  clicked,
  rowKey,
  bordered,
  className = "hover:bg-gray-50"
}) => {
  return /* @__PURE__ */ jsx77(
    "tr",
    {
      onClick: clicked,
      className: classNames(
        "cursor-pointer",
        bordered ? "divide-x-2" : "",
        className
      ),
      children
    },
    rowKey
  );
};

// src/components/lists/tables/EdTable.tsx
import { useCallback as useCallback8, useState as useState14 } from "react";
import { jsx as jsx78, jsxs as jsxs47 } from "react/jsx-runtime";
var EdTable = ({
  defaultColumns,
  rows,
  fixedHeight = true,
  onSortChanged,
  hasActionsColumn = true,
  classes
}) => {
  const [columns, setColumns] = useState14(defaultColumns);
  const sortDirChanged = useCallback8(
    (e) => {
      if (!onSortChanged) {
        return;
      }
      const updatedColumns = updateTableColumnSort(e.id, e.sortDir, columns);
      setColumns(updatedColumns);
      if (onSortChanged) {
        onSortChanged(updatedColumns);
      }
    },
    [columns]
  );
  const sortDirCleared = useCallback8(
    (id3) => {
      if (!onSortChanged) {
        return;
      }
      const updatedColumns = removeTableColumnSort(id3, columns);
      setColumns(updatedColumns);
      if (onSortChanged) {
        onSortChanged(updatedColumns);
      }
    },
    [columns]
  );
  return /* @__PURE__ */ jsx78(
    "div",
    {
      className: classNames(
        "w-full overflow-y-auto",
        fixedHeight ? "max-h-[60vh]" : "",
        classes ? classes : ""
      ),
      children: /* @__PURE__ */ jsx78("div", { className: "inline-block min-w-full overflow-y-auto rounded-md border border-gray-200 align-middle shadow", children: /* @__PURE__ */ jsxs47("table", { className: "min-w-full divide-y divide-gray-200", children: [
        /* @__PURE__ */ jsx78("thead", { className: "bg-gray-50", children: /* @__PURE__ */ jsxs47("tr", { children: [
          columns.map((column) => /* @__PURE__ */ jsx78(
            "th",
            {
              scope: "col",
              className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
              children: /* @__PURE__ */ jsxs47("div", { className: "flex", children: [
                /* @__PURE__ */ jsx78("span", { children: column.name }),
                /* @__PURE__ */ jsx78(
                  EdColumnSort,
                  {
                    column,
                    onSortChanged: sortDirChanged,
                    onSortCleared: sortDirCleared
                  }
                )
              ] })
            },
            column.name
          )),
          hasActionsColumn && /* @__PURE__ */ jsx78("th", { scope: "col", className: "relative px-6 py-3", children: /* @__PURE__ */ jsx78("span", { className: "sr-only", children: "Actions" }) })
        ] }) }),
        /* @__PURE__ */ jsx78("tbody", { className: "divide-y divide-gray-200 overflow-y-auto bg-white", children: rows })
      ] }) })
    }
  );
};

// src/components/lists/flatlist/FlatList.tsx
import { useCallback as useCallback9, useEffect as useEffect4, useRef, useState as useState15 } from "react";
import { useDebounce } from "shared-lib";
import { Fragment as Fragment20, jsx as jsx79, jsxs as jsxs48 } from "react/jsx-runtime";
function FlatList(props) {
  function handleScroll() {
    const bottom = this.scrollHeight - this.scrollTop - this.clientHeight < 1;
    if (bottom) {
      props.onEndReached(this.scrollHeight);
    }
  }
  const ref = useRef(null);
  const [height, setHeight] = useState15(window.innerHeight);
  const debouncedHeight = useDebounce(height, 50);
  const setSidebarHeight = useCallback9(() => {
    setHeight(window.innerHeight - (ref.current?.offsetTop || 0));
  }, []);
  useEffect4(() => {
    window.addEventListener("resize", setSidebarHeight);
    setSidebarHeight();
    return () => window.removeEventListener("resize", setSidebarHeight);
  }, [ref]);
  return /* @__PURE__ */ jsx79(Fragment20, { children: /* @__PURE__ */ jsxs48(
    "div",
    {
      onScroll: (e) => handleScroll.call(e.target),
      className: props.className || "relative w-full md:block md:h-screen md:overflow-scroll",
      style: props.style || { height: `${debouncedHeight}px` },
      ref,
      children: [
        props.data.map(props.renderItem),
        props.isLoading && /* @__PURE__ */ jsx79("div", { className: "flex justify-center py-5", children: /* @__PURE__ */ jsx79(Spinner, {}) })
      ]
    }
  ) });
}

// src/components/layouts/MobileHeader.tsx
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate as useNavigate4 } from "react-router-dom";
import { useSetAtom } from "jotai";
import { jsx as jsx80, jsxs as jsxs49 } from "react/jsx-runtime";
var MobileHeader = ({
  title,
  showBackButton = true,
  showMobileNavIcon = true,
  expandLink
}) => {
  const setHideMobileSublist = useSetAtom(listLayoutAtom);
  const navigate = useNavigate4();
  return /* @__PURE__ */ jsxs49(
    "div",
    {
      className: classNames(
        "flex min-h-[64px] w-full items-center justify-between gap-2 bg-white px-5 py-2 lg:flex-row"
      ),
      children: [
        showBackButton && /* @__PURE__ */ jsx80("div", { className: "lg:hidden", children: /* @__PURE__ */ jsxs49(
          "div",
          {
            onClick: () => {
              setHideMobileSublist(false);
              navigate(-1);
            },
            className: classNames(
              "text-primary-500  flex cursor-pointer items-center justify-center rounded-2xl text-sm",
              !showBackButton && "invisible"
            ),
            children: [
              /* @__PURE__ */ jsx80(ChevronLeftIcon, { className: "h-5 w-4" }),
              " Back"
            ]
          }
        ) }),
        title,
        expandLink && /* @__PURE__ */ jsx80("div", { className: "hidden xl:flex", children: /* @__PURE__ */ jsx80(ExpandButton, { to: expandLink, label: "Expand Chat" }) })
      ]
    }
  );
};

// src/components/suspense/Suspense.tsx
import {
  Suspense as ReactSuspense
} from "react";
import { jsx as jsx81 } from "react/jsx-runtime";
var Suspense = ({
  children,
  fallback
}) => {
  if (!fallback) {
    fallback = /* @__PURE__ */ jsx81(Loading, {});
  }
  if (typeof fallback === "string") {
    fallback = /* @__PURE__ */ jsx81("div", { className: "my-10", children: /* @__PURE__ */ jsx81(Loading, { label: fallback }) });
  }
  return /* @__PURE__ */ jsx81(ReactSuspense, { fallback, children });
};

// src/components/layouts/ListLayout.tsx
import { Fragment as Fragment21, jsx as jsx82, jsxs as jsxs50 } from "react/jsx-runtime";
var MobileItem = ({ sections, s, actionIdx }) => {
  const titleIsElement = isValidElement3(s.listTitle);
  return /* @__PURE__ */ jsxs50(
    "div",
    {
      className: classNames(
        actionIdx === 0 ? "" : "",
        actionIdx === 1 ? "sm:rounded-tr-lg" : "",
        actionIdx === sections.length - 2 ? "sm:rounded-bl-lg" : "",
        actionIdx === sections.length - 1 ? "" : "",
        "group relative cursor-pointer border-b bg-white px-2 py-4 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500 hover:bg-gray-50 sm:p-6"
      ),
      children: [
        s.highlight && /* @__PURE__ */ jsxs50("span", { className: "absolute right-3 top-3 flex h-3 w-3", children: [
          /* @__PURE__ */ jsx82("span", { className: "absolute inline-flex h-full w-full animate-ping rounded-full bg-sky-400 opacity-75" }),
          /* @__PURE__ */ jsx82("span", { className: "relative inline-flex h-3 w-3 rounded-full bg-sky-500" })
        ] }),
        /* @__PURE__ */ jsx82("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsxs50("div", { className: "flex flex-grow flex-col", children: [
          /* @__PURE__ */ jsxs50("div", { className: "flex items-center gap-3 space-x-2", children: [
            !s.hideIcon && s.icon && /* @__PURE__ */ jsx82(
              "span",
              {
                className: classNames(
                  s.iconBackground || "text-primary-700",
                  s.iconForeground || "bg-primary-50",
                  "hidden rounded-lg p-3 ring-4 ring-white sm:inline-flex"
                ),
                children: /* @__PURE__ */ jsx82(s.icon, { className: "h-6 w-6", "aria-hidden": "true" })
              }
            ),
            /* @__PURE__ */ jsx82("h3", { className: "font-medium sm:w-auto sm:text-lg", children: /* @__PURE__ */ jsxs50(EdLink, { href: `${s.key}`, name: s.key, children: [
              /* @__PURE__ */ jsx82("span", { className: "absolute inset-0", "aria-hidden": "true" }),
              titleIsElement ? s.listTitle : /* @__PURE__ */ jsxs50("div", { className: "flex grow items-center gap-3", children: [
                !s.hideIcon && s.icon && /* @__PURE__ */ jsx82("div", { className: "flex w-10 items-center justify-center rounded-lg bg-white p-1 sm:hidden", children: /* @__PURE__ */ jsx82(s.icon, { className: "w-full", "aria-hidden": "true" }) }),
                /* @__PURE__ */ jsxs50("div", { className: "flex flex-col", children: [
                  /* @__PURE__ */ jsx82("p", { className: "text-info-gray-900 text-md", children: s.listTitle }),
                  /* @__PURE__ */ jsx82("p", { className: "text-sm text-gray-600", children: s.listSubtitle })
                ] })
              ] })
            ] }, s.key + "-mobile") })
          ] }),
          s.description && /* @__PURE__ */ jsx82("p", { className: "mt-4 text-sm text-gray-500", children: s.description })
        ] }) })
      ]
    },
    s.key
  );
};
function useListLayoutContext() {
  return useOutletContext();
}
var ListLayoutMobileList = () => {
  const sections = useListLayoutContext();
  return /* @__PURE__ */ jsx82("div", { className: "divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 shadow xl:hidden", children: /* @__PURE__ */ jsx82(
    FlatList,
    {
      data: sections,
      renderItem: (section, index, sections2) => /* @__PURE__ */ jsx82(Suspense, { fallback: "Loading...", children: /* @__PURE__ */ jsx82(MobileItem, { s: section, actionIdx: index, sections: sections2 }) }),
      isLoading: false,
      onEndReached: () => console.log(`ListLayoutMobileList End Reached`)
    }
  ) });
};
var ListLayoutRoot = () => {
  const ref = useRef2(null);
  const [height, setHeight] = useState16(window.innerHeight);
  const debouncedHeight = useDebounce2(height, 50);
  const setSidebarHeight = useCallback10(() => {
    setHeight(window.innerHeight - (ref.current?.offsetTop || 0));
  }, []);
  useEffect5(() => {
    setSidebarHeight();
  }, [ref, setSidebarHeight]);
  useEffect5(() => {
    window.addEventListener("resize", setSidebarHeight);
    setSidebarHeight();
    return () => window.removeEventListener("resize", setSidebarHeight);
  }, [ref, setSidebarHeight]);
  return /* @__PURE__ */ jsx82(
    "div",
    {
      ref,
      style: { height: debouncedHeight },
      className: "w-full overflow-scroll",
      children: /* @__PURE__ */ jsx82(Outlet, {})
    }
  );
};
var ListLayoutContext = createContext({
  filterComponent: /* @__PURE__ */ jsx82(Fragment21, {}),
  setFilterComponent: noop,
  paginationComponent: /* @__PURE__ */ jsx82(Fragment21, {}),
  setPaginationComponent: noop
});
var listLayoutAtom = atom(false);
var ListLayout = ({
  title,
  sections,
  loadMore = () => 0,
  isLoading = false,
  shrinkSidebar = false,
  showFilters = false,
  showMobileNavIcon = false,
  listHeader,
  children
}) => {
  const [current, setCurrent] = useState16(null);
  const [filtersActive, setFiltersActive] = useState16(false);
  const [filterComponent, setFilterComponent] = useState16(/* @__PURE__ */ jsx82(Fragment21, {}));
  const [paginationComponent, setPaginationComponent] = useState16(/* @__PURE__ */ jsx82(Fragment21, {}));
  const [hideSidebar, setHideSidebar] = useAtom(listLayoutAtom);
  useEffect5(() => {
    return () => {
      setHideSidebar(false);
    };
  }, [setHideSidebar]);
  const item = (s) => {
    const titleIsElement = isValidElement3(s.listTitle);
    return /* @__PURE__ */ jsxs50("div", { className: "w-full", children: [
      /* @__PURE__ */ jsx82("div", { className: "flex w-full xl:hidden", children: /* @__PURE__ */ jsx82(
        Link2,
        {
          id: `project-${s.key}-mobile`,
          sectionData: {
            ...s,
            key: s.mobileLink || s.key
          },
          current,
          setCurrent,
          shrinkSidebar,
          titleIsElement
        }
      ) }),
      /* @__PURE__ */ jsx82("div", { className: "hidden w-full xl:flex", children: /* @__PURE__ */ jsx82(
        Link2,
        {
          id: `project-${s.key}-desktop`,
          sectionData: s,
          current,
          setCurrent,
          shrinkSidebar,
          titleIsElement
        }
      ) })
    ] }, s.key);
  };
  const leftSidebarList = /* @__PURE__ */ jsx82(
    FlatList,
    {
      data: sections,
      renderItem: item,
      onEndReached: loadMore,
      isLoading
    }
  );
  return /* @__PURE__ */ jsxs50(
    ListLayoutContext.Provider,
    {
      value: {
        filterComponent,
        setFilterComponent,
        paginationComponent,
        setPaginationComponent
      },
      children: [
        /* @__PURE__ */ jsx82("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ jsxs50("div", { className: "w-full min-w-0 flex-1 xl:flex", children: [
          /* @__PURE__ */ jsxs50(
            "nav",
            {
              "aria-label": "Sections",
              className: classNames(
                "border-info-gray-200 flex-shrink-0 border-r bg-white transition-[width] xl:flex xl:w-96 xl:flex-col",
                shrinkSidebar ? "w-40" : " "
              ),
              children: [
                (title || showFilters) && /* @__PURE__ */ jsxs50(
                  "div",
                  {
                    className: classNames(
                      "border-info-gray-200 h-16 flex-shrink-0 items-center justify-between border-b",
                      hideSidebar ? "hidden xl:flex" : "flex"
                    ),
                    children: [
                      /* @__PURE__ */ jsx82(
                        MobileHeader,
                        {
                          showMobileNavIcon,
                          showBackButton: false,
                          title: /* @__PURE__ */ jsx82("h1", { className: "flex w-full grow py-2 text-center text-2xl font-medium text-gray-700 md:text-right xl:text-left", children: title })
                        }
                      ),
                      showFilters && /* @__PURE__ */ jsx82(
                        "div",
                        {
                          onClick: () => setFiltersActive(!filtersActive),
                          className: "pr-5",
                          children: filtersActive ? /* @__PURE__ */ jsx82(FunnelIconSolid, { className: "h-6 w-6" }) : /* @__PURE__ */ jsx82(FunnelIconOutline, { className: "h-6 w-6" })
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ jsxs50(
                  "div",
                  {
                    className: classNames(
                      "relative min-h-0 flex-1 overflow-y-auto",
                      hideSidebar ? "hidden xl:flex" : "flex flex-col"
                    ),
                    children: [
                      /* @__PURE__ */ jsx82("div", { className: "absolute z-10 w-full", children: filtersActive && filterComponent }),
                      listHeader && listHeader,
                      leftSidebarList
                    ]
                  }
                ),
                /* @__PURE__ */ jsx82("div", { className: "sticky bottom-0 w-full justify-center bg-white", children: paginationComponent })
              ]
            }
          ),
          /* @__PURE__ */ jsx82("div", { className: "hidden w-full overflow-auto xl:flex xl:h-full", children: /* @__PURE__ */ jsx82(Suspense, { fallback: "Loading...", children: /* @__PURE__ */ jsx82(Outlet, { context: sections }) }) })
        ] }) }),
        /* @__PURE__ */ jsx82(Suspense, { fallback: "Loading...", children })
      ]
    }
  );
};
var Filters = ({ children }) => {
  const context = useContext(ListLayoutContext);
  useEffect5(() => {
    context.setFilterComponent(children);
  }, [children, context]);
  return /* @__PURE__ */ jsx82(Fragment21, {});
};
var Pagination = ({ children }) => {
  const context = useContext(ListLayoutContext);
  useEffect5(() => {
    context.setPaginationComponent(children);
  }, [children, context]);
  return /* @__PURE__ */ jsx82(Fragment21, {});
};
ListLayout.Filters = Filters;
ListLayout.Pagination = Pagination;
var DefaultListLayoutSectionElement = ({
  children
}) => {
  return /* @__PURE__ */ jsx82("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var DefaultListLayoutItemHeader = ({ title, to, section }) => {
  const linkTo = to(section);
  const titleIsElement = isValidElement3(section.itemTitle);
  return /* @__PURE__ */ jsxs50("div", { children: [
    /* @__PURE__ */ jsx82("div", { children: /* @__PURE__ */ jsx82("h1", { children: title }) }),
    titleIsElement ? section.itemTitle : /* @__PURE__ */ jsx82("div", { className: "font-InterMedium text-info-gray-800 text-3xl font-bold tracking-tight", children: section.itemTitle }),
    /* @__PURE__ */ jsx82("div", { className: "flex items-center space-x-2 sm:justify-end", children: /* @__PURE__ */ jsx82(EdButtonLink, { name: "View", to: linkTo }) })
  ] });
};
var Link2 = ({
  id: id3,
  sectionData: s,
  current,
  setCurrent,
  shrinkSidebar,
  titleIsElement
}) => {
  return /* @__PURE__ */ jsxs50(
    EdLink,
    {
      href: `${s.key}`,
      name: id3 || "",
      onClick: () => {
        setCurrent(s.key);
        if (s.onClick) {
          s.onClick(s);
        }
      },
      className: classNames(
        current && current === s.key ? "bg-primary-50 border-primary-500 rounded-lg border-2 bg-opacity-50" : "hover:bg-primary-100 hover:bg-opacity-50",
        "border-info-gray-200 flex w-full items-center p-4"
      ),
      children: [
        !shrinkSidebar && !s.hideIcon && s.icon && /* @__PURE__ */ jsx82(
          "span",
          {
            className: classNames(
              s.iconBackground || "text-primary-700",
              s.iconForeground || "bg-primary-50",
              "inline-flex rounded-lg ring-white",
              shrinkSidebar ? "p-1 ring-2" : "p-3 ring-4"
            ),
            children: /* @__PURE__ */ jsx82(
              s.icon,
              {
                className: shrinkSidebar ? "h-3 w-3" : "h-6 w-6",
                "aria-hidden": "true"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs50("div", { className: "text-md ml-3 w-full", children: [
          titleIsElement ? s.listTitle : /* @__PURE__ */ jsxs50("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ jsx82(
              "div",
              {
                className: classNames(
                  "text-info-gray-900 inline font-medium",
                  shrinkSidebar ? "text-sm" : "text-md"
                ),
                children: s.listTitle
              }
            ),
            /* @__PURE__ */ jsx82("div", { className: "text-sm text-gray-500", children: s.listSubtitle })
          ] }),
          /* @__PURE__ */ jsx82("div", { className: "text-info-gray-500 mt-1 inline", children: s.description })
        ] })
      ]
    },
    s.key
  );
};

// src/components/layouts/Loading.tsx
import { jsx as jsx83, jsxs as jsxs51 } from "react/jsx-runtime";
var Loading = ({ label }) => /* @__PURE__ */ jsx83("div", { className: classNames("flex items-center justify-center text-center"), children: /* @__PURE__ */ jsxs51("div", { children: [
  /* @__PURE__ */ jsx83(
    "div",
    {
      style: {
        height: 55,
        width: 500
      },
      children: /* @__PURE__ */ jsx83(
        "div",
        {
          style: {
            height: 55,
            width: 500
          },
          className: "flex animate-bounce items-center justify-center",
          children: /* @__PURE__ */ jsx83(AppSvg, { color: "#000000" })
        }
      )
    }
  ),
  label && /* @__PURE__ */ jsxs51("div", { className: "flex flex-row items-center justify-center gap-3", children: [
    /* @__PURE__ */ jsx83(Spinner, {}),
    /* @__PURE__ */ jsx83("div", { className: "text-sm italic text-gray-600", children: label })
  ] })
] }) });

// src/components/layouts/MultiColumn.tsx
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import { useToggle as useToggle3 } from "shared-lib";
import { jsx as jsx84, jsxs as jsxs52 } from "react/jsx-runtime";
var MultiColumn = ({
  mainContent,
  sideContent,
  mainContentHeader,
  rightContent,
  sidebarCollapse,
  hideLeftBar,
  hideRightBar
}) => {
  const [isExpanded, toggleExpanded] = useToggle3(false);
  const [leftSideBarOpen, toggleLeftSideBar] = useToggle3(true);
  return /* @__PURE__ */ jsx84("div", { className: "flex min-h-screen min-w-0 flex-1 flex-col border-t border-gray-200 xl:flex", children: /* @__PURE__ */ jsxs52("div", { className: "mx-auto flex w-full flex-grow flex-col lg:flex-row", children: [
    /* @__PURE__ */ jsxs52("div", { className: "flex min-w-0 flex-1 overflow-hidden bg-white", children: [
      !hideLeftBar && /* @__PURE__ */ jsxs52(
        "div",
        {
          className: classNames(
            "hidden overflow-hidden border-b border-gray-200 bg-white xl:flex xl:flex-shrink-0 xl:border-b-0 xl:border-r xl:border-gray-200"
          ),
          children: [
            /* @__PURE__ */ jsx84(
              "div",
              {
                className: classNames(
                  "flex h-full flex-grow overflow-hidden transition-[width] ",
                  leftSideBarOpen || !sidebarCollapse ? "xl:w-64" : "xl:w-0"
                ),
                children: /* @__PURE__ */ jsx84(
                  "div",
                  {
                    className: "relative flex flex-grow",
                    style: { minHeight: "12rem" },
                    children: sideContent
                  }
                )
              }
            ),
            sidebarCollapse && /* @__PURE__ */ jsx84(Button, { onClick: toggleLeftSideBar, children: leftSideBarOpen ? /* @__PURE__ */ jsx84(ArrowLeftIcon, { className: "h-3 w-3" }) : /* @__PURE__ */ jsx84(ArrowRightIcon, { className: "h-3 w-3" }) })
          ]
        }
      ),
      /* @__PURE__ */ jsxs52("div", { className: "flex-1 bg-white lg:min-w-0", children: [
        mainContentHeader,
        /* @__PURE__ */ jsx84("div", { className: "h-full px-4 py-6 sm:px-6 lg:px-8", children: /* @__PURE__ */ jsxs52("div", { className: "relative h-full", children: [
          /* @__PURE__ */ jsx84("div", { className: "flex xl:hidden", children: sideContent }),
          mainContent
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx84(
      "div",
      {
        className: classNames(
          "hidden overflow-hidden bg-gray-50 pr-4 transition-[width] duration-500 sm:pr-6 lg:flex-shrink-0 lg:border-l lg:border-gray-200 lg:pr-8 xl:pr-0",
          isExpanded ? "lg:w-6/12" : "lg:w-24",
          hideRightBar ? "lg:hidden" : "lg:flex"
        ),
        onDoubleClick: rightContent && toggleExpanded,
        children: /* @__PURE__ */ jsx84("div", { className: classNames("h-full py-6 pl-6"), children: /* @__PURE__ */ jsx84(
          "div",
          {
            className: "relative h-full whitespace-pre-wrap",
            style: { minHeight: "16rem" },
            children: rightContent
          }
        ) })
      }
    )
  ] }) });
};

// src/components/layouts/PageHeader.tsx
import { jsx as jsx85 } from "react/jsx-runtime";
var PageHeader = ({ children }) => {
  return /* @__PURE__ */ jsx85("div", { className: "flex", children: /* @__PURE__ */ jsx85("div", { className: "mb-2 flex-1 border-b bg-white p-3 sm:p-4", children }) });
};

// src/components/layouts/PageTitle.tsx
import { jsx as jsx86, jsxs as jsxs53 } from "react/jsx-runtime";
var PageTitle = ({ title, subTitle }) => {
  return /* @__PURE__ */ jsxs53("div", { className: "p-2", children: [
    /* @__PURE__ */ jsx86("h1", { className: "text-info-700 pb-2 text-2xl", children: title }),
    subTitle && /* @__PURE__ */ jsx86("h1", { className: "text-info-900 pb-4 text-lg", children: subTitle })
  ] });
};

// src/components/layouts/RouteContent.tsx
import { jsx as jsx87, jsxs as jsxs54 } from "react/jsx-runtime";
var RouteContent = ({
  title,
  actions,
  children
}) => {
  return /* @__PURE__ */ jsxs54("div", { children: [
    /* @__PURE__ */ jsxs54("div", { className: "flex items-center justify-between border border-gray-200 bg-white px-6 py-3", children: [
      /* @__PURE__ */ jsx87("h1", { className: "text-lg font-medium leading-6 text-gray-900", children: title }),
      actions
    ] }),
    children
  ] });
};

// src/components/layouts/SectionedLayout.tsx
import {
  useCallback as useCallback12,
  useContext as useContext8,
  useEffect as useEffect9,
  useRef as useRef5,
  useState as useState18
} from "react";
import * as React6 from "react";
import { Routes, Route, Outlet as Outlet2 } from "react-router-dom";
import {
  ArrowDownIcon,
  FunnelIcon as FunnelIconOutline2
} from "@heroicons/react/24/outline";
import { FunnelIcon as FunnelIconSolid2 } from "@heroicons/react/24/solid";

// ../../node_modules/framer-motion/dist/es/motion/index.mjs
import { jsxs as jsxs55, jsx as jsx88 } from "react/jsx-runtime";
import { forwardRef as forwardRef6, useContext as useContext4 } from "react";

// ../../node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
import { createContext as createContext2 } from "react";
var MotionConfigContext = createContext2({
  transformPagePoint: (p) => p,
  isStatic: false,
  reducedMotion: "never"
});

// ../../node_modules/framer-motion/dist/es/context/MotionContext/index.mjs
import { createContext as createContext3 } from "react";
var MotionContext = createContext3({});

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-element.mjs
import { useContext as useContext2, useRef as useRef3, useInsertionEffect, useEffect as useEffect7 } from "react";

// ../../node_modules/framer-motion/dist/es/context/PresenceContext.mjs
import { createContext as createContext4 } from "react";
var PresenceContext = createContext4(null);

// ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
import { useLayoutEffect, useEffect as useEffect6 } from "react";

// ../../node_modules/framer-motion/dist/es/utils/is-browser.mjs
var isBrowser = typeof document !== "undefined";

// ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect6;

// ../../node_modules/framer-motion/dist/es/context/LazyContext.mjs
import { createContext as createContext5 } from "react";
var LazyContext = createContext5({ strict: false });

// ../../node_modules/framer-motion/dist/es/render/dom/utils/camel-to-dash.mjs
var camelToDash = (str) => str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

// ../../node_modules/framer-motion/dist/es/animation/optimized-appear/data-id.mjs
var optimizedAppearDataId = "framerAppearId";
var optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

// ../../node_modules/framer-motion/dist/es/utils/GlobalConfig.mjs
var MotionGlobalConfig = {
  skipAnimations: false,
  useManualTiming: false
};

// ../../node_modules/framer-motion/dist/es/frameloop/render-step.mjs
var Queue = class {
  constructor() {
    this.order = [];
    this.scheduled = /* @__PURE__ */ new Set();
  }
  add(process2) {
    if (!this.scheduled.has(process2)) {
      this.scheduled.add(process2);
      this.order.push(process2);
      return true;
    }
  }
  remove(process2) {
    const index = this.order.indexOf(process2);
    if (index !== -1) {
      this.order.splice(index, 1);
      this.scheduled.delete(process2);
    }
  }
  clear() {
    this.order.length = 0;
    this.scheduled.clear();
  }
};
function createRenderStep(runNextFrame) {
  let thisFrame = new Queue();
  let nextFrame = new Queue();
  let numToRun = 0;
  let isProcessing = false;
  let flushNextFrame = false;
  const toKeepAlive = /* @__PURE__ */ new WeakSet();
  const step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (callback, keepAlive = false, immediate = false) => {
      const addToCurrentFrame = immediate && isProcessing;
      const queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive)
        toKeepAlive.add(callback);
      if (queue.add(callback) && addToCurrentFrame && isProcessing) {
        numToRun = thisFrame.order.length;
      }
      return callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (callback) => {
      nextFrame.remove(callback);
      toKeepAlive.delete(callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (frameData2) => {
      if (isProcessing) {
        flushNextFrame = true;
        return;
      }
      isProcessing = true;
      [thisFrame, nextFrame] = [nextFrame, thisFrame];
      nextFrame.clear();
      numToRun = thisFrame.order.length;
      if (numToRun) {
        for (let i = 0; i < numToRun; i++) {
          const callback = thisFrame.order[i];
          if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
          }
          callback(frameData2);
        }
      }
      isProcessing = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData2);
      }
    }
  };
  return step;
}

// ../../node_modules/framer-motion/dist/es/frameloop/batcher.mjs
var stepsOrder = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
var maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  let runNextFrame = false;
  let useDefaultElapsed = true;
  const state = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
  };
  const steps2 = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => runNextFrame = true);
    return acc;
  }, {});
  const processStep = (stepId) => {
    steps2[stepId].process(state);
  };
  const processBatch = () => {
    const timestamp = MotionGlobalConfig.useManualTiming ? state.timestamp : performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1e3 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    stepsOrder.forEach(processStep);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };
  const wake = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };
  const schedule = stepsOrder.reduce((acc, key) => {
    const step = steps2[key];
    acc[key] = (process2, keepAlive = false, immediate = false) => {
      if (!runNextFrame)
        wake();
      return step.schedule(process2, keepAlive, immediate);
    };
    return acc;
  }, {});
  const cancel = (process2) => stepsOrder.forEach((key) => steps2[key].cancel(process2));
  return { schedule, cancel, state, steps: steps2 };
}

// ../../node_modules/framer-motion/dist/es/frameloop/microtask.mjs
var { schedule: microtask, cancel: cancelMicrotask } = createRenderBatcher(queueMicrotask, false);

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-element.mjs
function useVisualElement(Component2, visualState, props, createVisualElement) {
  const { visualElement: parent } = useContext2(MotionContext);
  const lazyContext = useContext2(LazyContext);
  const presenceContext = useContext2(PresenceContext);
  const reducedMotionConfig = useContext2(MotionConfigContext).reducedMotion;
  const visualElementRef = useRef3();
  createVisualElement = createVisualElement || lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component2, {
      visualState,
      parent,
      props,
      presenceContext,
      blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
      reducedMotionConfig
    });
  }
  const visualElement = visualElementRef.current;
  useInsertionEffect(() => {
    visualElement && visualElement.update(props, presenceContext);
  });
  const wantsHandoff = useRef3(Boolean(props[optimizedAppearDataAttribute] && !window.HandoffComplete));
  useIsomorphicLayoutEffect(() => {
    if (!visualElement)
      return;
    microtask.postRender(visualElement.render);
    if (wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
  });
  useEffect7(() => {
    if (!visualElement)
      return;
    visualElement.updateFeatures();
    if (!wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
    if (wantsHandoff.current) {
      wantsHandoff.current = false;
      window.HandoffComplete = true;
    }
  });
  return visualElement;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.mjs
import { useCallback as useCallback11 } from "react";

// ../../node_modules/framer-motion/dist/es/utils/is-ref-object.mjs
function isRefObject(ref) {
  return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.mjs
function useMotionRef(visualState, visualElement, externalRef) {
  return useCallback11(
    (instance) => {
      instance && visualState.mount && visualState.mount(instance);
      if (visualElement) {
        instance ? visualElement.mount(instance) : visualElement.unmount();
      }
      if (externalRef) {
        if (typeof externalRef === "function") {
          externalRef(instance);
        } else if (isRefObject(externalRef)) {
          externalRef.current = instance;
        }
      }
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]
  );
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/create.mjs
import { useContext as useContext3, useMemo as useMemo3 } from "react";

// ../../node_modules/framer-motion/dist/es/render/utils/is-variant-label.mjs
function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
}

// ../../node_modules/framer-motion/dist/es/animation/utils/is-animation-controls.mjs
function isAnimationControls(v) {
  return v !== null && typeof v === "object" && typeof v.start === "function";
}

// ../../node_modules/framer-motion/dist/es/render/utils/variant-props.mjs
var variantPriorityOrder = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
];
var variantProps = ["initial", ...variantPriorityOrder];

// ../../node_modules/framer-motion/dist/es/render/utils/is-controlling-variants.mjs
function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some((name) => isVariantLabel(props[name]));
}
function isVariantNode(props) {
  return Boolean(isControllingVariants(props) || props.variants);
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/utils.mjs
function getCurrentTreeVariants(props, context) {
  if (isControllingVariants(props)) {
    const { initial, animate } = props;
    return {
      initial: initial === false || isVariantLabel(initial) ? initial : void 0,
      animate: isVariantLabel(animate) ? animate : void 0
    };
  }
  return props.inherit !== false ? context : {};
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/create.mjs
function useCreateMotionContext(props) {
  const { initial, animate } = getCurrentTreeVariants(props, useContext3(MotionContext));
  return useMemo3(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}

// ../../node_modules/framer-motion/dist/es/motion/features/definitions.mjs
var featureProps = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
var featureDefinitions = {};
for (const key in featureProps) {
  featureDefinitions[key] = {
    isEnabled: (props) => featureProps[key].some((name) => !!props[name])
  };
}

// ../../node_modules/framer-motion/dist/es/motion/features/load-features.mjs
function loadFeatures(features) {
  for (const key in features) {
    featureDefinitions[key] = {
      ...featureDefinitions[key],
      ...features[key]
    };
  }
}

// ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
import { createContext as createContext6 } from "react";
var LayoutGroupContext = createContext6({});

// ../../node_modules/framer-motion/dist/es/context/SwitchLayoutGroupContext.mjs
import { createContext as createContext7 } from "react";
var SwitchLayoutGroupContext = createContext7({});

// ../../node_modules/framer-motion/dist/es/motion/utils/symbol.mjs
var motionComponentSymbol = Symbol.for("motionComponentSymbol");

// ../../node_modules/framer-motion/dist/es/motion/index.mjs
function createMotionComponent({ preloadedFeatures: preloadedFeatures2, createVisualElement, useRender, useVisualState, Component: Component2 }) {
  preloadedFeatures2 && loadFeatures(preloadedFeatures2);
  function MotionComponent(props, externalRef) {
    let MeasureLayout2;
    const configAndProps = {
      ...useContext4(MotionConfigContext),
      ...props,
      layoutId: useLayoutId(props)
    };
    const { isStatic } = configAndProps;
    const context = useCreateMotionContext(props);
    const visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser) {
      context.visualElement = useVisualElement(Component2, visualState, configAndProps, createVisualElement);
      const initialLayoutGroupConfig = useContext4(SwitchLayoutGroupContext);
      const isStrict = useContext4(LazyContext).strict;
      if (context.visualElement) {
        MeasureLayout2 = context.visualElement.loadFeatures(
          // Note: Pass the full new combined props to correctly re-render dynamic feature components.
          configAndProps,
          isStrict,
          preloadedFeatures2,
          initialLayoutGroupConfig
        );
      }
    }
    return jsxs55(MotionContext.Provider, { value: context, children: [MeasureLayout2 && context.visualElement ? jsx88(MeasureLayout2, { visualElement: context.visualElement, ...configAndProps }) : null, useRender(Component2, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)] });
  }
  const ForwardRefComponent = forwardRef6(MotionComponent);
  ForwardRefComponent[motionComponentSymbol] = Component2;
  return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
  const layoutGroupId = useContext4(LayoutGroupContext).id;
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}

// ../../node_modules/framer-motion/dist/es/render/dom/motion-proxy.mjs
function createMotionProxy(createConfig) {
  function custom(Component2, customMotionComponentConfig = {}) {
    return createMotionComponent(createConfig(Component2, customMotionComponentConfig));
  }
  if (typeof Proxy === "undefined") {
    return custom;
  }
  const componentCache = /* @__PURE__ */ new Map();
  return new Proxy(custom, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (_target, key) => {
      if (!componentCache.has(key)) {
        componentCache.set(key, custom(key));
      }
      return componentCache.get(key);
    }
  });
}

// ../../node_modules/framer-motion/dist/es/render/svg/lowercase-elements.mjs
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-svg-component.mjs
function isSVGComponent(Component2) {
  if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component2 !== "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Component2.includes("-")
  ) {
    return false;
  } else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component2) > -1 || /**
     * If it contains a capital letter, it's an SVG component
     */
    /[A-Z]/u.test(Component2)
  ) {
    return true;
  }
  return false;
}

// ../../node_modules/framer-motion/dist/es/render/dom/use-render.mjs
import { Fragment as Fragment22, useMemo as useMemo6, createElement as createElement2 } from "react";

// ../../node_modules/framer-motion/dist/es/render/html/use-props.mjs
import { useMemo as useMemo4 } from "react";

// ../../node_modules/framer-motion/dist/es/projection/styles/scale-correction.mjs
var scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/transform.mjs
var transformPropOrder = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
];
var transformProps = new Set(transformPropOrder);

// ../../node_modules/framer-motion/dist/es/motion/utils/is-forced-motion-value.mjs
function isForcedMotionValue(key, { layout: layout2, layoutId }) {
  return transformProps.has(key) || key.startsWith("origin") || (layout2 || layoutId !== void 0) && (!!scaleCorrectors[key] || key === "opacity");
}

// ../../node_modules/framer-motion/dist/es/value/utils/is-motion-value.mjs
var isMotionValue = (value) => Boolean(value && value.getVelocity);

// ../../node_modules/framer-motion/dist/es/render/html/utils/build-transform.mjs
var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
var numTransforms = transformPropOrder.length;
function buildTransform(transform, { enableHardwareAcceleration = true, allowTransformNone = true }, transformIsDefault, transformTemplate) {
  let transformString = "";
  for (let i = 0; i < numTransforms; i++) {
    const key = transformPropOrder[i];
    if (transform[key] !== void 0) {
      const transformName = translateAlias[key] || key;
      transformString += `${transformName}(${transform[key]}) `;
    }
  }
  if (enableHardwareAcceleration && !transform.z) {
    transformString += "translateZ(0)";
  }
  transformString = transformString.trim();
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-css-variable.mjs
var checkStringStartsWith = (token) => (key) => typeof key === "string" && key.startsWith(token);
var isCSSVariableName = checkStringStartsWith("--");
var startsAsVariableToken = checkStringStartsWith("var(--");
var isCSSVariableToken = (value) => {
  const startsWithToken = startsAsVariableToken(value);
  if (!startsWithToken)
    return false;
  return singleCssVariableRegex.test(value.split("/*")[0].trim());
};
var singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/get-as-type.mjs
var getValueAsType = (value, type) => {
  return type && typeof value === "number" ? type.transform(value) : value;
};

// ../../node_modules/framer-motion/dist/es/utils/clamp.mjs
var clamp = (min, max, v) => {
  if (v > max)
    return max;
  if (v < min)
    return min;
  return v;
};

// ../../node_modules/framer-motion/dist/es/value/types/numbers/index.mjs
var number = {
  test: (v) => typeof v === "number",
  parse: parseFloat,
  transform: (v) => v
};
var alpha = {
  ...number,
  transform: (v) => clamp(0, 1, v)
};
var scale = {
  ...number,
  default: 1
};

// ../../node_modules/framer-motion/dist/es/value/types/utils.mjs
var sanitize = (v) => Math.round(v * 1e5) / 1e5;
var floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
var colorRegex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
var singleColorRegex = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function isString(v) {
  return typeof v === "string";
}

// ../../node_modules/framer-motion/dist/es/value/types/numbers/units.mjs
var createUnitType = (unit) => ({
  test: (v) => isString(v) && v.endsWith(unit) && v.split(" ").length === 1,
  parse: parseFloat,
  transform: (v) => `${v}${unit}`
});
var degrees = createUnitType("deg");
var percent = createUnitType("%");
var px = createUnitType("px");
var vh = createUnitType("vh");
var vw = createUnitType("vw");
var progressPercentage = {
  ...percent,
  parse: (v) => percent.parse(v) / 100,
  transform: (v) => percent.transform(v * 100)
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-int.mjs
var int = {
  ...number,
  transform: Math.round
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/number.mjs
var numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  backgroundPositionX: px,
  backgroundPositionY: px,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};

// ../../node_modules/framer-motion/dist/es/render/html/utils/build-styles.mjs
function buildHTMLStyles(state, latestValues, options, transformTemplate) {
  const { style, vars, transform, transformOrigin } = state;
  let hasTransform2 = false;
  let hasTransformOrigin = false;
  let transformIsNone = true;
  for (const key in latestValues) {
    const value = latestValues[key];
    if (isCSSVariableName(key)) {
      vars[key] = value;
      continue;
    }
    const valueType = numberValueTypes[key];
    const valueAsType = getValueAsType(value, valueType);
    if (transformProps.has(key)) {
      hasTransform2 = true;
      transform[key] = valueAsType;
      if (!transformIsNone)
        continue;
      if (value !== (valueType.default || 0))
        transformIsNone = false;
    } else if (key.startsWith("origin")) {
      hasTransformOrigin = true;
      transformOrigin[key] = valueAsType;
    } else {
      style[key] = valueAsType;
    }
  }
  if (!latestValues.transform) {
    if (hasTransform2 || transformTemplate) {
      style.transform = buildTransform(state.transform, options, transformIsNone, transformTemplate);
    } else if (style.transform) {
      style.transform = "none";
    }
  }
  if (hasTransformOrigin) {
    const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin;
    style.transformOrigin = `${originX} ${originY} ${originZ}`;
  }
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/create-render-state.mjs
var createHtmlRenderState = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});

// ../../node_modules/framer-motion/dist/es/render/html/use-props.mjs
function copyRawValuesOnly(target, source, props) {
  for (const key in source) {
    if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
      target[key] = source[key];
    }
  }
}
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
  return useMemo4(() => {
    const state = createHtmlRenderState();
    buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
    return Object.assign({}, state.vars, state.style);
  }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
  const styleProp = props.style || {};
  const style = {};
  copyRawValuesOnly(style, styleProp, props);
  Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
  return style;
}
function useHTMLProps(props, visualState, isStatic) {
  const htmlProps = {};
  const style = useStyle(props, visualState, isStatic);
  if (props.drag && props.dragListener !== false) {
    htmlProps.draggable = false;
    style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
    style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
  }
  if (props.tabIndex === void 0 && (props.onTap || props.onTapStart || props.whileTap)) {
    htmlProps.tabIndex = 0;
  }
  htmlProps.style = style;
  return htmlProps;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/valid-prop.mjs
var validMotionProps = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function isValidMotionProp(key) {
  return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/filter-props.mjs
var shouldForward = (key) => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
  if (!isValidProp)
    return;
  shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
try {
  loadExternalIsValidProp(__require("@emotion/is-prop-valid").default);
} catch (_a) {
}
function filterProps(props, isDom, forwardMotionProps) {
  const filteredProps = {};
  for (const key in props) {
    if (key === "values" && typeof props.values === "object")
      continue;
    if (shouldForward(key) || forwardMotionProps === true && isValidMotionProp(key) || !isDom && !isValidMotionProp(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}

// ../../node_modules/framer-motion/dist/es/render/svg/use-props.mjs
import { useMemo as useMemo5 } from "react";

// ../../node_modules/framer-motion/dist/es/render/svg/utils/transform-origin.mjs
function calcOrigin(origin, offset, size) {
  return typeof origin === "string" ? origin : px.transform(offset + size * origin);
}
function calcSVGTransformOrigin(dimensions, originX, originY) {
  const pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
  const pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
  return `${pxOriginX} ${pxOriginY}`;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/path.mjs
var dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
  attrs.pathLength = 1;
  const keys = useDashCase ? dashKeys : camelKeys;
  attrs[keys.offset] = px.transform(-offset);
  const pathLength = px.transform(length);
  const pathSpacing = px.transform(spacing);
  attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/build-attrs.mjs
function buildSVGAttrs(state, {
  attrX,
  attrY,
  attrScale,
  originX,
  originY,
  pathLength,
  pathSpacing = 1,
  pathOffset = 0,
  // This is object creation, which we try to avoid per-frame.
  ...latest
}, options, isSVGTag2, transformTemplate) {
  buildHTMLStyles(state, latest, options, transformTemplate);
  if (isSVGTag2) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }
    return;
  }
  state.attrs = state.style;
  state.style = {};
  const { attrs, style, dimensions } = state;
  if (attrs.transform) {
    if (dimensions)
      style.transform = attrs.transform;
    delete attrs.transform;
  }
  if (dimensions && (originX !== void 0 || originY !== void 0 || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== void 0 ? originX : 0.5, originY !== void 0 ? originY : 0.5);
  }
  if (attrX !== void 0)
    attrs.x = attrX;
  if (attrY !== void 0)
    attrs.y = attrY;
  if (attrScale !== void 0)
    attrs.scale = attrScale;
  if (pathLength !== void 0) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.mjs
var createSvgRenderState = () => ({
  ...createHtmlRenderState(),
  attrs: {}
});

// ../../node_modules/framer-motion/dist/es/render/svg/utils/is-svg-tag.mjs
var isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

// ../../node_modules/framer-motion/dist/es/render/svg/use-props.mjs
function useSVGProps(props, visualState, _isStatic, Component2) {
  const visualProps = useMemo5(() => {
    const state = createSvgRenderState();
    buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, isSVGTag(Component2), props.transformTemplate);
    return {
      ...state.attrs,
      style: { ...state.style }
    };
  }, [visualState]);
  if (props.style) {
    const rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = { ...rawStyles, ...visualProps.style };
  }
  return visualProps;
}

// ../../node_modules/framer-motion/dist/es/render/dom/use-render.mjs
function createUseRender(forwardMotionProps = false) {
  const useRender = (Component2, props, ref, { latestValues }, isStatic) => {
    const useVisualProps = isSVGComponent(Component2) ? useSVGProps : useHTMLProps;
    const visualProps = useVisualProps(props, latestValues, isStatic, Component2);
    const filteredProps = filterProps(props, typeof Component2 === "string", forwardMotionProps);
    const elementProps = Component2 !== Fragment22 ? { ...filteredProps, ...visualProps, ref } : {};
    const { children } = props;
    const renderedChildren = useMemo6(() => isMotionValue(children) ? children.get() : children, [children]);
    return createElement2(Component2, {
      ...elementProps,
      children: renderedChildren
    });
  };
  return useRender;
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/render.mjs
function renderHTML(element, { style, vars }, styleProp, projection) {
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  for (const key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/camel-case-attrs.mjs
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);

// ../../node_modules/framer-motion/dist/es/render/svg/utils/render.mjs
function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, void 0, projection);
  for (const key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
  }
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/scrape-motion-values.mjs
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
  var _a;
  const { style } = props;
  const newValues = {};
  for (const key in style) {
    if (isMotionValue(style[key]) || prevProps.style && isMotionValue(prevProps.style[key]) || isForcedMotionValue(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== void 0) {
      newValues[key] = style[key];
    }
  }
  return newValues;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/scrape-motion-values.mjs
function scrapeMotionValuesFromProps2(props, prevProps, visualElement) {
  const newValues = scrapeMotionValuesFromProps(props, prevProps, visualElement);
  for (const key in props) {
    if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
      const targetKey = transformPropOrder.indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs
import { useContext as useContext5 } from "react";

// ../../node_modules/framer-motion/dist/es/render/utils/resolve-variants.mjs
function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
  if (typeof definition === "function") {
    definition = definition(custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
  }
  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  if (typeof definition === "function") {
    definition = definition(custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
  }
  return definition;
}

// ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
import { useRef as useRef4 } from "react";
function useConstant(init) {
  const ref = useRef4(null);
  if (ref.current === null) {
    ref.current = init();
  }
  return ref.current;
}

// ../../node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.mjs
var isKeyframesTarget = (v) => {
  return Array.isArray(v);
};

// ../../node_modules/framer-motion/dist/es/utils/resolve-value.mjs
var isCustomValue = (v) => {
  return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = (v) => {
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

// ../../node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.mjs
function resolveMotionValue(value) {
  const unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs
function makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps3, createRenderState, onMount }, props, context, presenceContext) {
  const state = {
    latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps3),
    renderState: createRenderState()
  };
  if (onMount) {
    state.mount = (instance) => onMount(props, instance, state);
  }
  return state;
}
var makeUseVisualState = (config) => (props, isStatic) => {
  const context = useContext5(MotionContext);
  const presenceContext = useContext5(PresenceContext);
  const make = () => makeState(config, props, context, presenceContext);
  return isStatic ? make() : useConstant(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
  const values = {};
  const motionValues = scrapeMotionValues(props, {});
  for (const key in motionValues) {
    values[key] = resolveMotionValue(motionValues[key]);
  }
  let { initial, animate } = props;
  const isControllingVariants$1 = isControllingVariants(props);
  const isVariantNode$1 = isVariantNode(props);
  if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
    if (initial === void 0)
      initial = context.initial;
    if (animate === void 0)
      animate = context.animate;
  }
  let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
  const variantToSet = isInitialAnimationBlocked ? animate : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    list.forEach((definition) => {
      const resolved = resolveVariantFromProps(props, definition);
      if (!resolved)
        return;
      const { transitionEnd, transition, ...target } = resolved;
      for (const key in target) {
        let valueTarget = target[key];
        if (Array.isArray(valueTarget)) {
          const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
          valueTarget = valueTarget[index];
        }
        if (valueTarget !== null) {
          values[key] = valueTarget;
        }
      }
      for (const key in transitionEnd)
        values[key] = transitionEnd[key];
    });
  }
  return values;
}

// ../../node_modules/framer-motion/dist/es/utils/noop.mjs
var noop2 = (any) => any;

// ../../node_modules/framer-motion/dist/es/frameloop/frame.mjs
var { schedule: frame, cancel: cancelFrame, state: frameData, steps } = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop2, true);

// ../../node_modules/framer-motion/dist/es/render/svg/config-motion.mjs
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps2,
    createRenderState: createSvgRenderState,
    onMount: (props, instance, { renderState, latestValues }) => {
      frame.read(() => {
        try {
          renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
        } catch (e) {
          renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      });
      frame.render(() => {
        buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag(instance.tagName), props.transformTemplate);
        renderSVG(instance, renderState);
      });
    }
  })
};

// ../../node_modules/framer-motion/dist/es/render/html/config-motion.mjs
var htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createHtmlRenderState
  })
};

// ../../node_modules/framer-motion/dist/es/render/dom/utils/create-config.mjs
function createDomMotionConfig(Component2, { forwardMotionProps = false }, preloadedFeatures2, createVisualElement) {
  const baseConfig = isSVGComponent(Component2) ? svgMotionConfig : htmlMotionConfig;
  return {
    ...baseConfig,
    preloadedFeatures: preloadedFeatures2,
    useRender: createUseRender(forwardMotionProps),
    createVisualElement,
    Component: Component2
  };
}

// ../../node_modules/framer-motion/dist/es/events/add-dom-event.mjs
function addDomEvent(target, eventName, handler, options = { passive: true }) {
  target.addEventListener(eventName, handler, options);
  return () => target.removeEventListener(eventName, handler);
}

// ../../node_modules/framer-motion/dist/es/events/utils/is-primary-pointer.mjs
var isPrimaryPointer = (event) => {
  if (event.pointerType === "mouse") {
    return typeof event.button !== "number" || event.button <= 0;
  } else {
    return event.isPrimary !== false;
  }
};

// ../../node_modules/framer-motion/dist/es/events/event-info.mjs
function extractEventInfo(event, pointType = "page") {
  return {
    point: {
      x: event[`${pointType}X`],
      y: event[`${pointType}Y`]
    }
  };
}
var addPointerInfo = (handler) => {
  return (event) => isPrimaryPointer(event) && handler(event, extractEventInfo(event));
};

// ../../node_modules/framer-motion/dist/es/events/add-pointer-event.mjs
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, eventName, addPointerInfo(handler), options);
}

// ../../node_modules/framer-motion/dist/es/utils/pipe.mjs
var combineFunctions = (a, b) => (v) => b(a(v));
var pipe = (...transformers) => transformers.reduce(combineFunctions);

// ../../node_modules/framer-motion/dist/es/gestures/drag/utils/lock.mjs
function createLock(name) {
  let lock = null;
  return () => {
    const openLock = () => {
      lock = null;
    };
    if (lock === null) {
      lock = name;
      return openLock;
    }
    return false;
  };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag2) {
  let lock = false;
  if (drag2 === "y") {
    lock = globalVerticalLock();
  } else if (drag2 === "x") {
    lock = globalHorizontalLock();
  } else {
    const openHorizontal = globalHorizontalLock();
    const openVertical = globalVerticalLock();
    if (openHorizontal && openVertical) {
      lock = () => {
        openHorizontal();
        openVertical();
      };
    } else {
      if (openHorizontal)
        openHorizontal();
      if (openVertical)
        openVertical();
    }
  }
  return lock;
}
function isDragActive() {
  const openGestureLock = getGlobalLock(true);
  if (!openGestureLock)
    return true;
  openGestureLock();
  return false;
}

// ../../node_modules/framer-motion/dist/es/motion/features/Feature.mjs
var Feature = class {
  constructor(node4) {
    this.isMounted = false;
    this.node = node4;
  }
  update() {
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/hover.mjs
function addHoverEvent(node4, isActive) {
  const eventName = isActive ? "pointerenter" : "pointerleave";
  const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
  const handleEvent = (event, info) => {
    if (event.pointerType === "touch" || isDragActive())
      return;
    const props = node4.getProps();
    if (node4.animationState && props.whileHover) {
      node4.animationState.setActive("whileHover", isActive);
    }
    const callback = props[callbackName];
    if (callback)
      callback(event, info);
  };
  return addPointerEvent(node4.current, eventName, handleEvent, {
    passive: !node4.getProps()[callbackName]
  });
}
var HoverGesture = class extends Feature {
  mount() {
    this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/focus.mjs
var FocusGesture = class extends Feature {
  constructor() {
    super(...arguments);
    this.isActive = false;
  }
  onFocus() {
    let isFocusVisible = false;
    try {
      isFocusVisible = this.node.current.matches(":focus-visible");
    } catch (e) {
      isFocusVisible = true;
    }
    if (!isFocusVisible || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", true);
    this.isActive = true;
  }
  onBlur() {
    if (!this.isActive || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", false);
    this.isActive = false;
  }
  mount() {
    this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/utils/is-node-or-child.mjs
var isNodeOrChild = (parent, child) => {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/press.mjs
function fireSyntheticPointerEvent(name, handler) {
  if (!handler)
    return;
  const syntheticPointerEvent = new PointerEvent("pointer" + name);
  handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
var PressGesture = class extends Feature {
  constructor() {
    super(...arguments);
    this.removeStartListeners = noop2;
    this.removeEndListeners = noop2;
    this.removeAccessibleListeners = noop2;
    this.startPointerPress = (startEvent, startInfo) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const props = this.node.getProps();
      const endPointerPress = (endEvent, endInfo) => {
        if (!this.checkPressEnd())
          return;
        const { onTap, onTapCancel, globalTapTarget } = this.node.getProps();
        !globalTapTarget && !isNodeOrChild(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
      };
      const removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, {
        passive: !(props.onTap || props["onPointerUp"])
      });
      const removePointerCancelListener = addPointerEvent(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), {
        passive: !(props.onTapCancel || props["onPointerCancel"])
      });
      this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
      this.startPress(startEvent, startInfo);
    };
    this.startAccessiblePress = () => {
      const handleKeydown = (keydownEvent) => {
        if (keydownEvent.key !== "Enter" || this.isPressing)
          return;
        const handleKeyup = (keyupEvent) => {
          if (keyupEvent.key !== "Enter" || !this.checkPressEnd())
            return;
          fireSyntheticPointerEvent("up", (event, info) => {
            const { onTap } = this.node.getProps();
            if (onTap)
              onTap(event, info);
          });
        };
        this.removeEndListeners();
        this.removeEndListeners = addDomEvent(this.node.current, "keyup", handleKeyup);
        fireSyntheticPointerEvent("down", (event, info) => {
          this.startPress(event, info);
        });
      };
      const removeKeydownListener = addDomEvent(this.node.current, "keydown", handleKeydown);
      const handleBlur = () => {
        if (!this.isPressing)
          return;
        fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
      };
      const removeBlurListener = addDomEvent(this.node.current, "blur", handleBlur);
      this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
    };
  }
  startPress(event, info) {
    this.isPressing = true;
    const { onTapStart, whileTap } = this.node.getProps();
    if (whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", true);
    }
    if (onTapStart) {
      onTapStart(event, info);
    }
  }
  checkPressEnd() {
    this.removeEndListeners();
    this.isPressing = false;
    const props = this.node.getProps();
    if (props.whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", false);
    }
    return !isDragActive();
  }
  cancelPress(event, info) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel } = this.node.getProps();
    if (onTapCancel)
      onTapCancel(event, info);
  }
  mount() {
    const props = this.node.getProps();
    const removePointerListener = addPointerEvent(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(props.onTapStart || props["onPointerStart"])
    });
    const removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
  }
  unmount() {
    this.removeStartListeners();
    this.removeEndListeners();
    this.removeAccessibleListeners();
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/viewport/observers.mjs
var observerCallbacks = /* @__PURE__ */ new WeakMap();
var observers = /* @__PURE__ */ new WeakMap();
var fireObserverCallback = (entry) => {
  const callback = observerCallbacks.get(entry.target);
  callback && callback(entry);
};
var fireAllObserverCallbacks = (entries) => {
  entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root: root2, ...options }) {
  const lookupRoot = root2 || document;
  if (!observers.has(lookupRoot)) {
    observers.set(lookupRoot, {});
  }
  const rootObservers = observers.get(lookupRoot);
  const key = JSON.stringify(options);
  if (!rootObservers[key]) {
    rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root: root2, ...options });
  }
  return rootObservers[key];
}
function observeIntersection(element, options, callback) {
  const rootInteresectionObserver = initIntersectionObserver(options);
  observerCallbacks.set(element, callback);
  rootInteresectionObserver.observe(element);
  return () => {
    observerCallbacks.delete(element);
    rootInteresectionObserver.unobserve(element);
  };
}

// ../../node_modules/framer-motion/dist/es/motion/features/viewport/index.mjs
var thresholdNames = {
  some: 0,
  all: 1
};
var InViewFeature = class extends Feature {
  constructor() {
    super(...arguments);
    this.hasEnteredView = false;
    this.isInView = false;
  }
  startObserver() {
    this.unmount();
    const { viewport = {} } = this.node.getProps();
    const { root: root2, margin: rootMargin, amount = "some", once } = viewport;
    const options = {
      root: root2 ? root2.current : void 0,
      rootMargin,
      threshold: typeof amount === "number" ? amount : thresholdNames[amount]
    };
    const onIntersectionUpdate = (entry) => {
      const { isIntersecting } = entry;
      if (this.isInView === isIntersecting)
        return;
      this.isInView = isIntersecting;
      if (once && !isIntersecting && this.hasEnteredView) {
        return;
      } else if (isIntersecting) {
        this.hasEnteredView = true;
      }
      if (this.node.animationState) {
        this.node.animationState.setActive("whileInView", isIntersecting);
      }
      const { onViewportEnter, onViewportLeave } = this.node.getProps();
      const callback = isIntersecting ? onViewportEnter : onViewportLeave;
      callback && callback(entry);
    };
    return observeIntersection(this.node.current, options, onIntersectionUpdate);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver === "undefined")
      return;
    const { props, prevProps } = this.node;
    const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
    if (hasOptionsChanged) {
      this.startObserver();
    }
  }
  unmount() {
  }
};
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
  return (name) => viewport[name] !== prevViewport[name];
}

// ../../node_modules/framer-motion/dist/es/motion/features/gestures.mjs
var gestureAnimations = {
  inView: {
    Feature: InViewFeature
  },
  tap: {
    Feature: PressGesture
  },
  focus: {
    Feature: FocusGesture
  },
  hover: {
    Feature: HoverGesture
  }
};

// ../../node_modules/framer-motion/dist/es/utils/shallow-compare.mjs
function shallowCompare(next, prev) {
  if (!Array.isArray(prev))
    return false;
  const prevLength = prev.length;
  if (prevLength !== next.length)
    return false;
  for (let i = 0; i < prevLength; i++) {
    if (prev[i] !== next[i])
      return false;
  }
  return true;
}

// ../../node_modules/framer-motion/dist/es/render/utils/resolve-dynamic-variants.mjs
function getCurrent(visualElement) {
  const current = {};
  visualElement.values.forEach((value, key) => current[key] = value.get());
  return current;
}
function getVelocity(visualElement) {
  const velocity = {};
  visualElement.values.forEach((value, key) => velocity[key] = value.getVelocity());
  return velocity;
}
function resolveVariant(visualElement, definition, custom) {
  const props = visualElement.getProps();
  return resolveVariantFromProps(props, definition, custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity(visualElement));
}

// ../../node_modules/framer-motion/dist/es/utils/time-conversion.mjs
var secondsToMilliseconds = (seconds) => seconds * 1e3;
var millisecondsToSeconds = (milliseconds) => milliseconds / 1e3;

// ../../node_modules/framer-motion/dist/es/animation/utils/default-transitions.mjs
var underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
};
var criticallyDampedSpring = (target) => ({
  type: "spring",
  stiffness: 550,
  damping: target === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
});
var keyframesTransition = {
  type: "keyframes",
  duration: 0.8
};
var ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
};
var getDefaultTransition = (valueKey, { keyframes: keyframes2 }) => {
  if (keyframes2.length > 2) {
    return keyframesTransition;
  } else if (transformProps.has(valueKey)) {
    return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes2[1]) : underDampedSpring;
  }
  return ease;
};

// ../../node_modules/framer-motion/dist/es/animation/utils/transitions.mjs
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
  return !!Object.keys(transition).length;
}
function getValueTransition(transition, key) {
  return transition[key] || transition["default"] || transition;
}

// ../../node_modules/framer-motion/dist/es/utils/use-instant-transition-state.mjs
var instantAnimationState = {
  current: false
};

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/utils/get-final-keyframe.mjs
var isNotNull = (value) => value !== null;
function getFinalKeyframe(keyframes2, { repeat, repeatType = "loop" }, finalKeyframe) {
  const resolvedKeyframes = keyframes2.filter(isNotNull);
  const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === void 0 ? resolvedKeyframes[index] : finalKeyframe;
}

// ../../node_modules/framer-motion/dist/es/frameloop/sync-time.mjs
var now;
function clearTime() {
  now = void 0;
}
var time = {
  now: () => {
    if (now === void 0) {
      time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now());
    }
    return now;
  },
  set: (newTime) => {
    now = newTime;
    queueMicrotask(clearTime);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/is-zero-value-string.mjs
var isZeroValueString = (v) => /^0[^.\s]+$/u.test(v);

// ../../node_modules/framer-motion/dist/es/animation/utils/is-none.mjs
function isNone(value) {
  if (typeof value === "number") {
    return value === 0;
  } else if (value !== null) {
    return value === "none" || value === "0" || isZeroValueString(value);
  } else {
    return true;
  }
}

// ../../node_modules/framer-motion/dist/es/utils/errors.mjs
var warning = noop2;
var invariant = noop2;
if (process.env.NODE_ENV !== "production") {
  warning = (check, message) => {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = (check, message) => {
    if (!check) {
      throw new Error(message);
    }
  };
}

// ../../node_modules/framer-motion/dist/es/utils/is-numerical-string.mjs
var isNumericalString = (v) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

// ../../node_modules/framer-motion/dist/es/render/dom/utils/css-variables-conversion.mjs
var splitCSSVariableRegex = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function parseCSSVariable(current) {
  const match = splitCSSVariableRegex.exec(current);
  if (!match)
    return [,];
  const [, token1, token2, fallback] = match;
  return [`--${token1 !== null && token1 !== void 0 ? token1 : token2}`, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
  invariant(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
  const [token, fallback] = parseCSSVariable(current);
  if (!token)
    return;
  const resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    const trimmed = resolved.trim();
    return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
  }
  return isCSSVariableToken(fallback) ? getVariableValue(fallback, element, depth + 1) : fallback;
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/unit-conversion.mjs
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]);
var isNumOrPxType = (v) => v === number || v === px;
var getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
var getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
  if (transform === "none" || !transform)
    return 0;
  const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
  if (matrix3d) {
    return getPosFromMatrix(matrix3d[1], pos3);
  } else {
    const matrix = transform.match(/^matrix\((.+)\)$/u);
    if (matrix) {
      return getPosFromMatrix(matrix[1], pos2);
    } else {
      return 0;
    }
  }
};
var transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
  const removedTransforms = [];
  nonTranslationalTransformKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    if (value !== void 0) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  return removedTransforms;
}
var positionalValues = {
  // Dimensions
  width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
  height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
  top: (_bbox, { top }) => parseFloat(top),
  left: (_bbox, { left }) => parseFloat(left),
  bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
  right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/test.mjs
var testValueType = (v) => (type) => type.test(v);

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-auto.mjs
var auto = {
  test: (v) => v === "auto",
  parse: (v) => v
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/dimensions.mjs
var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
var findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

// ../../node_modules/framer-motion/dist/es/render/utils/KeyframesResolver.mjs
var toResolve = /* @__PURE__ */ new Set();
var isScheduled = false;
var anyNeedsMeasurement = false;
function measureAllKeyframes() {
  if (anyNeedsMeasurement) {
    const resolversToMeasure = Array.from(toResolve).filter((resolver) => resolver.needsMeasurement);
    const elementsToMeasure = new Set(resolversToMeasure.map((resolver) => resolver.element));
    const transformsToRestore = /* @__PURE__ */ new Map();
    elementsToMeasure.forEach((element) => {
      const removedTransforms = removeNonTranslationalTransform(element);
      if (!removedTransforms.length)
        return;
      transformsToRestore.set(element, removedTransforms);
      element.render();
    });
    resolversToMeasure.forEach((resolver) => resolver.measureInitialState());
    elementsToMeasure.forEach((element) => {
      element.render();
      const restore = transformsToRestore.get(element);
      if (restore) {
        restore.forEach(([key, value]) => {
          var _a;
          (_a = element.getValue(key)) === null || _a === void 0 ? void 0 : _a.set(value);
        });
      }
    });
    resolversToMeasure.forEach((resolver) => resolver.measureEndState());
    resolversToMeasure.forEach((resolver) => {
      if (resolver.suspendedScrollY !== void 0) {
        window.scrollTo(0, resolver.suspendedScrollY);
      }
    });
  }
  anyNeedsMeasurement = false;
  isScheduled = false;
  toResolve.forEach((resolver) => resolver.complete());
  toResolve.clear();
}
function readAllKeyframes() {
  toResolve.forEach((resolver) => {
    resolver.readKeyframes();
    if (resolver.needsMeasurement) {
      anyNeedsMeasurement = true;
    }
  });
}
function flushKeyframeResolvers() {
  readAllKeyframes();
  measureAllKeyframes();
}
var KeyframeResolver = class {
  constructor(unresolvedKeyframes, onComplete, name, motionValue2, element, isAsync = false) {
    this.isComplete = false;
    this.isAsync = false;
    this.needsMeasurement = false;
    this.isScheduled = false;
    this.unresolvedKeyframes = [...unresolvedKeyframes];
    this.onComplete = onComplete;
    this.name = name;
    this.motionValue = motionValue2;
    this.element = element;
    this.isAsync = isAsync;
  }
  scheduleResolve() {
    this.isScheduled = true;
    if (this.isAsync) {
      toResolve.add(this);
      if (!isScheduled) {
        isScheduled = true;
        frame.read(readAllKeyframes);
        frame.resolveKeyframes(measureAllKeyframes);
      }
    } else {
      this.readKeyframes();
      this.complete();
    }
  }
  readKeyframes() {
    const { unresolvedKeyframes, name, element, motionValue: motionValue2 } = this;
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      if (unresolvedKeyframes[i] === null) {
        if (i === 0) {
          const currentValue = motionValue2 === null || motionValue2 === void 0 ? void 0 : motionValue2.get();
          const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
          if (currentValue !== void 0) {
            unresolvedKeyframes[0] = currentValue;
          } else if (element && name) {
            const valueAsRead = element.readValue(name, finalKeyframe);
            if (valueAsRead !== void 0 && valueAsRead !== null) {
              unresolvedKeyframes[0] = valueAsRead;
            }
          }
          if (unresolvedKeyframes[0] === void 0) {
            unresolvedKeyframes[0] = finalKeyframe;
          }
          if (motionValue2 && currentValue === void 0) {
            motionValue2.set(unresolvedKeyframes[0]);
          }
        } else {
          unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
      }
    }
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = true;
    this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
    toResolve.delete(this);
  }
  cancel() {
    if (!this.isComplete) {
      this.isScheduled = false;
      toResolve.delete(this);
    }
  }
  resume() {
    if (!this.isComplete)
      this.scheduleResolve();
  }
};

// ../../node_modules/framer-motion/dist/es/value/types/color/utils.mjs
var isColorString = (type, testProp) => (v) => {
  return Boolean(isString(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
};
var splitColor = (aName, bName, cName) => (v) => {
  if (!isString(v))
    return v;
  const [a, b, c, alpha2] = v.match(floatRegex);
  return {
    [aName]: parseFloat(a),
    [bName]: parseFloat(b),
    [cName]: parseFloat(c),
    alpha: alpha2 !== void 0 ? parseFloat(alpha2) : 1
  };
};

// ../../node_modules/framer-motion/dist/es/value/types/color/rgba.mjs
var clampRgbUnit = (v) => clamp(0, 255, v);
var rgbUnit = {
  ...number,
  transform: (v) => Math.round(clampRgbUnit(v))
};
var rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")"
};

// ../../node_modules/framer-motion/dist/es/value/types/color/hex.mjs
function parseHex(v) {
  let r = "";
  let g = "";
  let b = "";
  let a = "";
  if (v.length > 5) {
    r = v.substring(1, 3);
    g = v.substring(3, 5);
    b = v.substring(5, 7);
    a = v.substring(7, 9);
  } else {
    r = v.substring(1, 2);
    g = v.substring(2, 3);
    b = v.substring(3, 4);
    a = v.substring(4, 5);
    r += r;
    g += g;
    b += b;
    a += a;
  }
  return {
    red: parseInt(r, 16),
    green: parseInt(g, 16),
    blue: parseInt(b, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
var hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
};

// ../../node_modules/framer-motion/dist/es/value/types/color/hsla.mjs
var hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};

// ../../node_modules/framer-motion/dist/es/value/types/color/index.mjs
var color = {
  test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
  parse: (v) => {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else {
      return hex.parse(v);
    }
  },
  transform: (v) => {
    return isString(v) ? v : v.hasOwnProperty("red") ? rgba.transform(v) : hsla.transform(v);
  }
};

// ../../node_modules/framer-motion/dist/es/value/types/complex/index.mjs
function test(v) {
  var _a, _b;
  return isNaN(v) && isString(v) && (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
var NUMBER_TOKEN = "number";
var COLOR_TOKEN = "color";
var VAR_TOKEN = "var";
var VAR_FUNCTION_TOKEN = "var(";
var SPLIT_TOKEN = "${}";
var complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function analyseComplexValue(value) {
  const originalValue = value.toString();
  const values = [];
  const indexes = {
    color: [],
    number: [],
    var: []
  };
  const types = [];
  let i = 0;
  const tokenised = originalValue.replace(complexRegex, (parsedValue) => {
    if (color.test(parsedValue)) {
      indexes.color.push(i);
      types.push(COLOR_TOKEN);
      values.push(color.parse(parsedValue));
    } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
      indexes.var.push(i);
      types.push(VAR_TOKEN);
      values.push(parsedValue);
    } else {
      indexes.number.push(i);
      types.push(NUMBER_TOKEN);
      values.push(parseFloat(parsedValue));
    }
    ++i;
    return SPLIT_TOKEN;
  });
  const split = tokenised.split(SPLIT_TOKEN);
  return { values, split, indexes, types };
}
function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}
function createTransformer(source) {
  const { split, types } = analyseComplexValue(source);
  const numSections = split.length;
  return (v) => {
    let output = "";
    for (let i = 0; i < numSections; i++) {
      output += split[i];
      if (v[i] !== void 0) {
        const type = types[i];
        if (type === NUMBER_TOKEN) {
          output += sanitize(v[i]);
        } else if (type === COLOR_TOKEN) {
          output += color.transform(v[i]);
        } else {
          output += v[i];
        }
      }
    }
    return output;
  };
}
var convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone(v) {
  const parsed = parseComplexValue(v);
  const transformer = createTransformer(v);
  return transformer(parsed.map(convertNumbersToZero));
}
var complex = {
  test,
  parse: parseComplexValue,
  createTransformer,
  getAnimatableNone
};

// ../../node_modules/framer-motion/dist/es/value/types/complex/filter.mjs
var maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
  const [name, value] = v.slice(0, -1).split("(");
  if (name === "drop-shadow")
    return v;
  const [number2] = value.match(floatRegex) || [];
  if (!number2)
    return v;
  const unit = value.replace(number2, "");
  let defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number2 !== value)
    defaultValue *= 100;
  return name + "(" + defaultValue + unit + ")";
}
var functionRegex = /\b([a-z-]*)\(.*?\)/gu;
var filter = {
  ...complex,
  getAnimatableNone: (v) => {
    const functions = v.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(" ") : v;
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/defaults.mjs
var defaultValueTypes = {
  ...numberValueTypes,
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
};
var getDefaultValueType = (key) => defaultValueTypes[key];

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/animatable-none.mjs
function getAnimatableNone2(key, value) {
  let defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter)
    defaultValueType = complex;
  return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : void 0;
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/make-none-animatable.mjs
function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
  let i = 0;
  let animatableTemplate = void 0;
  while (i < unresolvedKeyframes.length && !animatableTemplate) {
    if (typeof unresolvedKeyframes[i] === "string" && unresolvedKeyframes[i] !== "none" && unresolvedKeyframes[i] !== "0") {
      animatableTemplate = unresolvedKeyframes[i];
    }
    i++;
  }
  if (animatableTemplate && name) {
    for (const noneIndex of noneKeyframeIndexes) {
      unresolvedKeyframes[noneIndex] = getAnimatableNone2(name, animatableTemplate);
    }
  }
}

// ../../node_modules/framer-motion/dist/es/render/dom/DOMKeyframesResolver.mjs
var DOMKeyframesResolver = class extends KeyframeResolver {
  constructor(unresolvedKeyframes, onComplete, name, motionValue2) {
    super(unresolvedKeyframes, onComplete, name, motionValue2, motionValue2 === null || motionValue2 === void 0 ? void 0 : motionValue2.owner, true);
  }
  readKeyframes() {
    const { unresolvedKeyframes, element, name } = this;
    if (!element.current)
      return;
    super.readKeyframes();
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      const keyframe = unresolvedKeyframes[i];
      if (typeof keyframe === "string" && isCSSVariableToken(keyframe)) {
        const resolved = getVariableValue(keyframe, element.current);
        if (resolved !== void 0) {
          unresolvedKeyframes[i] = resolved;
        }
        if (i === unresolvedKeyframes.length - 1) {
          this.finalKeyframe = keyframe;
        }
      }
    }
    if (!positionalKeys.has(name) || unresolvedKeyframes.length !== 2) {
      return this.resolveNoneKeyframes();
    }
    const [origin, target] = unresolvedKeyframes;
    const originType = findDimensionValueType(origin);
    const targetType = findDimensionValueType(target);
    if (originType === targetType)
      return;
    if (isNumOrPxType(originType) && isNumOrPxType(targetType)) {
      for (let i = 0; i < unresolvedKeyframes.length; i++) {
        const value = unresolvedKeyframes[i];
        if (typeof value === "string") {
          unresolvedKeyframes[i] = parseFloat(value);
        }
      }
    } else {
      this.needsMeasurement = true;
    }
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes, name } = this;
    const noneKeyframeIndexes = [];
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      if (isNone(unresolvedKeyframes[i])) {
        noneKeyframeIndexes.push(i);
      }
    }
    if (noneKeyframeIndexes.length) {
      makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
  }
  measureInitialState() {
    const { element, unresolvedKeyframes, name } = this;
    if (!element.current)
      return;
    if (name === "height") {
      this.suspendedScrollY = window.pageYOffset;
    }
    this.measuredOrigin = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
    unresolvedKeyframes[0] = this.measuredOrigin;
    const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
    if (measureKeyframe !== void 0) {
      element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
  }
  measureEndState() {
    var _a;
    const { element, name, unresolvedKeyframes } = this;
    if (!element.current)
      return;
    const value = element.getValue(name);
    value && value.jump(this.measuredOrigin, false);
    const finalKeyframeIndex = unresolvedKeyframes.length - 1;
    const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
    unresolvedKeyframes[finalKeyframeIndex] = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
    if (finalKeyframe !== null && this.finalKeyframe === void 0) {
      this.finalKeyframe = finalKeyframe;
    }
    if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) {
      this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue]) => {
        element.getValue(unsetTransformName).set(unsetTransformValue);
      });
    }
    this.resolveNoneKeyframes();
  }
};

// ../../node_modules/framer-motion/dist/es/utils/memo.mjs
function memo(callback) {
  let result;
  return () => {
    if (result === void 0)
      result = callback();
    return result;
  };
}

// ../../node_modules/framer-motion/dist/es/animation/utils/is-animatable.mjs
var isAnimatable = (value, name) => {
  if (name === "zIndex")
    return false;
  if (typeof value === "number" || Array.isArray(value))
    return true;
  if (typeof value === "string" && // It's animatable if we have a string
  (complex.test(value) || value === "0") && // And it contains numbers and/or colors
  !value.startsWith("url(")) {
    return true;
  }
  return false;
};

// ../../node_modules/framer-motion/dist/es/animation/animators/utils/can-animate.mjs
function hasKeyframesChanged(keyframes2) {
  const current = keyframes2[0];
  if (keyframes2.length === 1)
    return true;
  for (let i = 0; i < keyframes2.length; i++) {
    if (keyframes2[i] !== current)
      return true;
  }
}
function canAnimate(keyframes2, name, type, velocity) {
  const originKeyframe = keyframes2[0];
  if (originKeyframe === null)
    return false;
  const targetKeyframe = keyframes2[keyframes2.length - 1];
  const isOriginAnimatable = isAnimatable(originKeyframe, name);
  const isTargetAnimatable = isAnimatable(targetKeyframe, name);
  warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
  if (!isOriginAnimatable || !isTargetAnimatable) {
    return false;
  }
  return hasKeyframesChanged(keyframes2) || type === "spring" && velocity;
}

// ../../node_modules/framer-motion/dist/es/animation/animators/BaseAnimation.mjs
var BaseAnimation = class {
  constructor({ autoplay = true, delay: delay2 = 0, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", ...options }) {
    this.isStopped = false;
    this.hasAttemptedResolve = false;
    this.options = {
      autoplay,
      delay: delay2,
      type,
      repeat,
      repeatDelay,
      repeatType,
      ...options
    };
    this.updateFinishedPromise();
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    if (!this._resolved && !this.hasAttemptedResolve) {
      flushKeyframeResolvers();
    }
    return this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(keyframes2, finalKeyframe) {
    this.hasAttemptedResolve = true;
    const { name, type, velocity, delay: delay2, onComplete, onUpdate, isGenerator } = this.options;
    if (!isGenerator && !canAnimate(keyframes2, name, type, velocity)) {
      if (instantAnimationState.current || !delay2) {
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(getFinalKeyframe(keyframes2, this.options, finalKeyframe));
        onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        this.resolveFinishedPromise();
        return;
      } else {
        this.options.duration = 0;
      }
    }
    const resolvedAnimation = this.initPlayback(keyframes2, finalKeyframe);
    if (resolvedAnimation === false)
      return;
    this._resolved = {
      keyframes: keyframes2,
      finalKeyframe,
      ...resolvedAnimation
    };
    this.onPostResolved();
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(resolve, reject) {
    return this.currentFinishedPromise.then(resolve, reject);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((resolve) => {
      this.resolveFinishedPromise = resolve;
    });
  }
};

// ../../node_modules/framer-motion/dist/es/utils/velocity-per-second.mjs
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1e3 / frameDuration) : 0;
}

// ../../node_modules/framer-motion/dist/es/animation/generators/utils/velocity.mjs
var velocitySampleDuration = 5;
function calcGeneratorVelocity(resolveValue, t, current) {
  const prevT = Math.max(t - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

// ../../node_modules/framer-motion/dist/es/animation/generators/spring/find.mjs
var safeMin = 1e-3;
var minDuration = 0.01;
var maxDuration = 10;
var minDamping = 0.05;
var maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
  let envelope;
  let derivative;
  warning(duration <= secondsToMilliseconds(maxDuration), "Spring duration must be 10 seconds or less");
  let dampingRatio = 1 - bounce;
  dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
  duration = clamp(minDuration, maxDuration, millisecondsToSeconds(duration));
  if (dampingRatio < 1) {
    envelope = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration;
      const a = exponentialDecay - velocity;
      const b = calcAngularFreq(undampedFreq2, dampingRatio);
      const c = Math.exp(-delta);
      return safeMin - a / b * c;
    };
    derivative = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration;
      const d = delta * velocity + velocity;
      const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration;
      const f = Math.exp(-delta);
      const g = calcAngularFreq(Math.pow(undampedFreq2, 2), dampingRatio);
      const factor = -envelope(undampedFreq2) + safeMin > 0 ? -1 : 1;
      return factor * ((d - e) * f) / g;
    };
  } else {
    envelope = (undampedFreq2) => {
      const a = Math.exp(-undampedFreq2 * duration);
      const b = (undampedFreq2 - velocity) * duration + 1;
      return -safeMin + a * b;
    };
    derivative = (undampedFreq2) => {
      const a = Math.exp(-undampedFreq2 * duration);
      const b = (velocity - undampedFreq2) * (duration * duration);
      return a * b;
    };
  }
  const initialGuess = 5 / duration;
  const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration = secondsToMilliseconds(duration);
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration
    };
  } else {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration
    };
  }
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  let result = initialGuess;
  for (let i = 1; i < rootIterations; i++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

// ../../node_modules/framer-motion/dist/es/animation/generators/spring/index.mjs
var durationKeys = ["duration", "bounce"];
var physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
  return keys.some((key) => options[key] !== void 0);
}
function getSpringOptions(options) {
  let springOptions = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: false,
    ...options
  };
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    const derived = findSpring(options);
    springOptions = {
      ...springOptions,
      ...derived,
      mass: 1
    };
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring({ keyframes: keyframes2, restDelta, restSpeed, ...options }) {
  const origin = keyframes2[0];
  const target = keyframes2[keyframes2.length - 1];
  const state = { done: false, value: origin };
  const { stiffness, damping, mass, duration, velocity, isResolvedFromDuration } = getSpringOptions({
    ...options,
    velocity: -millisecondsToSeconds(options.velocity || 0)
  });
  const initialVelocity = velocity || 0;
  const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
  const initialDelta = target - origin;
  const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
  const isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
  restDelta || (restDelta = isGranularScale ? 5e-3 : 0.5);
  let resolveSpring;
  if (dampingRatio < 1) {
    const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
    resolveSpring = (t) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
    };
  } else if (dampingRatio === 1) {
    resolveSpring = (t) => target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
  } else {
    const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = (t) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      const freqForT = Math.min(dampedAngularFreq * t, 300);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
    };
  }
  return {
    calculatedDuration: isResolvedFromDuration ? duration || null : null,
    next: (t) => {
      const current = resolveSpring(t);
      if (!isResolvedFromDuration) {
        let currentVelocity = initialVelocity;
        if (t !== 0) {
          if (dampingRatio < 1) {
            currentVelocity = calcGeneratorVelocity(resolveSpring, t, current);
          } else {
            currentVelocity = 0;
          }
        }
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t >= duration;
      }
      state.value = state.done ? target : current;
      return state;
    }
  };
}

// ../../node_modules/framer-motion/dist/es/animation/generators/inertia.mjs
function inertia({ keyframes: keyframes2, velocity = 0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed }) {
  const origin = keyframes2[0];
  const state = {
    done: false,
    value: origin
  };
  const isOutOfBounds = (v) => min !== void 0 && v < min || max !== void 0 && v > max;
  const nearestBoundary = (v) => {
    if (min === void 0)
      return max;
    if (max === void 0)
      return min;
    return Math.abs(min - v) < Math.abs(max - v) ? min : max;
  };
  let amplitude = power * velocity;
  const ideal = origin + amplitude;
  const target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
  if (target !== ideal)
    amplitude = target - origin;
  const calcDelta = (t) => -amplitude * Math.exp(-t / timeConstant);
  const calcLatest = (t) => target + calcDelta(t);
  const applyFriction = (t) => {
    const delta = calcDelta(t);
    const latest = calcLatest(t);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  let timeReachedBoundary;
  let spring$1;
  const checkCatchBoundary = (t) => {
    if (!isOutOfBounds(state.value))
      return;
    timeReachedBoundary = t;
    spring$1 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t, state.value),
      // TODO: This should be passing * 1000
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta,
      restSpeed
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: (t) => {
      let hasUpdatedFrame = false;
      if (!spring$1 && timeReachedBoundary === void 0) {
        hasUpdatedFrame = true;
        applyFriction(t);
        checkCatchBoundary(t);
      }
      if (timeReachedBoundary !== void 0 && t >= timeReachedBoundary) {
        return spring$1.next(t - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t);
        return state;
      }
    }
  };
}

// ../../node_modules/framer-motion/dist/es/easing/cubic-bezier.mjs
var calcBezier = (t, a1, a2) => (((1 - 3 * a2 + 3 * a1) * t + (3 * a2 - 6 * a1)) * t + 3 * a1) * t;
var subdivisionPrecision = 1e-7;
var subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
  let currentX;
  let currentT;
  let i = 0;
  do {
    currentT = lowerBound + (upperBound - lowerBound) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - x;
    if (currentX > 0) {
      upperBound = currentT;
    } else {
      lowerBound = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
  return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return noop2;
  const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
  return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

// ../../node_modules/framer-motion/dist/es/easing/ease.mjs
var easeIn = cubicBezier(0.42, 0, 1, 1);
var easeOut = cubicBezier(0, 0, 0.58, 1);
var easeInOut = cubicBezier(0.42, 0, 0.58, 1);

// ../../node_modules/framer-motion/dist/es/easing/utils/is-easing-array.mjs
var isEasingArray = (ease2) => {
  return Array.isArray(ease2) && typeof ease2[0] !== "number";
};

// ../../node_modules/framer-motion/dist/es/easing/modifiers/mirror.mjs
var mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

// ../../node_modules/framer-motion/dist/es/easing/modifiers/reverse.mjs
var reverseEasing = (easing) => (p) => 1 - easing(1 - p);

// ../../node_modules/framer-motion/dist/es/easing/circ.mjs
var circIn = (p) => 1 - Math.sin(Math.acos(p));
var circOut = reverseEasing(circIn);
var circInOut = mirrorEasing(circIn);

// ../../node_modules/framer-motion/dist/es/easing/back.mjs
var backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
var backIn = reverseEasing(backOut);
var backInOut = mirrorEasing(backIn);

// ../../node_modules/framer-motion/dist/es/easing/anticipate.mjs
var anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

// ../../node_modules/framer-motion/dist/es/easing/utils/map.mjs
var easingLookup = {
  linear: noop2,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate
};
var easingDefinitionToFunction = (definition) => {
  if (Array.isArray(definition)) {
    invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
    const [x1, y1, x2, y2] = definition;
    return cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    invariant(easingLookup[definition] !== void 0, `Invalid easing type '${definition}'`);
    return easingLookup[definition];
  }
  return definition;
};

// ../../node_modules/framer-motion/dist/es/utils/progress.mjs
var progress = (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

// ../../node_modules/framer-motion/dist/es/utils/mix/number.mjs
var mixNumber = (from, to, progress2) => {
  return from + (to - from) * progress2;
};

// ../../node_modules/framer-motion/dist/es/utils/hsla-to-rgba.mjs
function hueToRgb(p, q, t) {
  if (t < 0)
    t += 1;
  if (t > 1)
    t -= 1;
  if (t < 1 / 6)
    return p + (q - p) * 6 * t;
  if (t < 1 / 2)
    return q;
  if (t < 2 / 3)
    return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha: alpha2 }) {
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  let red = 0;
  let green = 0;
  let blue = 0;
  if (!saturation) {
    red = green = blue = lightness;
  } else {
    const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    const p = 2 * lightness - q;
    red = hueToRgb(p, q, hue + 1 / 3);
    green = hueToRgb(p, q, hue);
    blue = hueToRgb(p, q, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha: alpha2
  };
}

// ../../node_modules/framer-motion/dist/es/utils/mix/color.mjs
var mixLinearColor = (from, to, v) => {
  const fromExpo = from * from;
  const expo = v * (to * to - fromExpo) + fromExpo;
  return expo < 0 ? 0 : Math.sqrt(expo);
};
var colorTypes = [hex, rgba, hsla];
var getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color2) {
  const type = getColorType(color2);
  invariant(Boolean(type), `'${color2}' is not an animatable color. Use the equivalent color code instead.`);
  let model = type.parse(color2);
  if (type === hsla) {
    model = hslaToRgba(model);
  }
  return model;
}
var mixColor = (from, to) => {
  const fromRGBA = asRGBA(from);
  const toRGBA = asRGBA(to);
  const blended = { ...fromRGBA };
  return (v) => {
    blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
    blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
    blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
    blended.alpha = mixNumber(fromRGBA.alpha, toRGBA.alpha, v);
    return rgba.transform(blended);
  };
};

// ../../node_modules/framer-motion/dist/es/utils/mix/complex.mjs
function mixImmediate(a, b) {
  return (p) => p > 0 ? b : a;
}
function mixNumber2(a, b) {
  return (p) => mixNumber(a, b, p);
}
function getMixer(a) {
  if (typeof a === "number") {
    return mixNumber2;
  } else if (typeof a === "string") {
    return isCSSVariableToken(a) ? mixImmediate : color.test(a) ? mixColor : mixComplex;
  } else if (Array.isArray(a)) {
    return mixArray;
  } else if (typeof a === "object") {
    return color.test(a) ? mixColor : mixObject;
  }
  return mixImmediate;
}
function mixArray(a, b) {
  const output = [...a];
  const numValues = output.length;
  const blendValue = a.map((v, i) => getMixer(v)(v, b[i]));
  return (p) => {
    for (let i = 0; i < numValues; i++) {
      output[i] = blendValue[i](p);
    }
    return output;
  };
}
function mixObject(a, b) {
  const output = { ...a, ...b };
  const blendValue = {};
  for (const key in output) {
    if (a[key] !== void 0 && b[key] !== void 0) {
      blendValue[key] = getMixer(a[key])(a[key], b[key]);
    }
  }
  return (v) => {
    for (const key in blendValue) {
      output[key] = blendValue[key](v);
    }
    return output;
  };
}
function matchOrder(origin, target) {
  var _a;
  const orderedOrigin = [];
  const pointers = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < target.values.length; i++) {
    const type = target.types[i];
    const originIndex = origin.indexes[type][pointers[type]];
    const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
    orderedOrigin[i] = originValue;
    pointers[type]++;
  }
  return orderedOrigin;
}
var mixComplex = (origin, target) => {
  const template = complex.createTransformer(target);
  const originStats = analyseComplexValue(origin);
  const targetStats = analyseComplexValue(target);
  const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
  if (canInterpolate) {
    return pipe(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
  } else {
    warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
    return mixImmediate(origin, target);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/mix/index.mjs
function mix(from, to, p) {
  if (typeof from === "number" && typeof to === "number" && typeof p === "number") {
    return mixNumber(from, to, p);
  }
  const mixer = getMixer(from);
  return mixer(from, to);
}

// ../../node_modules/framer-motion/dist/es/utils/interpolate.mjs
function createMixers(output, ease2, customMixer) {
  const mixers = [];
  const mixerFactory = customMixer || mix;
  const numMixers = output.length - 1;
  for (let i = 0; i < numMixers; i++) {
    let mixer = mixerFactory(output[i], output[i + 1]);
    if (ease2) {
      const easingFunction = Array.isArray(ease2) ? ease2[i] || noop2 : ease2;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
function interpolate(input, output, { clamp: isClamp = true, ease: ease2, mixer } = {}) {
  const inputLength = input.length;
  invariant(inputLength === output.length, "Both input and output ranges must be the same length");
  if (inputLength === 1)
    return () => output[0];
  if (inputLength === 2 && input[0] === input[1])
    return () => output[1];
  if (input[0] > input[inputLength - 1]) {
    input = [...input].reverse();
    output = [...output].reverse();
  }
  const mixers = createMixers(output, ease2, mixer);
  const numMixers = mixers.length;
  const interpolator = (v) => {
    let i = 0;
    if (numMixers > 1) {
      for (; i < input.length - 2; i++) {
        if (v < input[i + 1])
          break;
      }
    }
    const progressInRange = progress(input[i], input[i + 1], v);
    return mixers[i](progressInRange);
  };
  return isClamp ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v)) : interpolator;
}

// ../../node_modules/framer-motion/dist/es/utils/offsets/fill.mjs
function fillOffset(offset, remaining) {
  const min = offset[offset.length - 1];
  for (let i = 1; i <= remaining; i++) {
    const offsetProgress = progress(0, remaining, i);
    offset.push(mixNumber(min, 1, offsetProgress));
  }
}

// ../../node_modules/framer-motion/dist/es/utils/offsets/default.mjs
function defaultOffset(arr) {
  const offset = [0];
  fillOffset(offset, arr.length - 1);
  return offset;
}

// ../../node_modules/framer-motion/dist/es/utils/offsets/time.mjs
function convertOffsetToTimes(offset, duration) {
  return offset.map((o) => o * duration);
}

// ../../node_modules/framer-motion/dist/es/animation/generators/keyframes.mjs
function defaultEasing(values, easing) {
  return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function keyframes({ duration = 300, keyframes: keyframeValues, times, ease: ease2 = "easeInOut" }) {
  const easingFunctions = isEasingArray(ease2) ? ease2.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease2);
  const state = {
    done: false,
    value: keyframeValues[0]
  };
  const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : defaultOffset(keyframeValues),
    duration
  );
  const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
  });
  return {
    calculatedDuration: duration,
    next: (t) => {
      state.value = mapTimeToKeyframe(t);
      state.done = t >= duration;
      return state;
    }
  };
}

// ../../node_modules/framer-motion/dist/es/animation/generators/utils/calc-duration.mjs
var maxGeneratorDuration = 2e4;
function calcGeneratorDuration(generator) {
  let duration = 0;
  const timeStep = 50;
  let state = generator.next(duration);
  while (!state.done && duration < maxGeneratorDuration) {
    duration += timeStep;
    state = generator.next(duration);
  }
  return duration >= maxGeneratorDuration ? Infinity : duration;
}

// ../../node_modules/framer-motion/dist/es/animation/animators/drivers/driver-frameloop.mjs
var frameloopDriver = (update) => {
  const passTimestamp = ({ timestamp }) => update(timestamp);
  return {
    start: () => frame.update(passTimestamp, true),
    stop: () => cancelFrame(passTimestamp),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => frameData.isProcessing ? frameData.timestamp : time.now()
  };
};

// ../../node_modules/framer-motion/dist/es/animation/animators/MainThreadAnimation.mjs
var generators = {
  decay: inertia,
  inertia,
  tween: keyframes,
  keyframes,
  spring
};
var percentToProgress = (percent2) => percent2 / 100;
var MainThreadAnimation = class extends BaseAnimation {
  constructor({ KeyframeResolver: KeyframeResolver$1 = KeyframeResolver, ...options }) {
    super(options);
    this.holdTime = null;
    this.startTime = null;
    this.cancelTime = null;
    this.currentTime = 0;
    this.playbackSpeed = 1;
    this.pendingPlayState = "running";
    this.state = "idle";
    const { name, motionValue: motionValue2, keyframes: keyframes2 } = this.options;
    const onResolved = (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
    if (name && motionValue2 && motionValue2.owner) {
      this.resolver = motionValue2.owner.resolveKeyframes(keyframes2, onResolved, name, motionValue2);
    } else {
      this.resolver = new KeyframeResolver$1(keyframes2, onResolved, name, motionValue2);
    }
    this.resolver.scheduleResolve();
  }
  initPlayback(keyframes$1) {
    const { type = "keyframes", repeat = 0, repeatDelay = 0, repeatType, velocity = 0 } = this.options;
    const generatorFactory = generators[type] || keyframes;
    let mapPercentToKeyframes;
    let mirroredGenerator;
    if (generatorFactory !== keyframes && typeof keyframes$1[0] !== "number") {
      if (process.env.NODE_ENV !== "production") {
        invariant(keyframes$1.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$1}`);
      }
      mapPercentToKeyframes = pipe(percentToProgress, mix(keyframes$1[0], keyframes$1[1]));
      keyframes$1 = [0, 100];
    }
    const generator = generatorFactory({ ...this.options, keyframes: keyframes$1 });
    if (repeatType === "mirror") {
      mirroredGenerator = generatorFactory({
        ...this.options,
        keyframes: [...keyframes$1].reverse(),
        velocity: -velocity
      });
    }
    if (generator.calculatedDuration === null) {
      generator.calculatedDuration = calcGeneratorDuration(generator);
    }
    const { calculatedDuration } = generator;
    const resolvedDuration = calculatedDuration + repeatDelay;
    const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    return {
      generator,
      mirroredGenerator,
      mapPercentToKeyframes,
      calculatedDuration,
      resolvedDuration,
      totalDuration
    };
  }
  onPostResolved() {
    const { autoplay = true } = this.options;
    this.play();
    if (this.pendingPlayState === "paused" || !autoplay) {
      this.pause();
    } else {
      this.state = this.pendingPlayState;
    }
  }
  tick(timestamp, sample = false) {
    const { resolved } = this;
    if (!resolved) {
      const { keyframes: keyframes3 } = this.options;
      return { done: true, value: keyframes3[keyframes3.length - 1] };
    }
    const { finalKeyframe, generator, mirroredGenerator, mapPercentToKeyframes, keyframes: keyframes2, calculatedDuration, totalDuration, resolvedDuration } = resolved;
    if (this.startTime === null)
      return generator.next(0);
    const { delay: delay2, repeat, repeatType, repeatDelay, onUpdate } = this.options;
    if (this.speed > 0) {
      this.startTime = Math.min(this.startTime, timestamp);
    } else if (this.speed < 0) {
      this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
    }
    if (sample) {
      this.currentTime = timestamp;
    } else if (this.holdTime !== null) {
      this.currentTime = this.holdTime;
    } else {
      this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
    }
    const timeWithoutDelay = this.currentTime - delay2 * (this.speed >= 0 ? 1 : -1);
    const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    this.currentTime = Math.max(timeWithoutDelay, 0);
    if (this.state === "finished" && this.holdTime === null) {
      this.currentTime = totalDuration;
    }
    let elapsed = this.currentTime;
    let frameGenerator = generator;
    if (repeat) {
      const progress2 = Math.min(this.currentTime, totalDuration) / resolvedDuration;
      let currentIteration = Math.floor(progress2);
      let iterationProgress = progress2 % 1;
      if (!iterationProgress && progress2 >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      currentIteration = Math.min(currentIteration, repeat + 1);
      const isOddIteration = Boolean(currentIteration % 2);
      if (isOddIteration) {
        if (repeatType === "reverse") {
          iterationProgress = 1 - iterationProgress;
          if (repeatDelay) {
            iterationProgress -= repeatDelay / resolvedDuration;
          }
        } else if (repeatType === "mirror") {
          frameGenerator = mirroredGenerator;
        }
      }
      elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
    }
    const state = isInDelayPhase ? { done: false, value: keyframes2[0] } : frameGenerator.next(elapsed);
    if (mapPercentToKeyframes) {
      state.value = mapPercentToKeyframes(state.value);
    }
    let { done } = state;
    if (!isInDelayPhase && calculatedDuration !== null) {
      done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
    }
    const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
    if (isAnimationFinished && finalKeyframe !== void 0) {
      state.value = getFinalKeyframe(keyframes2, this.options, finalKeyframe);
    }
    if (onUpdate) {
      onUpdate(state.value);
    }
    if (isAnimationFinished) {
      this.finish();
    }
    return state;
  }
  get duration() {
    const { resolved } = this;
    return resolved ? millisecondsToSeconds(resolved.calculatedDuration) : 0;
  }
  get time() {
    return millisecondsToSeconds(this.currentTime);
  }
  set time(newTime) {
    newTime = secondsToMilliseconds(newTime);
    this.currentTime = newTime;
    if (this.holdTime !== null || this.speed === 0) {
      this.holdTime = newTime;
    } else if (this.driver) {
      this.startTime = this.driver.now() - newTime / this.speed;
    }
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(newSpeed) {
    const hasChanged = this.playbackSpeed !== newSpeed;
    this.playbackSpeed = newSpeed;
    if (hasChanged) {
      this.time = millisecondsToSeconds(this.currentTime);
    }
  }
  play() {
    if (!this.resolver.isScheduled) {
      this.resolver.resume();
    }
    if (!this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver = frameloopDriver, onPlay } = this.options;
    if (!this.driver) {
      this.driver = driver((timestamp) => this.tick(timestamp));
    }
    onPlay && onPlay();
    const now3 = this.driver.now();
    if (this.holdTime !== null) {
      this.startTime = now3 - this.holdTime;
    } else if (!this.startTime || this.state === "finished") {
      this.startTime = now3;
    }
    if (this.state === "finished") {
      this.updateFinishedPromise();
    }
    this.cancelTime = this.startTime;
    this.holdTime = null;
    this.state = "running";
    this.driver.start();
  }
  pause() {
    var _a;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused";
    this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
  }
  stop() {
    this.resolver.cancel();
    this.isStopped = true;
    if (this.state === "idle")
      return;
    this.teardown();
    const { onStop } = this.options;
    onStop && onStop();
  }
  complete() {
    if (this.state !== "running") {
      this.play();
    }
    this.pendingPlayState = this.state = "finished";
    this.holdTime = null;
  }
  finish() {
    this.teardown();
    this.state = "finished";
    const { onComplete } = this.options;
    onComplete && onComplete();
  }
  cancel() {
    if (this.cancelTime !== null) {
      this.tick(this.cancelTime);
    }
    this.teardown();
    this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle";
    this.stopDriver();
    this.resolveFinishedPromise();
    this.updateFinishedPromise();
    this.startTime = this.cancelTime = null;
    this.resolver.cancel();
  }
  stopDriver() {
    if (!this.driver)
      return;
    this.driver.stop();
    this.driver = void 0;
  }
  sample(time2) {
    this.startTime = 0;
    return this.tick(time2, true);
  }
};

// ../../node_modules/framer-motion/dist/es/easing/utils/is-bezier-definition.mjs
var isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/easing.mjs
function isWaapiSupportedEasing(easing) {
  return Boolean(!easing || typeof easing === "string" && easing in supportedWaapiEasing || isBezierDefinition(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}
var cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
var supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasingWithDefault(easing) {
  return mapEasingToNativeEasing(easing) || supportedWaapiEasing.easeOut;
}
function mapEasingToNativeEasing(easing) {
  if (!easing) {
    return void 0;
  } else if (isBezierDefinition(easing)) {
    return cubicBezierAsString(easing);
  } else if (Array.isArray(easing)) {
    return easing.map(mapEasingToNativeEasingWithDefault);
  } else {
    return supportedWaapiEasing[easing];
  }
}

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/index.mjs
function animateStyle(element, valueName, keyframes2, { delay: delay2 = 0, duration = 300, repeat = 0, repeatType = "loop", ease: ease2, times } = {}) {
  const keyframeOptions = { [valueName]: keyframes2 };
  if (times)
    keyframeOptions.offset = times;
  const easing = mapEasingToNativeEasing(ease2);
  if (Array.isArray(easing))
    keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay: delay2,
    duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}

// ../../node_modules/framer-motion/dist/es/animation/animators/AcceleratedAnimation.mjs
var supportsWaapi = memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
var acceleratedValues = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
var sampleDelta = 10;
var maxDuration2 = 2e4;
function requiresPregeneratedKeyframes(options) {
  return options.type === "spring" || options.name === "backgroundColor" || !isWaapiSupportedEasing(options.ease);
}
function pregenerateKeyframes(keyframes2, options) {
  const sampleAnimation = new MainThreadAnimation({
    ...options,
    keyframes: keyframes2,
    repeat: 0,
    delay: 0,
    isGenerator: true
  });
  let state = { done: false, value: keyframes2[0] };
  const pregeneratedKeyframes = [];
  let t = 0;
  while (!state.done && t < maxDuration2) {
    state = sampleAnimation.sample(t);
    pregeneratedKeyframes.push(state.value);
    t += sampleDelta;
  }
  return {
    times: void 0,
    keyframes: pregeneratedKeyframes,
    duration: t - sampleDelta,
    ease: "linear"
  };
}
var AcceleratedAnimation = class extends BaseAnimation {
  constructor(options) {
    super(options);
    const { name, motionValue: motionValue2, keyframes: keyframes2 } = this.options;
    this.resolver = new DOMKeyframesResolver(keyframes2, (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue2);
    this.resolver.scheduleResolve();
  }
  initPlayback(keyframes2, finalKeyframe) {
    var _a;
    let { duration = 300, times, ease: ease2, type, motionValue: motionValue2, name } = this.options;
    if (!((_a = motionValue2.owner) === null || _a === void 0 ? void 0 : _a.current)) {
      return false;
    }
    if (requiresPregeneratedKeyframes(this.options)) {
      const { onComplete, onUpdate, motionValue: motionValue3, ...options } = this.options;
      const pregeneratedAnimation = pregenerateKeyframes(keyframes2, options);
      keyframes2 = pregeneratedAnimation.keyframes;
      if (keyframes2.length === 1) {
        keyframes2[1] = keyframes2[0];
      }
      duration = pregeneratedAnimation.duration;
      times = pregeneratedAnimation.times;
      ease2 = pregeneratedAnimation.ease;
      type = "keyframes";
    }
    const animation = animateStyle(motionValue2.owner.current, name, keyframes2, { ...this.options, duration, times, ease: ease2 });
    animation.startTime = time.now();
    if (this.pendingTimeline) {
      animation.timeline = this.pendingTimeline;
      this.pendingTimeline = void 0;
    } else {
      animation.onfinish = () => {
        const { onComplete } = this.options;
        motionValue2.set(getFinalKeyframe(keyframes2, this.options, finalKeyframe));
        onComplete && onComplete();
        this.cancel();
        this.resolveFinishedPromise();
      };
    }
    return {
      animation,
      duration,
      times,
      type,
      ease: ease2,
      keyframes: keyframes2
    };
  }
  get duration() {
    const { resolved } = this;
    if (!resolved)
      return 0;
    const { duration } = resolved;
    return millisecondsToSeconds(duration);
  }
  get time() {
    const { resolved } = this;
    if (!resolved)
      return 0;
    const { animation } = resolved;
    return millisecondsToSeconds(animation.currentTime || 0);
  }
  set time(newTime) {
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    animation.currentTime = secondsToMilliseconds(newTime);
  }
  get speed() {
    const { resolved } = this;
    if (!resolved)
      return 1;
    const { animation } = resolved;
    return animation.playbackRate;
  }
  set speed(newSpeed) {
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    animation.playbackRate = newSpeed;
  }
  get state() {
    const { resolved } = this;
    if (!resolved)
      return "idle";
    const { animation } = resolved;
    return animation.playState;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(timeline) {
    if (!this._resolved) {
      this.pendingTimeline = timeline;
    } else {
      const { resolved } = this;
      if (!resolved)
        return noop2;
      const { animation } = resolved;
      animation.timeline = timeline;
      animation.onfinish = null;
    }
    return noop2;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    if (animation.playState === "finished") {
      this.updateFinishedPromise();
    }
    animation.play();
  }
  pause() {
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    animation.pause();
  }
  stop() {
    this.resolver.cancel();
    this.isStopped = true;
    if (this.state === "idle")
      return;
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation, keyframes: keyframes2, duration, type, ease: ease2, times } = resolved;
    if (animation.playState === "idle" || animation.playState === "finished") {
      return;
    }
    if (this.time) {
      const { motionValue: motionValue2, onUpdate, onComplete, ...options } = this.options;
      const sampleAnimation = new MainThreadAnimation({
        ...options,
        keyframes: keyframes2,
        duration,
        type,
        ease: ease2,
        times,
        isGenerator: true
      });
      const sampleTime = secondsToMilliseconds(this.time);
      motionValue2.setWithVelocity(sampleAnimation.sample(sampleTime - sampleDelta).value, sampleAnimation.sample(sampleTime).value, sampleDelta);
    }
    this.cancel();
  }
  complete() {
    const { resolved } = this;
    if (!resolved)
      return;
    resolved.animation.finish();
  }
  cancel() {
    const { resolved } = this;
    if (!resolved)
      return;
    resolved.animation.cancel();
  }
  static supports(options) {
    const { motionValue: motionValue2, name, repeatDelay, repeatType, damping, type } = options;
    return supportsWaapi() && name && acceleratedValues.has(name) && motionValue2 && motionValue2.owner && motionValue2.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !motionValue2.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
  }
};

// ../../node_modules/framer-motion/dist/es/animation/interfaces/motion-value.mjs
var animateMotionValue = (name, value, target, transition = {}, element, isHandoff) => (onComplete) => {
  const valueTransition = getValueTransition(transition, name) || {};
  const delay2 = valueTransition.delay || transition.delay || 0;
  let { elapsed = 0 } = transition;
  elapsed = elapsed - secondsToMilliseconds(delay2);
  let options = {
    keyframes: Array.isArray(target) ? target : [null, target],
    ease: "easeOut",
    velocity: value.getVelocity(),
    ...valueTransition,
    delay: -elapsed,
    onUpdate: (v) => {
      value.set(v);
      valueTransition.onUpdate && valueTransition.onUpdate(v);
    },
    onComplete: () => {
      onComplete();
      valueTransition.onComplete && valueTransition.onComplete();
    },
    name,
    motionValue: value,
    element: isHandoff ? void 0 : element
  };
  if (!isTransitionDefined(valueTransition)) {
    options = {
      ...options,
      ...getDefaultTransition(name, options)
    };
  }
  if (options.duration) {
    options.duration = secondsToMilliseconds(options.duration);
  }
  if (options.repeatDelay) {
    options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
  }
  if (options.from !== void 0) {
    options.keyframes[0] = options.from;
  }
  let shouldSkip = false;
  if (options.type === false || options.duration === 0 && !options.repeatDelay) {
    options.duration = 0;
    if (options.delay === 0) {
      shouldSkip = true;
    }
  }
  if (instantAnimationState.current || MotionGlobalConfig.skipAnimations) {
    shouldSkip = true;
    options.duration = 0;
    options.delay = 0;
  }
  if (shouldSkip && !isHandoff && value.get() !== void 0) {
    const finalKeyframe = getFinalKeyframe(options.keyframes, valueTransition);
    if (finalKeyframe !== void 0) {
      frame.update(() => {
        options.onUpdate(finalKeyframe);
        options.onComplete();
      });
      return;
    }
  }
  if (!isHandoff && AcceleratedAnimation.supports(options)) {
    return new AcceleratedAnimation(options);
  } else {
    return new MainThreadAnimation(options);
  }
};

// ../../node_modules/framer-motion/dist/es/value/use-will-change/is.mjs
function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}

// ../../node_modules/framer-motion/dist/es/utils/array.mjs
function addUniqueItem(arr, item) {
  if (arr.indexOf(item) === -1)
    arr.push(item);
}
function removeItem(arr, item) {
  const index = arr.indexOf(item);
  if (index > -1)
    arr.splice(index, 1);
}

// ../../node_modules/framer-motion/dist/es/utils/subscription-manager.mjs
var SubscriptionManager = class {
  constructor() {
    this.subscriptions = [];
  }
  add(handler) {
    addUniqueItem(this.subscriptions, handler);
    return () => removeItem(this.subscriptions, handler);
  }
  notify(a, b, c) {
    const numSubscriptions = this.subscriptions.length;
    if (!numSubscriptions)
      return;
    if (numSubscriptions === 1) {
      this.subscriptions[0](a, b, c);
    } else {
      for (let i = 0; i < numSubscriptions; i++) {
        const handler = this.subscriptions[i];
        handler && handler(a, b, c);
      }
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
};

// ../../node_modules/framer-motion/dist/es/utils/warn-once.mjs
var warned = /* @__PURE__ */ new Set();
function warnOnce(condition, message, element) {
  if (condition || warned.has(message))
    return;
  console.warn(message);
  if (element)
    console.warn(element);
  warned.add(message);
}

// ../../node_modules/framer-motion/dist/es/value/index.mjs
var MAX_VELOCITY_DELTA = 30;
var isFloat = (value) => {
  return !isNaN(parseFloat(value));
};
var collectMotionValues = {
  current: void 0
};
var MotionValue = class {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(init, options = {}) {
    this.version = "11.1.5";
    this.canTrackVelocity = false;
    this.events = {};
    this.updateAndNotify = (v, render = true) => {
      const currentTime = time.now();
      if (this.updatedAt !== currentTime) {
        this.setPrevFrameValue();
      }
      this.prev = this.current;
      this.setCurrent(v);
      if (this.current !== this.prev && this.events.change) {
        this.events.change.notify(this.current);
      }
      if (render && this.events.renderRequest) {
        this.events.renderRequest.notify(this.current);
      }
    };
    this.hasAnimated = false;
    this.setCurrent(init);
    this.canTrackVelocity = isFloat(this.current);
    this.owner = options.owner;
  }
  setCurrent(current) {
    this.current = current;
    this.updatedAt = time.now();
  }
  setPrevFrameValue(prevFrameValue = this.current) {
    this.prevFrameValue = prevFrameValue;
    this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(subscription) {
    if (process.env.NODE_ENV !== "production") {
      warnOnce(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
    }
    return this.on("change", subscription);
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    const unsubscribe = this.events[eventName].add(callback);
    if (eventName === "change") {
      return () => {
        unsubscribe();
        frame.read(() => {
          if (!this.events.change.getSize()) {
            this.stop();
          }
        });
      };
    }
    return unsubscribe;
  }
  clearListeners() {
    for (const eventManagers in this.events) {
      this.events[eventManagers].clear();
    }
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(passiveEffect, stopPassiveEffect) {
    this.passiveEffect = passiveEffect;
    this.stopPassiveEffect = stopPassiveEffect;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(v, render = true) {
    if (!render || !this.passiveEffect) {
      this.updateAndNotify(v, render);
    } else {
      this.passiveEffect(v, this.updateAndNotify);
    }
  }
  setWithVelocity(prev, current, delta) {
    this.set(current);
    this.prev = void 0;
    this.prevFrameValue = prev;
    this.prevUpdatedAt = this.updatedAt - delta;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(v, endAnimation = true) {
    this.updateAndNotify(v);
    this.prev = v;
    this.prevUpdatedAt = this.prevFrameValue = void 0;
    endAnimation && this.stop();
    if (this.stopPassiveEffect)
      this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    if (collectMotionValues.current) {
      collectMotionValues.current.push(this);
    }
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const currentTime = time.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || currentTime - this.updatedAt > MAX_VELOCITY_DELTA) {
      return 0;
    }
    const delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
    return velocityPerSecond(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(startAnimation) {
    this.stop();
    return new Promise((resolve) => {
      this.hasAnimated = true;
      this.animation = startAnimation(resolve);
      if (this.events.animationStart) {
        this.events.animationStart.notify();
      }
    }).then(() => {
      if (this.events.animationComplete) {
        this.events.animationComplete.notify();
      }
      this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    if (this.animation) {
      this.animation.stop();
      if (this.events.animationCancel) {
        this.events.animationCancel.notify();
      }
    }
    this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners();
    this.stop();
    if (this.stopPassiveEffect) {
      this.stopPassiveEffect();
    }
  }
};
function motionValue(init, options) {
  return new MotionValue(init, options);
}

// ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs
function setMotionValue(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionValue(value));
  }
}
function setTarget(visualElement, definition) {
  const resolved = resolveVariant(visualElement, definition);
  let { transitionEnd = {}, transition = {}, ...target } = resolved || {};
  target = { ...target, ...transitionEnd };
  for (const key in target) {
    const value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement, key, value);
  }
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/visual-element-target.mjs
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
  const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition, { delay: delay2 = 0, transitionOverride, type } = {}) {
  var _a;
  let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = targetAndTransition;
  const willChange = visualElement.getValue("willChange");
  if (transitionOverride)
    transition = transitionOverride;
  const animations2 = [];
  const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  for (const key in target) {
    const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
    const valueTarget = target[key];
    if (valueTarget === void 0 || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
      continue;
    }
    const valueTransition = {
      delay: delay2,
      elapsed: 0,
      ...getValueTransition(transition || {}, key)
    };
    let isHandoff = false;
    if (window.HandoffAppearAnimations) {
      const props = visualElement.getProps();
      const appearId = props[optimizedAppearDataAttribute];
      if (appearId) {
        const elapsed = window.HandoffAppearAnimations(appearId, key);
        if (elapsed !== null) {
          valueTransition.elapsed = elapsed;
          isHandoff = true;
        }
      }
    }
    value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key) ? { type: false } : valueTransition, visualElement, isHandoff));
    const animation = value.animation;
    if (animation) {
      if (isWillChangeMotionValue(willChange)) {
        willChange.add(key);
        animation.then(() => willChange.remove(key));
      }
      animations2.push(animation);
    }
  }
  if (transitionEnd) {
    Promise.all(animations2).then(() => {
      frame.update(() => {
        transitionEnd && setTarget(visualElement, transitionEnd);
      });
    });
  }
  return animations2;
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/visual-element-variant.mjs
function animateVariant(visualElement, variant, options = {}) {
  var _a;
  const resolved = resolveVariant(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : void 0);
  let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  const getAnimation = resolved ? () => Promise.all(animateTarget(visualElement, resolved, options)) : () => Promise.resolve();
  const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0) => {
    const { delayChildren = 0, staggerChildren, staggerDirection } = transition;
    return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : () => Promise.resolve();
  const { when } = transition;
  if (when) {
    const [first, last] = when === "beforeChildren" ? [getAnimation, getChildAnimations] : [getChildAnimations, getAnimation];
    return first().then(() => last());
  } else {
    return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
  }
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
  const animations2 = [];
  const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
  const generateStaggerDuration = staggerDirection === 1 ? (i = 0) => i * staggerChildren : (i = 0) => maxStaggerDuration - i * staggerChildren;
  Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach((child, i) => {
    child.notify("AnimationStart", variant);
    animations2.push(animateVariant(child, variant, {
      ...options,
      delay: delayChildren + generateStaggerDuration(i)
    }).then(() => child.notify("AnimationComplete", variant)));
  });
  return Promise.all(animations2);
}
function sortByTreeOrder(a, b) {
  return a.sortNodePosition(b);
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/visual-element.mjs
function animateVisualElement(visualElement, definition, options = {}) {
  visualElement.notify("AnimationStart", definition);
  let animation;
  if (Array.isArray(definition)) {
    const animations2 = definition.map((variant) => animateVariant(visualElement, variant, options));
    animation = Promise.all(animations2);
  } else if (typeof definition === "string") {
    animation = animateVariant(visualElement, definition, options);
  } else {
    const resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement, definition, options.custom) : definition;
    animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
  }
  return animation.then(() => {
    frame.postRender(() => {
      visualElement.notify("AnimationComplete", definition);
    });
  });
}

// ../../node_modules/framer-motion/dist/es/render/utils/animation-state.mjs
var reversePriorityOrder = [...variantPriorityOrder].reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
  return (animations2) => Promise.all(animations2.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
  let animate = animateList(visualElement);
  const state = createState();
  let isInitialRender = true;
  const buildResolvedTypeValues = (type) => (acc, definition) => {
    var _a;
    const resolved = resolveVariant(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : void 0);
    if (resolved) {
      const { transition, transitionEnd, ...target } = resolved;
      acc = { ...acc, ...target, ...transitionEnd };
    }
    return acc;
  };
  function setAnimateFunction(makeAnimator) {
    animate = makeAnimator(visualElement);
  }
  function animateChanges(changedActiveType) {
    const props = visualElement.getProps();
    const context = visualElement.getVariantContext(true) || {};
    const animations2 = [];
    const removedKeys = /* @__PURE__ */ new Set();
    let encounteredKeys = {};
    let removedVariantIndex = Infinity;
    for (let i = 0; i < numAnimationTypes; i++) {
      const type = reversePriorityOrder[i];
      const typeState = state[type];
      const prop = props[type] !== void 0 ? props[type] : context[type];
      const propIsVariant = isVariantLabel(prop);
      const activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false)
        removedVariantIndex = i;
      let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) {
        isInherited = false;
      }
      typeState.protectedKeys = { ...encounteredKeys };
      if (
        // If it isn't active and hasn't *just* been set as inactive
        !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
        !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
        isAnimationControls(prop) || typeof prop === "boolean"
      ) {
        continue;
      }
      const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
      let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
      type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
      i > removedVariantIndex && propIsVariant;
      let handledRemovedValues = false;
      const definitionList = Array.isArray(prop) ? prop : [prop];
      let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
      if (activeDelta === false)
        resolvedValues = {};
      const { prevResolvedValues = {} } = typeState;
      const allKeys = {
        ...prevResolvedValues,
        ...resolvedValues
      };
      const markToAnimate = (key) => {
        shouldAnimateType = true;
        if (removedKeys.has(key)) {
          handledRemovedValues = true;
          removedKeys.delete(key);
        }
        typeState.needsAnimating[key] = true;
        const motionValue2 = visualElement.getValue(key);
        if (motionValue2)
          motionValue2.liveStyle = false;
      };
      for (const key in allKeys) {
        const next = resolvedValues[key];
        const prev = prevResolvedValues[key];
        if (encounteredKeys.hasOwnProperty(key))
          continue;
        let valueHasChanged = false;
        if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
          valueHasChanged = !shallowCompare(next, prev);
        } else {
          valueHasChanged = next !== prev;
        }
        if (valueHasChanged) {
          if (next !== void 0 && next !== null) {
            markToAnimate(key);
          } else {
            removedKeys.add(key);
          }
        } else if (next !== void 0 && removedKeys.has(key)) {
          markToAnimate(key);
        } else {
          typeState.protectedKeys[key] = true;
        }
      }
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      if (typeState.isActive) {
        encounteredKeys = { ...encounteredKeys, ...resolvedValues };
      }
      if (isInitialRender && visualElement.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      if (shouldAnimateType && (!isInherited || handledRemovedValues)) {
        animations2.push(...definitionList.map((animation) => ({
          animation,
          options: { type }
        })));
      }
    }
    if (removedKeys.size) {
      const fallbackAnimation = {};
      removedKeys.forEach((key) => {
        const fallbackTarget = visualElement.getBaseTarget(key);
        const motionValue2 = visualElement.getValue(key);
        if (motionValue2)
          motionValue2.liveStyle = true;
        fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
      });
      animations2.push({ animation: fallbackAnimation });
    }
    let shouldAnimate = Boolean(animations2.length);
    if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate(animations2) : Promise.resolve();
  }
  function setActive(type, isActive) {
    var _a;
    if (state[type].isActive === isActive)
      return Promise.resolve();
    (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
      var _a2;
      return (_a2 = child.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(type, isActive);
    });
    state[type].isActive = isActive;
    const animations2 = animateChanges(type);
    for (const key in state) {
      state[key].protectedKeys = {};
    }
    return animations2;
  }
  return {
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: () => state
  };
}
function checkVariantsDidChange(prev, next) {
  if (typeof next === "string") {
    return next !== prev;
  } else if (Array.isArray(next)) {
    return !shallowCompare(next, prev);
  }
  return false;
}
function createTypeState(isActive = false) {
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  return {
    animate: createTypeState(true),
    whileInView: createTypeState(),
    whileHover: createTypeState(),
    whileTap: createTypeState(),
    whileDrag: createTypeState(),
    whileFocus: createTypeState(),
    exit: createTypeState()
  };
}

// ../../node_modules/framer-motion/dist/es/motion/features/animation/index.mjs
var AnimationFeature = class extends Feature {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(node4) {
    super(node4);
    node4.animationState || (node4.animationState = createAnimationState(node4));
  }
  updateAnimationControlsSubscription() {
    const { animate } = this.node.getProps();
    this.unmount();
    if (isAnimationControls(animate)) {
      this.unmount = animate.subscribe(this.node);
    }
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate } = this.node.getProps();
    const { animate: prevAnimate } = this.node.prevProps || {};
    if (animate !== prevAnimate) {
      this.updateAnimationControlsSubscription();
    }
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/animation/exit.mjs
var id = 0;
var ExitAnimationFeature = class extends Feature {
  constructor() {
    super(...arguments);
    this.id = id++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent, onExitComplete } = this.node.presenceContext;
    const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || isPresent === prevIsPresent) {
      return;
    }
    const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
    if (onExitComplete && !isPresent) {
      exitAnimation.then(() => onExitComplete(this.id));
    }
  }
  mount() {
    const { register } = this.node.presenceContext || {};
    if (register) {
      this.unmount = register(this.id);
    }
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/animations.mjs
var animations = {
  animation: {
    Feature: AnimationFeature
  },
  exit: {
    Feature: ExitAnimationFeature
  }
};

// ../../node_modules/framer-motion/dist/es/utils/distance.mjs
var distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
  const xDelta = distance(a.x, b.x);
  const yDelta = distance(a.y, b.y);
  return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

// ../../node_modules/framer-motion/dist/es/gestures/pan/PanSession.mjs
var PanSession = class {
  constructor(event, handlers, { transformPagePoint, contextWindow, dragSnapToOrigin = false } = {}) {
    this.startEvent = null;
    this.lastMoveEvent = null;
    this.lastMoveEventInfo = null;
    this.handlers = {};
    this.contextWindow = window;
    this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const info2 = getPanInfo(this.lastMoveEventInfo, this.history);
      const isPanStarted = this.startEvent !== null;
      const isDistancePastThreshold = distance2D(info2.offset, { x: 0, y: 0 }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      const { point: point2 } = info2;
      const { timestamp: timestamp2 } = frameData;
      this.history.push({ ...point2, timestamp: timestamp2 });
      const { onStart, onMove } = this.handlers;
      if (!isPanStarted) {
        onStart && onStart(this.lastMoveEvent, info2);
        this.startEvent = this.lastMoveEvent;
      }
      onMove && onMove(this.lastMoveEvent, info2);
    };
    this.handlePointerMove = (event2, info2) => {
      this.lastMoveEvent = event2;
      this.lastMoveEventInfo = transformPoint(info2, this.transformPagePoint);
      frame.update(this.updatePoint, true);
    };
    this.handlePointerUp = (event2, info2) => {
      this.end();
      const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
      if (this.dragSnapToOrigin)
        resumeAnimation && resumeAnimation();
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const panInfo = getPanInfo(event2.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(info2, this.transformPagePoint), this.history);
      if (this.startEvent && onEnd) {
        onEnd(event2, panInfo);
      }
      onSessionEnd && onSessionEnd(event2, panInfo);
    };
    if (!isPrimaryPointer(event))
      return;
    this.dragSnapToOrigin = dragSnapToOrigin;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    this.contextWindow = contextWindow || window;
    const info = extractEventInfo(event);
    const initialInfo = transformPoint(info, this.transformPagePoint);
    const { point } = initialInfo;
    const { timestamp } = frameData;
    this.history = [{ ...point, timestamp }];
    const { onSessionStart } = handlers;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
    this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(handlers) {
    this.handlers = handlers;
  }
  end() {
    this.removeListeners && this.removeListeners();
    cancelFrame(this.updatePoint);
  }
};
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
  return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo({ point }, history) {
  return {
    point,
    delta: subtractPoint(point, lastDevicePoint(history)),
    offset: subtractPoint(point, startDevicePoint(history)),
    velocity: getVelocity2(history, 0.1)
  };
}
function startDevicePoint(history) {
  return history[0];
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
function getVelocity2(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  let i = history.length - 1;
  let timestampedPoint = null;
  const lastPoint = lastDevicePoint(history);
  while (i >= 0) {
    timestampedPoint = history[i];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }
    i--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  const time2 = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
  if (time2 === 0) {
    return { x: 0, y: 0 };
  }
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time2,
    y: (lastPoint.y - timestampedPoint.y) / time2
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/delta-calc.mjs
function calcLength(axis) {
  return axis.max - axis.min;
}
function isNear(value, target = 0, maxDistance = 0.01) {
  return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
  delta.origin = origin;
  delta.originPoint = mixNumber(source.min, source.max, delta.origin);
  delta.scale = calcLength(target) / calcLength(source);
  if (isNear(delta.scale, 1, 1e-4) || isNaN(delta.scale))
    delta.scale = 1;
  delta.translate = mixNumber(target.min, target.max, delta.origin) - delta.originPoint;
  if (isNear(delta.translate) || isNaN(delta.translate))
    delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
  calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : void 0);
  calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : void 0);
}
function calcRelativeAxis(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
  calcRelativeAxis(target.x, relative.x, parent.x);
  calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout2, parent) {
  target.min = layout2.min - parent.min;
  target.max = target.min + calcLength(layout2);
}
function calcRelativePosition(target, layout2, parent) {
  calcRelativeAxisPosition(target.x, layout2.x, parent.x);
  calcRelativeAxisPosition(target.y, layout2.y, parent.y);
}

// ../../node_modules/framer-motion/dist/es/gestures/drag/utils/constraints.mjs
function applyConstraints(point, { min, max }, elastic) {
  if (min !== void 0 && point < min) {
    point = elastic ? mixNumber(min, point, elastic.min) : Math.max(point, min);
  } else if (max !== void 0 && point > max) {
    point = elastic ? mixNumber(max, point, elastic.max) : Math.min(point, max);
  }
  return point;
}
function calcRelativeAxisConstraints(axis, min, max) {
  return {
    min: min !== void 0 ? axis.min + min : void 0,
    max: max !== void 0 ? axis.max + max - (axis.max - axis.min) : void 0
  };
}
function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left, right),
    y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
  };
}
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  let min = constraintsAxis.min - layoutAxis.min;
  let max = constraintsAxis.max - layoutAxis.max;
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    [min, max] = [max, min];
  }
  return { min, max };
}
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
function calcOrigin2(source, target) {
  let origin = 0.5;
  const sourceLength = calcLength(source);
  const targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress(source.min, source.max - targetLength, target.min);
  }
  return clamp(0, 1, origin);
}
function rebaseAxisConstraints(layout2, constraints) {
  const relativeConstraints = {};
  if (constraints.min !== void 0) {
    relativeConstraints.min = constraints.min - layout2.min;
  }
  if (constraints.max !== void 0) {
    relativeConstraints.max = constraints.max - layout2.min;
  }
  return relativeConstraints;
}
var defaultElastic = 0.35;
function resolveDragElastic(dragElastic = defaultElastic) {
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic;
  }
  return {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
function resolvePointElastic(dragElastic, label) {
  return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/models.mjs
var createAxisDelta = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
});
var createDelta = () => ({
  x: createAxisDelta(),
  y: createAxisDelta()
});
var createAxis = () => ({ min: 0, max: 0 });
var createBox = () => ({
  x: createAxis(),
  y: createAxis()
});

// ../../node_modules/framer-motion/dist/es/projection/utils/each-axis.mjs
function eachAxis(callback) {
  return [callback("x"), callback("y")];
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/conversion.mjs
function convertBoundingBoxToBox({ top, left, right, bottom }) {
  return {
    x: { min: left, max: right },
    y: { min: top, max: bottom }
  };
}
function convertBoxToBoundingBox({ x, y }) {
  return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
function transformBoxPoints(point, transformPoint2) {
  if (!transformPoint2)
    return point;
  const topLeft = transformPoint2({ x: point.left, y: point.top });
  const bottomRight = transformPoint2({ x: point.right, y: point.bottom });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}

// ../../node_modules/framer-motion/dist/es/projection/utils/has-transform.mjs
function isIdentityScale(scale2) {
  return scale2 === void 0 || scale2 === 1;
}
function hasScale({ scale: scale2, scaleX, scaleY }) {
  return !isIdentityScale(scale2) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
  return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function has2DTranslate(values) {
  return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
  return value && value !== "0%";
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/delta-apply.mjs
function scalePoint(point, scale2, originPoint) {
  const distanceFromOrigin = point - originPoint;
  const scaled = scale2 * distanceFromOrigin;
  return originPoint + scaled;
}
function applyPointDelta(point, translate, scale2, originPoint, boxScale) {
  if (boxScale !== void 0) {
    point = scalePoint(point, boxScale, originPoint);
  }
  return scalePoint(point, scale2, originPoint) + translate;
}
function applyAxisDelta(axis, translate = 0, scale2 = 1, originPoint, boxScale) {
  axis.min = applyPointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function applyBoxDelta(box, { x, y }) {
  applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
  applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
  const treeLength = treePath.length;
  if (!treeLength)
    return;
  treeScale.x = treeScale.y = 1;
  let node4;
  let delta;
  for (let i = 0; i < treeLength; i++) {
    node4 = treePath[i];
    delta = node4.projectionDelta;
    const instance = node4.instance;
    if (instance && instance.style && instance.style.display === "contents") {
      continue;
    }
    if (isSharedTransition && node4.options.layoutScroll && node4.scroll && node4 !== node4.root) {
      transformBox(box, {
        x: -node4.scroll.offset.x,
        y: -node4.scroll.offset.y
      });
    }
    if (delta) {
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      applyBoxDelta(box, delta);
    }
    if (isSharedTransition && hasTransform(node4.latestValues)) {
      transformBox(box, node4.latestValues);
    }
  }
  treeScale.x = snapToDefault(treeScale.x);
  treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale2) {
  if (Number.isInteger(scale2))
    return scale2;
  return scale2 > 1.0000000000001 || scale2 < 0.999999999999 ? scale2 : 1;
}
function translateAxis(axis, distance2) {
  axis.min = axis.min + distance2;
  axis.max = axis.max + distance2;
}
function transformAxis(axis, transforms, [key, scaleKey, originKey]) {
  const axisOrigin = transforms[originKey] !== void 0 ? transforms[originKey] : 0.5;
  const originPoint = mixNumber(axis.min, axis.max, axisOrigin);
  applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
function transformBox(box, transform) {
  transformAxis(box.x, transform, xKeys);
  transformAxis(box.y, transform, yKeys);
}

// ../../node_modules/framer-motion/dist/es/projection/utils/measure.mjs
function measureViewportBox(instance, transformPoint2) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint2));
}
function measurePageBox(element, rootProjectionNode2, transformPagePoint) {
  const viewportBox = measureViewportBox(element, transformPagePoint);
  const { scroll } = rootProjectionNode2;
  if (scroll) {
    translateAxis(viewportBox.x, scroll.offset.x);
    translateAxis(viewportBox.y, scroll.offset.y);
  }
  return viewportBox;
}

// ../../node_modules/framer-motion/dist/es/utils/get-context-window.mjs
var getContextWindow = ({ current }) => {
  return current ? current.ownerDocument.defaultView : null;
};

// ../../node_modules/framer-motion/dist/es/gestures/drag/VisualElementDragControls.mjs
var elementDragControls = /* @__PURE__ */ new WeakMap();
var VisualElementDragControls = class {
  constructor(visualElement) {
    this.openGlobalLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = { x: 0, y: 0 };
    this.constraints = false;
    this.hasMutatedConstraints = false;
    this.elastic = createBox();
    this.visualElement = visualElement;
  }
  start(originEvent, { snapToCursor = false } = {}) {
    const { presenceContext } = this.visualElement;
    if (presenceContext && presenceContext.isPresent === false)
      return;
    const onSessionStart = (event) => {
      const { dragSnapToOrigin: dragSnapToOrigin2 } = this.getProps();
      dragSnapToOrigin2 ? this.pauseAnimation() : this.stopAnimation();
      if (snapToCursor) {
        this.snapToCursor(extractEventInfo(event, "page").point);
      }
    };
    const onStart = (event, info) => {
      const { drag: drag2, dragPropagation, onDragStart } = this.getProps();
      if (drag2 && !dragPropagation) {
        if (this.openGlobalLock)
          this.openGlobalLock();
        this.openGlobalLock = getGlobalLock(drag2);
        if (!this.openGlobalLock)
          return;
      }
      this.isDragging = true;
      this.currentDirection = null;
      this.resolveConstraints();
      if (this.visualElement.projection) {
        this.visualElement.projection.isAnimationBlocked = true;
        this.visualElement.projection.target = void 0;
      }
      eachAxis((axis) => {
        let current = this.getAxisMotionValue(axis).get() || 0;
        if (percent.test(current)) {
          const { projection } = this.visualElement;
          if (projection && projection.layout) {
            const measuredAxis = projection.layout.layoutBox[axis];
            if (measuredAxis) {
              const length = calcLength(measuredAxis);
              current = length * (parseFloat(current) / 100);
            }
          }
        }
        this.originPoint[axis] = current;
      });
      if (onDragStart)
        onDragStart(event, info);
      const { animationState } = this.visualElement;
      animationState && animationState.setActive("whileDrag", true);
    };
    const onMove = (event, info) => {
      const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag } = this.getProps();
      if (!dragPropagation && !this.openGlobalLock)
        return;
      const { offset } = info;
      if (dragDirectionLock && this.currentDirection === null) {
        this.currentDirection = getCurrentDirection(offset);
        if (this.currentDirection !== null) {
          onDirectionLock && onDirectionLock(this.currentDirection);
        }
        return;
      }
      this.updateAxis("x", info.point, offset);
      this.updateAxis("y", info.point, offset);
      this.visualElement.render();
      onDrag && onDrag(event, info);
    };
    const onSessionEnd = (event, info) => this.stop(event, info);
    const resumeAnimation = () => eachAxis((axis) => {
      var _a;
      return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
    });
    const { dragSnapToOrigin } = this.getProps();
    this.panSession = new PanSession(originEvent, {
      onSessionStart,
      onStart,
      onMove,
      onSessionEnd,
      resumeAnimation
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin,
      contextWindow: getContextWindow(this.visualElement)
    });
  }
  stop(event, info) {
    const isDragging = this.isDragging;
    this.cancel();
    if (!isDragging)
      return;
    const { velocity } = info;
    this.startAnimation(velocity);
    const { onDragEnd } = this.getProps();
    if (onDragEnd)
      onDragEnd(event, info);
  }
  cancel() {
    this.isDragging = false;
    const { projection, animationState } = this.visualElement;
    if (projection) {
      projection.isAnimationBlocked = false;
    }
    this.panSession && this.panSession.end();
    this.panSession = void 0;
    const { dragPropagation } = this.getProps();
    if (!dragPropagation && this.openGlobalLock) {
      this.openGlobalLock();
      this.openGlobalLock = null;
    }
    animationState && animationState.setActive("whileDrag", false);
  }
  updateAxis(axis, _point, offset) {
    const { drag: drag2 } = this.getProps();
    if (!offset || !shouldDrag(axis, drag2, this.currentDirection))
      return;
    const axisValue = this.getAxisMotionValue(axis);
    let next = this.originPoint[axis] + offset[axis];
    if (this.constraints && this.constraints[axis]) {
      next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
    }
    axisValue.set(next);
  }
  resolveConstraints() {
    var _a;
    const { dragConstraints, dragElastic } = this.getProps();
    const layout2 = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
    const prevConstraints = this.constraints;
    if (dragConstraints && isRefObject(dragConstraints)) {
      if (!this.constraints) {
        this.constraints = this.resolveRefConstraints();
      }
    } else {
      if (dragConstraints && layout2) {
        this.constraints = calcRelativeConstraints(layout2.layoutBox, dragConstraints);
      } else {
        this.constraints = false;
      }
    }
    this.elastic = resolveDragElastic(dragElastic);
    if (prevConstraints !== this.constraints && layout2 && this.constraints && !this.hasMutatedConstraints) {
      eachAxis((axis) => {
        if (this.constraints !== false && this.getAxisMotionValue(axis)) {
          this.constraints[axis] = rebaseAxisConstraints(layout2.layoutBox[axis], this.constraints[axis]);
        }
      });
    }
  }
  resolveRefConstraints() {
    const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
    if (!constraints || !isRefObject(constraints))
      return false;
    const constraintsElement = constraints.current;
    invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection } = this.visualElement;
    if (!projection || !projection.layout)
      return false;
    const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
    let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
    if (onMeasureDragConstraints) {
      const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
      this.hasMutatedConstraints = !!userConstraints;
      if (userConstraints) {
        measuredConstraints = convertBoundingBoxToBox(userConstraints);
      }
    }
    return measuredConstraints;
  }
  startAnimation(velocity) {
    const { drag: drag2, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd } = this.getProps();
    const constraints = this.constraints || {};
    const momentumAnimations = eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, this.currentDirection)) {
        return;
      }
      let transition = constraints && constraints[axis] || {};
      if (dragSnapToOrigin)
        transition = { min: 0, max: 0 };
      const bounceStiffness = dragElastic ? 200 : 1e6;
      const bounceDamping = dragElastic ? 40 : 1e7;
      const inertia2 = {
        type: "inertia",
        velocity: dragMomentum ? velocity[axis] : 0,
        bounceStiffness,
        bounceDamping,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...dragTransition,
        ...transition
      };
      return this.startAxisValueAnimation(axis, inertia2);
    });
    return Promise.all(momentumAnimations).then(onDragTransitionEnd);
  }
  startAxisValueAnimation(axis, transition) {
    const axisValue = this.getAxisMotionValue(axis);
    return axisValue.start(animateMotionValue(axis, axisValue, 0, transition, this.visualElement));
  }
  stopAnimation() {
    eachAxis((axis) => this.getAxisMotionValue(axis).stop());
  }
  pauseAnimation() {
    eachAxis((axis) => {
      var _a;
      return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
    });
  }
  getAnimationState(axis) {
    var _a;
    return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(axis) {
    const dragKey = `_drag${axis.toUpperCase()}`;
    const props = this.visualElement.getProps();
    const externalMotionValue = props[dragKey];
    return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : void 0) || 0);
  }
  snapToCursor(point) {
    eachAxis((axis) => {
      const { drag: drag2 } = this.getProps();
      if (!shouldDrag(axis, drag2, this.currentDirection))
        return;
      const { projection } = this.visualElement;
      const axisValue = this.getAxisMotionValue(axis);
      if (projection && projection.layout) {
        const { min, max } = projection.layout.layoutBox[axis];
        axisValue.set(point[axis] - mixNumber(min, max, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: drag2, dragConstraints } = this.getProps();
    const { projection } = this.visualElement;
    if (!isRefObject(dragConstraints) || !projection || !this.constraints)
      return;
    this.stopAnimation();
    const boxProgress = { x: 0, y: 0 };
    eachAxis((axis) => {
      const axisValue = this.getAxisMotionValue(axis);
      if (axisValue && this.constraints !== false) {
        const latest = axisValue.get();
        boxProgress[axis] = calcOrigin2({ min: latest, max: latest }, this.constraints[axis]);
      }
    });
    const { transformTemplate } = this.visualElement.getProps();
    this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    projection.root && projection.root.updateScroll();
    projection.updateLayout();
    this.resolveConstraints();
    eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, null))
        return;
      const axisValue = this.getAxisMotionValue(axis);
      const { min, max } = this.constraints[axis];
      axisValue.set(mixNumber(min, max, boxProgress[axis]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    elementDragControls.set(this.visualElement, this);
    const element = this.visualElement.current;
    const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
      const { drag: drag2, dragListener = true } = this.getProps();
      drag2 && dragListener && this.start(event);
    });
    const measureDragConstraints = () => {
      const { dragConstraints } = this.getProps();
      if (isRefObject(dragConstraints)) {
        this.constraints = this.resolveRefConstraints();
      }
    };
    const { projection } = this.visualElement;
    const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
    if (projection && !projection.layout) {
      projection.root && projection.root.updateScroll();
      projection.updateLayout();
    }
    measureDragConstraints();
    const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
    const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta, hasLayoutChanged }) => {
      if (this.isDragging && hasLayoutChanged) {
        eachAxis((axis) => {
          const motionValue2 = this.getAxisMotionValue(axis);
          if (!motionValue2)
            return;
          this.originPoint[axis] += delta[axis].translate;
          motionValue2.set(motionValue2.get() + delta[axis].translate);
        });
        this.visualElement.render();
      }
    });
    return () => {
      stopResizeListener();
      stopPointerListener();
      stopMeasureLayoutListener();
      stopLayoutUpdateListener && stopLayoutUpdateListener();
    };
  }
  getProps() {
    const props = this.visualElement.getProps();
    const { drag: drag2 = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true } = props;
    return {
      ...props,
      drag: drag2,
      dragDirectionLock,
      dragPropagation,
      dragConstraints,
      dragElastic,
      dragMomentum
    };
  }
};
function shouldDrag(direction, drag2, currentDirection) {
  return (drag2 === true || drag2 === direction) && (currentDirection === null || currentDirection === direction);
}
function getCurrentDirection(offset, lockThreshold = 10) {
  let direction = null;
  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}

// ../../node_modules/framer-motion/dist/es/gestures/drag/index.mjs
var DragGesture = class extends Feature {
  constructor(node4) {
    super(node4);
    this.removeGroupControls = noop2;
    this.removeListeners = noop2;
    this.controls = new VisualElementDragControls(node4);
  }
  mount() {
    const { dragControls } = this.node.getProps();
    if (dragControls) {
      this.removeGroupControls = dragControls.subscribe(this.controls);
    }
    this.removeListeners = this.controls.addListeners() || noop2;
  }
  unmount() {
    this.removeGroupControls();
    this.removeListeners();
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/pan/index.mjs
var asyncHandler = (handler) => (event, info) => {
  if (handler) {
    handler(event, info);
  }
};
var PanGesture = class extends Feature {
  constructor() {
    super(...arguments);
    this.removePointerDownListener = noop2;
  }
  onPointerDown(pointerDownEvent) {
    this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: getContextWindow(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
    return {
      onSessionStart: asyncHandler(onPanSessionStart),
      onStart: asyncHandler(onPanStart),
      onMove: onPan,
      onEnd: (event, info) => {
        delete this.session;
        if (onPanEnd)
          onPanEnd(event, info);
      }
    };
  }
  mount() {
    this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener();
    this.session && this.session.end();
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout/MeasureLayout.mjs
import { jsx as jsx89 } from "react/jsx-runtime";
import { useContext as useContext7, Component } from "react";

// ../../node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.mjs
import { useContext as useContext6, useId, useEffect as useEffect8 } from "react";
function usePresence() {
  const context = useContext6(PresenceContext);
  if (context === null)
    return [true, null];
  const { isPresent, onExitComplete, register } = context;
  const id3 = useId();
  useEffect8(() => register(id3), []);
  const safeToRemove = () => onExitComplete && onExitComplete(id3);
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}

// ../../node_modules/framer-motion/dist/es/projection/node/state.mjs
var globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: true,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: false
};

// ../../node_modules/framer-motion/dist/es/projection/styles/scale-border-radius.mjs
function pixelsToPercent(pixels, axis) {
  if (axis.max === axis.min)
    return 0;
  return pixels / (axis.max - axis.min) * 100;
}
var correctBorderRadius = {
  correct: (latest, node4) => {
    if (!node4.target)
      return latest;
    if (typeof latest === "string") {
      if (px.test(latest)) {
        latest = parseFloat(latest);
      } else {
        return latest;
      }
    }
    const x = pixelsToPercent(latest, node4.target.x);
    const y = pixelsToPercent(latest, node4.target.y);
    return `${x}% ${y}%`;
  }
};

// ../../node_modules/framer-motion/dist/es/projection/styles/scale-box-shadow.mjs
var correctBoxShadow = {
  correct: (latest, { treeScale, projectionDelta }) => {
    const original = latest;
    const shadow = complex.parse(latest);
    if (shadow.length > 5)
      return original;
    const template = complex.createTransformer(latest);
    const offset = typeof shadow[0] !== "number" ? 1 : 0;
    const xScale = projectionDelta.x.scale * treeScale.x;
    const yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    const averageScale = mixNumber(xScale, yScale, 0.5);
    if (typeof shadow[2 + offset] === "number")
      shadow[2 + offset] /= averageScale;
    if (typeof shadow[3 + offset] === "number")
      shadow[3 + offset] /= averageScale;
    return template(shadow);
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout/MeasureLayout.mjs
var MeasureLayoutWithContext = class extends Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
    const { projection } = visualElement;
    addScaleCorrector(defaultScaleCorrectors);
    if (projection) {
      if (layoutGroup.group)
        layoutGroup.group.add(projection);
      if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
        switchLayoutGroup.register(projection);
      }
      projection.root.didUpdate();
      projection.addEventListener("animationComplete", () => {
        this.safeToRemove();
      });
      projection.setOptions({
        ...projection.options,
        onExitComplete: () => this.safeToRemove()
      });
    }
    globalProjectionState.hasEverUpdated = true;
  }
  getSnapshotBeforeUpdate(prevProps) {
    const { layoutDependency, visualElement, drag: drag2, isPresent } = this.props;
    const projection = visualElement.projection;
    if (!projection)
      return null;
    projection.isPresent = isPresent;
    if (drag2 || prevProps.layoutDependency !== layoutDependency || layoutDependency === void 0) {
      projection.willUpdate();
    } else {
      this.safeToRemove();
    }
    if (prevProps.isPresent !== isPresent) {
      if (isPresent) {
        projection.promote();
      } else if (!projection.relegate()) {
        frame.postRender(() => {
          const stack = projection.getStack();
          if (!stack || !stack.members.length) {
            this.safeToRemove();
          }
        });
      }
    }
    return null;
  }
  componentDidUpdate() {
    const { projection } = this.props.visualElement;
    if (projection) {
      projection.root.didUpdate();
      microtask.postRender(() => {
        if (!projection.currentAnimation && projection.isLead()) {
          this.safeToRemove();
        }
      });
    }
  }
  componentWillUnmount() {
    const { visualElement, layoutGroup, switchLayoutGroup: promoteContext } = this.props;
    const { projection } = visualElement;
    if (projection) {
      projection.scheduleCheckAfterUnmount();
      if (layoutGroup && layoutGroup.group)
        layoutGroup.group.remove(projection);
      if (promoteContext && promoteContext.deregister)
        promoteContext.deregister(projection);
    }
  }
  safeToRemove() {
    const { safeToRemove } = this.props;
    safeToRemove && safeToRemove();
  }
  render() {
    return null;
  }
};
function MeasureLayout(props) {
  const [isPresent, safeToRemove] = usePresence();
  const layoutGroup = useContext7(LayoutGroupContext);
  return jsx89(MeasureLayoutWithContext, { ...props, layoutGroup, switchLayoutGroup: useContext7(SwitchLayoutGroupContext), isPresent, safeToRemove });
}
var defaultScaleCorrectors = {
  borderRadius: {
    ...correctBorderRadius,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};

// ../../node_modules/framer-motion/dist/es/projection/animation/mix-values.mjs
var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
var numBorders = borders.length;
var asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
var isPx = (value) => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress2, shouldCrossfadeOpacity, isOnlyMember) {
  if (shouldCrossfadeOpacity) {
    target.opacity = mixNumber(
      0,
      // TODO Reinstate this if only child
      lead.opacity !== void 0 ? lead.opacity : 1,
      easeCrossfadeIn(progress2)
    );
    target.opacityExit = mixNumber(follow.opacity !== void 0 ? follow.opacity : 1, 0, easeCrossfadeOut(progress2));
  } else if (isOnlyMember) {
    target.opacity = mixNumber(follow.opacity !== void 0 ? follow.opacity : 1, lead.opacity !== void 0 ? lead.opacity : 1, progress2);
  }
  for (let i = 0; i < numBorders; i++) {
    const borderLabel = `border${borders[i]}Radius`;
    let followRadius = getRadius(follow, borderLabel);
    let leadRadius = getRadius(lead, borderLabel);
    if (followRadius === void 0 && leadRadius === void 0)
      continue;
    followRadius || (followRadius = 0);
    leadRadius || (leadRadius = 0);
    const canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
    if (canMix) {
      target[borderLabel] = Math.max(mixNumber(asNumber(followRadius), asNumber(leadRadius), progress2), 0);
      if (percent.test(leadRadius) || percent.test(followRadius)) {
        target[borderLabel] += "%";
      }
    } else {
      target[borderLabel] = leadRadius;
    }
  }
  if (follow.rotate || lead.rotate) {
    target.rotate = mixNumber(follow.rotate || 0, lead.rotate || 0, progress2);
  }
}
function getRadius(values, radiusName) {
  return values[radiusName] !== void 0 ? values[radiusName] : values.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, noop2);
function compress(min, max, easing) {
  return (p) => {
    if (p < min)
      return 0;
    if (p > max)
      return 1;
    return easing(progress(min, max, p));
  };
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/copy.mjs
function copyAxisInto(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
function copyBoxInto(box, originBox) {
  copyAxisInto(box.x, originBox.x);
  copyAxisInto(box.y, originBox.y);
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/delta-remove.mjs
function removePointDelta(point, translate, scale2, originPoint, boxScale) {
  point -= translate;
  point = scalePoint(point, 1 / scale2, originPoint);
  if (boxScale !== void 0) {
    point = scalePoint(point, 1 / boxScale, originPoint);
  }
  return point;
}
function removeAxisDelta(axis, translate = 0, scale2 = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
  if (percent.test(translate)) {
    translate = parseFloat(translate);
    const relativeProgress = mixNumber(sourceAxis.min, sourceAxis.max, translate / 100);
    translate = relativeProgress - sourceAxis.min;
  }
  if (typeof translate !== "number")
    return;
  let originPoint = mixNumber(originAxis.min, originAxis.max, origin);
  if (axis === originAxis)
    originPoint -= translate;
  axis.min = removePointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = removePointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
  removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
var xKeys2 = ["x", "scaleX", "originX"];
var yKeys2 = ["y", "scaleY", "originY"];
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
  removeAxisTransforms(box.x, transforms, xKeys2, originBox ? originBox.x : void 0, sourceBox ? sourceBox.x : void 0);
  removeAxisTransforms(box.y, transforms, yKeys2, originBox ? originBox.y : void 0, sourceBox ? sourceBox.y : void 0);
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/utils.mjs
function isAxisDeltaZero(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
  return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
  return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function boxEqualsRounded(a, b) {
  return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function aspectRatio(box) {
  return calcLength(box.x) / calcLength(box.y);
}

// ../../node_modules/framer-motion/dist/es/projection/shared/stack.mjs
var NodeStack = class {
  constructor() {
    this.members = [];
  }
  add(node4) {
    addUniqueItem(this.members, node4);
    node4.scheduleRender();
  }
  remove(node4) {
    removeItem(this.members, node4);
    if (node4 === this.prevLead) {
      this.prevLead = void 0;
    }
    if (node4 === this.lead) {
      const prevLead = this.members[this.members.length - 1];
      if (prevLead) {
        this.promote(prevLead);
      }
    }
  }
  relegate(node4) {
    const indexOfNode = this.members.findIndex((member) => node4 === member);
    if (indexOfNode === 0)
      return false;
    let prevLead;
    for (let i = indexOfNode; i >= 0; i--) {
      const member = this.members[i];
      if (member.isPresent !== false) {
        prevLead = member;
        break;
      }
    }
    if (prevLead) {
      this.promote(prevLead);
      return true;
    } else {
      return false;
    }
  }
  promote(node4, preserveFollowOpacity) {
    const prevLead = this.lead;
    if (node4 === prevLead)
      return;
    this.prevLead = prevLead;
    this.lead = node4;
    node4.show();
    if (prevLead) {
      prevLead.instance && prevLead.scheduleRender();
      node4.scheduleRender();
      node4.resumeFrom = prevLead;
      if (preserveFollowOpacity) {
        node4.resumeFrom.preserveOpacity = true;
      }
      if (prevLead.snapshot) {
        node4.snapshot = prevLead.snapshot;
        node4.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
      }
      if (node4.root && node4.root.isUpdating) {
        node4.isLayoutDirty = true;
      }
      const { crossfade } = node4.options;
      if (crossfade === false) {
        prevLead.hide();
      }
    }
  }
  exitAnimationComplete() {
    this.members.forEach((node4) => {
      const { options, resumingFrom } = node4;
      options.onExitComplete && options.onExitComplete();
      if (resumingFrom) {
        resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
      }
    });
  }
  scheduleRender() {
    this.members.forEach((node4) => {
      node4.instance && node4.scheduleRender(false);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    if (this.lead && this.lead.snapshot) {
      this.lead.snapshot = void 0;
    }
  }
};

// ../../node_modules/framer-motion/dist/es/projection/styles/transform.mjs
function buildProjectionTransform(delta, treeScale, latestTransform) {
  let transform = "";
  const xTranslate = delta.x.translate / treeScale.x;
  const yTranslate = delta.y.translate / treeScale.y;
  const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
  if (xTranslate || yTranslate || zTranslate) {
    transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
  }
  if (treeScale.x !== 1 || treeScale.y !== 1) {
    transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
  }
  if (latestTransform) {
    const { transformPerspective, rotate, rotateX, rotateY, skewX, skewY } = latestTransform;
    if (transformPerspective)
      transform = `perspective(${transformPerspective}px) ${transform}`;
    if (rotate)
      transform += `rotate(${rotate}deg) `;
    if (rotateX)
      transform += `rotateX(${rotateX}deg) `;
    if (rotateY)
      transform += `rotateY(${rotateY}deg) `;
    if (skewX)
      transform += `skewX(${skewX}deg) `;
    if (skewY)
      transform += `skewY(${skewY}deg) `;
  }
  const elementScaleX = delta.x.scale * treeScale.x;
  const elementScaleY = delta.y.scale * treeScale.y;
  if (elementScaleX !== 1 || elementScaleY !== 1) {
    transform += `scale(${elementScaleX}, ${elementScaleY})`;
  }
  return transform || "none";
}

// ../../node_modules/framer-motion/dist/es/render/utils/compare-by-depth.mjs
var compareByDepth = (a, b) => a.depth - b.depth;

// ../../node_modules/framer-motion/dist/es/render/utils/flat-tree.mjs
var FlatTree = class {
  constructor() {
    this.children = [];
    this.isDirty = false;
  }
  add(child) {
    addUniqueItem(this.children, child);
    this.isDirty = true;
  }
  remove(child) {
    removeItem(this.children, child);
    this.isDirty = true;
  }
  forEach(callback) {
    this.isDirty && this.children.sort(compareByDepth);
    this.isDirty = false;
    this.children.forEach(callback);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/delay.mjs
function delay(callback, timeout) {
  const start = time.now();
  const checkElapsed = ({ timestamp }) => {
    const elapsed = timestamp - start;
    if (elapsed >= timeout) {
      cancelFrame(checkElapsed);
      callback(elapsed - timeout);
    }
  };
  frame.read(checkElapsed, true);
  return () => cancelFrame(checkElapsed);
}

// ../../node_modules/framer-motion/dist/es/debug/record.mjs
function record(data) {
  if (window.MotionDebug) {
    window.MotionDebug.record(data);
  }
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-svg-element.mjs
function isSVGElement(element) {
  return element instanceof SVGElement && element.tagName !== "svg";
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/single-value.mjs
function animateSingleValue(value, keyframes2, options) {
  const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
  motionValue$1.start(animateMotionValue("", motionValue$1, keyframes2, options));
  return motionValue$1.animation;
}

// ../../node_modules/framer-motion/dist/es/projection/node/create-projection-node.mjs
var transformAxes = ["", "X", "Y", "Z"];
var hiddenVisibility = { visibility: "hidden" };
var animationTarget = 1e3;
var id2 = 0;
var projectionFrameData = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
  const { latestValues } = visualElement;
  if (latestValues[key]) {
    values[key] = latestValues[key];
    visualElement.setStaticValue(key, 0);
    if (sharedAnimationValues) {
      sharedAnimationValues[key] = 0;
    }
  }
}
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform }) {
  return class ProjectionNode {
    constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
      this.id = id2++;
      this.animationId = 0;
      this.children = /* @__PURE__ */ new Set();
      this.options = {};
      this.isTreeAnimating = false;
      this.isAnimationBlocked = false;
      this.isLayoutDirty = false;
      this.isProjectionDirty = false;
      this.isSharedProjectionDirty = false;
      this.isTransformDirty = false;
      this.updateManuallyBlocked = false;
      this.updateBlockedByResize = false;
      this.isUpdating = false;
      this.isSVG = false;
      this.needsReset = false;
      this.shouldResetTransform = false;
      this.treeScale = { x: 1, y: 1 };
      this.eventHandlers = /* @__PURE__ */ new Map();
      this.hasTreeAnimated = false;
      this.updateScheduled = false;
      this.projectionUpdateScheduled = false;
      this.checkUpdateFailed = () => {
        if (this.isUpdating) {
          this.isUpdating = false;
          this.clearAllSnapshots();
        }
      };
      this.updateProjection = () => {
        this.projectionUpdateScheduled = false;
        projectionFrameData.totalNodes = projectionFrameData.resolvedTargetDeltas = projectionFrameData.recalculatedProjection = 0;
        this.nodes.forEach(propagateDirtyNodes);
        this.nodes.forEach(resolveTargetDelta);
        this.nodes.forEach(calcProjection);
        this.nodes.forEach(cleanDirtyNodes);
        record(projectionFrameData);
      };
      this.hasProjected = false;
      this.isVisible = true;
      this.animationProgress = 0;
      this.sharedNodes = /* @__PURE__ */ new Map();
      this.latestValues = latestValues;
      this.root = parent ? parent.root || parent : this;
      this.path = parent ? [...parent.path, parent] : [];
      this.parent = parent;
      this.depth = parent ? parent.depth + 1 : 0;
      for (let i = 0; i < this.path.length; i++) {
        this.path[i].shouldResetTransform = true;
      }
      if (this.root === this)
        this.nodes = new FlatTree();
    }
    addEventListener(name, handler) {
      if (!this.eventHandlers.has(name)) {
        this.eventHandlers.set(name, new SubscriptionManager());
      }
      return this.eventHandlers.get(name).add(handler);
    }
    notifyListeners(name, ...args) {
      const subscriptionManager = this.eventHandlers.get(name);
      subscriptionManager && subscriptionManager.notify(...args);
    }
    hasListeners(name) {
      return this.eventHandlers.has(name);
    }
    /**
     * Lifecycles
     */
    mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = isSVGElement(instance);
      this.instance = instance;
      const { layoutId, layout: layout2, visualElement } = this.options;
      if (visualElement && !visualElement.current) {
        visualElement.mount(instance);
      }
      this.root.nodes.add(this);
      this.parent && this.parent.children.add(this);
      if (isLayoutDirty && (layout2 || layoutId)) {
        this.isLayoutDirty = true;
      }
      if (attachResizeListener) {
        let cancelDelay;
        const resizeUnblockUpdate = () => this.root.updateBlockedByResize = false;
        attachResizeListener(instance, () => {
          this.root.updateBlockedByResize = true;
          cancelDelay && cancelDelay();
          cancelDelay = delay(resizeUnblockUpdate, 250);
          if (globalProjectionState.hasAnimatedSinceResize) {
            globalProjectionState.hasAnimatedSinceResize = false;
            this.nodes.forEach(finishAnimation);
          }
        });
      }
      if (layoutId) {
        this.root.registerSharedNode(layoutId, this);
      }
      if (this.options.animate !== false && visualElement && (layoutId || layout2)) {
        this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout }) => {
          if (this.isTreeAnimationBlocked()) {
            this.target = void 0;
            this.relativeTarget = void 0;
            return;
          }
          const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
          const { onLayoutAnimationStart, onLayoutAnimationComplete } = visualElement.getProps();
          const targetChanged = !this.targetLayout || !boxEqualsRounded(this.targetLayout, newLayout) || hasRelativeTargetChanged;
          const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
          if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
            if (this.resumeFrom) {
              this.resumingFrom = this.resumeFrom;
              this.resumingFrom.resumingFrom = void 0;
            }
            this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
            const animationOptions = {
              ...getValueTransition(layoutTransition, "layout"),
              onPlay: onLayoutAnimationStart,
              onComplete: onLayoutAnimationComplete
            };
            if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
              animationOptions.delay = 0;
              animationOptions.type = false;
            }
            this.startAnimation(animationOptions);
          } else {
            if (!hasLayoutChanged) {
              finishAnimation(this);
            }
            if (this.isLead() && this.options.onExitComplete) {
              this.options.onExitComplete();
            }
          }
          this.targetLayout = newLayout;
        });
      }
    }
    unmount() {
      this.options.layoutId && this.willUpdate();
      this.root.nodes.remove(this);
      const stack = this.getStack();
      stack && stack.remove(this);
      this.parent && this.parent.children.delete(this);
      this.instance = void 0;
      cancelFrame(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = true;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = false;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
    }
    // Note: currently only running on root node
    startUpdate() {
      if (this.isUpdateBlocked())
        return;
      this.isUpdating = true;
      this.nodes && this.nodes.forEach(resetSkewAndRotation);
      this.animationId++;
    }
    getTransformTemplate() {
      const { visualElement } = this.options;
      return visualElement && visualElement.getProps().transformTemplate;
    }
    willUpdate(shouldNotifyListeners = true) {
      this.root.hasTreeAnimated = true;
      if (this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      !this.root.isUpdating && this.root.startUpdate();
      if (this.isLayoutDirty)
        return;
      this.isLayoutDirty = true;
      for (let i = 0; i < this.path.length; i++) {
        const node4 = this.path[i];
        node4.shouldResetTransform = true;
        node4.updateScroll("snapshot");
        if (node4.options.layoutRoot) {
          node4.willUpdate(false);
        }
      }
      const { layoutId, layout: layout2 } = this.options;
      if (layoutId === void 0 && !layout2)
        return;
      const transformTemplate = this.getTransformTemplate();
      this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      this.updateSnapshot();
      shouldNotifyListeners && this.notifyListeners("willUpdate");
    }
    update() {
      this.updateScheduled = false;
      const updateWasBlocked = this.isUpdateBlocked();
      if (updateWasBlocked) {
        this.unblockUpdate();
        this.clearAllSnapshots();
        this.nodes.forEach(clearMeasurements);
        return;
      }
      if (!this.isUpdating) {
        this.nodes.forEach(clearIsLayoutDirty);
      }
      this.isUpdating = false;
      if (window.HandoffCancelAllAnimations) {
        window.HandoffCancelAllAnimations();
      }
      this.nodes.forEach(resetTransformStyle);
      this.nodes.forEach(updateLayout);
      this.nodes.forEach(notifyLayoutUpdate);
      this.clearAllSnapshots();
      const now3 = time.now();
      frameData.delta = clamp(0, 1e3 / 60, now3 - frameData.timestamp);
      frameData.timestamp = now3;
      frameData.isProcessing = true;
      steps.update.process(frameData);
      steps.preRender.process(frameData);
      steps.render.process(frameData);
      frameData.isProcessing = false;
    }
    didUpdate() {
      if (!this.updateScheduled) {
        this.updateScheduled = true;
        microtask.read(() => this.update());
      }
    }
    clearAllSnapshots() {
      this.nodes.forEach(clearSnapshot);
      this.sharedNodes.forEach(removeLeadSnapshots);
    }
    scheduleUpdateProjection() {
      if (!this.projectionUpdateScheduled) {
        this.projectionUpdateScheduled = true;
        frame.preRender(this.updateProjection, false, true);
      }
    }
    scheduleCheckAfterUnmount() {
      frame.postRender(() => {
        if (this.isLayoutDirty) {
          this.root.didUpdate();
        } else {
          this.root.checkUpdateFailed();
        }
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      if (this.snapshot || !this.instance)
        return;
      this.snapshot = this.measure();
    }
    updateLayout() {
      if (!this.instance)
        return;
      this.updateScroll();
      if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) {
        return;
      }
      if (this.resumeFrom && !this.resumeFrom.instance) {
        for (let i = 0; i < this.path.length; i++) {
          const node4 = this.path[i];
          node4.updateScroll();
        }
      }
      const prevLayout = this.layout;
      this.layout = this.measure(false);
      this.layoutCorrected = createBox();
      this.isLayoutDirty = false;
      this.projectionDelta = void 0;
      this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement } = this.options;
      visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : void 0);
    }
    updateScroll(phase = "measure") {
      let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) {
        needsMeasurement = false;
      }
      if (needsMeasurement) {
        this.scroll = {
          animationId: this.root.animationId,
          phase,
          isRoot: checkIsScrollRoot(this.instance),
          offset: measureScroll(this.instance)
        };
      }
    }
    resetTransform() {
      if (!resetTransform)
        return;
      const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
      const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
      const transformTemplate = this.getTransformTemplate();
      const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
      if (isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged)) {
        resetTransform(this.instance, transformTemplateValue);
        this.shouldResetTransform = false;
        this.scheduleRender();
      }
    }
    measure(removeTransform = true) {
      const pageBox = this.measurePageBox();
      let layoutBox = this.removeElementScroll(pageBox);
      if (removeTransform) {
        layoutBox = this.removeTransform(layoutBox);
      }
      roundBox(layoutBox);
      return {
        animationId: this.root.animationId,
        measuredBox: pageBox,
        layoutBox,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement } = this.options;
      if (!visualElement)
        return createBox();
      const box = visualElement.measureViewportBox();
      const { scroll } = this.root;
      if (scroll) {
        translateAxis(box.x, scroll.offset.x);
        translateAxis(box.y, scroll.offset.y);
      }
      return box;
    }
    removeElementScroll(box) {
      const boxWithoutScroll = createBox();
      copyBoxInto(boxWithoutScroll, box);
      for (let i = 0; i < this.path.length; i++) {
        const node4 = this.path[i];
        const { scroll, options } = node4;
        if (node4 !== this.root && scroll && options.layoutScroll) {
          if (scroll.isRoot) {
            copyBoxInto(boxWithoutScroll, box);
            const { scroll: rootScroll } = this.root;
            if (rootScroll) {
              translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
              translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
            }
          }
          translateAxis(boxWithoutScroll.x, scroll.offset.x);
          translateAxis(boxWithoutScroll.y, scroll.offset.y);
        }
      }
      return boxWithoutScroll;
    }
    applyTransform(box, transformOnly = false) {
      const withTransforms = createBox();
      copyBoxInto(withTransforms, box);
      for (let i = 0; i < this.path.length; i++) {
        const node4 = this.path[i];
        if (!transformOnly && node4.options.layoutScroll && node4.scroll && node4 !== node4.root) {
          transformBox(withTransforms, {
            x: -node4.scroll.offset.x,
            y: -node4.scroll.offset.y
          });
        }
        if (!hasTransform(node4.latestValues))
          continue;
        transformBox(withTransforms, node4.latestValues);
      }
      if (hasTransform(this.latestValues)) {
        transformBox(withTransforms, this.latestValues);
      }
      return withTransforms;
    }
    removeTransform(box) {
      const boxWithoutTransform = createBox();
      copyBoxInto(boxWithoutTransform, box);
      for (let i = 0; i < this.path.length; i++) {
        const node4 = this.path[i];
        if (!node4.instance)
          continue;
        if (!hasTransform(node4.latestValues))
          continue;
        hasScale(node4.latestValues) && node4.updateSnapshot();
        const sourceBox = createBox();
        const nodeBox = node4.measurePageBox();
        copyBoxInto(sourceBox, nodeBox);
        removeBoxTransforms(boxWithoutTransform, node4.latestValues, node4.snapshot ? node4.snapshot.layoutBox : void 0, sourceBox);
      }
      if (hasTransform(this.latestValues)) {
        removeBoxTransforms(boxWithoutTransform, this.latestValues);
      }
      return boxWithoutTransform;
    }
    setTargetDelta(delta) {
      this.targetDelta = delta;
      this.root.scheduleUpdateProjection();
      this.isProjectionDirty = true;
    }
    setOptions(options) {
      this.options = {
        ...this.options,
        ...options,
        crossfade: options.crossfade !== void 0 ? options.crossfade : true
      };
    }
    clearMeasurements() {
      this.scroll = void 0;
      this.layout = void 0;
      this.snapshot = void 0;
      this.prevTransformTemplateValue = void 0;
      this.targetDelta = void 0;
      this.target = void 0;
      this.isLayoutDirty = false;
    }
    forceRelativeParentToResolveTarget() {
      if (!this.relativeParent)
        return;
      if (this.relativeParent.resolvedRelativeTargetAt !== frameData.timestamp) {
        this.relativeParent.resolveTargetDelta(true);
      }
    }
    resolveTargetDelta(forceRecalculation = false) {
      var _a;
      const lead = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
      this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
      this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      if (!this.layout || !(layout2 || layoutId))
        return;
      this.resolvedRelativeTargetAt = frameData.timestamp;
      if (!this.targetDelta && !this.relativeTarget) {
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      if (!this.relativeTarget && !this.targetDelta)
        return;
      if (!this.target) {
        this.target = createBox();
        this.targetWithTransforms = createBox();
      }
      if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
        this.forceRelativeParentToResolveTarget();
        calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
      } else if (this.targetDelta) {
        if (Boolean(this.resumingFrom)) {
          this.target = this.applyTransform(this.layout.layoutBox);
        } else {
          copyBoxInto(this.target, this.layout.layoutBox);
        }
        applyBoxDelta(this.target, this.targetDelta);
      } else {
        copyBoxInto(this.target, this.layout.layoutBox);
      }
      if (this.attemptToResolveRelativeTarget) {
        this.attemptToResolveRelativeTarget = false;
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      projectionFrameData.resolvedTargetDeltas++;
    }
    getClosestProjectingParent() {
      if (!this.parent || hasScale(this.parent.latestValues) || has2DTranslate(this.parent.latestValues)) {
        return void 0;
      }
      if (this.parent.isProjecting()) {
        return this.parent;
      } else {
        return this.parent.getClosestProjectingParent();
      }
    }
    isProjecting() {
      return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var _a;
      const lead = this.getLead();
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      let canSkip = true;
      if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
        canSkip = false;
      }
      if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) {
        canSkip = false;
      }
      if (this.resolvedRelativeTargetAt === frameData.timestamp) {
        canSkip = false;
      }
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
      if (!this.isTreeAnimating) {
        this.targetDelta = this.relativeTarget = void 0;
      }
      if (!this.layout || !(layout2 || layoutId))
        return;
      copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
      const prevTreeScaleX = this.treeScale.x;
      const prevTreeScaleY = this.treeScale.y;
      applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
      if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
        lead.target = lead.layout.layoutBox;
        lead.targetWithTransforms = createBox();
      }
      const { target } = lead;
      if (!target) {
        if (this.projectionTransform) {
          this.projectionDelta = createDelta();
          this.projectionTransform = "none";
          this.scheduleRender();
        }
        return;
      }
      if (!this.projectionDelta) {
        this.projectionDelta = createDelta();
        this.projectionDeltaWithTransform = createDelta();
      }
      const prevProjectionTransform = this.projectionTransform;
      calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
      this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
      if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
        this.hasProjected = true;
        this.scheduleRender();
        this.notifyListeners("projectionUpdate", target);
      }
      projectionFrameData.recalculatedProjection++;
    }
    hide() {
      this.isVisible = false;
    }
    show() {
      this.isVisible = true;
    }
    scheduleRender(notifyAll = true) {
      this.options.scheduleRender && this.options.scheduleRender();
      if (notifyAll) {
        const stack = this.getStack();
        stack && stack.scheduleRender();
      }
      if (this.resumingFrom && !this.resumingFrom.instance) {
        this.resumingFrom = void 0;
      }
    }
    setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
      const snapshot = this.snapshot;
      const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
      const mixedValues = { ...this.latestValues };
      const targetDelta = createDelta();
      if (!this.relativeParent || !this.relativeParent.options.layoutRoot) {
        this.relativeTarget = this.relativeTargetOrigin = void 0;
      }
      this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
      const relativeLayout = createBox();
      const snapshotSource = snapshot ? snapshot.source : void 0;
      const layoutSource = this.layout ? this.layout.source : void 0;
      const isSharedLayoutAnimation = snapshotSource !== layoutSource;
      const stack = this.getStack();
      const isOnlyMember = !stack || stack.members.length <= 1;
      const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
      this.animationProgress = 0;
      let prevRelativeTarget;
      this.mixTargetDelta = (latest) => {
        const progress2 = latest / 1e3;
        mixAxisDelta(targetDelta.x, delta.x, progress2);
        mixAxisDelta(targetDelta.y, delta.y, progress2);
        this.setTargetDelta(targetDelta);
        if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
          calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
          mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress2);
          if (prevRelativeTarget && boxEquals(this.relativeTarget, prevRelativeTarget)) {
            this.isProjectionDirty = false;
          }
          if (!prevRelativeTarget)
            prevRelativeTarget = createBox();
          copyBoxInto(prevRelativeTarget, this.relativeTarget);
        }
        if (isSharedLayoutAnimation) {
          this.animationValues = mixedValues;
          mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress2, shouldCrossfadeOpacity, isOnlyMember);
        }
        this.root.scheduleUpdateProjection();
        this.scheduleRender();
        this.animationProgress = progress2;
      };
      this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(options) {
      this.notifyListeners("animationStart");
      this.currentAnimation && this.currentAnimation.stop();
      if (this.resumingFrom && this.resumingFrom.currentAnimation) {
        this.resumingFrom.currentAnimation.stop();
      }
      if (this.pendingAnimation) {
        cancelFrame(this.pendingAnimation);
        this.pendingAnimation = void 0;
      }
      this.pendingAnimation = frame.update(() => {
        globalProjectionState.hasAnimatedSinceResize = true;
        this.currentAnimation = animateSingleValue(0, animationTarget, {
          ...options,
          onUpdate: (latest) => {
            this.mixTargetDelta(latest);
            options.onUpdate && options.onUpdate(latest);
          },
          onComplete: () => {
            options.onComplete && options.onComplete();
            this.completeAnimation();
          }
        });
        if (this.resumingFrom) {
          this.resumingFrom.currentAnimation = this.currentAnimation;
        }
        this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      if (this.resumingFrom) {
        this.resumingFrom.currentAnimation = void 0;
        this.resumingFrom.preserveOpacity = void 0;
      }
      const stack = this.getStack();
      stack && stack.exitAnimationComplete();
      this.resumingFrom = this.currentAnimation = this.animationValues = void 0;
      this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      if (this.currentAnimation) {
        this.mixTargetDelta && this.mixTargetDelta(animationTarget);
        this.currentAnimation.stop();
      }
      this.completeAnimation();
    }
    applyTransformsToTarget() {
      const lead = this.getLead();
      let { targetWithTransforms, target, layout: layout2, latestValues } = lead;
      if (!targetWithTransforms || !target || !layout2)
        return;
      if (this !== lead && this.layout && layout2 && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout2.layoutBox)) {
        target = this.target || createBox();
        const xLength = calcLength(this.layout.layoutBox.x);
        target.x.min = lead.target.x.min;
        target.x.max = target.x.min + xLength;
        const yLength = calcLength(this.layout.layoutBox.y);
        target.y.min = lead.target.y.min;
        target.y.max = target.y.min + yLength;
      }
      copyBoxInto(targetWithTransforms, target);
      transformBox(targetWithTransforms, latestValues);
      calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
    }
    registerSharedNode(layoutId, node4) {
      if (!this.sharedNodes.has(layoutId)) {
        this.sharedNodes.set(layoutId, new NodeStack());
      }
      const stack = this.sharedNodes.get(layoutId);
      stack.add(node4);
      const config = node4.options.initialPromotionConfig;
      node4.promote({
        transition: config ? config.transition : void 0,
        preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node4) : void 0
      });
    }
    isLead() {
      const stack = this.getStack();
      return stack ? stack.lead === this : true;
    }
    getLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
    }
    getPrevLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : void 0;
    }
    getStack() {
      const { layoutId } = this.options;
      if (layoutId)
        return this.root.sharedNodes.get(layoutId);
    }
    promote({ needsReset, transition, preserveFollowOpacity } = {}) {
      const stack = this.getStack();
      if (stack)
        stack.promote(this, preserveFollowOpacity);
      if (needsReset) {
        this.projectionDelta = void 0;
        this.needsReset = true;
      }
      if (transition)
        this.setOptions({ transition });
    }
    relegate() {
      const stack = this.getStack();
      if (stack) {
        return stack.relegate(this);
      } else {
        return false;
      }
    }
    resetSkewAndRotation() {
      const { visualElement } = this.options;
      if (!visualElement)
        return;
      let hasDistortingTransform = false;
      const { latestValues } = visualElement;
      if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) {
        hasDistortingTransform = true;
      }
      if (!hasDistortingTransform)
        return;
      const resetValues = {};
      if (latestValues.z) {
        resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
      }
      for (let i = 0; i < transformAxes.length; i++) {
        resetDistortingTransform(`rotate${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
        resetDistortingTransform(`skew${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
      }
      visualElement.render();
      for (const key in resetValues) {
        visualElement.setStaticValue(key, resetValues[key]);
        if (this.animationValues) {
          this.animationValues[key] = resetValues[key];
        }
      }
      visualElement.scheduleRender();
    }
    getProjectionStyles(styleProp) {
      var _a, _b;
      if (!this.instance || this.isSVG)
        return void 0;
      if (!this.isVisible) {
        return hiddenVisibility;
      }
      const styles = {
        visibility: ""
      };
      const transformTemplate = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = false;
        styles.opacity = "";
        styles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
        return styles;
      }
      const lead = this.getLead();
      if (!this.projectionDelta || !this.layout || !lead.target) {
        const emptyStyles = {};
        if (this.options.layoutId) {
          emptyStyles.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1;
          emptyStyles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        }
        if (this.hasProjected && !hasTransform(this.latestValues)) {
          emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
          this.hasProjected = false;
        }
        return emptyStyles;
      }
      const valuesToRender = lead.animationValues || lead.latestValues;
      this.applyTransformsToTarget();
      styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
      if (transformTemplate) {
        styles.transform = transformTemplate(valuesToRender, styles.transform);
      }
      const { x, y } = this.projectionDelta;
      styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
      if (lead.animationValues) {
        styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
      } else {
        styles.opacity = lead === this ? valuesToRender.opacity !== void 0 ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== void 0 ? valuesToRender.opacityExit : 0;
      }
      for (const key in scaleCorrectors) {
        if (valuesToRender[key] === void 0)
          continue;
        const { correct, applyTo } = scaleCorrectors[key];
        const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
        if (applyTo) {
          const num = applyTo.length;
          for (let i = 0; i < num; i++) {
            styles[applyTo[i]] = corrected;
          }
        } else {
          styles[key] = corrected;
        }
      }
      if (this.options.layoutId) {
        styles.pointerEvents = lead === this ? resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
      }
      return styles;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((node4) => {
        var _a;
        return (_a = node4.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
      });
      this.root.nodes.forEach(clearMeasurements);
      this.root.sharedNodes.clear();
    }
  };
}
function updateLayout(node4) {
  node4.updateLayout();
}
function notifyLayoutUpdate(node4) {
  var _a;
  const snapshot = ((_a = node4.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node4.snapshot;
  if (node4.isLead() && node4.layout && snapshot && node4.hasListeners("didUpdate")) {
    const { layoutBox: layout2, measuredBox: measuredLayout } = node4.layout;
    const { animationType } = node4.options;
    const isShared = snapshot.source !== node4.layout.source;
    if (animationType === "size") {
      eachAxis((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length = calcLength(axisSnapshot);
        axisSnapshot.min = layout2[axis].min;
        axisSnapshot.max = axisSnapshot.min + length;
      });
    } else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout2)) {
      eachAxis((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length = calcLength(layout2[axis]);
        axisSnapshot.max = axisSnapshot.min + length;
        if (node4.relativeTarget && !node4.currentAnimation) {
          node4.isProjectionDirty = true;
          node4.relativeTarget[axis].max = node4.relativeTarget[axis].min + length;
        }
      });
    }
    const layoutDelta = createDelta();
    calcBoxDelta(layoutDelta, layout2, snapshot.layoutBox);
    const visualDelta = createDelta();
    if (isShared) {
      calcBoxDelta(visualDelta, node4.applyTransform(measuredLayout, true), snapshot.measuredBox);
    } else {
      calcBoxDelta(visualDelta, layout2, snapshot.layoutBox);
    }
    const hasLayoutChanged = !isDeltaZero(layoutDelta);
    let hasRelativeTargetChanged = false;
    if (!node4.resumeFrom) {
      const relativeParent = node4.getClosestProjectingParent();
      if (relativeParent && !relativeParent.resumeFrom) {
        const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
        if (parentSnapshot && parentLayout) {
          const relativeSnapshot = createBox();
          calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
          const relativeLayout = createBox();
          calcRelativePosition(relativeLayout, layout2, parentLayout.layoutBox);
          if (!boxEqualsRounded(relativeSnapshot, relativeLayout)) {
            hasRelativeTargetChanged = true;
          }
          if (relativeParent.options.layoutRoot) {
            node4.relativeTarget = relativeLayout;
            node4.relativeTargetOrigin = relativeSnapshot;
            node4.relativeParent = relativeParent;
          }
        }
      }
    }
    node4.notifyListeners("didUpdate", {
      layout: layout2,
      snapshot,
      delta: visualDelta,
      layoutDelta,
      hasLayoutChanged,
      hasRelativeTargetChanged
    });
  } else if (node4.isLead()) {
    const { onExitComplete } = node4.options;
    onExitComplete && onExitComplete();
  }
  node4.options.transition = void 0;
}
function propagateDirtyNodes(node4) {
  projectionFrameData.totalNodes++;
  if (!node4.parent)
    return;
  if (!node4.isProjecting()) {
    node4.isProjectionDirty = node4.parent.isProjectionDirty;
  }
  node4.isSharedProjectionDirty || (node4.isSharedProjectionDirty = Boolean(node4.isProjectionDirty || node4.parent.isProjectionDirty || node4.parent.isSharedProjectionDirty));
  node4.isTransformDirty || (node4.isTransformDirty = node4.parent.isTransformDirty);
}
function cleanDirtyNodes(node4) {
  node4.isProjectionDirty = node4.isSharedProjectionDirty = node4.isTransformDirty = false;
}
function clearSnapshot(node4) {
  node4.clearSnapshot();
}
function clearMeasurements(node4) {
  node4.clearMeasurements();
}
function clearIsLayoutDirty(node4) {
  node4.isLayoutDirty = false;
}
function resetTransformStyle(node4) {
  const { visualElement } = node4.options;
  if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
    visualElement.notify("BeforeLayoutMeasure");
  }
  node4.resetTransform();
}
function finishAnimation(node4) {
  node4.finishAnimation();
  node4.targetDelta = node4.relativeTarget = node4.target = void 0;
  node4.isProjectionDirty = true;
}
function resolveTargetDelta(node4) {
  node4.resolveTargetDelta();
}
function calcProjection(node4) {
  node4.calcProjection();
}
function resetSkewAndRotation(node4) {
  node4.resetSkewAndRotation();
}
function removeLeadSnapshots(stack) {
  stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
  output.translate = mixNumber(delta.translate, 0, p);
  output.scale = mixNumber(delta.scale, 1, p);
  output.origin = delta.origin;
  output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
  output.min = mixNumber(from.min, to.min, p);
  output.max = mixNumber(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
  mixAxis(output.x, from.x, to.x, p);
  mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node4) {
  return node4.animationValues && node4.animationValues.opacityExit !== void 0;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
var userAgentContains = (string) => typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
var roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : noop2;
function roundAxis(axis) {
  axis.min = roundPoint(axis.min);
  axis.max = roundPoint(axis.max);
}
function roundBox(box) {
  roundAxis(box.x);
  roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout2) {
  return animationType === "position" || animationType === "preserve-aspect" && !isNear(aspectRatio(snapshot), aspectRatio(layout2), 0.2);
}

// ../../node_modules/framer-motion/dist/es/projection/node/DocumentProjectionNode.mjs
var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => true
});

// ../../node_modules/framer-motion/dist/es/projection/node/HTMLProjectionNode.mjs
var rootProjectionNode = {
  current: void 0
};
var HTMLProjectionNode = createProjectionNode({
  measureScroll: (instance) => ({
    x: instance.scrollLeft,
    y: instance.scrollTop
  }),
  defaultParent: () => {
    if (!rootProjectionNode.current) {
      const documentNode = new DocumentProjectionNode({});
      documentNode.mount(window);
      documentNode.setOptions({ layoutScroll: true });
      rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: (instance, value) => {
    instance.style.transform = value !== void 0 ? value : "none";
  },
  checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed")
});

// ../../node_modules/framer-motion/dist/es/motion/features/drag.mjs
var drag = {
  pan: {
    Feature: PanGesture
  },
  drag: {
    Feature: DragGesture,
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/create-visual-element.mjs
import { Fragment as Fragment23 } from "react";

// ../../node_modules/framer-motion/dist/es/utils/reduced-motion/state.mjs
var prefersReducedMotion = { current: null };
var hasReducedMotionListener = { current: false };

// ../../node_modules/framer-motion/dist/es/utils/reduced-motion/index.mjs
function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser)
    return;
  if (window.matchMedia) {
    const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
    const setReducedMotionPreferences = () => prefersReducedMotion.current = motionMediaQuery.matches;
    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}

// ../../node_modules/framer-motion/dist/es/render/utils/motion-values.mjs
function updateMotionValuesFromProps(element, next, prev) {
  const { willChange } = next;
  for (const key in next) {
    const nextValue = next[key];
    const prevValue = prev[key];
    if (isMotionValue(nextValue)) {
      element.addValue(key, nextValue);
      if (isWillChangeMotionValue(willChange)) {
        willChange.add(key);
      }
      if (process.env.NODE_ENV === "development") {
        warnOnce(nextValue.version === "11.1.5", `Attempting to mix Framer Motion versions ${nextValue.version} with 11.1.5 may not work as expected.`);
      }
    } else if (isMotionValue(prevValue)) {
      element.addValue(key, motionValue(nextValue, { owner: element }));
      if (isWillChangeMotionValue(willChange)) {
        willChange.remove(key);
      }
    } else if (prevValue !== nextValue) {
      if (element.hasValue(key)) {
        const existingValue = element.getValue(key);
        if (existingValue.liveStyle === true) {
          existingValue.jump(nextValue);
        } else if (!existingValue.hasAnimated) {
          existingValue.set(nextValue);
        }
      } else {
        const latestValue = element.getStaticValue(key);
        element.addValue(key, motionValue(latestValue !== void 0 ? latestValue : nextValue, { owner: element }));
      }
    }
  }
  for (const key in prev) {
    if (next[key] === void 0)
      element.removeValue(key);
  }
  return next;
}

// ../../node_modules/framer-motion/dist/es/render/store.mjs
var visualElementStore = /* @__PURE__ */ new WeakMap();

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/find.mjs
var valueTypes = [...dimensionValueTypes, color, complex];
var findValueType = (v) => valueTypes.find(testValueType(v));

// ../../node_modules/framer-motion/dist/es/render/VisualElement.mjs
var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
var propEventHandlers = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
var numVariantProps = variantProps.length;
function getClosestProjectingNode(visualElement) {
  if (!visualElement)
    return void 0;
  return visualElement.options.allowProjection !== false ? visualElement.projection : getClosestProjectingNode(visualElement.parent);
}
var VisualElement = class {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
    return {};
  }
  constructor({ parent, props, presenceContext, reducedMotionConfig, blockInitialAnimation, visualState }, options = {}) {
    this.resolveKeyframes = (keyframes2, onComplete, name, value) => {
      return new this.KeyframeResolver(keyframes2, onComplete, name, value, this);
    };
    this.current = null;
    this.children = /* @__PURE__ */ new Set();
    this.isVariantNode = false;
    this.isControllingVariants = false;
    this.shouldReduceMotion = null;
    this.values = /* @__PURE__ */ new Map();
    this.KeyframeResolver = KeyframeResolver;
    this.features = {};
    this.valueSubscriptions = /* @__PURE__ */ new Map();
    this.prevMotionValues = {};
    this.events = {};
    this.propEventSubscriptions = {};
    this.notifyUpdate = () => this.notify("Update", this.latestValues);
    this.render = () => {
      if (!this.current)
        return;
      this.triggerBuild();
      this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
    };
    this.scheduleRender = () => frame.render(this.render, false, true);
    const { latestValues, renderState } = visualState;
    this.latestValues = latestValues;
    this.baseTarget = { ...latestValues };
    this.initialValues = props.initial ? { ...latestValues } : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.blockInitialAnimation = Boolean(blockInitialAnimation);
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);
    if (this.isVariantNode) {
      this.variantChildren = /* @__PURE__ */ new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
    for (const key in initialMotionValues) {
      const value = initialMotionValues[key];
      if (latestValues[key] !== void 0 && isMotionValue(value)) {
        value.set(latestValues[key], false);
        if (isWillChangeMotionValue(willChange)) {
          willChange.add(key);
        }
      }
    }
  }
  mount(instance) {
    this.current = instance;
    visualElementStore.set(instance, this);
    if (this.projection && !this.projection.instance) {
      this.projection.mount(instance);
    }
    if (this.parent && this.isVariantNode && !this.isControllingVariants) {
      this.removeFromVariantTree = this.parent.addVariantChild(this);
    }
    this.values.forEach((value, key) => this.bindToMotionValue(key, value));
    if (!hasReducedMotionListener.current) {
      initPrefersReducedMotion();
    }
    this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;
    if (process.env.NODE_ENV !== "production") {
      warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
    }
    if (this.parent)
      this.parent.children.add(this);
    this.update(this.props, this.presenceContext);
  }
  unmount() {
    var _a;
    visualElementStore.delete(this.current);
    this.projection && this.projection.unmount();
    cancelFrame(this.notifyUpdate);
    cancelFrame(this.render);
    this.valueSubscriptions.forEach((remove) => remove());
    this.removeFromVariantTree && this.removeFromVariantTree();
    this.parent && this.parent.children.delete(this);
    for (const key in this.events) {
      this.events[key].clear();
    }
    for (const key in this.features) {
      (_a = this.features[key]) === null || _a === void 0 ? void 0 : _a.unmount();
    }
    this.current = null;
  }
  bindToMotionValue(key, value) {
    const valueIsTransform = transformProps.has(key);
    const removeOnChange = value.on("change", (latestValue) => {
      this.latestValues[key] = latestValue;
      this.props.onUpdate && frame.preRender(this.notifyUpdate);
      if (valueIsTransform && this.projection) {
        this.projection.isTransformDirty = true;
      }
    });
    const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(key, () => {
      removeOnChange();
      removeOnRenderRequest();
      if (value.owner)
        value.stop();
    });
  }
  sortNodePosition(other) {
    if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
      return 0;
    }
    return this.sortInstanceNodePosition(this.current, other.current);
  }
  loadFeatures({ children, ...renderedProps }, isStrict, preloadedFeatures2, initialLayoutGroupConfig) {
    let ProjectionNodeConstructor;
    let MeasureLayout2;
    if (process.env.NODE_ENV !== "production" && preloadedFeatures2 && isStrict) {
      const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      renderedProps.ignoreStrict ? warning(false, strictMessage) : invariant(false, strictMessage);
    }
    for (let i = 0; i < numFeatures; i++) {
      const name = featureNames[i];
      const { isEnabled, Feature: FeatureConstructor, ProjectionNode, MeasureLayout: MeasureLayoutComponent } = featureDefinitions[name];
      if (ProjectionNode)
        ProjectionNodeConstructor = ProjectionNode;
      if (isEnabled(renderedProps)) {
        if (!this.features[name] && FeatureConstructor) {
          this.features[name] = new FeatureConstructor(this);
        }
        if (MeasureLayoutComponent) {
          MeasureLayout2 = MeasureLayoutComponent;
        }
      }
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
      this.projection = new ProjectionNodeConstructor(this.latestValues, getClosestProjectingNode(this.parent));
      const { layoutId, layout: layout2, drag: drag2, dragConstraints, layoutScroll, layoutRoot } = renderedProps;
      this.projection.setOptions({
        layoutId,
        layout: layout2,
        alwaysMeasureLayout: Boolean(drag2) || dragConstraints && isRefObject(dragConstraints),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof layout2 === "string" ? layout2 : "both",
        initialPromotionConfig: initialLayoutGroupConfig,
        layoutScroll,
        layoutRoot
      });
    }
    return MeasureLayout2;
  }
  updateFeatures() {
    for (const key in this.features) {
      const feature = this.features[key];
      if (feature.isMounted) {
        feature.update();
      } else {
        feature.mount();
        feature.isMounted = true;
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
  }
  getStaticValue(key) {
    return this.latestValues[key];
  }
  setStaticValue(key, value) {
    this.latestValues[key] = value;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(props, presenceContext) {
    if (props.transformTemplate || this.props.transformTemplate) {
      this.scheduleRender();
    }
    this.prevProps = this.props;
    this.props = props;
    this.prevPresenceContext = this.presenceContext;
    this.presenceContext = presenceContext;
    for (let i = 0; i < propEventHandlers.length; i++) {
      const key = propEventHandlers[i];
      if (this.propEventSubscriptions[key]) {
        this.propEventSubscriptions[key]();
        delete this.propEventSubscriptions[key];
      }
      const listenerName = "on" + key;
      const listener = props[listenerName];
      if (listener) {
        this.propEventSubscriptions[key] = this.on(key, listener);
      }
    }
    this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
    if (this.handleChildMotionValue) {
      this.handleChildMotionValue();
    }
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(name) {
    return this.props.variants ? this.props.variants[name] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(startAtParent = false) {
    if (startAtParent) {
      return this.parent ? this.parent.getVariantContext() : void 0;
    }
    if (!this.isControllingVariants) {
      const context2 = this.parent ? this.parent.getVariantContext() || {} : {};
      if (this.props.initial !== void 0) {
        context2.initial = this.props.initial;
      }
      return context2;
    }
    const context = {};
    for (let i = 0; i < numVariantProps; i++) {
      const name = variantProps[i];
      const prop = this.props[name];
      if (isVariantLabel(prop) || prop === false) {
        context[name] = prop;
      }
    }
    return context;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(child) {
    const closestVariantNode = this.getClosestVariantNode();
    if (closestVariantNode) {
      closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
      return () => closestVariantNode.variantChildren.delete(child);
    }
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(key, value) {
    const existingValue = this.values.get(key);
    if (value !== existingValue) {
      if (existingValue)
        this.removeValue(key);
      this.bindToMotionValue(key, value);
      this.values.set(key, value);
      this.latestValues[key] = value.get();
    }
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(key) {
    this.values.delete(key);
    const unsubscribe = this.valueSubscriptions.get(key);
    if (unsubscribe) {
      unsubscribe();
      this.valueSubscriptions.delete(key);
    }
    delete this.latestValues[key];
    this.removeValueFromRenderState(key, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(key) {
    return this.values.has(key);
  }
  getValue(key, defaultValue) {
    if (this.props.values && this.props.values[key]) {
      return this.props.values[key];
    }
    let value = this.values.get(key);
    if (value === void 0 && defaultValue !== void 0) {
      value = motionValue(defaultValue === null ? void 0 : defaultValue, { owner: this });
      this.addValue(key, value);
    }
    return value;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(key, target) {
    var _a;
    let value = this.latestValues[key] !== void 0 || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    if (value !== void 0 && value !== null) {
      if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
        value = parseFloat(value);
      } else if (!findValueType(value) && complex.test(target)) {
        value = getAnimatableNone2(key, target);
      }
      this.setBaseTarget(key, isMotionValue(value) ? value.get() : value);
    }
    return isMotionValue(value) ? value.get() : value;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(key, value) {
    this.baseTarget[key] = value;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(key) {
    var _a;
    const { initial } = this.props;
    let valueFromInitial;
    if (typeof initial === "string" || typeof initial === "object") {
      const variant = resolveVariantFromProps(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
      if (variant) {
        valueFromInitial = variant[key];
      }
    }
    if (initial && valueFromInitial !== void 0) {
      return valueFromInitial;
    }
    const target = this.getBaseTargetFromProps(this.props, key);
    if (target !== void 0 && !isMotionValue(target))
      return target;
    return this.initialValues[key] !== void 0 && valueFromInitial === void 0 ? void 0 : this.baseTarget[key];
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    return this.events[eventName].add(callback);
  }
  notify(eventName, ...args) {
    if (this.events[eventName]) {
      this.events[eventName].notify(...args);
    }
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/DOMVisualElement.mjs
var DOMVisualElement = class extends VisualElement {
  constructor() {
    super(...arguments);
    this.KeyframeResolver = DOMKeyframesResolver;
  }
  sortInstanceNodePosition(a, b) {
    return a.compareDocumentPosition(b) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(props, key) {
    return props.style ? props.style[key] : void 0;
  }
  removeValueFromRenderState(key, { vars, style }) {
    delete vars[key];
    delete style[key];
  }
};

// ../../node_modules/framer-motion/dist/es/render/html/HTMLVisualElement.mjs
function getComputedStyle(element) {
  return window.getComputedStyle(element);
}
var HTMLVisualElement = class extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = "html";
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    } else {
      const computedStyle = getComputedStyle(instance);
      const value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
      return typeof value === "string" ? value.trim() : value;
    }
  }
  measureInstanceViewportBox(instance, { transformPagePoint }) {
    return measureViewportBox(instance, transformPagePoint);
  }
  build(renderState, latestValues, options, props) {
    buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps(props, prevProps, visualElement);
  }
  handleChildMotionValue() {
    if (this.childSubscription) {
      this.childSubscription();
      delete this.childSubscription;
    }
    const { children } = this.props;
    if (isMotionValue(children)) {
      this.childSubscription = children.on("change", (latest) => {
        if (this.current)
          this.current.textContent = `${latest}`;
      });
    }
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderHTML(instance, renderState, styleProp, projection);
  }
};

// ../../node_modules/framer-motion/dist/es/render/svg/SVGVisualElement.mjs
var SVGVisualElement = class extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = "svg";
    this.isSVGTag = false;
  }
  getBaseTargetFromProps(props, key) {
    return props[key];
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    }
    key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
    return instance.getAttribute(key);
  }
  measureInstanceViewportBox() {
    return createBox();
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps2(props, prevProps, visualElement);
  }
  build(renderState, latestValues, options, props) {
    buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderSVG(instance, renderState, styleProp, projection);
  }
  mount(instance) {
    this.isSVGTag = isSVGTag(instance.tagName);
    super.mount(instance);
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/create-visual-element.mjs
var createDomVisualElement = (Component2, options) => {
  return isSVGComponent(Component2) ? new SVGVisualElement(options, { enableHardwareAcceleration: false }) : new HTMLVisualElement(options, {
    allowProjection: Component2 !== Fragment23,
    enableHardwareAcceleration: true
  });
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout.mjs
var layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs
var preloadedFeatures = {
  ...animations,
  ...gestureAnimations,
  ...drag,
  ...layout
};
var motion = /* @__PURE__ */ createMotionProxy((Component2, config) => createDomMotionConfig(Component2, config, preloadedFeatures, createDomVisualElement));

// src/components/layouts/SectionedLayout.tsx
import { noop as noop4, useDebounce as useDebounce3, useToggle as useToggle5 } from "shared-lib";

// src/components/errors/Error.tsx
import { jsx as jsx90 } from "react/jsx-runtime";
function Error3({
  children,
  className
}) {
  return /* @__PURE__ */ jsx90("div", { className: classNames("text-sm text-red-400", className || ""), children });
}

// src/components/errors/ErrorContainer.tsx
import { Fragment as Fragment25, useState as useState17 } from "react";
import { useRouteError } from "react-router-dom";
import { Transition as Transition4 } from "@headlessui/react";
import { XMarkIcon as XMarkIcon2 } from "@heroicons/react/24/outline";
import { XCircleIcon as XCircleIcon2 } from "@heroicons/react/24/outline";
import {
  AuthError,
  ElevateEnvironment,
  getClientEnvironment,
  useLogger,
  useToggle as useToggle4
} from "shared-lib";

// src/components/modals/Modal.tsx
import { Dialog, Transition as Transition3 } from "@headlessui/react";
import { Fragment as Fragment24 } from "react";
import { noop as noop3 } from "shared-lib";
import { jsx as jsx91, jsxs as jsxs56 } from "react/jsx-runtime";
var Modal = ({
  children,
  title,
  onClose = noop3
}) => {
  return /* @__PURE__ */ jsx91(Transition3, { appear: true, show: true, as: "div", children: /* @__PURE__ */ jsxs56(Dialog, { as: "div", className: "relative z-10", onClose, children: [
    /* @__PURE__ */ jsx91(
      Transition3.Child,
      {
        as: Fragment24,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /* @__PURE__ */ jsx91("div", { className: "fixed inset-0 bg-black bg-opacity-25" })
      }
    ),
    /* @__PURE__ */ jsx91("div", { className: "fixed inset-0 overflow-y-auto", children: /* @__PURE__ */ jsx91("div", { className: "flex min-h-full items-center justify-center p-4 text-center", children: /* @__PURE__ */ jsx91(
      Transition3.Child,
      {
        as: Fragment24,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95",
        children: /* @__PURE__ */ jsxs56(Dialog.Panel, { className: "transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all", children: [
          /* @__PURE__ */ jsx91(Dialog.Title, { children: /* @__PURE__ */ jsx91("h1", { className: "text-2xl", children: title }) }),
          children
        ] })
      }
    ) }) })
  ] }) });
  return /* @__PURE__ */ jsxs56("div", { className: "z-99 absolute bottom-0 left-0 right-0 top-0 flex justify-center", children: [
    /* @__PURE__ */ jsx91(
      "div",
      {
        className: "absolute bottom-0 left-0 right-0 top-0 z-10 bg-black/50",
        onClick: onClose
      }
    ),
    /* @__PURE__ */ jsx91("div", { className: "absolute z-20", children })
  ] });
};

// src/components/errors/ErrorContainer.tsx
import { Fragment as Fragment26, jsx as jsx92, jsxs as jsxs57 } from "react/jsx-runtime";
function ErrorContainer() {
  const error = useRouteError();
  const [log] = useLogger();
  log(error);
  console.group("ErrorContainer");
  console.error(error);
  console.groupEnd();
  if (AuthError.isAuthError(error)) {
    return /* @__PURE__ */ jsxs57("div", { children: [
      /* @__PURE__ */ jsx92("p", { children: "Authentication Error" }),
      /* @__PURE__ */ jsx92("pre", { children: JSON.stringify(error) })
    ] });
  }
  return /* @__PURE__ */ jsx92(ErrorModal, { error });
}
var ErrorModal = ({ error }) => {
  const env = getClientEnvironment();
  console.group("ErrorModal");
  console.error(error);
  console.groupEnd();
  const isDevelopment = env === ElevateEnvironment.LocalHost || env === ElevateEnvironment.Develop;
  const [showError, toggleShowError] = useToggle4();
  return /* @__PURE__ */ jsx92(Modal, { title: `Something went wrong`, children: /* @__PURE__ */ jsxs57("div", { className: "flex flex-col gap-10", children: [
    /* @__PURE__ */ jsxs57("p", { className: "mt-2", children: [
      "We were unable to load the page. Please try again, or",
      " ",
      /* @__PURE__ */ jsx92(
        EdLink,
        {
          href: "mailto:support@myn.co.uk",
          className: "text-primary-700 underline",
          name: "contact-support",
          children: "contact support"
        }
      ),
      "."
    ] }),
    isDevelopment && /* @__PURE__ */ jsxs57("div", { className: "flex flex-col justify-end gap-2", children: [
      /* @__PURE__ */ jsxs57(
        Button,
        {
          color: `white`,
          className: "flex self-end",
          onClick: toggleShowError,
          outline: true,
          children: [
            showError ? "Hide" : "Show",
            " Error"
          ]
        }
      ),
      showError && /* @__PURE__ */ jsx92("pre", { className: "prose overflow-scroll bg-gray-200 p-4", children: error.stack })
    ] }),
    /* @__PURE__ */ jsx92(
      Button,
      {
        color: "green",
        size: "xl" /* xl */,
        onClick: () => {
          window.location.reload();
        },
        children: "Try again"
      }
    )
  ] }) });
};
var ErrorToast = ({ error }) => {
  const [show, setShow] = useState17(true);
  return /* @__PURE__ */ jsx92(Fragment26, { children: /* @__PURE__ */ jsx92(
    "div",
    {
      "aria-live": "assertive",
      className: "pointer-events-none fixed inset-0 flex items-start px-4 py-6 sm:p-6",
      children: /* @__PURE__ */ jsx92("div", { className: "flex w-full flex-col items-center space-y-4 sm:items-end", children: /* @__PURE__ */ jsx92(
        Transition4,
        {
          show,
          as: Fragment25,
          enter: "transform ease-out duration-300 transition",
          enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
          enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ jsx92("div", { className: "min-w-sm pointer-events-auto w-full overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5", children: /* @__PURE__ */ jsx92("div", { className: "p-4", children: /* @__PURE__ */ jsxs57("div", { className: "flex items-start", children: [
            /* @__PURE__ */ jsx92("div", { className: "flex-shrink-0", children: /* @__PURE__ */ jsx92(
              XCircleIcon2,
              {
                className: "h-6 w-6 text-red-400",
                "aria-hidden": "true"
              }
            ) }),
            /* @__PURE__ */ jsxs57("div", { className: "ml-3 w-0 flex-1 pt-0.5", children: [
              /* @__PURE__ */ jsx92("p", { className: "text-sm font-medium text-gray-900", children: "Something went wrong" }),
              /* @__PURE__ */ jsx92("p", { className: "mt-1 text-sm text-gray-500", children: error.message }),
              /* @__PURE__ */ jsx92("pre", { children: error.stack })
            ] }),
            /* @__PURE__ */ jsx92("div", { className: "ml-4 flex flex-shrink-0", children: /* @__PURE__ */ jsxs57(
              "button",
              {
                type: "button",
                className: "inline-flex rounded-md bg-white text-gray-600 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                onClick: () => {
                  setShow(false);
                },
                children: [
                  /* @__PURE__ */ jsx92("span", { className: "sr-only", children: "Close" }),
                  /* @__PURE__ */ jsx92(XMarkIcon2, { className: "h-5 w-5", "aria-hidden": "true" })
                ]
              }
            ) })
          ] }) }) })
        }
      ) })
    }
  ) });
};

// src/components/errors/FormErrorCodes.tsx
import { XCircleIcon as XCircleIcon3 } from "@heroicons/react/20/solid";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { useUserErrorContext } from "shared-lib";
import { Fragment as Fragment27, jsx as jsx93, jsxs as jsxs58 } from "react/jsx-runtime";
var FormErrorCode = ({
  title,
  message
}) => {
  return /* @__PURE__ */ jsx93("div", { className: "m-4 rounded-md border bg-yellow-50 p-4", children: /* @__PURE__ */ jsxs58("div", { className: "flex", children: [
    /* @__PURE__ */ jsx93("div", { className: "flex-shrink-0", children: /* @__PURE__ */ jsx93(
      ExclamationTriangleIcon,
      {
        className: "h-5 w-5 text-yellow-400",
        "aria-hidden": "true"
      }
    ) }),
    /* @__PURE__ */ jsxs58("div", { className: "ml-3", children: [
      /* @__PURE__ */ jsx93("h3", { className: "text-sm font-medium text-yellow-800", children: title ? title : "There is a problem" }),
      /* @__PURE__ */ jsx93("div", { className: "mt-2 text-sm text-yellow-700", children: /* @__PURE__ */ jsx93("p", { children: message }) })
    ] })
  ] }) });
};
var FormErrorCodes = () => {
  const errorContext = useUserErrorContext();
  if (errorContext && errorContext.errors && errorContext.errors.length > 0) {
    const errorItems = errorContext.errors.map((e) => {
      return /* @__PURE__ */ jsx93("li", { children: e.message }, e.code);
    });
    return /* @__PURE__ */ jsx93("div", { className: "my-4 rounded-md border border-red-200 bg-red-50 p-4", children: /* @__PURE__ */ jsxs58("div", { className: "flex", children: [
      /* @__PURE__ */ jsx93("div", { className: "flex-shrink-0", children: /* @__PURE__ */ jsx93(XCircleIcon3, { className: "h-5 w-5 text-red-400", "aria-hidden": "true" }) }),
      /* @__PURE__ */ jsxs58("div", { className: "ml-3", children: [
        /* @__PURE__ */ jsxs58("h3", { className: "text-sm font-medium text-red-800", children: [
          "There were ",
          errorContext.errors.length,
          " errors"
        ] }),
        /* @__PURE__ */ jsx93("div", { className: "mt-2 text-sm text-red-700", children: /* @__PURE__ */ jsx93("ul", { role: "list", className: "list-disc space-y-1 pl-5", children: errorItems }) })
      ] })
    ] }) });
  }
  return /* @__PURE__ */ jsx93(Fragment27, {});
};

// src/components/layouts/SectionedLayout.tsx
import { Fragment as Fragment28, jsx as jsx94, jsxs as jsxs59 } from "react/jsx-runtime";
var SectionRoot = () => {
  const ref = useRef5(null);
  useEffect9(() => {
    setSidebarHeight();
  }, [ref]);
  const [height, setHeight] = useState18(window.innerHeight);
  const debouncedHeight = useDebounce3(height, 50);
  const setSidebarHeight = useCallback12(() => {
    setHeight(window.innerHeight - (ref.current?.offsetTop || 0));
  }, []);
  useEffect9(() => {
    window.addEventListener("resize", setSidebarHeight);
    setSidebarHeight();
    return () => window.removeEventListener("resize", setSidebarHeight);
  }, [ref]);
  return /* @__PURE__ */ jsx94(
    "div",
    {
      ref,
      style: { height: debouncedHeight },
      className: "w-full overflow-auto",
      children: /* @__PURE__ */ jsx94(Outlet2, {})
    }
  );
};
var SectionedLayoutContext = React6.createContext({
  filterComponent: /* @__PURE__ */ jsx94(Fragment28, {}),
  setFilterComponent: noop4
});
var DefaultSectionElement = ({ data }) => {
  const titleIsElement = React6.isValidElement(data.itemTitle);
  return /* @__PURE__ */ jsxs59(Fragment28, { children: [
    titleIsElement ? data.itemTitle : /* @__PURE__ */ jsx94(
      motion.h1,
      {
        className: "font-InterMedium text-info-gray-800 line-clamp-1 text-center text-base font-bold tracking-tight sm:text-3xl",
        animate: { opacity: 1, scale: 1 },
        initial: { opacity: 0, scale: 0.5 },
        children: data.itemTitle
      }
    ),
    data.description && /* @__PURE__ */ jsx94("div", { className: "line-clamp-1 text-right text-xs", children: data.description })
  ] });
};
var SectionedLayout = ({
  title,
  sections,
  loadMore = () => 0,
  isLoading = false,
  emptyState: emptyState2,
  shrinkSidebar = false,
  showFilters = false,
  showMobileMenuIcon = true,
  showBackButton = true,
  children,
  FilterIconActive,
  FilterIconInactive,
  itemHeader,
  expandLink = () => void 0
}) => {
  const [current, setCurrent] = useState18(null);
  const routes = sections.map((s) => {
    return /* @__PURE__ */ jsx94(
      Route,
      {
        path: `${s.key}/*`,
        element: /* @__PURE__ */ jsxs59("div", { className: "flex h-full flex-grow flex-col xl:overflow-y-auto", children: [
          /* @__PURE__ */ jsx94(
            MobileHeader,
            {
              expandLink: expandLink(s.key),
              showMobileNavIcon: showMobileMenuIcon,
              showBackButton,
              title: itemHeader ? itemHeader(s) : /* @__PURE__ */ jsx94(DefaultSectionElement, { data: s })
            }
          ),
          /* @__PURE__ */ jsx94("div", { className: "flex flex-grow flex-col", children: s.element })
        ] }),
        errorElement: /* @__PURE__ */ jsx94(ErrorContainer, {})
      },
      s.key
    );
  });
  const mobileItem = (s, actionIdx) => {
    const titleIsElement = React6.isValidElement(s.listTitle);
    return /* @__PURE__ */ jsxs59(
      "div",
      {
        className: classNames(
          actionIdx === 0 ? "" : "",
          actionIdx === 1 ? "sm:rounded-tr-lg" : "",
          actionIdx === sections.length - 2 ? "sm:rounded-bl-lg" : "",
          actionIdx === sections.length - 1 ? "rounded-bl-lg rounded-br-lg sm:rounded-bl-none" : "",
          "group relative flex w-full cursor-pointer items-center justify-between border-b bg-white px-2 py-4 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500 hover:bg-gray-50 sm:p-6"
        ),
        children: [
          s.highlight && /* @__PURE__ */ jsxs59(
            "span",
            {
              className: classNames(
                "absolute  flex h-3 w-3",
                s.highlightPosition == "left" ? "left-6 top-7" : "right-3 top-3"
              ),
              children: [
                /* @__PURE__ */ jsx94(
                  "span",
                  {
                    className: classNames(
                      "absolute inline-flex h-full w-full animate-ping rounded-full opacity-75",
                      s.highlightColor || "bg-sky-400"
                    )
                  }
                ),
                /* @__PURE__ */ jsx94(
                  "span",
                  {
                    className: classNames(
                      "relative inline-flex h-3 w-3 rounded-full ",
                      s.highlightColor || "bg-sky-500"
                    )
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx94("div", { className: "flex w-full items-center justify-between", children: /* @__PURE__ */ jsxs59("div", { className: "flex flex-grow flex-col", children: [
            /* @__PURE__ */ jsxs59("div", { className: "flex items-center gap-3", children: [
              s.icon !== null && /* @__PURE__ */ jsx94(
                "span",
                {
                  className: classNames(
                    s.iconBackground || "text-primary-700",
                    s.iconForeground || "bg-primary-50",
                    "hidden rounded-lg p-3 ring-4 ring-white sm:inline-flex"
                  ),
                  children: s.icon ? /* @__PURE__ */ jsx94(s.icon, { className: "h-6 w-6", "aria-hidden": "true" }) : null
                }
              ),
              /* @__PURE__ */ jsx94("div", { className: "grow font-medium sm:w-auto sm:text-lg", children: /* @__PURE__ */ jsxs59(EdLink, { href: `${s.key}`, name: s.key, children: [
                /* @__PURE__ */ jsx94("span", { className: "absolute inset-0", "aria-hidden": "true" }),
                titleIsElement ? s.listTitle : /* @__PURE__ */ jsxs59("div", { className: "flex grow items-center gap-3", children: [
                  s.icon ? /* @__PURE__ */ jsx94("div", { className: "flex w-10 items-center justify-center rounded-lg bg-white p-1 sm:hidden", children: /* @__PURE__ */ jsx94(s.icon, { className: "w-full", "aria-hidden": "true" }) }) : null,
                  /* @__PURE__ */ jsxs59("div", { className: "flex flex-col", children: [
                    /* @__PURE__ */ jsx94("p", { className: "text-info-gray-900 text-md", children: s.listTitle }),
                    /* @__PURE__ */ jsx94("p", { className: "text-sm text-gray-600", children: s.listSubtitle })
                  ] })
                ] })
              ] }, s.key + "-mobile") })
            ] }),
            s.description && /* @__PURE__ */ jsx94("p", { className: "mt-4 text-sm text-gray-500", children: s.description })
          ] }) })
        ]
      },
      s.key
    );
  };
  const listPage = /* @__PURE__ */ jsx94("div", { className: "mb-10 divide-y divide-gray-200 overflow-hidden bg-gray-50 shadow xl:hidden", children: /* @__PURE__ */ jsx94(
    FlatList,
    {
      data: sections,
      renderItem: mobileItem,
      isLoading,
      onEndReached: loadMore
    }
  ) });
  const item = (s) => {
    const titleIsElement = React6.isValidElement(s.listTitle);
    return /* @__PURE__ */ jsxs59(
      EdLink,
      {
        href: `${s.key}`,
        name: s.key,
        onClick: () => {
          setCurrent(s.key);
          if (s.onClick) {
            s.onClick(s);
          }
        },
        className: classNames(
          current && current === s.key ? "bg-primary-100 rounded-lg bg-opacity-50" : "hover:bg-primary-100 hover:bg-opacity-50",
          "border-info-gray-200 relative flex w-full items-center p-4"
        ),
        children: [
          s.highlight && /* @__PURE__ */ jsxs59(
            "span",
            {
              className: classNames(
                "absolute flex h-3 w-3",
                s.highlightPosition == "left" ? "left-6 top-7" : "right-3 top-3"
              ),
              children: [
                /* @__PURE__ */ jsx94(
                  "span",
                  {
                    className: classNames(
                      "absolute inline-flex h-full w-full animate-ping rounded-full opacity-75",
                      s.highlightColor || "bg-sky-400"
                    )
                  }
                ),
                /* @__PURE__ */ jsx94(
                  "span",
                  {
                    className: classNames(
                      "relative inline-flex h-3 w-3 rounded-full ",
                      s.highlightColor || "bg-sky-500"
                    )
                  }
                )
              ]
            }
          ),
          !shrinkSidebar && /* @__PURE__ */ jsx94("div", { className: "relative", children: s.icon && /* @__PURE__ */ jsx94(
            "span",
            {
              className: classNames(
                s.iconBackground || "text-primary-700",
                s.iconForeground || "bg-primary-50",
                "inline-flex rounded-lg ring-white",
                shrinkSidebar ? "p-1 ring-2" : "p-3 ring-4"
              ),
              children: /* @__PURE__ */ jsx94(
                s.icon,
                {
                  className: shrinkSidebar ? "h-3 w-3" : "h-6 w-6",
                  "aria-hidden": "true"
                }
              )
            }
          ) }),
          /* @__PURE__ */ jsxs59("div", { className: "text-md ml-3 grow", children: [
            titleIsElement ? s.listTitle : /* @__PURE__ */ jsxs59("div", { className: "flex flex-col", children: [
              /* @__PURE__ */ jsx94(
                "p",
                {
                  className: classNames(
                    "text-info-gray-900 font-medium",
                    shrinkSidebar ? "text-sm" : "text-md"
                  ),
                  children: s.listTitle
                }
              ),
              /* @__PURE__ */ jsx94("div", { className: "text-sm text-gray-500", children: s.listSubtitle })
            ] }),
            /* @__PURE__ */ jsx94("p", { className: "text-info-gray-500 mt-1", children: s.description })
          ] })
        ]
      },
      s.key + "-desktop"
    );
  };
  const leftSidebarList = /* @__PURE__ */ jsx94(
    FlatList,
    {
      data: sections,
      renderItem: item,
      onEndReached: loadMore,
      isLoading
    }
  );
  const [filtersActive, toggleFiltersActive] = useToggle5(false);
  const [filterComponent, setFilterComponent] = useState18(/* @__PURE__ */ jsx94(Fragment28, {}));
  const navigationComponent = /* @__PURE__ */ jsxs59(
    "nav",
    {
      "aria-label": "Sections",
      className: classNames(
        "border-info-gray-200 grow flex-col border-r transition-[width] md:flex  xl:flex xl:w-96 xl:flex-col",
        shrinkSidebar ? "w-40" : " "
      ),
      children: [
        (title || showFilters) && /* @__PURE__ */ jsx94("div", { children: /* @__PURE__ */ jsxs59("div", { className: "border-info-gray-200 flex flex-col items-center justify-between border-b lg:flex-row  lg:bg-white", children: [
          /* @__PURE__ */ jsx94("div", { className: "flex flex-col bg-white lg:pb-0", children: /* @__PURE__ */ jsx94("div", { className: "flex flex-col justify-between gap-2 px-4 py-2 lg:flex-row lg:gap-0", children: /* @__PURE__ */ jsx94("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx94("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ jsx94("div", { className: "py-2 text-2xl font-medium text-gray-700", children: title }) }) }) }) }),
          /* @__PURE__ */ jsxs59(
            "div",
            {
              "aria-label": "Filters",
              onClick: toggleFiltersActive,
              className: "flex w-full grow cursor-pointer items-center justify-between px-4 py-2 text-sm font-medium hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 lg:hidden",
              children: [
                /* @__PURE__ */ jsx94("div", { children: "Filter" }),
                /* @__PURE__ */ jsx94(ArrowDownIcon, { className: "h-5 w-5" })
              ]
            }
          ),
          showFilters && /* @__PURE__ */ jsx94(
            "div",
            {
              onClick: toggleFiltersActive,
              className: "mr-6 flex w-full grow justify-end lg:self-auto",
              children: /* @__PURE__ */ jsx94("div", { className: "hidden md:flex-col lg:flex", children: filtersActive ? FilterIconActive ? FilterIconActive : /* @__PURE__ */ jsx94(FunnelIconSolid2, { className: "h-6 w-6" }) : FilterIconInactive ? FilterIconInactive : /* @__PURE__ */ jsx94(FunnelIconOutline2, { className: "h-6 w-6" }) })
            }
          )
        ] }) }),
        filtersActive && filterComponent,
        /* @__PURE__ */ jsx94("div", { className: "hidden min-h-0 flex-1 overflow-y-auto xl:flex", children: leftSidebarList })
      ]
    }
  );
  return /* @__PURE__ */ jsxs59(
    SectionedLayoutContext.Provider,
    {
      value: { filterComponent, setFilterComponent },
      children: [
        /* @__PURE__ */ jsx94("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ jsxs59("div", { className: "w-full min-w-0 flex-1 xl:flex", children: [
          /* @__PURE__ */ jsx94("div", { className: "hidden xl:flex", children: navigationComponent }),
          /* @__PURE__ */ jsx94(Routes, { children: /* @__PURE__ */ jsxs59(
            Route,
            {
              path: "/",
              element: /* @__PURE__ */ jsx94(SectionRoot, {}),
              errorElement: /* @__PURE__ */ jsx94(ErrorContainer, {}),
              children: [
                /* @__PURE__ */ jsx94(
                  Route,
                  {
                    path: `/`,
                    element: /* @__PURE__ */ jsx94(Suspense, { children: /* @__PURE__ */ jsxs59("div", { className: "flex w-full grow flex-col", children: [
                      /* @__PURE__ */ jsx94("div", { className: "flex w-full grow xl:hidden", children: navigationComponent }),
                      sections && sections.length > 0 ? listPage : emptyState2
                    ] }) }),
                    errorElement: /* @__PURE__ */ jsx94(ErrorContainer, {})
                  }
                ),
                routes
              ]
            }
          ) })
        ] }) }),
        children
      ]
    }
  );
};
var Filters2 = ({ children }) => {
  const context = useContext8(SectionedLayoutContext);
  useEffect9(() => {
    context.setFilterComponent(children);
  }, [children, context]);
  return /* @__PURE__ */ jsx94(Fragment28, {});
};
SectionedLayout.Filters = Filters2;

// src/components/layouts/TwoColumnLayout.tsx
import { jsx as jsx95, jsxs as jsxs60 } from "react/jsx-runtime";
var TwoColumnLayout = ({ main, aside }) => {
  return /* @__PURE__ */ jsxs60("div", { className: "flex flex-1 items-stretch overflow-hidden", children: [
    /* @__PURE__ */ jsx95("main", { className: "flex-1 overflow-y-auto", children: main }),
    /* @__PURE__ */ jsx95("aside", { className: "hidden w-96 overflow-y-auto border-l border-gray-200 bg-white lg:block", children: aside })
  ] });
};

// src/components/navigation/Navigation.tsx
import { jsx as jsx96, jsxs as jsxs61 } from "react/jsx-runtime";
var mobileViewState = atom2(false);
var Navigation = ({
  accountLink,
  list,
  accountInfo,
  collapseNavigation = false,
  toggleCollapseNavigation
}) => {
  const hasGlobalAccountNotification = list.reduce(
    (a, c) => {
      if (c.name === "Account") {
        return c?.highlight || false;
      }
      return a;
    },
    false
  );
  return /* @__PURE__ */ jsx96(
    "div",
    {
      className: classNames(
        "block h-full bg-gray-200",
        !collapseNavigation ? "" : ""
      ),
      children: /* @__PURE__ */ jsxs61("div", { className: "z-50 flex h-full w-full flex-col items-center", children: [
        /* @__PURE__ */ jsx96("div", { className: "flex w-full min-w-[60px] flex-1 flex-col justify-between space-y-1", children: /* @__PURE__ */ jsx96("div", { className: "flex flex-col justify-center", children: list.filter(({ name }) => name !== "Account").map((item) => /* @__PURE__ */ jsx96("div", { className: "flex", children: /* @__PURE__ */ jsx96(
          EdSidebarLink,
          {
            name: item.name,
            link: {
              ...item
            },
            highlight: item.highlight
          }
        ) }, item.name)) }) }),
        accountInfo && /* @__PURE__ */ jsx96("div", { className: "absolute relative flex w-full flex-shrink-0 flex-col gap-2 overflow-y-clip border-gray-200 bg-gray-300 pb-4 pt-4 text-gray-500 hover:z-50 hover:bg-gray-600 hover:text-white", children: /* @__PURE__ */ jsx96(
          NavLink2,
          {
            to: accountLink,
            className: "group block flex-shrink-0 px-4",
            children: /* @__PURE__ */ jsxs61("div", { className: "relative flex items-center", children: [
              /* @__PURE__ */ jsxs61("div", { children: [
                /* @__PURE__ */ jsx96(UserCircleIcon, { className: "h-7 w-7 " }),
                hasGlobalAccountNotification && /* @__PURE__ */ jsx96("div", { className: "absolute -right-1 -top-1 flex items-center justify-center", children: /* @__PURE__ */ jsx96(Pulse, {}) })
              ] }),
              /* @__PURE__ */ jsx96("div", { className: "absolute left-7 flex ", children: /* @__PURE__ */ jsx96(
                "span",
                {
                  className: `mx-4 flex rounded-r-xl  bg-gray-600 px-10 py-5 font-bold text-white`,
                  children: "Account"
                }
              ) })
            ] })
          }
        ) })
      ] })
    }
  );
};
var useMobileNavigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useAtom2(mobileViewState);
  return [mobileMenuOpen, setMobileMenuOpen];
};
var MobileNavigation = ({
  list,
  accountInfo,
  portalType
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useMobileNavigation();
  const setHideMobileSublist = useSetAtom2(listLayoutAtom);
  const hasGlobalAccountNotification = list.reduce(
    (a, c) => {
      if (c.name === "Account") {
        return c?.highlight || false;
      }
      return a;
    },
    false
  );
  return /* @__PURE__ */ jsx96(Transition5.Root, { show: mobileMenuOpen, as: Fragment29, children: /* @__PURE__ */ jsx96(Dialog2, { as: "div", static: true, open: mobileMenuOpen, onClose: setMobileMenuOpen, children: /* @__PURE__ */ jsxs61("div", { className: "fixed inset-0 z-40 flex", children: [
    /* @__PURE__ */ jsx96(
      Transition5.Child,
      {
        as: Fragment29,
        enter: "transition-opacity ease-linear duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity ease-linear duration-300",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /* @__PURE__ */ jsx96(Dialog2.Overlay, { className: "fixed inset-0 bg-gray-600 bg-opacity-75" })
      }
    ),
    /* @__PURE__ */ jsx96(
      Transition5.Child,
      {
        as: Fragment29,
        enter: "transition ease-in-out duration-300 transform",
        enterFrom: "-translate-x-full",
        enterTo: "translate-x-0",
        leave: "transition ease-in-out duration-300 transform",
        leaveFrom: "translate-x-0",
        leaveTo: "-translate-x-full",
        children: /* @__PURE__ */ jsxs61("div", { className: "relative flex w-full max-w-xs flex-1 flex-col bg-gray-50 ", children: [
          /* @__PURE__ */ jsx96(
            Transition5.Child,
            {
              as: Fragment29,
              enter: "ease-in-out duration-300",
              enterFrom: "opacity-0",
              enterTo: "opacity-100",
              leave: "ease-in-out duration-300",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              children: /* @__PURE__ */ jsx96("div", { className: "absolute right-0 top-1 -mr-14 p-1", children: /* @__PURE__ */ jsxs61(
                "button",
                {
                  type: "button",
                  className: "flex h-12 w-12 items-center justify-center rounded-full",
                  onClick: () => setMobileMenuOpen(false),
                  children: [
                    /* @__PURE__ */ jsx96(
                      XCircleIcon4,
                      {
                        className: "h-6 w-6 text-white",
                        "aria-hidden": "true"
                      }
                    ),
                    /* @__PURE__ */ jsx96("span", { className: "sr-only", children: "Close sidebar" })
                  ]
                }
              ) })
            }
          ),
          /* @__PURE__ */ jsx96("div", { className: "flex flex-shrink-0 items-center bg-gray-800 px-4 py-4", children: /* @__PURE__ */ jsx96(AppSvg, { color: "#ffffff" }) }),
          /* @__PURE__ */ jsx96("div", { className: "mt-5 h-0 flex-1 overflow-y-auto px-2", children: /* @__PURE__ */ jsx96("nav", { className: "flex h-full flex-col", children: /* @__PURE__ */ jsx96("div", { className: "space-y-1", children: list.filter(({ name }) => name !== "Account").map((item) => /* @__PURE__ */ jsx96(
            EdMobileLink,
            {
              highlight: item.highlight,
              name: item.name,
              link: item,
              onClick: () => {
                setMobileMenuOpen(false);
                setHideMobileSublist(false);
              }
            },
            item.name
          )) }) }) }),
          accountInfo && /* @__PURE__ */ jsxs61("div", { className: "pb-safe relative flex w-full flex-shrink-0 border-t border-gray-200 bg-gray-100 p-4", children: [
            hasGlobalAccountNotification && /* @__PURE__ */ jsx96("div", { className: "absolute right-0 top-0 flex h-8 w-8 items-center justify-center", children: /* @__PURE__ */ jsx96(Pulse, {}) }),
            /* @__PURE__ */ jsx96(
              Link3,
              {
                to: `/${portalType}/app/account`,
                onClick: () => {
                  setMobileMenuOpen(false);
                  setHideMobileSublist(false);
                },
                children: /* @__PURE__ */ jsx96("a", { href: "#", className: "group block flex-shrink-0", children: /* @__PURE__ */ jsxs61("div", { className: "flex items-center", children: [
                  /* @__PURE__ */ jsx96("div", { children: /* @__PURE__ */ jsx96(UserCircleIcon, { className: "h-7 w-7 text-gray-500" }) }),
                  /* @__PURE__ */ jsxs61("div", { className: "ml-3", children: [
                    /* @__PURE__ */ jsxs61("p", { className: "text-base font-medium text-gray-700 group-hover:text-gray-900", children: [
                      accountInfo.firstName,
                      " ",
                      accountInfo.lastName
                    ] }),
                    /* @__PURE__ */ jsx96("p", { className: "text-sm font-medium text-gray-500 group-hover:text-gray-700", children: "View account" })
                  ] })
                ] }) })
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx96("div", { className: "w-14 flex-shrink-0", "aria-hidden": "true" })
  ] }) }) });
};

// src/components/navigation/NavigationLink.tsx
import { jsx as jsx97 } from "react/jsx-runtime";
var NavigationLink = ({ to, active, onClick, children }) => {
  return /* @__PURE__ */ jsx97("div", { onClick, children: /* @__PURE__ */ jsx97(EdLink, { name: to, href: to, children: /* @__PURE__ */ jsx97(
    "div",
    {
      className: classNames(
        "flex w-full cursor-pointer border-b-2 border-gray-100 px-6 py-5 transition hover:bg-gray-50",
        active ? "bg-gray-200" : ""
      ),
      children: /* @__PURE__ */ jsx97("div", { className: "text-gray-700", children })
    }
  ) }) });
};

// src/components/cron/CronEditor.tsx
import { jsx as jsx98, jsxs as jsxs62 } from "react/jsx-runtime";
var initialWeekDayItems = [
  { id: "MON", title: "Monday", checked: false },
  { id: "TUE", title: "Tuesday", checked: false },
  { id: "WED", title: "Wednesday", checked: false },
  { id: "THU", title: "Thursday", checked: false },
  { id: "FRI", title: "Friday", checked: false },
  { id: "SAT", title: "Saturday", checked: false },
  { id: "SUN", title: "Sunday", checked: false }
];
function everyMonthOn(dayOfsTheMonth, hourOfTheDay = "12", minuteOfTheHour = "00") {
  const days = dayOfsTheMonth.join(",");
  return `0 ${minuteOfTheHour} ${hourOfTheDay} ${days} 1/1 ? *`;
}
function onSpecificDays(daysOfTheWeek, hourOfTheDay = "12", minuteOfTheHour = "00") {
  const days = daysOfTheWeek.map((d) => d.toUpperCase()).join(",");
  return `0 ${minuteOfTheHour} ${hourOfTheDay} ? * ${days} *`;
}
function buildCron(mode, weekDays, startTime, monthDays) {
  const selectionMode = mode;
  switch (selectionMode) {
    case "Week" /* Week */: {
      const dayNames = weekDays.filter((i) => i.checked).map((i) => i.id);
      if (dayNames.length === 0) {
        return "";
      }
      if (startTime) {
        const [hour, minute] = startTime.split(":");
        return onSpecificDays(dayNames, hour, minute);
      } else {
        return onSpecificDays(dayNames);
      }
    }
    case "Month" /* Month */: {
      if (!monthDays || monthDays.length == 0) {
        return "";
      }
      const monthDayId = monthDays.map((i) => i.id);
      if (startTime) {
        const [hour, minute] = startTime.split(":");
        return everyMonthOn(monthDayId, hour, minute);
      } else {
        return everyMonthOn(monthDayId);
      }
    }
  }
}
var CronEditor = ({ data, onChanged }) => {
  const [startDate, setStartDate] = useState19(formatDate2(data.startDate));
  const [endDate, setEndDate] = useState19(formatDate2(data.endDate));
  const [startTime, setStartTime] = useState19("12:00");
  const [weekDays, setWeekDays] = useState19(initialWeekDayItems);
  const [monthDays, setMonthDays] = useState19([]);
  const [current, tabLinks] = useTabs([
    { name: "Week" /* Week */ },
    { name: "Month" /* Month */ }
  ]);
  const [cronExpression, setCronExpression] = useState19("");
  function changed(start, end, cron) {
    setCronExpression(cron);
    onChanged({
      startDate: parseDate2(start),
      endDate: parseDate2(end),
      cronExpression: cron
    });
  }
  function changeWeekDays(changedItems) {
    setWeekDays(changedItems);
    const cron = buildCron(current.name, changedItems, startTime, monthDays);
    changed(startDate, endDate, cron);
  }
  function changeMonthDays(changedItems) {
    setMonthDays(changedItems);
    const cron = buildCron(current.name, weekDays, startTime, changedItems);
    changed(startDate, endDate, cron);
  }
  function changeTime(time2) {
    setStartTime(time2);
    const cron = buildCron(current.name, weekDays, time2, monthDays);
    changed(startDate, endDate, cron);
  }
  function changeStartDate(date) {
    setStartDate(date);
    const cron = buildCron(current.name, weekDays, startTime, monthDays);
    changed(date, endDate, cron);
  }
  function changeEndDate(date) {
    setEndDate(date);
    const cron = buildCron(current.name, weekDays, startTime, monthDays);
    changed(startDate, date, cron);
  }
  let currentTab;
  switch (current.name) {
    case "Week" /* Week */: {
      currentTab = /* @__PURE__ */ jsxs62("div", { className: "flex items-center space-x-4 py-4", children: [
        /* @__PURE__ */ jsx98("label", { className: "w-24", htmlFor: "startTime", children: "Week Day" }),
        /* @__PURE__ */ jsx98("div", { className: "flex-1", children: /* @__PURE__ */ jsx98(CheckBoxList, { initialItems: weekDays, onChanged: changeWeekDays }) })
      ] });
      break;
    }
    case "Month" /* Month */: {
      currentTab = /* @__PURE__ */ jsxs62("div", { className: "flex items-center space-x-4 py-4", children: [
        /* @__PURE__ */ jsx98("label", { className: "w-24", htmlFor: "startTime", children: "Day of Month" }),
        /* @__PURE__ */ jsx98("div", { className: "flex-1", children: /* @__PURE__ */ jsx98(
          DayOfMonthSelector,
          {
            initialSelected: monthDays,
            onChanged: changeMonthDays
          }
        ) })
      ] });
      break;
    }
  }
  return /* @__PURE__ */ jsxs62("div", { className: "sm:w-1/2", children: [
    /* @__PURE__ */ jsx98("div", { className: "mb-2 p-2", children: /* @__PURE__ */ jsx98(CronSummary, { cron: cronExpression }) }),
    /* @__PURE__ */ jsx98(ButtonTabPills, { tabs: tabLinks }),
    currentTab,
    /* @__PURE__ */ jsxs62("div", { className: "flex items-center space-x-4 py-2", children: [
      /* @__PURE__ */ jsx98("label", { className: "w-24", htmlFor: "startTime", children: "Start Time" }),
      /* @__PURE__ */ jsx98(
        TimeSelector,
        {
          name: "startTime",
          initialTime: startTime,
          onChanged: changeTime
        }
      )
    ] }),
    /* @__PURE__ */ jsxs62("div", { className: "flex items-center space-x-4 py-2", children: [
      /* @__PURE__ */ jsx98("label", { className: "w-24", htmlFor: "startDate", children: "Start Date" }),
      /* @__PURE__ */ jsx98(
        DateInput,
        {
          name: "startDate",
          initialDate: startDate,
          onChanged: changeStartDate
        }
      )
    ] }),
    /* @__PURE__ */ jsxs62("div", { className: "flex items-center space-x-4 py-2", children: [
      /* @__PURE__ */ jsx98("label", { className: "w-24", htmlFor: "endDate", children: "End Date" }),
      /* @__PURE__ */ jsx98(
        DateInput,
        {
          name: "endDate",
          initialDate: endDate,
          onChanged: changeEndDate
        }
      )
    ] })
  ] });
};

// src/components/debugging/RendersCounter.tsx
import { useRendersCount } from "react-use";
import { jsx as jsx99, jsxs as jsxs63 } from "react/jsx-runtime";
var RendersCounter = () => {
  const rendersCount = useRendersCount();
  return /* @__PURE__ */ jsxs63("div", { className: "text-secondary-700 flex items-center gap-2 border bg-white p-2", children: [
    /* @__PURE__ */ jsx99("div", { children: "renders" }),
    /* @__PURE__ */ jsx99("div", { children: rendersCount })
  ] });
};

// src/components/description-lists/DescriptionItem.tsx
import { jsx as jsx100, jsxs as jsxs64 } from "react/jsx-runtime";
var DescriptionItem = ({
  label,
  noGrid,
  children
}) => {
  const className = noGrid ? "" : "sm:grid sm:grid-cols-3 sm:gap-4";
  return /* @__PURE__ */ jsxs64("div", { className: `py-4 sm:py-5 ${className} sm:px-6`, children: [
    /* @__PURE__ */ jsx100("dt", { className: "text-sm font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsx100("dd", { className: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0", children })
  ] });
};

// src/components/description-lists/DescriptionList.tsx
import { jsx as jsx101, jsxs as jsxs65 } from "react/jsx-runtime";
var DescriptionList = ({
  heading,
  description,
  items,
  classes
}) => /* @__PURE__ */ jsxs65("div", { className: `bg-white shadow sm:rounded-lg ${classes}`, children: [
  /* @__PURE__ */ jsx101("div", { className: "px-4 py-5 sm:px-6", children: /* @__PURE__ */ jsxs65("div", { children: [
    heading ? /* @__PURE__ */ jsx101("div", { className: "text-lg font-medium leading-6 text-gray-900", children: heading }) : null,
    description ? /* @__PURE__ */ jsx101("div", { className: "mt-1 max-w-2xl text-sm text-gray-500", children: description }) : null
  ] }) }),
  /* @__PURE__ */ jsx101("div", { className: "border-t border-gray-200 px-4 py-5 sm:p-0", children: /* @__PURE__ */ jsx101("dl", { className: "sm:divide-y sm:divide-gray-200", children: items }) })
] });

// src/components/editor/ContentEditor.tsx
import { useCallback as useCallback13, useMemo as useMemo7 } from "react";
import isHotkey from "is-hotkey";
import { Editable, withReact, Slate } from "slate-react";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import { FaBold } from "@react-icons/all-files/fa/FaBold";
import { FaItalic } from "@react-icons/all-files/fa/FaItalic";
import { FaUnderline } from "@react-icons/all-files/fa/FaUnderline";
import { FaCode } from "@react-icons/all-files/fa/FaCode";
import { FaQuoteLeft } from "@react-icons/all-files/fa/FaQuoteLeft";
import { FaListOl } from "@react-icons/all-files/fa/FaListOl";
import { FaListUl } from "@react-icons/all-files/fa/FaListUl";
import { FaAlignLeft } from "@react-icons/all-files/fa/FaAlignLeft";
import { FaAlignCenter } from "@react-icons/all-files/fa/FaAlignCenter";
import { FaAlignRight } from "@react-icons/all-files/fa/FaAlignRight";
import { FaAlignJustify } from "@react-icons/all-files/fa/FaAlignJustify";

// src/components/editor/EditorBlockButton.tsx
import { useSlate } from "slate-react";

// src/components/editor/EditorUtil.ts
import { useState as useState20 } from "react";
import {
  Editor,
  Transforms,
  Text,
  Element as SlateElement
} from "slate";
import { jsx as jsx102 } from "slate-hyperscript";
import escapeHtml from "escape-html";
import { useLogger as useLogger2 } from "shared-lib";

// src/components/editor/HtmlUtil.ts
var validateHTML = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const errorNode = doc.querySelector("parsererror");
  if (errorNode) {
    return false;
  } else {
    return true;
  }
};
function parseHTML(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  return doc;
}
var isHTMLDocument = (htmlString) => {
  return htmlString.startsWith("<");
  const isHtml = validateHTML(htmlString);
  return isHtml;
};

// src/components/editor/EditorUtil.ts
var HOTKEYS = {
  "mod+b": "bold",
  "mod+i": "italic",
  "mod+u": "underline",
  "mod+`": "code"
};
var LIST_TYPES = ["numbered-list", "bulleted-list"];
var TEXT_ALIGN_TYPES = ["left", "center", "right", "justify"];
var isBlockActive = (editor, format2, blockType = "type") => {
  const { selection } = editor;
  if (!selection)
    return false;
  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n) => !Editor.isEditor(n) && SlateElement.isElement(n) && n[blockType] === format2
    })
  );
  return !!match;
};
var isMarkActive = (editor, format2) => {
  const marks = Editor.marks(editor);
  console.log(JSON.stringify(marks));
  return marks ? marks[format2] === true : false;
};
var toggleBlock = (editor, format2) => {
  const isActive = isBlockActive(
    editor,
    format2,
    TEXT_ALIGN_TYPES.includes(format2) ? "align" : "type"
  );
  const isList = LIST_TYPES.includes(format2);
  Transforms.unwrapNodes(editor, {
    match: (n) => !Editor.isEditor(n) && SlateElement.isElement(n) && LIST_TYPES.includes(n.type) && !TEXT_ALIGN_TYPES.includes(format2),
    split: true
  });
  let newProperties;
  if (TEXT_ALIGN_TYPES.includes(format2)) {
    newProperties = {
      align: isActive ? void 0 : format2
    };
  } else {
    newProperties = {
      type: isActive ? "paragraph" : isList ? "list-item" : format2
    };
  }
  Transforms.setNodes(editor, newProperties);
  if (!isActive && isList) {
    const block = { type: format2, children: [] };
    Transforms.wrapNodes(editor, block);
  }
};
var toggleMark = (editor, format2) => {
  const isActive = isMarkActive(editor, format2);
  if (isActive) {
    Editor.removeMark(editor, format2);
  } else {
    Editor.addMark(editor, format2, true);
  }
};
function parseText(content) {
  const elements = content.split(/\r?\n|\r|\n/g);
  return elements.map((text) => {
    return {
      type: "paragraph",
      children: [{ text }]
    };
  });
}
var emptyState = [
  {
    type: "paragraph",
    children: [{ text: "" }]
  }
];
function useEditorState(serializedEditorState, textState, defaultState) {
  const [log] = useLogger2();
  const [editorState, setEditorState] = useState20(() => {
    if (serializedEditorState) {
      return JSON.parse(serializedEditorState);
    }
    if (textState) {
      return parseEditorState(textState, defaultState || emptyState, log);
    }
    return defaultState || emptyState;
  });
  return [editorState, setEditorState];
}
var parseEditorState = (content, defaultState, log) => {
  const isHtml = content.startsWith("<");
  if (content && isHtml) {
    const document2 = parseHTML(content);
    const editorState = deserializeHtmlElementToEditorState(
      document2.body,
      {},
      log
    );
    log(`EditorState Html Parsed`);
    log(editorState);
    return editorState;
  } else if (content) {
    const elements = parseText(content);
    log(`EditorState Text Parsed`);
    log(elements);
    return elements;
  } else {
    log(`EditorState Loaded Sample`);
    return defaultState;
  }
};
var serializeEditorStateToHtml = (value, log) => {
  return value.map((n) => serializeNodeToHtml(n, log)).join("\n");
};
var serializeNodeToHtml = (node4, log) => {
  if (!node4) {
    log && log(`serialize editor node, node = null or undefined`);
    return;
  }
  if (Text.isText(node4)) {
    let string = escapeHtml(node4.text);
    if (node4.bold) {
      string = `<strong>${string}</strong>`;
    }
    log && log(`serializing editor node as text`);
    return string;
  }
  if (!node4.children) {
    log && log(`serialize editor node, node has no children`);
    log && log(node4);
    return;
  }
  const children = (node4.children || []).map((n) => serializeNodeToHtml(n)).join("");
  const currentNode = node4;
  switch (currentNode.type) {
    case "quote":
      log && log(`serializing editor node as quote`);
      return `<blockquote><p>${children}</p></blockquote>`;
    case "paragraph":
      log && log(`serializing editor node as paragraph return children`);
      return `<p>${children}</p>`;
    case "link":
      log && log(`serializing editor node as link`);
      return `<a href="${escapeHtml(currentNode.url)}">${children}</a>`;
    default:
      log && log(`serializing editor node return children`);
      return children;
  }
};
var deserializeHtmlElementsToEditorState = (value, markAttributes = {}, log) => {
  return value.map((n) => deserializeHtmlElementToEditorState(n, markAttributes, log));
};
var deserializeHtmlElementToEditorState = (el, markAttributes = {}, log) => {
  log && log(`deserialize editor node`);
  log && log(el);
  if (el.nodeType === Node.TEXT_NODE) {
    return jsx102("text", markAttributes, el.textContent);
  } else if (el.nodeType !== Node.ELEMENT_NODE) {
    return null;
  }
  const nodeAttributes = { ...markAttributes };
  switch (el.nodeName) {
    case "STRONG":
      nodeAttributes.bold = true;
  }
  const children = Array.from(el.childNodes).map((node4) => deserializeHtmlElementToEditorState(node4, nodeAttributes)).flat();
  if (children.length === 0) {
    children.push(jsx102("text", nodeAttributes, ""));
  }
  switch (el.nodeName) {
    case "BODY": {
      log && log(`Body Element Found`);
      return jsx102("fragment", {}, children);
    }
    case "BR": {
      return "\n";
    }
    case "BLOCKQUOTE": {
      return jsx102("element", { type: "quote" }, children);
    }
    case "H1":
      return jsx102("element", { type: "heading-one" }, children);
    case "H2":
      return jsx102("element", { type: "heading-two" }, children);
    case "STRONG":
      return jsx102("text", { bold: true }, children);
    case "EM":
      return jsx102("text", { italic: true }, children);
    case "U":
      return jsx102("text", { underline: true }, children);
    case "P": {
      const element = el;
      return jsx102("element", { type: "paragraph" }, children);
    }
    case "A": {
      const element = el;
      return jsx102(
        "element",
        { type: "link", url: element.getAttribute("href") },
        children
      );
    }
    default:
      return children;
  }
};

// src/components/editor/EditorBlockButton.tsx
import { jsx as jsx103 } from "react/jsx-runtime";
var EditorBlockButton = ({ format: format2, label }) => {
  const editor = useSlate();
  return /* @__PURE__ */ jsx103(
    Button,
    {
      "aria-label": format2,
      className: classNames(
        isBlockActive(
          editor,
          format2,
          TEXT_ALIGN_TYPES.includes(format2) ? "align" : "type"
        ) ? "bg-gray-300" : "",
        "h-8 w-8 items-center justify-center rounded-none border-none bg-gray-100"
      ),
      onMouseDown: (event) => {
        event.preventDefault();
        toggleBlock(editor, format2);
      },
      children: /* @__PURE__ */ jsx103("div", { children: label })
    }
  );
};

// src/components/editor/EditorMarkButton.tsx
import { useSlate as useSlate2 } from "slate-react";
import { jsx as jsx104 } from "react/jsx-runtime";
var EditorMarkButton = ({ format: format2, label }) => {
  const editor = useSlate2();
  return /* @__PURE__ */ jsx104(
    Button,
    {
      "aria-label": format2,
      className: classNames(
        "h-8 w-8 items-center justify-center rounded-none border-none bg-gray-100",
        isMarkActive(editor, format2) ? "bg-gray-300" : ""
      ),
      onMouseDown: (event) => {
        event.preventDefault();
        toggleMark(editor, format2);
      },
      children: /* @__PURE__ */ jsx104("div", { children: label })
    }
  );
};

// src/components/editor/EditorToolbar.tsx
import { jsx as jsx105 } from "react/jsx-runtime";
var EditorToolbar = ({ children }) => {
  return /* @__PURE__ */ jsx105("div", { className: "flex flex-row gap-2 p-4", children });
};

// src/components/editor/EditorElement.tsx
import { DefaultElement } from "slate-react";
import { jsx as jsx106 } from "react/jsx-runtime";
var EditorElement = ({ attributes, element, children }) => {
  const style = { textAlign: element.align };
  switch (element.type) {
    case "block-quote":
      return /* @__PURE__ */ jsx106(
        "blockquote",
        {
          className: "text-md border-l bg-yellow-50 text-gray-900",
          style,
          ...attributes,
          children
        }
      );
    case "bulleted-list":
      return /* @__PURE__ */ jsx106(
        "ul",
        {
          className: "list-inside list-disc pl-1",
          style,
          ...attributes,
          children
        }
      );
    case "heading-one":
      return /* @__PURE__ */ jsx106("h1", { className: "text-xl font-medium", style, ...attributes, children });
    case "heading-two":
      return /* @__PURE__ */ jsx106("h2", { className: "text-lg font-medium", style, ...attributes, children });
    case "list-item":
      return /* @__PURE__ */ jsx106("li", { style, ...attributes, children });
    case "numbered-list":
      return /* @__PURE__ */ jsx106(
        "ol",
        {
          className: "list-inside list-decimal pl-1",
          style,
          ...attributes,
          children
        }
      );
    default:
      return /* @__PURE__ */ jsx106(DefaultElement, { element, attributes, children });
  }
};

// src/components/editor/EditorLeaf.tsx
import { jsx as jsx107 } from "react/jsx-runtime";
var EditorLeaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = /* @__PURE__ */ jsx107("strong", { className: "font-bold", children });
  }
  if (leaf.code) {
    children = /* @__PURE__ */ jsx107("code", { className: "bg-gray-100 font-mono text-red-400", children });
  }
  if (leaf.italic) {
    children = /* @__PURE__ */ jsx107("em", { children });
  }
  if (leaf.underline) {
    children = /* @__PURE__ */ jsx107("u", { children });
  }
  return /* @__PURE__ */ jsx107("span", { ...attributes, children });
};

// src/components/editor/ContentEditor.tsx
import { jsx as jsx108, jsxs as jsxs66 } from "react/jsx-runtime";
var sampleState = [
  {
    type: "paragraph",
    children: [{ text: "" }]
  }
];
var ContentEditor = ({ state, onChanged, placeholder }) => {
  const renderElement = useCallback13((props) => /* @__PURE__ */ jsx108(EditorElement, { ...props }), []);
  const renderLeaf = useCallback13((props) => /* @__PURE__ */ jsx108(EditorLeaf, { ...props }), []);
  const editor = useMemo7(() => withHistory(withReact(createEditor())), []);
  return /* @__PURE__ */ jsxs66(
    Slate,
    {
      editor,
      initialValue: state ?? sampleState,
      onChange: onChanged,
      children: [
        /* @__PURE__ */ jsx108(EditorToolbar, { children: /* @__PURE__ */ jsxs66("div", { className: "flex flex-wrap items-center gap-[1px] overflow-hidden rounded md:bg-gray-200", children: [
          /* @__PURE__ */ jsx108(EditorMarkButton, { format: "bold", label: /* @__PURE__ */ jsx108(FaBold, {}) }),
          /* @__PURE__ */ jsx108(EditorMarkButton, { format: "italic", label: /* @__PURE__ */ jsx108(FaItalic, {}) }),
          /* @__PURE__ */ jsx108(EditorMarkButton, { format: "underline", label: /* @__PURE__ */ jsx108(FaUnderline, {}) }),
          /* @__PURE__ */ jsx108(EditorMarkButton, { format: "code", label: /* @__PURE__ */ jsx108(FaCode, {}) }),
          /* @__PURE__ */ jsx108(EditorBlockButton, { format: "heading-one", label: "H1" }),
          /* @__PURE__ */ jsx108(EditorBlockButton, { format: "heading-two", label: "H2" }),
          /* @__PURE__ */ jsx108(EditorBlockButton, { format: "block-quote", label: /* @__PURE__ */ jsx108(FaQuoteLeft, {}) }),
          /* @__PURE__ */ jsx108(EditorBlockButton, { format: "numbered-list", label: /* @__PURE__ */ jsx108(FaListOl, {}) }),
          /* @__PURE__ */ jsx108(EditorBlockButton, { format: "bulleted-list", label: /* @__PURE__ */ jsx108(FaListUl, {}) }),
          /* @__PURE__ */ jsx108(EditorBlockButton, { format: "left", label: /* @__PURE__ */ jsx108(FaAlignLeft, {}) }),
          /* @__PURE__ */ jsx108(EditorBlockButton, { format: "center", label: /* @__PURE__ */ jsx108(FaAlignCenter, {}) }),
          /* @__PURE__ */ jsx108(EditorBlockButton, { format: "right", label: /* @__PURE__ */ jsx108(FaAlignRight, {}) }),
          /* @__PURE__ */ jsx108(EditorBlockButton, { format: "justify", label: /* @__PURE__ */ jsx108(FaAlignJustify, {}) })
        ] }) }),
        /* @__PURE__ */ jsx108("div", { children: /* @__PURE__ */ jsx108(
          Editable,
          {
            "aria-label": "Job Description",
            className: "h-[50vh] overflow-scroll pt-6 focus-visible:outline-none md:px-6",
            renderElement,
            renderLeaf,
            placeholder: placeholder || "Enter some rich text...",
            spellCheck: true,
            onKeyDown: (event) => {
              for (const hotkey in HOTKEYS) {
                if (isHotkey(hotkey, event)) {
                  event.preventDefault();
                  const mark = HOTKEYS[hotkey];
                  toggleMark(editor, mark);
                }
              }
            }
          }
        ) })
      ]
    }
  );
};

// src/components/editable/Editable.tsx
import {
  useCallback as useCallback14
} from "react";
import { useToggle as useToggle6 } from "shared-lib";
import { jsx as jsx109 } from "react/jsx-runtime";
var EdEditable = ({
  view,
  edit,
  title,
  className
}) => {
  const [editing, toggleEditing] = useToggle6();
  const onToggleEditing = useCallback14(() => {
    toggleEditing();
  }, [editing]);
  let current;
  switch (editing) {
    case true: {
      current = edit();
      break;
    }
    case false: {
      current = view();
      break;
    }
  }
  const currentButtonText = editing ? "Cancel" : "Edit";
  return /* @__PURE__ */ jsx109(
    EdCard,
    {
      title,
      link: /* @__PURE__ */ jsx109(Button, { clicked: onToggleEditing, children: currentButtonText }),
      children: /* @__PURE__ */ jsx109("div", { className: classNames(className ? className : ""), children: current })
    }
  );
};

// src/components/feedback/alerts/AlertMessage.tsx
import { useState as useState21 } from "react";
import { CheckCircleIcon, XMarkIcon as XMarkIcon3 } from "@heroicons/react/20/solid";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { Fragment as Fragment30, jsx as jsx110, jsxs as jsxs67 } from "react/jsx-runtime";
var AlertMessage = ({ message, isError }) => {
  const [show, setShow] = useState21(true);
  if (!show) {
    return /* @__PURE__ */ jsx110(Fragment30, {});
  }
  return /* @__PURE__ */ jsx110("div", { className: "my-4 border", children: /* @__PURE__ */ jsx110(
    motion.h1,
    {
      animate: { opacity: 1, scale: 1 },
      initial: { opacity: 0, scale: 0.5 },
      children: /* @__PURE__ */ jsx110(
        "div",
        {
          className: `${isError ? "bg-danger-50" : "bg-success-50"} rounded-md p-4`,
          children: /* @__PURE__ */ jsxs67("div", { className: "flex", children: [
            /* @__PURE__ */ jsx110("div", { className: "flex-shrink-0", children: isError ? /* @__PURE__ */ jsx110(
              ExclamationCircleIcon,
              {
                className: "text-danger-400 h-5 w-5",
                "aria-hidden": "true"
              }
            ) : /* @__PURE__ */ jsx110(
              CheckCircleIcon,
              {
                className: "text-success-400 h-5 w-5",
                "aria-hidden": "true"
              }
            ) }),
            /* @__PURE__ */ jsx110("div", { className: "ml-3", children: /* @__PURE__ */ jsx110(
              "p",
              {
                className: ` ${isError ? "text-danger-800" : "text-success-800"} text-sm font-medium`,
                children: message
              }
            ) }),
            /* @__PURE__ */ jsx110("div", { className: "ml-auto pl-3", children: /* @__PURE__ */ jsx110("div", { className: "-mx-1.5 -my-1.5", children: /* @__PURE__ */ jsxs67(
              "button",
              {
                type: "button",
                className: `${isError ? "bg-danger-50 text-danger-500 hover:bg-danger-100 focus:ring-danger-600 focus:ring-offset-danger-50" : "bg-success-50 text-success-500 hover:bg-success-100 focus:ring-success-600 focus:ring-offset-success-50"} inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2`,
                onClick: () => {
                  setShow(false);
                },
                children: [
                  /* @__PURE__ */ jsx110("span", { className: "sr-only", children: "Dismiss" }),
                  /* @__PURE__ */ jsx110(XMarkIcon3, { className: "h-5 w-5", "aria-hidden": "true" })
                ]
              }
            ) }) })
          ] })
        }
      )
    }
  ) });
};

// src/components/graphs/FunnelChart.tsx
import { useState as useState22 } from "react";
import { ResponsiveFunnel } from "@nivo/funnel";

// src/components/graphs/ChartColors.ts
var ChartColors = [
  "#2084EF",
  "#4B9CF2",
  "#64AAF4",
  "#97C6F8",
  "#CBE3FB",
  "#CFF4B8",
  "#BBEB9D",
  "#93EE5C",
  "#7EDA47"
];

// src/components/graphs/FunnelChart.tsx
import { jsx as jsx111, jsxs as jsxs68 } from "react/jsx-runtime";
function valueFormat(x) {
  return Math.round(x).toString();
}
var SvgBoxWithLabel = ({ value, label, rectangleColor, textColor, width, height }) => {
  const [isHovered, setIsHovered] = useState22(false);
  const hoverWidth = isHovered ? width + 10 : width;
  return /* @__PURE__ */ jsx111(
    ToolTipMessage,
    {
      styles: { backgroundColor: "#fff", borderColor: "#fff" },
      tooltip: /* @__PURE__ */ jsxs68("div", { className: "text-md flex w-full flex-row items-center bg-white text-black", children: [
        /* @__PURE__ */ jsx111(
          "div",
          {
            className: "mr-1 h-3 w-3",
            style: { background: rectangleColor }
          }
        ),
        `${label}: `,
        /* @__PURE__ */ jsxs68("span", { className: "font-bold", children: [
          "\xA0",
          value
        ] })
      ] }),
      children: /* @__PURE__ */ jsxs68(
        "svg",
        {
          width: hoverWidth,
          height,
          xmlns: "http://www.w3.org/2000/svg",
          className: "mx-auto block",
          onMouseEnter: () => {
            setIsHovered(true);
          },
          onMouseLeave: () => {
            setIsHovered(false);
          },
          children: [
            /* @__PURE__ */ jsx111(
              "rect",
              {
                x: "5",
                y: "0",
                width: hoverWidth - 10,
                height: height - 0,
                fill: rectangleColor,
                stroke: rectangleColor,
                strokeWidth: "0"
              }
            ),
            /* @__PURE__ */ jsx111(
              "text",
              {
                x: hoverWidth / 2,
                y: height / 2,
                textAnchor: "middle",
                fontSize: "11",
                fill: textColor,
                children: value
              }
            )
          ]
        }
      )
    }
  );
};
var FunnelChart = ({ data, height, colors }) => {
  if (data.length === 0)
    return /* @__PURE__ */ jsx111("div", {});
  let filteredData = data.filter((item) => item.value !== 0);
  const zeroValueData = data.filter((item) => item.value === 0);
  const useExp = filteredData[0].value - filteredData[filteredData.length - 1].value > 1e3;
  if (useExp) {
    filteredData = filteredData.map((x) => ({ ...x, value: Math.log(x.value) }));
  }
  const convertToDecimal = (percentageString) => {
    return parseFloat(percentageString.replace("%", "")) / 100;
  };
  const multiplyAndConvertToPercentage = (number2, times) => {
    const sub = 9 * times / 100;
    return `${(number2 - sub) * 100}%`;
  };
  if (zeroValueData?.length) {
    height = multiplyAndConvertToPercentage(
      convertToDecimal(height.toString()),
      zeroValueData?.length
    );
  }
  return /* @__PURE__ */ jsxs68("div", { style: { height }, children: [
    /* @__PURE__ */ jsx111(
      ResponsiveFunnel,
      {
        data: filteredData,
        valueFormat: (x) => valueFormat(useExp ? Math.exp(x) : x),
        margin: { top: 0, right: 0, bottom: 0, left: 0 },
        labelColor: "#000",
        colors: colors || ChartColors,
        borderWidth: 0,
        shapeBlending: 0,
        spacing: 1,
        beforeSeparatorLength: 20,
        beforeSeparatorOffset: 20,
        afterSeparatorLength: 20,
        afterSeparatorOffset: 20,
        currentPartSizeExtension: 10,
        currentBorderWidth: 0,
        animate: false
      }
    ),
    zeroValueData?.length > 0 && zeroValueData.map((item, index) => /* @__PURE__ */ jsx111("div", { className: "flex justify-center border-t  bg-white", children: /* @__PURE__ */ jsx111(
      SvgBoxWithLabel,
      {
        width: 30,
        height: 50,
        rectangleColor: "#f3f4f6",
        textColor: "#000",
        value: item?.value,
        label: item.label
      }
    ) }, index))
  ] });
};

// src/components/form-wizard/wizard/index.tsx
import { createContext as createContext9, useContext as useContext9 } from "react";
import { Routes as Routes2, Route as Route2 } from "react-router-dom";
import {
  useForm
} from "react-hook-form";
import { noop as noop5 } from "shared-lib";

// src/components/container/ActionContainer.tsx
import { Fragment as Fragment31, jsx as jsx112, jsxs as jsxs69 } from "react/jsx-runtime";
var ActionContainer = ({
  titleTop,
  subTitleTop,
  titleBottom,
  showDelete,
  onDelete,
  deleteText,
  showCancel,
  onCancel,
  isDisabled,
  isDirty,
  onSubmit,
  submitText = "Save",
  cancelText = "Cancel",
  isSaving,
  children,
  buttonElement,
  showProgress,
  progressTotal,
  progressIndex,
  color: color2,
  submitButtonColor,
  mainDivClassName,
  subDivClassName,
  titleTopClassName,
  subTitleTopClassName,
  showSubmit = true
}) => {
  let titleBottomElement = /* @__PURE__ */ jsx112(Fragment31, {});
  if (typeof titleBottom == "string") {
    titleBottomElement = /* @__PURE__ */ jsx112("h1", { className: "text-md grow font-bold text-gray-600 sm:text-2xl", children: titleBottom });
  } else if (typeof titleBottom == "object") {
    titleBottomElement = titleBottom;
  }
  return /* @__PURE__ */ jsxs69(
    "div",
    {
      className: mainDivClassName ?? "relative grow rounded-2xl border bg-white px-8 ring-black ring-opacity-5",
      children: [
        isSaving && /* @__PURE__ */ jsx112("div", { className: "absolute right-3 top-5", children: /* @__PURE__ */ jsx112(Spinner, {}) }),
        /* @__PURE__ */ jsxs69("div", { className: subDivClassName ?? "flex flex-col gap-5 pt-8", children: [
          titleTop && /* @__PURE__ */ jsx112("h1", { className: titleTopClassName ?? "font-regular text-gray-600", children: titleTop }),
          subTitleTop && /* @__PURE__ */ jsx112("h1", { className: subTitleTopClassName ?? "text-center", children: subTitleTop }),
          children
        ] }),
        showProgress && progressIndex && progressTotal && /* @__PURE__ */ jsx112(
          Progress,
          {
            count: progressIndex,
            total: progressTotal,
            progressText: ({ count: count2, total }) => `Step ${count2} of ${total}`
          }
        ),
        /* @__PURE__ */ jsxs69(
          "div",
          {
            className: classNames(
              "flex items-center justify-between py-5",
              color2 ?? "text-gray-600"
            ),
            children: [
              titleBottomElement,
              showDelete && /* @__PURE__ */ jsx112(
                "div",
                {
                  "aria-label": deleteText || "Delete",
                  onClick: onDelete,
                  className: `cursor-pointer text-sm font-bold  sm:text-2xl`,
                  children: deleteText || "Delete"
                }
              ),
              /* @__PURE__ */ jsxs69("div", { className: "flex grow justify-end gap-2", children: [
                buttonElement,
                !buttonElement && /* @__PURE__ */ jsxs69("div", { className: "flex grow justify-end gap-2", children: [
                  /* @__PURE__ */ jsx112("div", { children: showCancel && /* @__PURE__ */ jsx112(
                    Button,
                    {
                      "aria-label": cancelText,
                      onClick: (e) => {
                        e.preventDefault();
                        if (onCancel) {
                          onCancel();
                        }
                      },
                      className: "border border-black px-5 py-2 font-medium text-black",
                      size: "md" /* md */,
                      children: cancelText
                    }
                  ) }),
                  /* @__PURE__ */ jsx112("div", { children: showSubmit && /* @__PURE__ */ jsx112(
                    Button,
                    {
                      "aria-label": submitText || "Submit form",
                      type: "submit",
                      size: "md" /* md */,
                      disabled: isDisabled || isSaving,
                      className: classNames(
                        submitButtonColor ?? "bg-sulu-500 border-sulu-500 hover:bg-sulu-600 grow px-5 py-2 font-medium text-black"
                      ),
                      onClick: () => {
                        if (onSubmit) {
                          onSubmit();
                        }
                      },
                      children: submitText
                    }
                  ) })
                ] })
              ] })
            ]
          }
        )
      ]
    }
  );
};

// src/components/labels/BooleanIcon.tsx
import { CheckCircleIcon as CheckCircleIcon2, XCircleIcon as XCircleIcon5 } from "@heroicons/react/24/solid";
import { jsx as jsx113 } from "react/jsx-runtime";
var BooleanIcon = ({
  value,
  onTrue,
  onFalse
}) => {
  if (value) {
    if (onTrue) {
      return onTrue;
    } else {
      return /* @__PURE__ */ jsx113(
        CheckCircleIcon2,
        {
          className: "h-5 w-5 font-medium text-green-500",
          "aria-hidden": "true"
        }
      );
    }
  }
  if (onFalse) {
    return onFalse;
  }
  return /* @__PURE__ */ jsx113(
    XCircleIcon5,
    {
      className: "h-5 w-5 font-medium text-red-500",
      "aria-hidden": "true"
    }
  );
};

// src/components/labels/BooleanLabel.tsx
import { jsx as jsx114 } from "react/jsx-runtime";
var BooleanLabel = ({
  value,
  onTrue,
  onFalse
}) => {
  if (value) {
    if (onTrue) {
      return onTrue;
    } else {
      return /* @__PURE__ */ jsx114("span", { className: "font-medium text-green-800", children: "Yes" });
    }
  }
  if (onFalse) {
    return onFalse;
  }
  return /* @__PURE__ */ jsx114("span", { className: "font-medium text-gray-500", children: "No" });
};

// src/components/labels/PageHeading.tsx
import { jsx as jsx115 } from "react/jsx-runtime";
var PageHeading = ({ children, ...props }) => /* @__PURE__ */ jsx115("div", { className: "flex", children: /* @__PURE__ */ jsx115("div", { className: "px-4 py-2", children: /* @__PURE__ */ jsx115("h1", { className: "text-info-800 text-lg font-medium", ...props, children }) }) });

// src/components/labels/Tag.tsx
import { jsx as jsx116 } from "react/jsx-runtime";
var Tag = ({
  children,
  size,
  color: color2,
  onSelected,
  className,
  shape
}) => {
  let tagSize = "text-sm";
  switch (size) {
    case "large":
      tagSize = "text-lg";
      break;
    case "medium":
      tagSize = "text-md";
      break;
    case "xsmall":
      tagSize = "text-xs";
      break;
    case "small":
    default:
      tagSize = "text-sm";
      break;
  }
  if (shape === "rounded") {
    tagSize += " rounded-full";
  } else {
    tagSize += " rounded";
  }
  if (!color2) {
    color2 = "bg-primary-200 text-primary-800";
  }
  if (!children) {
    return null;
  }
  let ariaLabel = "";
  if (children instanceof String) {
    ariaLabel = children;
  }
  return /* @__PURE__ */ jsx116(
    "button",
    {
      onClick: onSelected,
      "aria-label": ariaLabel,
      className: classNames(
        "inline-flex items-center px-2.5 py-1 text-left font-medium lowercase transition-[height]",
        onSelected ? "cursor-pointer" : "cursor-default",
        tagSize,
        color2,
        className || ""
      ),
      children
    }
  );
};

// src/components/labels/Tags.tsx
import { jsx as jsx117 } from "react/jsx-runtime";
var Tags = ({
  list,
  size,
  color: color2
}) => {
  return /* @__PURE__ */ jsx117("div", { className: "flex flex-wrap gap-1", children: list.map((tag, key) => /* @__PURE__ */ jsx117(Tag, { color: color2, size, children: tag }, key)) });
};

// src/components/labels/HighlightTags.tsx
import { jsx as jsx118 } from "react/jsx-runtime";
var HighlightTags = ({
  tags
}) => {
  return /* @__PURE__ */ jsx118("div", { className: "flex flex-wrap justify-center gap-2", children: tags.map((x) => /* @__PURE__ */ jsx118(Tag, { color: x.highlight ? `border` : `bg-primary-200`, children: x.name }, x.name)) });
};

// src/components/labels/TagsEditor.tsx
import { jsx as jsx119 } from "react/jsx-runtime";
var TagsEditor = ({ tags, size, color: color2, onSelected }) => {
  return /* @__PURE__ */ jsx119("div", { className: "flex flex-wrap gap-1", children: tags.map((tag, key) => /* @__PURE__ */ jsx119(
    Tag,
    {
      color: color2,
      size,
      onSelected: () => onSelected(tag),
      children: tag
    },
    key
  )) });
};

// src/components/labels/MynPageTitle.tsx
import { Helmet } from "react-helmet";
import { jsx as jsx120, jsxs as jsxs70 } from "react/jsx-runtime";
var MynPageTitle = ({ title }) => /* @__PURE__ */ jsx120(Helmet, { children: /* @__PURE__ */ jsxs70("title", { children: [
  title,
  " | Myn"
] }) });

// src/components/container/BooleanActionItem.tsx
import { jsx as jsx121, jsxs as jsxs71 } from "react/jsx-runtime";
var BooleanActionItem = ({ label, value, action }) => {
  return /* @__PURE__ */ jsxs71("div", { className: "mb-2 flex items-center justify-between gap-2 border-b pb-4", children: [
    /* @__PURE__ */ jsxs71("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ jsx121("div", { className: "w-16 border-r pr-3", children: /* @__PURE__ */ jsx121(BooleanIcon, { value }) }),
      /* @__PURE__ */ jsx121(
        "div",
        {
          className: classNames(
            value ? "font-bold" : "line-through",
            "text-primary-700 text-lg"
          ),
          children: label
        }
      )
    ] }),
    /* @__PURE__ */ jsx121("div", { children: action })
  ] });
};

// src/components/container/EditContainer.tsx
import { PencilIcon as PencilIcon2 } from "@heroicons/react/24/outline";
import { jsx as jsx122, jsxs as jsxs72 } from "react/jsx-runtime";
var EditContainer = (props) => {
  return /* @__PURE__ */ jsxs72("div", { className: "flex w-full grow justify-between rounded-lg bg-white px-6 py-5 xl:border", children: [
    /* @__PURE__ */ jsxs72("div", { children: [
      props.title && /* @__PURE__ */ jsx122("div", { className: "text-gray-600", children: props.title }),
      props.value
    ] }),
    /* @__PURE__ */ jsx122(
      "div",
      {
        "aria-label": `Edit ${props.title}`,
        className: "text-primary-400 flex cursor-pointer pb-5 pl-5",
        onClick: props.onClick,
        children: /* @__PURE__ */ jsx122(PencilIcon2, { className: "h-6 w-6" })
      }
    )
  ] });
};

// src/components/form-wizard/wizard/index.tsx
import { jsx as jsx123, jsxs as jsxs73 } from "react/jsx-runtime";
var FormContext = createContext9({
  register: null,
  handleSubmit: noop5
});
var FormWizard = ({
  schema,
  title,
  onSubmit
}) => {
  const { register, handleSubmit } = useForm();
  return /* @__PURE__ */ jsx123(
    FormContext.Provider,
    {
      value: {
        register,
        handleSubmit
      },
      children: /* @__PURE__ */ jsxs73(Routes2, { children: [
        /* @__PURE__ */ jsx123(
          Route2,
          {
            path: "/",
            element: /* @__PURE__ */ jsx123(
              FormPage,
              {
                form: schema[0],
                page: 1,
                totalPages: schema.length,
                onSubmit,
                title
              }
            )
          }
        ),
        schema.map((form, i) => /* @__PURE__ */ jsx123(
          Route2,
          {
            path: `step-${i + 1}`,
            element: /* @__PURE__ */ jsx123(
              FormPage,
              {
                form,
                page: i + 1,
                totalPages: schema.length,
                onSubmit,
                title
              }
            )
          },
          i
        ))
      ] })
    }
  );
};
var FormPage = ({
  form,
  title,
  page,
  totalPages,
  onSubmit
}) => {
  const formContext = useContext9(FormContext);
  return /* @__PURE__ */ jsx123("div", { children: /* @__PURE__ */ jsx123(
    ActionContainer,
    {
      showProgress: true,
      titleTop: form.title,
      titleBottom: title,
      progressTotal: totalPages,
      progressIndex: page,
      buttonElement: /* @__PURE__ */ jsxs73("div", { className: "flex items-end gap-2", children: [
        page != 1 && /* @__PURE__ */ jsx123(EdLink, { name: "prev", href: `../step-${page - 1}`, children: /* @__PURE__ */ jsx123(Button, { type: "submit", color: "secondary", size: "md" /* md */, children: "Prev" }) }),
        totalPages != page && /* @__PURE__ */ jsx123(EdLink, { name: "next", href: `../step-${page + 1}`, children: /* @__PURE__ */ jsx123(Button, { type: "submit", color: "secondary", size: "md" /* md */, children: "Next" }) }),
        totalPages == page && /* @__PURE__ */ jsx123(
          Button,
          {
            color: "primary",
            size: "lg" /* lg */,
            onClick: () => {
              formContext.handleSubmit((data) => {
                if (onSubmit) {
                  onSubmit(data);
                }
              })();
            },
            children: "Submit"
          }
        )
      ] }),
      children: form.nodes.map(({ type, label, id: id3, value }) => /* @__PURE__ */ jsx123(
        FormElement,
        {
          type,
          label,
          value,
          id: id3
        },
        id3
      ))
    }
  ) });
};
var FormElement = ({ id: id3, label, type, value }) => {
  const formContext = useContext9(FormContext);
  if (!formContext || !formContext.register) {
    return /* @__PURE__ */ jsx123("div", {});
  }
  const { register } = formContext;
  return /* @__PURE__ */ jsx123(FormInputRow, { name: id3, title: label, children: /* @__PURE__ */ jsx123(FormInput, { type, register: () => register(id3), value }) });
};

// src/components/headers/Header.tsx
import { jsx as jsx124, jsxs as jsxs74 } from "react/jsx-runtime";
var Header = ({
  title,
  children
}) => {
  return /* @__PURE__ */ jsx124("div", { className: "my-2 w-full bg-gray-100", children: /* @__PURE__ */ jsxs74("div", { className: "h-full px-4 py-6 sm:px-6 lg:px-8", children: [
    /* @__PURE__ */ jsx124("h2", { className: "pb-1 text-2xl text-gray-700", children: title }),
    /* @__PURE__ */ jsx124("p", { className: "text-sm text-gray-600", children })
  ] }) });
};

// src/components/headers/HeaderBar.tsx
import { jsx as jsx125, jsxs as jsxs75 } from "react/jsx-runtime";
var HeaderBar = ({
  title,
  children
}) => {
  return /* @__PURE__ */ jsx125("div", { className: "flex flex-col border-b bg-white lg:pb-0", children: /* @__PURE__ */ jsxs75("div", { className: "flex flex-col justify-start gap-2 px-4 py-2 lg:flex-row lg:gap-10", children: [
    /* @__PURE__ */ jsx125("div", { className: "flex items-center lg:w-1/3 ", children: /* @__PURE__ */ jsx125("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ jsx125("div", { className: "py-2 text-2xl font-medium text-gray-700", children: title }) }) }),
    /* @__PURE__ */ jsx125("div", { className: "flex lg:w-2/3", children: /* @__PURE__ */ jsx125("div", { className: "flex w-full items-center justify-start gap-3", children }) })
  ] }) });
};

// src/components/headers/SectionHeader.tsx
import { jsx as jsx126, jsxs as jsxs76 } from "react/jsx-runtime";
var SectionHeader = ({
  title,
  children
}) => {
  return /* @__PURE__ */ jsx126("div", { className: "my-2 w-full bg-gray-100", children: /* @__PURE__ */ jsxs76("div", { className: "h-full px-4 py-6 sm:px-6 lg:px-8", children: [
    /* @__PURE__ */ jsx126("h2", { className: "pb-1 text-2xl text-gray-700", children: title }),
    /* @__PURE__ */ jsx126("p", { className: "text-sm text-gray-600", children })
  ] }) });
};

// src/components/json-forms/index.ts
import { vanillaCells, vanillaRenderers } from "@jsonforms/vanilla-renderers";

// src/components/json-forms/TailwindGroupLayout.tsx
var import_isEmpty2 = __toESM(require_isEmpty());
import { memo as memo2 } from "react";
import {
  rankWith as rankWith3,
  uiTypeIs
} from "@jsonforms/core";
import { useJsonForms, withJsonFormsLayoutProps } from "@jsonforms/react";
import {
  withVanillaControlProps
} from "@jsonforms/vanilla-renderers";

// src/components/json-forms/JsonFormsUtil.tsx
var import_isEmpty = __toESM(require_isEmpty());
import { JsonFormsDispatch } from "@jsonforms/react";
import { jsx as jsx127 } from "react/jsx-runtime";
var renderChildren = (renderers, cells, layout2, schema, className, path, enabled) => {
  if ((0, import_isEmpty.default)(layout2.elements)) {
    return [];
  }
  return layout2.elements.map((child, index) => {
    return /* @__PURE__ */ jsx127("div", { className, children: /* @__PURE__ */ jsx127(
      JsonFormsDispatch,
      {
        renderers,
        cells,
        uischema: child,
        schema,
        path,
        enabled
      }
    ) }, `${path}-${index}`);
  });
};

// src/components/json-forms/TailwindGroupLayout.tsx
import { jsx as jsx128, jsxs as jsxs77 } from "react/jsx-runtime";
var groupTester = rankWith3(1, uiTypeIs("Group"));
var GroupLayoutRenderer = (props) => {
  const { data, ...otherProps } = props;
  return /* @__PURE__ */ jsx128(GroupLayoutRendererComponent, { ...otherProps });
};
var GroupLayoutRendererComponent = memo2(
  ({
    schema,
    uischema,
    path,
    enabled,
    visible,
    getStyle,
    getStyleAsClassName
  }) => {
    const { renderers, cells } = useJsonForms();
    const group = uischema;
    const elementsSize = group.elements ? group.elements.length : 0;
    const classNames2 = "group-layout";
    const childClassNames = "group-layout-item";
    return /* @__PURE__ */ jsxs77(
      "fieldset",
      {
        className: classNames2,
        hidden: visible === void 0 || visible === null ? false : !visible,
        children: [
          !(0, import_isEmpty2.default)(group.label) ? /* @__PURE__ */ jsx128("legend", { className: "p-2 font-bold", children: group.label }) : "",
          renderChildren(
            renderers,
            cells,
            group,
            schema,
            childClassNames,
            path,
            enabled
          )
        ]
      }
    );
  }
);
var TailwindGroupLayout_default = withVanillaControlProps(
  withJsonFormsLayoutProps(GroupLayoutRenderer)
);

// src/components/json-forms/TailwindVerticalLayout.tsx
import { memo as memo3 } from "react";
import {
  rankWith as rankWith4,
  uiTypeIs as uiTypeIs2
} from "@jsonforms/core";
import { useJsonForms as useJsonForms2, withJsonFormsLayoutProps as withJsonFormsLayoutProps2 } from "@jsonforms/react";
import {
  withVanillaControlProps as withVanillaControlProps2
} from "@jsonforms/vanilla-renderers";

// src/components/json-forms/JsonFormsLayout.tsx
import { jsx as jsx129 } from "react/jsx-runtime";
var JsonFormsLayout = ({
  className,
  children,
  visible
}) => {
  return /* @__PURE__ */ jsx129(
    "div",
    {
      className,
      hidden: visible === void 0 || visible === null ? false : !visible,
      children
    }
  );
};

// src/components/json-forms/TailwindVerticalLayout.tsx
import { jsx as jsx130 } from "react/jsx-runtime";
var verticalLayoutTester = rankWith4(
  1,
  uiTypeIs2("VerticalLayout")
);
var VerticalLayoutRenderer = (props) => {
  const { data, ...otherProps } = props;
  return /* @__PURE__ */ jsx130(VerticalLayoutRendererComponent, { ...otherProps });
};
var VerticalLayoutRendererComponent = memo3(
  ({
    schema,
    uischema,
    path,
    visible,
    enabled,
    getStyle,
    getStyleAsClassName
  }) => {
    const { renderers, cells } = useJsonForms2();
    const verticalLayout = uischema;
    const elementsSize = verticalLayout.elements ? verticalLayout.elements.length : 0;
    const layoutClassName = "flex-1";
    const childClassNames = "pb-2";
    return /* @__PURE__ */ jsx130(
      JsonFormsLayout,
      {
        className: layoutClassName,
        uischema,
        schema,
        visible,
        enabled,
        path,
        getStyle,
        getStyleAsClassName,
        children: renderChildren(
          renderers,
          cells,
          verticalLayout,
          schema,
          childClassNames,
          path,
          enabled
        )
      }
    );
  }
);
var TailwindVerticalLayout_default = withVanillaControlProps2(
  withJsonFormsLayoutProps2(VerticalLayoutRenderer, false)
);

// src/components/json-forms/TailwindHorizontalLayout.tsx
import { memo as memo4 } from "react";
import {
  rankWith as rankWith5,
  uiTypeIs as uiTypeIs3
} from "@jsonforms/core";
import { useJsonForms as useJsonForms3, withJsonFormsLayoutProps as withJsonFormsLayoutProps3 } from "@jsonforms/react";
import {
  withVanillaControlProps as withVanillaControlProps3
} from "@jsonforms/vanilla-renderers";
import { jsx as jsx131 } from "react/jsx-runtime";
var horizontalLayoutTester = rankWith5(
  1,
  uiTypeIs3("HorizontalLayout")
);
var HorizontalLayoutRenderer = (props) => {
  const { data, ...otherProps } = props;
  return /* @__PURE__ */ jsx131(HorizontalLayoutRendererComponent, { ...otherProps });
};
var HorizontalLayoutRendererComponent = memo4(
  ({
    schema,
    uischema,
    getStyle,
    getStyleAsClassName,
    enabled,
    visible,
    path
  }) => {
    const { renderers, cells } = useJsonForms3();
    const horizontalLayout = uischema;
    const elementsSize = horizontalLayout.elements ? horizontalLayout.elements.length : 0;
    const layoutClassName = "p-2 flex items-center";
    const childClassNames = "p-2 mx-2";
    return /* @__PURE__ */ jsx131(
      JsonFormsLayout,
      {
        className: layoutClassName,
        visible,
        enabled,
        path,
        uischema,
        schema,
        getStyle,
        getStyleAsClassName,
        children: renderChildren(
          renderers,
          cells,
          horizontalLayout,
          schema,
          childClassNames,
          path,
          enabled
        )
      }
    );
  }
);
var TailwindHorizontalLayout_default = withVanillaControlProps3(
  withJsonFormsLayoutProps3(HorizontalLayoutRenderer, false)
);

// src/components/json-forms/index.ts
var elevateJsonFormsRenderers = [
  ...vanillaRenderers,
  //register custom renderers
  { tester: groupTester, renderer: TailwindGroupLayout_default },
  { tester: verticalLayoutTester, renderer: TailwindVerticalLayout_default },
  { tester: horizontalLayoutTester, renderer: TailwindHorizontalLayout_default }
];
var elevateJsonFormsCells = [...vanillaCells];
var elevateJsonFormsStyleContext = {
  styles: [
    {
      name: "control",
      classNames: [
        "sm:grid sm:grid-cols-3 sm:gap-4  sm:border-gray-200 sm:pt-5 items-baseline"
      ]
    },
    {
      name: "control.input",
      classNames: ["mt-1 sm:mt-0 sm:col-span-2 w-full"]
    },
    {
      name: "control.trim",
      classNames: ["trim"]
    },
    {
      name: "control.label",
      classNames: ["block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"]
    },
    {
      name: "control.validation",
      classNames: ["mt-1 sm:mt-0 sm:col-start-2 sm:col-span-2"]
    },
    {
      name: "array.button",
      classNames: ["custom-array-button"]
    }
  ]
};

// src/components/overlays/notifications/NotificationAtom.ts
import { atom as atom3, useAtom as useAtom3, useSetAtom as useSetAtom3, useAtomValue } from "jotai";
var notificationMessageAtom = atom3(null);
function useNotificationMessageState() {
  const [notificationMessage, setNotificationMessage] = useAtom3(
    notificationMessageAtom
  );
  return [notificationMessage, setNotificationMessage];
}
function useSetNotificationMessage() {
  const setNotification = useSetAtom3(notificationMessageAtom);
  return setNotification;
}
function useNotificationMessage() {
  const notificationMessage = useAtomValue(notificationMessageAtom);
  return notificationMessage;
}

// src/components/overlays/notifications/NotificationMessageOverlay.tsx
import {
  Fragment as Fragment32,
  useState as useState23
} from "react";
import { Transition as Transition6 } from "@headlessui/react";
import { CheckCircleIcon as CheckCircleIcon3 } from "@heroicons/react/24/outline";
import { XCircleIcon as XCircleIcon6 } from "@heroicons/react/24/solid";
import { Fragment as Fragment33, jsx as jsx132, jsxs as jsxs78 } from "react/jsx-runtime";
var NotificationMessageOverlay = ({ isShowing, children }) => {
  const [show, setShow] = useState23(isShowing);
  return /* @__PURE__ */ jsx132(Fragment33, { children: /* @__PURE__ */ jsx132(
    "div",
    {
      "aria-live": "assertive",
      className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6",
      children: /* @__PURE__ */ jsx132("div", { className: "flex w-full flex-col items-center space-y-4 sm:items-end", children: /* @__PURE__ */ jsx132(
        Transition6,
        {
          show,
          as: Fragment32,
          enter: "transform ease-out duration-300 transition",
          enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
          enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ jsx132("div", { className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5", children: /* @__PURE__ */ jsx132("div", { className: "p-4", children: /* @__PURE__ */ jsxs78("div", { className: "flex items-start", children: [
            /* @__PURE__ */ jsx132("div", { className: "flex-shrink-0", children: /* @__PURE__ */ jsx132(
              CheckCircleIcon3,
              {
                className: "text-success-400 h-6 w-6",
                "aria-hidden": "true"
              }
            ) }),
            children,
            /* @__PURE__ */ jsx132("div", { className: "ml-4 flex flex-shrink-0", children: /* @__PURE__ */ jsxs78(
              "button",
              {
                className: "inline-flex rounded-md bg-white text-gray-600 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                onClick: () => {
                  setShow(false);
                },
                children: [
                  /* @__PURE__ */ jsx132("span", { className: "sr-only", children: "Close" }),
                  /* @__PURE__ */ jsx132(XCircleIcon6, { className: "h-5 w-5", "aria-hidden": "true" })
                ]
              }
            ) })
          ] }) }) })
        }
      ) })
    }
  ) });
};

// src/components/overlays/notifications/NotificationMessageContainer.tsx
import { Fragment as Fragment34, jsx as jsx133, jsxs as jsxs79 } from "react/jsx-runtime";
var NotificationMessageContainer = () => {
  const notificationMessage = useNotificationMessage();
  if (!notificationMessage) {
    return /* @__PURE__ */ jsx133(Fragment34, {});
  }
  return /* @__PURE__ */ jsx133(NotificationMessageOverlay, { isShowing: true, children: /* @__PURE__ */ jsxs79("div", { className: "ml-3 w-0 flex-1 pt-0.5", children: [
    /* @__PURE__ */ jsx133("p", { className: "text-sm font-medium text-gray-900", children: notificationMessage.title }),
    /* @__PURE__ */ jsx133("p", { className: "mt-1 text-sm text-gray-500", children: notificationMessage.message })
  ] }) });
};

// src/components/pagination/EdPagination.tsx
import { useCallback as useCallback15 } from "react";
import { Fragment as Fragment35, jsx as jsx134, jsxs as jsxs80 } from "react/jsx-runtime";
var EdPagination = ({ pagination }) => {
  const {
    hasPrevious,
    loadPrevious,
    isLoadingPrevious,
    hasNext,
    loadNext,
    isLoadingNext
  } = pagination;
  const loadPreviousPage = useCallback15(() => {
    if (isLoadingPrevious) {
      return;
    }
    loadPrevious(20);
  }, [isLoadingPrevious, loadPrevious]);
  const loadNextPage = useCallback15(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(20);
  }, [isLoadingNext, loadNext]);
  const showNav = hasNext || hasPrevious;
  if (showNav == false) {
    return /* @__PURE__ */ jsx134(Fragment35, {});
  }
  return /* @__PURE__ */ jsxs80(
    "nav",
    {
      className: "flex items-center justify-between p-2",
      "aria-label": "Pagination",
      children: [
        /* @__PURE__ */ jsx134("div", { className: "hidden sm:block" }),
        /* @__PURE__ */ jsxs80("div", { className: "flex flex-1 justify-between sm:justify-end", children: [
          hasPrevious && /* @__PURE__ */ jsx134(
            "a",
            {
              href: "",
              onClick: loadPreviousPage,
              className: "bg-info-800 hover:bg-info-600 relative inline-flex items-center rounded-md border border-gray-300 px-3 py-1 text-sm font-medium text-white",
              children: "Previous"
            }
          ),
          hasNext && /* @__PURE__ */ jsx134(
            "a",
            {
              href: "#",
              onClick: loadNextPage,
              className: "bg-info-800 hover:bg-info-600 relative ml-3 inline-flex items-center rounded-md border border-gray-300 px-3 py-1 text-sm font-medium text-white",
              children: "Load More"
            }
          )
        ] })
      ]
    }
  );
};

// src/components/pagination/EdListHeader.tsx
import { jsx as jsx135, jsxs as jsxs81 } from "react/jsx-runtime";
var EdListHeader = ({
  total,
  paging,
  content
}) => {
  if (!total && !paging.hasNext && !paging.hasPrevious) {
    return /* @__PURE__ */ jsx135("div", {});
  }
  return /* @__PURE__ */ jsx135("div", { className: "border border-gray-200 bg-white", children: /* @__PURE__ */ jsxs81("div", { className: "my-2 flex justify-between", children: [
    /* @__PURE__ */ jsxs81("div", { className: "flex justify-start", children: [
      total ? /* @__PURE__ */ jsxs81("div", { className: "text-md flex items-center space-x-1 px-4 py-2", children: [
        /* @__PURE__ */ jsx135("div", { className: "text-gray-900", children: "Total" }),
        /* @__PURE__ */ jsx135("div", { className: "text-info-900 font-medium", children: total })
      ] }) : null,
      paging && /* @__PURE__ */ jsx135(EdPagination, { pagination: paging })
    ] }),
    content ? /* @__PURE__ */ jsx135("div", { children: content }) : null
  ] }) });
};

// src/components/pagination/SimplePagination.tsx
import { useCallback as useCallback16 } from "react";

// src/components/@shadcn/components/ui/pagination.tsx
import * as React7 from "react";
import { ChevronLeft as ChevronLeft2, ChevronRight as ChevronRight2, MoreHorizontal } from "lucide-react";
import { jsx as jsx136, jsxs as jsxs82 } from "react/jsx-runtime";
var Pagination2 = ({ className, ...props }) => /* @__PURE__ */ jsx136(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: cn("mx-auto flex w-full justify-center", className),
    ...props
  }
);
Pagination2.displayName = "Pagination";
var PaginationContent = React7.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx136(
  "ul",
  {
    ref,
    className: cn("flex flex-row items-center gap-1", className),
    ...props
  }
));
PaginationContent.displayName = "PaginationContent";
var PaginationItem = React7.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx136("li", { ref, className: cn("", className), ...props }));
PaginationItem.displayName = "PaginationItem";
var PaginationLink = ({
  className,
  isActive,
  size = "icon",
  ...props
}) => /* @__PURE__ */ jsx136(
  "a",
  {
    "aria-current": isActive ? "page" : void 0,
    className: cn(
      buttonVariants({
        variant: isActive ? "outline" : "ghost",
        size
      }),
      className
    ),
    ...props
  }
);
PaginationLink.displayName = "PaginationLink";
var PaginationPrevious = ({
  className,
  ...props
}) => /* @__PURE__ */ jsxs82(
  PaginationLink,
  {
    "aria-label": "Go to previous page",
    size: "default",
    className: cn("gap-1 pl-2.5", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx136(ChevronLeft2, { className: "h-4 w-4" }),
      /* @__PURE__ */ jsx136("span", { children: "Previous" })
    ]
  }
);
PaginationPrevious.displayName = "PaginationPrevious";
var PaginationNext = ({
  className,
  ...props
}) => /* @__PURE__ */ jsxs82(
  PaginationLink,
  {
    "aria-label": "Go to next page",
    size: "default",
    className: cn("gap-1 pr-2.5", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx136("span", { children: "Next" }),
      /* @__PURE__ */ jsx136(ChevronRight2, { className: "h-4 w-4" })
    ]
  }
);
PaginationNext.displayName = "PaginationNext";
var PaginationEllipsis = ({
  className,
  ...props
}) => /* @__PURE__ */ jsxs82(
  "span",
  {
    "aria-hidden": true,
    className: cn("flex h-9 w-9 items-center justify-center", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx136(MoreHorizontal, { className: "h-4 w-4" }),
      /* @__PURE__ */ jsx136("span", { className: "sr-only", children: "More pages" })
    ]
  }
);
PaginationEllipsis.displayName = "PaginationEllipsis";

// src/components/pagination/SimplePagination.tsx
import { ChevronLeft as ChevronLeft3 } from "lucide-react";
import { createNumberRange } from "shared-lib";
import { Fragment as Fragment36, jsx as jsx137, jsxs as jsxs83 } from "react/jsx-runtime";
var maxPages = 4;
function createPages(pages, currentPage) {
  const offset = getOffset(pages, currentPage, maxPages) + 1;
  return createNumberRange(offset, offset + Math.min(pages, maxPages) - 1);
}
function getOffset(pages, page, maxPages2) {
  const halfway = Math.ceil(maxPages2 / 2);
  return pages > maxPages2 && page > halfway ? Math.min(page - halfway, pages - maxPages2) : 0;
}
var PagingLink = ({
  prefix,
  currentPageNumber,
  pageNumber,
  onPage
}) => {
  const onSelectPage = useCallback16(() => {
    onPage(pageNumber);
  }, [onPage, pageNumber]);
  return /* @__PURE__ */ jsx137(
    "li",
    {
      className: classNames(
        "flex items-center justify-center border-y",
        currentPageNumber === pageNumber ? "bg-primary-500 border-primary-500 border-gray-800 font-bold text-white  no-underline" : "text-primary-500 border-gray-200",
        "cursor-pointer px-3 py-2 hover:underline"
      ),
      onClick: onSelectPage,
      children: /* @__PURE__ */ jsx137("div", { children: pageNumber })
    },
    `${prefix}-${pageNumber}`
  );
};
var SimplePagination = ({
  name,
  totalResults,
  pageNumber,
  pages,
  onPage
}) => {
  const pageLinks = createPages(pages, pageNumber).map((p) => {
    return /* @__PURE__ */ jsx137(PaginationItem, { className: "hover:cursor-pointer", children: /* @__PURE__ */ jsx137(PaginationLink, { isActive: p == pageNumber, onClick: () => onPage(p), children: p }) }, `name-page-${p}`);
  });
  return /* @__PURE__ */ jsx137(Pagination2, { children: /* @__PURE__ */ jsxs83(PaginationContent, { children: [
    pageNumber > 2 && /* @__PURE__ */ jsx137(Fragment36, { children: /* @__PURE__ */ jsx137(PaginationItem, { className: "hover:cursor-pointer", children: /* @__PURE__ */ jsxs83(
      PaginationLink,
      {
        onClick: () => onPage(1),
        "aria-label": "Go to previous page",
        size: "default",
        className: "gap-1 pl-2.5",
        children: [
          /* @__PURE__ */ jsx137(ChevronLeft3, { className: "h-4 w-4" }),
          /* @__PURE__ */ jsx137("span", { children: "First" })
        ]
      }
    ) }) }),
    pageNumber !== 1 && /* @__PURE__ */ jsx137(PaginationItem, { className: "hover:cursor-pointer", children: /* @__PURE__ */ jsx137(PaginationPrevious, { onClick: () => onPage(pageNumber - 1) }) }),
    pageLinks,
    pageNumber < pages - 2 && /* @__PURE__ */ jsxs83(Fragment36, { children: [
      pageNumber < pages - 3 && /* @__PURE__ */ jsx137(PaginationItem, { className: "hover:cursor-pointer", children: /* @__PURE__ */ jsx137(PaginationEllipsis, {}) }),
      /* @__PURE__ */ jsx137(PaginationItem, { className: "hover:cursor-pointer", children: /* @__PURE__ */ jsx137(PaginationLink, { onClick: () => onPage(pages), children: pages }) })
    ] }),
    pageNumber < pages && /* @__PURE__ */ jsx137(PaginationItem, { className: "hover:cursor-pointer", children: /* @__PURE__ */ jsx137(PaginationNext, { onClick: () => onPage(pageNumber + 1) }) })
  ] }) });
};

// src/components/pagination/SimplePaginationCounts.tsx
import { jsx as jsx138, jsxs as jsxs84 } from "react/jsx-runtime";
function pagingInfo(currentPage, itemsPerPage, totalResults) {
  return (currentPage - 1) * itemsPerPage + 1 + " - " + Math.min(currentPage * itemsPerPage, totalResults);
}
var SimplePaginationCounts = ({
  totalResults,
  itemsPerPage,
  pageNumber,
  pages
}) => {
  const hasNext = pageNumber < pages;
  const hasPrevious = pageNumber > 1;
  if (hasNext || hasPrevious) {
    return /* @__PURE__ */ jsx138("div", { className: "text-xs leading-loose text-neutral-600", children: /* @__PURE__ */ jsxs84("p", { children: [
      pagingInfo(pageNumber, itemsPerPage, totalResults),
      " of",
      " ",
      Number(totalResults).toLocaleString(),
      " results"
    ] }) });
  }
  return /* @__PURE__ */ jsx138("div", { className: "text-sm leading-loose text-neutral-600", children: /* @__PURE__ */ jsxs84("p", { children: [
    totalResults,
    "\xA0results"
  ] }) });
};

// src/components/rates/RateType.tsx
import { Fragment as Fragment37, jsx as jsx139 } from "react/jsx-runtime";
var RateType = ({ payType }) => {
  switch (payType) {
    case "PER_HOUR":
      return /* @__PURE__ */ jsx139("div", { children: "Per Hour" });
    case "PER_YEAR":
      return /* @__PURE__ */ jsx139("div", { children: "Per Year" });
    case "PER_DAY":
      return /* @__PURE__ */ jsx139("div", { children: "Per Day" });
  }
  return /* @__PURE__ */ jsx139(Fragment37, {});
};

// src/components/search/faceting/SelectListFacet.tsx
import { Fragment as Fragment38, useState as useState24, useCallback as useCallback17 } from "react";
import { Listbox as Listbox3, Transition as Transition7 } from "@headlessui/react";
import { CheckIcon as CheckIcon5, ChevronUpDownIcon as ChevronUpDownIcon3 } from "@heroicons/react/24/solid";

// src/components/search/lib/Facets.ts
function sortFacetsBySelected(a, b) {
  if (b.isSelected && a.isSelected) {
    return a.text.toLowerCase() < b.text.toLowerCase() ? 1 : -1;
  }
  if (b.isSelected) {
    return -1;
  }
  if (a.isSelected) {
    return 1;
  }
  return a.text.toLowerCase() < b.text.toLowerCase() ? 1 : -1;
}
function sortFacetsByCount(a, b) {
  return a.count < b.count ? 1 : -1;
}

// src/components/search/faceting/SelectListFacet.tsx
import { Fragment as Fragment39, jsx as jsx140, jsxs as jsxs85 } from "react/jsx-runtime";
var SelectListFacet = ({
  title,
  facet,
  onValuesChanged
}) => {
  const [facetValues] = useState24(() => {
    return [...facet.values].sort(sortFacetsBySelected);
  });
  const [selectedValues, setSelectedValues] = useState24(() => {
    return [];
  });
  const onSelectValues = useCallback17(
    (values) => {
      const sorted = [...values ?? []].sort(sortFacetsBySelected);
      setSelectedValues(sorted);
      onValuesChanged(sorted);
    },
    [onValuesChanged]
  );
  return /* @__PURE__ */ jsx140("div", { className: "w-full max-w-xs", children: /* @__PURE__ */ jsx140(Listbox3, { value: selectedValues, onChange: onSelectValues, multiple: true, children: ({ open }) => /* @__PURE__ */ jsxs85(Fragment39, { children: [
    title && /* @__PURE__ */ jsx140(Listbox3.Label, { className: "mx-2 block text-sm font-medium leading-6 text-gray-900", children: facet.title }),
    /* @__PURE__ */ jsxs85("div", { className: "relative", children: [
      /* @__PURE__ */ jsxs85(Listbox3.Button, { className: "relative w-full cursor-default rounded-md bg-white py-2 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6", children: [
        /* @__PURE__ */ jsx140("span", { className: "block truncate", children: selectedValues.length > 0 ? `Filtering by ${facet.title}` : `Filter by ${facet.title}` }),
        /* @__PURE__ */ jsx140("span", { className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2", children: /* @__PURE__ */ jsx140(
          ChevronUpDownIcon3,
          {
            className: "h-5 w-5 text-gray-600",
            "aria-hidden": "true"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx140(
        Transition7,
        {
          show: open,
          as: Fragment38,
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ jsx140(Listbox3.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: facetValues.map((facetValue) => /* @__PURE__ */ jsx140(
            Listbox3.Option,
            {
              className: ({ active }) => classNames(
                active ? "bg-indigo-600 text-white" : "text-gray-900",
                "relative cursor-default select-none py-2 pl-3 pr-9"
              ),
              value: facetValue,
              children: ({ selected, active }) => /* @__PURE__ */ jsxs85(Fragment39, { children: [
                /* @__PURE__ */ jsx140(
                  "span",
                  {
                    className: classNames(
                      selected ? "font-semibold" : "font-normal",
                      "block truncate"
                    ),
                    children: facetValue.text
                  }
                ),
                selected ? /* @__PURE__ */ jsx140(
                  "span",
                  {
                    className: classNames(
                      active ? "text-white" : "text-indigo-600",
                      "absolute inset-y-0 right-0 flex items-center pr-4"
                    ),
                    children: /* @__PURE__ */ jsx140(
                      CheckIcon5,
                      {
                        className: "h-5 w-5",
                        "aria-hidden": "true"
                      }
                    )
                  }
                ) : null
              ] })
            },
            facetValue.name
          )) })
        }
      )
    ] })
  ] }) }) });
};

// src/components/search/faceting/FilterSections.tsx
import { useCallback as useCallback18 } from "react";
import { ArrowLeftIcon as ArrowLeftIcon2, ArrowRightIcon as ArrowRightIcon2 } from "@heroicons/react/24/solid";
import { XIcon } from "lucide-react";
import { jsx as jsx141, jsxs as jsxs86 } from "react/jsx-runtime";
var FilterSectionLink = ({
  section,
  selectedKey,
  onSelect
}) => {
  const onClick = useCallback18(() => {
    onSelect(section.key);
  }, []);
  return /* @__PURE__ */ jsxs86(
    "button",
    {
      "aria-label": section.title,
      className: classNames(
        "flex cursor-pointer items-center justify-between border bg-white p-5 hover:bg-gray-200 lg:rounded-lg lg:px-3 lg:py-2",
        section.key === selectedKey ? "text-primary-500 font-medium" : "font-normal"
      ),
      onClick,
      children: [
        /* @__PURE__ */ jsx141("div", { children: section.title }),
        /* @__PURE__ */ jsx141("div", { className: "lg:hidden", children: /* @__PURE__ */ jsx141(ArrowRightIcon2, { className: "h-5 w-5 flex-shrink-0", "aria-hidden": "true" }) })
      ]
    }
  );
};
var FilterSectionContainer = ({
  sections,
  isFiltersOpen,
  hasSelectedValue = false,
  toggleSelectedValue,
  children
}) => {
  return /* @__PURE__ */ jsx141("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ jsxs86("div", { className: "flex w-full flex-col", children: [
    /* @__PURE__ */ jsx141(
      "div",
      {
        className: classNames(
          "w-full ",
          hasSelectedValue ? "hidden lg:flex" : ""
        ),
        children: /* @__PURE__ */ jsx141("div", { className: "flex w-full flex-col divide-y border-b pb-2 lg:flex-row lg:flex-wrap lg:gap-1 lg:text-base", children: sections })
      }
    ),
    /* @__PURE__ */ jsxs86("div", { className: "relative flex flex-col", children: [
      hasSelectedValue && /* @__PURE__ */ jsx141("div", { className: "pointer-cursor flex items-center justify-between px-2 pt-4 lg:absolute lg:right-0  lg:top-0 lg:px-3 lg:py-2.5", children: /* @__PURE__ */ jsxs86("button", { onClick: toggleSelectedValue, children: [
        /* @__PURE__ */ jsx141(
          ArrowLeftIcon2,
          {
            className: "h-5 w-5 flex-shrink-0 lg:hidden",
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ jsx141(
          XIcon,
          {
            className: "hidden h-5 w-5 flex-shrink-0 lg:block",
            "aria-hidden": "true"
          }
        )
      ] }) }),
      /* @__PURE__ */ jsx141("div", { className: "flex flex-1 flex-col gap-2", children })
    ] })
  ] }) });
};

// src/components/search/faceting/__generated__/TagFacetFragment.graphql.ts
var node = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TagFacetFragment",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationValueModel",
        "kind": "LinkedField",
        "name": "values",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSelected",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "DefaultAggregationModel",
    "abstractKey": null
  };
}();
node.hash = "7fd8194d17225eb3ca78fbf5978e6920";
var TagFacetFragment_graphql_default = node;

// src/components/search/faceting/TagFacet.tsx
import { useCallback as useCallback19, useEffect as useEffect10, useState as useState25 } from "react";
import { useFragment } from "react-relay";
import { atom as atom4, useAtom as useAtom4 } from "jotai";
import { noop as noop6 } from "shared-lib";
import { jsx as jsx142, jsxs as jsxs87 } from "react/jsx-runtime";
var facetFragmentDef = TagFacetFragment_graphql_default;
var useTextSearch = (args, mapper) => {
  const [data, setData] = useState25(args);
  useEffect10(() => {
    setData(args);
  }, [args]);
  const query = useCallback19(
    (value) => {
      setData(
        args.filter((x) => mapper(x).toLowerCase().includes(value.toLowerCase()))
      );
    },
    [args, mapper]
  );
  return [data, query];
};
var activeTagsAtom = atom4([]);
var TagFacet = ({
  fragmentRef,
  onSelect = noop6
}) => {
  const data = useFragment(facetFragmentDef, fragmentRef);
  const [results, query] = useTextSearch(
    data.values,
    (data2) => data2.text
  );
  const [activeTags, setActiveTags] = useAtom4(activeTagsAtom);
  useEffect10(() => {
    setActiveTags([]);
  }, [setActiveTags, data]);
  return /* @__PURE__ */ jsxs87("div", { className: "flex w-full flex-col gap-5", children: [
    /* @__PURE__ */ jsx142(
      Input,
      {
        placeholder: `Search ${data.title}`,
        onChange: (e) => {
          query(e.target.value);
        }
      }
    ),
    /* @__PURE__ */ jsx142("div", { className: "flex max-h-screen flex-wrap gap-2 overflow-scroll", children: results.map((x) => /* @__PURE__ */ jsx142(
      "div",
      {
        onClick: () => {
          setActiveTags([...activeTags, x.name]);
          onSelect(x);
        },
        children: /* @__PURE__ */ jsxs87(
          Tag,
          {
            className: "flex cursor-pointer flex-row gap-2 pr-1",
            color: x.isSelected ? "text-white bg-primary-400" : "bg-gray-200",
            children: [
              /* @__PURE__ */ jsx142("div", { children: x.text }),
              /* @__PURE__ */ jsx142(
                "div",
                {
                  className: classNames(
                    x.isSelected ? "bg-primary-300" : "bg-gray-300",
                    "rounded-full px-2"
                  ),
                  children: activeTags.includes(x.name) ? /* @__PURE__ */ jsx142(Spinner, {}) : x.count
                }
              )
            ]
          }
        )
      },
      x.text
    )) })
  ] });
};

// src/components/search/faceting/SortDir.ts
function sortDirToGraphQL(sort) {
  switch (sort) {
    case "ASC" /* Asc */: {
      return "ASC";
    }
    case "DESC" /* Desc */: {
      return "DESC";
    }
  }
}
function getSortDirFromGraphQL(sort) {
  switch (sort) {
    case "ASC": {
      return "ASC" /* Asc */;
    }
    case "DESC": {
      return "DESC" /* Desc */;
    }
  }
  return "ASC" /* Asc */;
}

// src/components/search/faceting/SortFacet.tsx
import { useState as useState26, useCallback as useCallback20 } from "react";
import { ArrowDownIcon as ArrowDownIcon2, ArrowUpIcon } from "@heroicons/react/24/solid";
import { noop as noop7 } from "shared-lib";
import { jsx as jsx143, jsxs as jsxs88 } from "react/jsx-runtime";
var SortFacet = ({
  customFields,
  onChange = noop7
}) => {
  const [field, setField] = useState26({
    id: "BEST_MATCH",
    name: "Best Match"
  });
  const [direction, setDirection] = useState26("ASC");
  const isCustomField = useCallback20(
    (field2) => customFields.find((x) => x.id === field2?.id),
    [customFields]
  );
  const onUpdate = useCallback20(
    ({ updatedDirection, updatedField }) => {
      setField(updatedField);
      setDirection(updatedDirection);
      onChange({
        sort: {
          field: {
            [isCustomField(updatedField) ? "custom" : "standard"]: updatedField?.id
          },
          order: updatedDirection
        }
      });
    },
    [onChange, isCustomField]
  );
  return /* @__PURE__ */ jsxs88("div", { className: "flex w-full items-center gap-5", children: [
    /* @__PURE__ */ jsx143(
      SelectMenu,
      {
        items: [
          {
            id: "BEST_MATCH",
            name: "Best Match"
          },
          {
            id: "NAME",
            name: "Name"
          },
          ...customFields
        ],
        onChange: (updatedField) => {
          onUpdate({
            updatedDirection: direction,
            updatedField
          });
        },
        value: field
      }
    ),
    /* @__PURE__ */ jsx143(
      "div",
      {
        onClick: () => {
          onUpdate({
            updatedDirection: direction === "ASC" ? "DESC" : "ASC",
            updatedField: field
          });
        },
        children: direction === "ASC" ? /* @__PURE__ */ jsx143(ArrowDownIcon2, { className: "h-5 w-5" }) : /* @__PURE__ */ jsx143(ArrowUpIcon, { className: "h-5 w-5" })
      }
    )
  ] });
};

// src/components/search/faceting/__generated__/AggregationTags_Aggregation.graphql.ts
var node2 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregationTags_Aggregation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSelected",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DefaultAggregationModel",
  "abstractKey": null
};
node2.hash = "04b0eac8397242ba2e46254389fb9039";
var AggregationTags_Aggregation_graphql_default = node2;

// src/components/search/faceting/AggregationTags.tsx
import { useFragment as useFragment2 } from "react-relay";
import { Fragment as Fragment40, jsx as jsx144, jsxs as jsxs89 } from "react/jsx-runtime";
var aggregationFragmentDef = AggregationTags_Aggregation_graphql_default;
var DisplayFieldEnum = /* @__PURE__ */ ((DisplayFieldEnum2) => {
  DisplayFieldEnum2["name"] = "name";
  DisplayFieldEnum2["text"] = "text";
  return DisplayFieldEnum2;
})(DisplayFieldEnum || {});
var AggregationTags = ({
  fragmentRef,
  displayField = "name" /* name */,
  tagColor,
  onSelected
}) => {
  const data = useFragment2(
    aggregationFragmentDef,
    fragmentRef
  );
  return /* @__PURE__ */ jsx144(Fragment40, { children: data.values.filter((x) => x.isSelected).map((x) => /* @__PURE__ */ jsx144(
    Tag,
    {
      color: tagColor,
      onSelected: () => onSelected && onSelected(x.name),
      children: /* @__PURE__ */ jsxs89("div", { className: "group flex items-center justify-center gap-3", children: [
        /* @__PURE__ */ jsxs89("div", { className: "flex flex-col justify-center", children: [
          /* @__PURE__ */ jsx144("div", { className: "font-base text-[8px] leading-[8px] text-gray-900 md:font-bold", children: data.title }),
          /* @__PURE__ */ jsx144("div", { className: "text-xs", children: workflowLabelMap(x[displayField]) })
        ] }),
        /* @__PURE__ */ jsx144("div", { className: "bg-primary-700 flex h-6 items-center justify-center rounded-full px-2", children: /* @__PURE__ */ jsx144("div", { className: "flex text-xs text-white md:font-bold", children: Number(x.count).toLocaleString() }) })
      ] })
    },
    x.name
  )) });
};

// src/components/search/full-text-search/FullTextSearch.tsx
import { useState as useState27, useCallback as useCallback21 } from "react";
import { noop as noop8 } from "shared-lib";
import { jsx as jsx145, jsxs as jsxs90 } from "react/jsx-runtime";
var FullTextSearch = ({
  customQueryFields,
  onChange = noop8
}) => {
  const [query, setQuery] = useState27("");
  const [queryField, setQueryField] = useState27({
    id: "ALL",
    name: "All"
  });
  const isCustomQueryField = customQueryFields.find(
    (x) => x.id === queryField?.id
  );
  const onUpdate = useCallback21(
    ({ updatedQuery, updatedQueryField }) => {
      setQuery(updatedQuery);
      setQueryField(updatedQueryField);
      onChange({
        fullTextSearch: {
          queryField: {
            [isCustomQueryField ? "custom" : "standard"]: updatedQueryField?.id
          },
          query: updatedQuery
        }
      });
    },
    [onChange, isCustomQueryField]
  );
  return /* @__PURE__ */ jsxs90("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ jsx145("div", { className: "flex w-1/3", children: /* @__PURE__ */ jsx145(
      SelectMenu,
      {
        items: [
          {
            id: "ALL",
            name: "All"
          },
          {
            id: "EMAIL",
            name: "Email"
          },
          {
            id: "EXPERIENCE",
            name: "Experience"
          },
          {
            id: "JOB_TITLE",
            name: "Job Title"
          },
          {
            id: "NAME",
            name: "Name"
          },
          {
            id: "SKILL",
            name: "Skill"
          },
          ...customQueryFields
        ],
        onChange: (updatedQueryField) => {
          onUpdate({
            updatedQuery: query,
            updatedQueryField
          });
        },
        value: queryField
      }
    ) }),
    /* @__PURE__ */ jsx145(
      Input,
      {
        onChange: (e) => onUpdate({
          updatedQuery: e.target.value,
          updatedQueryField: queryField
        }),
        value: query
      }
    )
  ] });
};

// src/components/search/searchbox/SearchBox.tsx
import { useEffect as useEffect11, useMemo as useMemo8 } from "react";

// ../../node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// ../../node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root;

// ../../node_modules/lodash-es/_Symbol.js
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;

// ../../node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
  try {
    value[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}
var getRawTag_default = getRawTag;

// ../../node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value) {
  return nativeObjectToString2.call(value);
}
var objectToString_default = objectToString;

// ../../node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
}
var baseGetTag_default = baseGetTag;

// ../../node_modules/lodash-es/isObjectLike.js
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_default = isObjectLike;

// ../../node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
}
var isSymbol_default = isSymbol;

// ../../node_modules/lodash-es/_trimmedEndIndex.js
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var trimmedEndIndex_default = trimmedEndIndex;

// ../../node_modules/lodash-es/_baseTrim.js
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex_default(string) + 1).replace(reTrimStart, "") : string;
}
var baseTrim_default = baseTrim;

// ../../node_modules/lodash-es/isObject.js
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_default = isObject;

// ../../node_modules/lodash-es/toNumber.js
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol_default(value)) {
    return NAN;
  }
  if (isObject_default(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject_default(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim_default(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_default = toNumber;

// ../../node_modules/lodash-es/now.js
var now2 = function() {
  return root_default.Date.now();
};
var now_default = now2;

// ../../node_modules/lodash-es/debounce.js
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max;
var nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_default(wait) || 0;
  if (isObject_default(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber_default(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now_default();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now_default());
  }
  function debounced() {
    var time2 = now_default(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_default = debounce;

// src/components/search/searchbox/SearchBox.tsx
import { jsx as jsx146 } from "react/jsx-runtime";
var SearchBox = ({ onChange, placeholder }) => {
  const onQueryChangeHandler = useMemo8(
    () => debounce_default((q) => {
      onChange(q);
    }, 500),
    []
  );
  useEffect11(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  return /* @__PURE__ */ jsx146("div", { className: "", children: /* @__PURE__ */ jsx146(
    Input,
    {
      placeholder,
      className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
      onChange: (event) => onQueryChangeHandler(event.target.value),
      autoComplete: "off"
    }
  ) });
};

// src/components/settings/__generated__/GlobalSettingsManagerQuery.graphql.ts
var node3 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "HostingTenant",
      "kind": "LinkedField",
      "name": "platformHostingCurrentTenant",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HostStyleConfiguration",
          "kind": "LinkedField",
          "name": "styling",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondaryColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "faviconUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GlobalSettings",
      "kind": "LinkedField",
      "name": "globalSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "environmentName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identityServerAuthority",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identityServerFullPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identityServerServerHost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sentryPortalDSN",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "GlobalSettingsManagerQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "GlobalSettingsManagerQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "8ac1a48a65e5f33ee20f9374ac75a009",
      "id": null,
      "metadata": {},
      "name": "GlobalSettingsManagerQuery",
      "operationKind": "query",
      "text": "query GlobalSettingsManagerQuery {\n  platformHostingCurrentTenant {\n    id\n    name\n    styling {\n      primaryColor\n      secondaryColor\n      logoUrl\n      faviconUrl\n    }\n  }\n  globalSettings {\n    environmentName\n    identityServerAuthority\n    identityServerFullPath\n    identityServerServerHost\n    sentryPortalDSN\n  }\n}\n"
    }
  };
}();
node3.hash = "7e8ba10bf15d9d7dbf270c14b7855930";
var GlobalSettingsManagerQuery_graphql_default = node3;

// src/components/settings/GlobalSettingsManager.tsx
import { useEffect as useEffect12 } from "react";
import { usePreloadedQuery } from "react-relay";
import {
  GlobalSettingsContext,
  initializeSentry,
  useSetPlatformSettings
} from "shared-lib";
import { jsx as jsx147 } from "react/jsx-runtime";
var GlobalSettingsQueryDef = GlobalSettingsManagerQuery_graphql_default;
var GlobalSettingsManager = ({ queryRef, children }) => {
  const setPlatformSettings = useSetPlatformSettings();
  const data = usePreloadedQuery(
    GlobalSettingsQueryDef,
    queryRef
  );
  useEffect12(() => {
    if (data.platformHostingCurrentTenant) {
      setPlatformSettings(data.platformHostingCurrentTenant);
    }
  }, [setPlatformSettings, data.platformHostingCurrentTenant]);
  initializeSentry(data.globalSettings);
  return /* @__PURE__ */ jsx147(GlobalSettingsContext.Provider, { value: data.globalSettings, children });
};

// src/components/shells/Shell.tsx
import { useCallback as useCallback22 } from "react";
import { Bars3Icon, PuzzlePieceIcon } from "@heroicons/react/24/outline";
import { useLocation as useLocation2 } from "react-router-dom";
import { useToggle as useToggle7 } from "shared-lib";
import { Fragment as Fragment41, jsx as jsx148, jsxs as jsxs91 } from "react/jsx-runtime";
var CandidateShell = ({
  accountLink,
  children,
  sidebarNavigation,
  trayNavigation,
  accountInfo
}) => {
  const [collapseNavigation, toggleCollapseNavigation] = useToggle7(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useMobileNavigation();
  const onSetMobileMenuOpen = useCallback22(() => {
    setMobileMenuOpen(!mobileMenuOpen);
  }, [mobileMenuOpen, setMobileMenuOpen]);
  return /* @__PURE__ */ jsxs91(Fragment41, { children: [
    /* @__PURE__ */ jsx148("div", { className: "lg:hidden", children: trayNavigation && /* @__PURE__ */ jsx148(
      Tray,
      {
        navigation: trayNavigation,
        setMobileMenuOpen: () => onSetMobileMenuOpen()
      }
    ) }),
    /* @__PURE__ */ jsxs91("div", { className: "flex h-screen lg:overflow-hidden", children: [
      /* @__PURE__ */ jsx148("nav", { className: "hidden lg:block", "aria-controls": "content", children: /* @__PURE__ */ jsx148(
        Navigation,
        {
          accountLink,
          list: sidebarNavigation,
          accountInfo,
          collapseNavigation,
          toggleCollapseNavigation
        }
      ) }),
      /* @__PURE__ */ jsx148("nav", { className: "lg:hidden", "aria-controls": "content", children: /* @__PURE__ */ jsx148(
        MobileNavigation,
        {
          portalType: "candidates",
          list: sidebarNavigation,
          accountInfo
        }
      ) }),
      /* @__PURE__ */ jsx148(
        "main",
        {
          className: "z-10 flex flex-1 flex-col bg-gray-100 lg:overflow-auto",
          id: "content",
          children: /* @__PURE__ */ jsx148("div", { className: "relative flex flex-grow flex-col", children })
        }
      )
    ] })
  ] });
};
var Shell = ({
  accountLink,
  children,
  sidebarNavigation,
  trayNavigation,
  accountInfo
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useMobileNavigation();
  const onSetMobileMenuOpen = useCallback22(() => {
    setMobileMenuOpen(!mobileMenuOpen);
  }, [mobileMenuOpen, setMobileMenuOpen]);
  return /* @__PURE__ */ jsxs91("div", { className: "flex h-screen lg:overflow-hidden", children: [
    /* @__PURE__ */ jsx148("div", { className: "hidden lg:block", children: /* @__PURE__ */ jsx148(
      Navigation,
      {
        accountLink,
        list: sidebarNavigation,
        accountInfo
      }
    ) }),
    /* @__PURE__ */ jsx148("div", { className: "lg:hidden", children: /* @__PURE__ */ jsx148(
      MobileNavigation,
      {
        portalType: "employers",
        list: sidebarNavigation,
        accountInfo
      }
    ) }),
    /* @__PURE__ */ jsx148("div", {}),
    /* @__PURE__ */ jsxs91("div", { className: "z-10 flex flex-1 flex-col bg-gray-100 lg:overflow-auto", children: [
      /* @__PURE__ */ jsx148("div", { className: "relative z-10 flex flex-grow flex-col bg-gray-100 pb-28 lg:pb-0", children }),
      trayNavigation && /* @__PURE__ */ jsx148(
        Tray,
        {
          navigation: trayNavigation,
          setMobileMenuOpen: onSetMobileMenuOpen
        }
      )
    ] })
  ] });
};
var Tray = ({
  navigation,
  setMobileMenuOpen
}) => {
  const location = useLocation2();
  return /* @__PURE__ */ jsx148("div", { className: "relative", children: /* @__PURE__ */ jsx148("div", { className: "pb-safe fixed bottom-0 left-0 z-40 flex w-full shrink-0 items-center gap-x-4  border-t border-gray-200 bg-white pt-3 shadow-sm sm:gap-x-6 md:pb-0 lg:hidden", children: /* @__PURE__ */ jsx148("div", { className: "flex flex-1 justify-evenly gap-x-4 lg:gap-x-6", children: /* @__PURE__ */ jsxs91("div", { className: "flex w-full items-center justify-between gap-x-4 px-2 lg:gap-x-6 ", children: [
    navigation.map((item) => {
      const Icon2 = item.icon ? item.icon : PuzzlePieceIcon;
      return /* @__PURE__ */ jsx148(
        EdLink,
        {
          href: item.to,
          className: "-mt-1 flex w-1/5 flex-col items-center justify-center text-gray-600 hover:text-gray-700",
          name: item.name + "-mobile",
          children: /* @__PURE__ */ jsxs91(
            "button",
            {
              type: "button",
              className: classNames(
                "-m-2.5 flex flex-col items-center justify-center p-2.5 text-center hover:text-gray-700",
                location.pathname.includes(item.to) ? "text-gray-700" : "text-gray-600"
              ),
              children: [
                location.pathname.includes(item.to) ? /* @__PURE__ */ jsx148(
                  Icon2,
                  {
                    className: "h-6 w-6  text-gray-700",
                    "aria-hidden": "true"
                  }
                ) : /* @__PURE__ */ jsx148(
                  Icon2,
                  {
                    className: "h-6 w-6 hover:text-gray-700",
                    "aria-hidden": "true"
                  }
                ),
                /* @__PURE__ */ jsx148("span", { className: "whitespace-break-spaces text-center text-xs", children: item.name })
              ]
            }
          )
        },
        item.name
      );
    }),
    /* @__PURE__ */ jsxs91(
      "div",
      {
        className: "-mt-1 flex w-1/5 flex-col items-center justify-center",
        onClick: () => setMobileMenuOpen(true),
        children: [
          /* @__PURE__ */ jsx148(
            "button",
            {
              type: "button",
              className: "-m-2.5 p-2.5 text-gray-600 hover:text-gray-700",
              children: /* @__PURE__ */ jsx148(
                Bars3Icon,
                {
                  className: "h-6 w-6 text-gray-600",
                  "aria-hidden": "true"
                }
              )
            }
          ),
          /* @__PURE__ */ jsx148("span", { className: "whitespace-break-spaces text-center text-xs text-gray-600", children: "Other" })
        ]
      }
    )
  ] }) }) }) });
};

// src/components/shells/ShellHeader.tsx
import { Bars3Icon as Bars3Icon2 } from "@heroicons/react/24/outline";
import { jsx as jsx149, jsxs as jsxs92 } from "react/jsx-runtime";
var EdShellHeader = ({ setMobileMenuOpen, userNavigation }) => {
  return /* @__PURE__ */ jsx149("header", { className: "fixed top-0 w-full lg:hidden", children: /* @__PURE__ */ jsx149("div", { className: "relative z-50 flex h-16 flex-shrink-0 border-b border-gray-200 bg-white shadow-sm", children: /* @__PURE__ */ jsxs92(
    "button",
    {
      type: "button",
      className: "focus:ring-info-500 border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset lg:hidden",
      onClick: () => setMobileMenuOpen(true),
      children: [
        /* @__PURE__ */ jsx149("span", { className: "sr-only", children: "Open sidebar" }),
        /* @__PURE__ */ jsx149(Bars3Icon2, { className: "h-6 w-6", "aria-hidden": "true" })
      ]
    }
  ) }) });
};

// src/components/skeletons/Skeleton.tsx
import { jsx as jsx150 } from "react/jsx-runtime";
var EdSkeleton = (props) => {
  const { label, showBorder } = props;
  return /* @__PURE__ */ jsx150(Loading, { label });
};

// src/components/skeletons/ListSkeleton.tsx
import { jsx as jsx151 } from "react/jsx-runtime";
var ListSkeleton = ({ title }) => {
  return /* @__PURE__ */ jsx151(
    ListLayout,
    {
      title,
      sections: Array(10).fill(0).map((x, i) => ({
        key: String(i),
        listTitle: /* @__PURE__ */ jsx151(EdSkeleton, { showBorder: false }),
        itemTitle: "Item Title",
        hideIcon: true,
        icon: () => /* @__PURE__ */ jsx151("div", {}),
        element: /* @__PURE__ */ jsx151("div", {})
      }))
    }
  );
};

// src/components/jobs/JobDetails.tsx
import { format } from "date-fns";
import { ExclamationCircleIcon as ExclamationCircleIcon2 } from "@heroicons/react/24/solid";
import { CheckCircleIcon as CheckCircleIcon4 } from "@heroicons/react/24/solid";
import { jsx as jsx152, jsxs as jsxs93 } from "react/jsx-runtime";
var JobDetailsComponent = ({
  title,
  company,
  startDate,
  endDate,
  type,
  status
}) => {
  return /* @__PURE__ */ jsx152(
    Info,
    {
      label: title,
      value: /* @__PURE__ */ jsxs93("div", { children: [
        /* @__PURE__ */ jsx152("div", { children: company }),
        /* @__PURE__ */ jsxs93("div", { children: [
          format(startDate, "dd MMM yyyy"),
          " -",
          " ",
          format(endDate, "dd MMM yyyy"),
          " - ",
          type
        ] })
      ] }),
      icon: status == "UNVERIFIED" ? ExclamationCircleIcon2 : CheckCircleIcon4
    }
  );
};
var JobDetails = (props) => {
  return /* @__PURE__ */ jsx152(JobDetailsComponent, { ...props });
};

// src/components/pages/PageBuilder.tsx
import { createElement as createElement3 } from "react";
import { Fragment as Fragment42, jsx as jsx153, jsxs as jsxs94 } from "react/jsx-runtime";
var PageBuilderElement = ({ layout: layout2 }) => {
  const content = /* @__PURE__ */ jsx153(Fragment42, { children: /* @__PURE__ */ jsx153("div", { className: "flex flex-col gap-5", children: Object.values(layout2).map((x) => {
    return createElement3(x.component, x.props);
  }) }) });
  return content;
};
var PageBuilder = ({
  headerTitle,
  headerDescription,
  layout: layout2
}) => {
  const headerComponent = /* @__PURE__ */ jsx153(Header, { title: headerTitle, children: headerDescription });
  const content = /* @__PURE__ */ jsx153(Fragment42, { children: /* @__PURE__ */ jsx153("div", { className: "flex flex-col gap-5", children: Object.values(layout2).map((x) => {
    return createElement3(x.component, x.props);
  }) }) });
  return /* @__PURE__ */ jsxs94(Fragment42, { children: [
    headerComponent,
    content
  ] });
};

// src/components/tags/DataTagEditor.tsx
import { useCallback as useCallback23, useState as useState28 } from "react";
import { timeAgo as timeAgo2 } from "shared-lib";
import { jsx as jsx154, jsxs as jsxs95 } from "react/jsx-runtime";
var EditTag = ({ tag, onChangeTag }) => {
  const [currentTag, setCurrentTag] = useState28(() => {
    if (!tag) {
      return {
        tagName: "",
        tagValue: ""
      };
    }
    return tag;
  });
  const onChange = useCallback23(
    (change) => {
      if (!currentTag) {
        return;
      }
      const newTag = {
        ...currentTag,
        ...change
      };
      setCurrentTag(newTag);
      onChangeTag(newTag);
    },
    [currentTag, setCurrentTag]
  );
  return /* @__PURE__ */ jsxs95("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsxs95("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx154("div", { children: "Name" }),
      /* @__PURE__ */ jsx154(
        Input,
        {
          placeholder: " Tag Name ",
          name: "tagName",
          value: currentTag?.tagName,
          onValueChange: (tagName) => onChange({
            tagName
          })
        },
        "tagName"
      )
    ] }),
    /* @__PURE__ */ jsxs95("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx154("div", { children: "Value" }),
      /* @__PURE__ */ jsx154(
        Input,
        {
          placeholder: " Tag Value ",
          name: "tagValue",
          value: currentTag?.tagValue,
          onValueChange: (tagValue) => onChange({
            tagValue
          })
        },
        "tagValue"
      )
    ] })
  ] });
};
var DataTagEditor = ({
  isBusy,
  tags,
  onAdd,
  onUpdated,
  onRemove
}) => {
  const [addTag, setAddTag] = useState28(null);
  const [addingTag, setAddingTag] = useState28(false);
  const onChangeAddTag = useCallback23(
    (change) => {
      if (!addTag) {
        return;
      }
      setAddTag({
        ...addTag,
        ...change
      });
    },
    [addTag, setAddTag]
  );
  const onAddStart = useCallback23(() => {
    if (addingTag) {
      return;
    }
    setAddTag({ tagName: "", tagValue: "" });
    setAddingTag(true);
  }, [setAddTag]);
  const onAddTag = useCallback23(() => {
    if (!addTag || !addTag.tagName || !addTag.tagValue) {
      return;
    }
    onAdd(addTag, () => {
      setAddingTag(false);
    });
  }, [addTag, onAdd]);
  const [editTag, setEditTag] = useState28(null);
  const onChangeEditTag = useCallback23(
    (change) => {
      if (!editTag) {
        return;
      }
      setEditTag({
        ...editTag,
        ...change
      });
    },
    [editTag, setEditTag]
  );
  const onUpdateTag = useCallback23(() => {
    if (!editTag || !editTag.tagName || !editTag.tagValue) {
      return;
    }
    onUpdated(editTag, () => {
      setEditTag(null);
    });
  }, [editTag, onUpdated]);
  const onDeleteEditTag = useCallback23(() => {
    if (!editTag) {
      return;
    }
    onRemove(editTag.tagId, () => {
      setEditTag(null);
    });
  }, [editTag, onRemove]);
  const tagsItems = tags.map((t, i) => {
    return /* @__PURE__ */ jsxs95(
      "div",
      {
        className: classNames(
          "flex items-center justify-between gap-2 px-4 py-2",
          i < tags.length - 1 ? "border-b" : ""
        ),
        children: [
          /* @__PURE__ */ jsxs95("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ jsxs95("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ jsx154("div", { className: "text-gray-500", children: t.tagName }),
              /* @__PURE__ */ jsx154("div", { className: "text-primary-500", children: t.tagValue })
            ] }),
            /* @__PURE__ */ jsxs95("div", { className: "flex items-center gap-x-2 text-sm leading-5 text-gray-500", children: [
              /* @__PURE__ */ jsxs95("p", { className: "flex items-center gap-x-1 whitespace-nowrap", children: [
                /* @__PURE__ */ jsx154("span", { children: t.createdByUser.firstName }),
                " ",
                /* @__PURE__ */ jsx154("span", { children: t.createdByUser.lastName })
              ] }),
              /* @__PURE__ */ jsx154("p", { className: "whitespace-nowrap", children: timeAgo2(t.updatedAt) })
            ] })
          ] }),
          /* @__PURE__ */ jsx154(LinkButton, { clicked: () => setEditTag(t), children: "Edit" })
        ]
      },
      t.code.toString()
    );
  });
  let editorContent;
  if (addingTag) {
    editorContent = /* @__PURE__ */ jsxs95("div", { className: "flex flex-col gap-1 p-2 py-4", children: [
      /* @__PURE__ */ jsx154("div", { className: "mb-2 border-b p-2", children: /* @__PURE__ */ jsx154(EditTag, { tag: addTag, onChangeTag: onChangeAddTag }) }),
      /* @__PURE__ */ jsxs95(ButtonList, { children: [
        /* @__PURE__ */ jsx154(
          Button,
          {
            "aria-label": "Save Tag",
            color: "primary",
            disabled: isBusy,
            clicked: onAddTag,
            children: "Save"
          }
        ),
        /* @__PURE__ */ jsx154(
          Button,
          {
            "aria-label": "Cancel Tag",
            color: "gray",
            clicked: () => setAddingTag(false),
            children: "Cancel"
          }
        )
      ] })
    ] });
  } else if (editTag) {
    editorContent = /* @__PURE__ */ jsxs95("div", { className: "flex flex-col gap-1 p-2 py-4", children: [
      /* @__PURE__ */ jsx154("div", { className: "mb-2 border-b p-2", children: /* @__PURE__ */ jsx154(EditTag, { tag: editTag, onChangeTag: onChangeEditTag }) }),
      /* @__PURE__ */ jsxs95(ButtonList, { children: [
        /* @__PURE__ */ jsx154(Button, { "aria-label": "Save tag", color: "primary", clicked: onUpdateTag, children: "Save" }),
        /* @__PURE__ */ jsx154(
          Button,
          {
            "aria-label": "Cancel tag",
            color: "gray",
            clicked: () => setEditTag(null),
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ jsx154(
          Button,
          {
            "aria-label": "Delete tag",
            color: "danger",
            clicked: onDeleteEditTag,
            children: "Delete"
          }
        )
      ] })
    ] });
  } else {
    editorContent = /* @__PURE__ */ jsx154("div", { className: "mt-2 flex", children: /* @__PURE__ */ jsx154("div", { className: "flex w-full flex-col gap-2", children: tagsItems }) });
  }
  return /* @__PURE__ */ jsx154("div", { children: /* @__PURE__ */ jsx154("div", { className: "", children: /* @__PURE__ */ jsxs95("div", { className: "my-4 flex flex-col gap-1", children: [
    /* @__PURE__ */ jsxs95("div", { className: "flex items-center justify-between border-b pb-4", children: [
      /* @__PURE__ */ jsx154("div", { className: "text-primary-500 px-4 text-lg font-medium", children: "Tags" }),
      /* @__PURE__ */ jsx154(
        Button,
        {
          "aria-label": "Add Tags",
          color: "primary",
          disabled: addingTag,
          clicked: onAddStart,
          children: "Add"
        }
      )
    ] }),
    editorContent
  ] }) }) });
};

// src/components/text/DebouncedInput.tsx
import {
  useState as useState29,
  useEffect as useEffect13,
  useCallback as useCallback24
} from "react";
import { noop as noop9, useDebounce as useDebounce4 } from "shared-lib";
import { jsx as jsx155, jsxs as jsxs96 } from "react/jsx-runtime";
var DebouncedInput = ({
  value,
  placeholder,
  onValueChanged = noop9,
  onBlur = noop9,
  className,
  label,
  showClearButton = false
}) => {
  const [query, setQuery] = useState29(value || "");
  const delayedQueryText = useDebounce4(query, 300);
  useEffect13(() => {
    onValueChanged(delayedQueryText);
  }, [delayedQueryText]);
  const onChange = (event) => {
    setQuery(event.target.value);
  };
  const onClear = useCallback24(() => {
    setQuery("");
  }, []);
  return /* @__PURE__ */ jsxs96("div", { className: "flex gap-1", children: [
    /* @__PURE__ */ jsxs96("div", { className: "w-full", children: [
      /* @__PURE__ */ jsx155("label", { className: "text-xs", children: label }),
      /* @__PURE__ */ jsx155(
        Input,
        {
          "aria-label": placeholder || "Search",
          placeholder,
          value: query,
          onChange,
          className,
          onBlur: () => onBlur(query)
        }
      )
    ] }),
    showClearButton && /* @__PURE__ */ jsx155(Button, { "aria-label": "Clear", onClick: onClear, children: "Clear" })
  ] });
};

// src/components/text/FormattedText.tsx
import { Fragment as Fragment43, jsx as jsx156 } from "react/jsx-runtime";
var FormattedText = ({ text }) => {
  if (!text) {
    return /* @__PURE__ */ jsx156(Fragment43, {});
  }
  const lines = text.split(/\n/);
  const html = lines.map((l) => l.replace(/\\n/g, "<br/>")).map((l, i) => /* @__PURE__ */ jsx156("p", { className: "py-1", children: l }, i.toString()));
  return /* @__PURE__ */ jsx156("div", { children: html });
};

// src/components/text/HtmlDisplay.tsx
import { jsx as jsx157 } from "react/jsx-runtime";
var HtmlDisplay = ({ html }) => {
  return /* @__PURE__ */ jsx157(
    "div",
    {
      className: "whitespace-pre-wrap",
      dangerouslySetInnerHTML: {
        __html: html ?? ""
      }
    }
  );
};

// src/components/timeline/Timeline.tsx
import { noop as noop10 } from "shared-lib";
import { jsx as jsx158, jsxs as jsxs97 } from "react/jsx-runtime";
var Timeline = ({
  list
}) => {
  return /* @__PURE__ */ jsx158("ul", { className: "p-4", children: list.map(
    ({
      isActive,
      isCompleted,
      isEmpty: isEmpty3 = true,
      title,
      body,
      onClick = noop10
    }, i) => {
      return /* @__PURE__ */ jsxs97(
        "li",
        {
          onClick,
          className: classNames(
            "relative cursor-pointer",
            list.length === i + 1 ? "" : "pb-10"
          ),
          children: [
            list.length != i + 1 && /* @__PURE__ */ jsx158(
              "div",
              {
                className: classNames(
                  "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5",
                  isActive || isCompleted ? "bg-gray-300" : "bg-green-600"
                )
              }
            ),
            /* @__PURE__ */ jsxs97("div", { className: "hover:bg-primary-50 group relative flex items-start space-x-4 rounded-l-full focus:outline-none", children: [
              /* @__PURE__ */ jsxs97("div", { className: "flex h-9 items-center", children: [
                isEmpty3 && !isActive && !isCompleted && /* @__PURE__ */ jsx158("span", { className: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white", children: /* @__PURE__ */ jsx158("span", { className: "h-2.5 w-2.5 rounded-full bg-transparent" }) }),
                isActive && /* @__PURE__ */ jsx158("span", { className: "border-primary-600 relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 bg-white", children: /* @__PURE__ */ jsx158("span", { className: "bg-primary-600 h-2.5 w-2.5 rounded-full" }) }),
                isCompleted && /* @__PURE__ */ jsx158("span", { className: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-green-600", children: /* @__PURE__ */ jsx158(
                  "svg",
                  {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    className: "h-5 w-5 text-white",
                    children: /* @__PURE__ */ jsx158(
                      "path",
                      {
                        fillRule: "evenodd",
                        d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                        clipRule: "evenodd"
                      }
                    )
                  }
                ) })
              ] }),
              /* @__PURE__ */ jsxs97("div", { className: "min-w-0", children: [
                /* @__PURE__ */ jsx158("h3", { className: "m-0 text-xs font-semibold uppercase leading-4 tracking-wide", children: title }),
                /* @__PURE__ */ jsx158("p", { className: "text-sm leading-5 text-gray-500", children: body })
              ] })
            ] })
          ]
        },
        title
      );
    }
  ) });
};

// src/components/wizard/HorizontalWizardSteps.tsx
import { CheckIcon as CheckIcon7 } from "@heroicons/react/24/solid";

// src/components/wizard/Steps.tsx
import { CheckIcon as CheckIcon6 } from "@heroicons/react/24/solid";
import { Fragment as Fragment44, jsx as jsx159, jsxs as jsxs98 } from "react/jsx-runtime";
var StepStatus = /* @__PURE__ */ ((StepStatus2) => {
  StepStatus2[StepStatus2["Current"] = 0] = "Current";
  StepStatus2[StepStatus2["Complete"] = 1] = "Complete";
  StepStatus2[StepStatus2["Pending"] = 2] = "Pending";
  return StepStatus2;
})(StepStatus || {});
var Steps = ({ currentStep, steps: steps2, onSelect }) => {
  return /* @__PURE__ */ jsx159("nav", { "aria-label": "Progress", children: /* @__PURE__ */ jsx159("ol", { role: "list", className: "overflow-hidden", children: steps2.map((step, stepIdx) => /* @__PURE__ */ jsx159(
    "li",
    {
      onClick: () => onSelect(step),
      className: classNames(
        stepIdx !== steps2.length - 1 ? "pb-10" : "",
        "relative"
      ),
      children: step.status === 1 /* Complete */ ? /* @__PURE__ */ jsxs98(Fragment44, { children: [
        stepIdx !== steps2.length - 1 ? /* @__PURE__ */ jsx159(
          "div",
          {
            className: "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-indigo-600",
            "aria-hidden": "true"
          }
        ) : null,
        /* @__PURE__ */ jsxs98("div", { className: "group relative flex items-start", children: [
          /* @__PURE__ */ jsx159("span", { className: "flex h-9 items-center", children: /* @__PURE__ */ jsx159("span", { className: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-indigo-600 group-hover:bg-indigo-800", children: /* @__PURE__ */ jsx159(
            CheckIcon6,
            {
              className: "h-5 w-5 text-white",
              "aria-hidden": "true"
            }
          ) }) }),
          /* @__PURE__ */ jsxs98("span", { className: "ml-4 flex min-w-0 flex-col", children: [
            /* @__PURE__ */ jsx159("span", { className: "text-sm font-medium", children: step.name }),
            /* @__PURE__ */ jsx159("span", { className: "text-sm text-gray-500", children: step.description })
          ] })
        ] })
      ] }) : step.key === currentStep ? /* @__PURE__ */ jsxs98(Fragment44, { children: [
        stepIdx !== steps2.length - 1 ? /* @__PURE__ */ jsx159(
          "div",
          {
            className: "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300",
            "aria-hidden": "true"
          }
        ) : null,
        /* @__PURE__ */ jsxs98(
          "div",
          {
            className: "group relative flex items-start",
            "aria-current": "step",
            children: [
              /* @__PURE__ */ jsx159("span", { className: "flex h-9 items-center", "aria-hidden": "true", children: /* @__PURE__ */ jsx159("span", { className: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-indigo-600 bg-white", children: /* @__PURE__ */ jsx159("span", { className: "h-2.5 w-2.5 rounded-full bg-indigo-600" }) }) }),
              /* @__PURE__ */ jsxs98("span", { className: "ml-4 flex min-w-0 flex-col", children: [
                /* @__PURE__ */ jsx159("span", { className: "text-sm font-medium text-indigo-600", children: step.name }),
                /* @__PURE__ */ jsx159("span", { className: "text-sm text-gray-500", children: step.description })
              ] })
            ]
          }
        )
      ] }) : /* @__PURE__ */ jsxs98(Fragment44, { children: [
        stepIdx !== steps2.length - 1 ? /* @__PURE__ */ jsx159(
          "div",
          {
            className: "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300",
            "aria-hidden": "true"
          }
        ) : null,
        /* @__PURE__ */ jsxs98("div", { className: "group relative flex items-start", children: [
          /* @__PURE__ */ jsx159("span", { className: "flex h-9 items-center", "aria-hidden": "true", children: /* @__PURE__ */ jsx159("span", { className: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-400", children: /* @__PURE__ */ jsx159("span", { className: "h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300" }) }) }),
          /* @__PURE__ */ jsxs98("span", { className: "ml-4 flex min-w-0 flex-col", children: [
            /* @__PURE__ */ jsx159("span", { className: "text-sm font-medium text-gray-500", children: step.name }),
            /* @__PURE__ */ jsx159("span", { className: "text-sm text-gray-500", children: step.description })
          ] })
        ] })
      ] })
    },
    step.key
  )) }) });
};

// src/components/wizard/HorizontalWizardSteps.tsx
import { Fragment as Fragment45, jsx as jsx160, jsxs as jsxs99 } from "react/jsx-runtime";
var WizardStageTypes = /* @__PURE__ */ ((WizardStageTypes2) => {
  WizardStageTypes2["Panel"] = "Panel";
  WizardStageTypes2["Progress"] = "Progress";
  return WizardStageTypes2;
})(WizardStageTypes || {});
var HorizontalWizardSteps = (props) => {
  switch (props.type) {
    case "Progress" /* Progress */:
      return /* @__PURE__ */ jsx160(HorizontalWizardStepsProgressBar, { ...props });
    case "Panel" /* Panel */:
    default:
      return /* @__PURE__ */ jsx160(HorizontalWizardStepsPanel, { ...props });
  }
};
var HorizontalWizardStepsPanel = ({
  currentStep,
  steps: steps2,
  onSelect
}) => {
  return /* @__PURE__ */ jsx160("nav", { "aria-label": "Progress", children: /* @__PURE__ */ jsx160(
    "ol",
    {
      role: "list",
      className: "divide-y divide-gray-300 rounded-md border border-gray-300 bg-white md:flex md:divide-y-0",
      children: steps2.map((step, stepIdx) => /* @__PURE__ */ jsxs99(
        "li",
        {
          onClick: () => onSelect && onSelect(step),
          className: "relative md:flex md:flex-1",
          children: [
            step.status === 1 /* Complete */ ? /* @__PURE__ */ jsx160("div", { className: "group flex w-full items-center", children: /* @__PURE__ */ jsxs99("span", { className: "flex items-center px-6 py-4 text-sm font-medium", children: [
              /* @__PURE__ */ jsx160("span", { className: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-indigo-600 group-hover:bg-indigo-800", children: /* @__PURE__ */ jsx160(
                CheckIcon7,
                {
                  className: "h-6 w-6 text-white",
                  "aria-hidden": "true"
                }
              ) }),
              /* @__PURE__ */ jsx160("span", { className: "ml-4 text-sm font-medium text-gray-900", children: step.name })
            ] }) }) : step.key === currentStep ? /* @__PURE__ */ jsxs99(
              "div",
              {
                className: "flex items-center px-6 py-4 text-sm font-medium",
                "aria-current": "step",
                children: [
                  /* @__PURE__ */ jsx160("span", { className: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border-2 border-indigo-600", children: /* @__PURE__ */ jsx160("span", { className: "text-indigo-600", children: step.index }) }),
                  /* @__PURE__ */ jsx160("span", { className: "ml-4 text-sm font-medium text-indigo-600", children: step.name })
                ]
              }
            ) : /* @__PURE__ */ jsx160("div", { className: "group flex items-center", children: /* @__PURE__ */ jsxs99("span", { className: "flex items-center px-6 py-4 text-sm font-medium", children: [
              /* @__PURE__ */ jsx160("span", { className: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border-2 border-gray-300 group-hover:border-gray-400", children: /* @__PURE__ */ jsx160("span", { className: "text-gray-500 group-hover:text-gray-900", children: step.index }) }),
              /* @__PURE__ */ jsx160("span", { className: "ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900", children: step.name })
            ] }) }),
            stepIdx !== steps2.length - 1 ? /* @__PURE__ */ jsx160(Fragment45, { children: /* @__PURE__ */ jsx160(
              "div",
              {
                className: "absolute right-0 top-0 hidden h-full w-5 md:block",
                "aria-hidden": "true",
                children: /* @__PURE__ */ jsx160(
                  "svg",
                  {
                    className: "h-full w-full text-gray-300",
                    viewBox: "0 0 22 80",
                    fill: "none",
                    preserveAspectRatio: "none",
                    children: /* @__PURE__ */ jsx160(
                      "path",
                      {
                        d: "M0 -2L20 40L0 82",
                        vectorEffect: "non-scaling-stroke",
                        stroke: "currentcolor",
                        strokeLinejoin: "round"
                      }
                    )
                  }
                )
              }
            ) }) : null
          ]
        },
        step.key
      ))
    }
  ) });
};
var HorizontalWizardStepsProgressBar = ({
  currentStep,
  steps: steps2,
  onSelect
}) => {
  const index = steps2.findIndex((step) => step.key === currentStep);
  const percentageOfStepsComplete = index / (steps2.length - 1) * 100;
  const isCurrentStep = (step) => {
    return step.key === currentStep;
  };
  return /* @__PURE__ */ jsx160("div", { children: /* @__PURE__ */ jsx160("div", { className: "mt-6", "aria-hidden": "true", children: /* @__PURE__ */ jsxs99("div", { className: "flex flex-col ", children: [
    /* @__PURE__ */ jsx160("div", { className: "relative mb-14 flex ", children: steps2.map((step, stepIdx) => {
      return /* @__PURE__ */ jsx160(
        "div",
        {
          className: classNames(
            "absolute top-4 -ml-[100px] w-[200px] text-center text-base text-gray-700",
            isCurrentStep(step) && "text-primary-900 font-semibold"
          ),
          style: { left: `${stepIdx / (steps2.length - 1) * 100}%` },
          children: step.name
        },
        stepIdx
      );
    }) }),
    /* @__PURE__ */ jsx160("div", { className: "flex gap-1 overflow-hidden rounded-full bg-gray-200", children: /* @__PURE__ */ jsx160(
      "div",
      {
        className: "h-3 overflow-hidden rounded-full bg-green-700 transition-[width] duration-300",
        style: { width: `${percentageOfStepsComplete}%` }
      }
    ) })
  ] }) }) });
};

// src/components/wizard/VerticalWizardSteps.tsx
import { CheckIcon as CheckIcon8 } from "@heroicons/react/24/solid";
import { noop as noop11 } from "shared-lib";
import { Fragment as Fragment46, jsx as jsx161, jsxs as jsxs100 } from "react/jsx-runtime";
var VerticalWizardSteps = ({ currentStep, steps: steps2, onSelect = noop11 }) => {
  return /* @__PURE__ */ jsx161("nav", { "aria-label": "Progress", children: /* @__PURE__ */ jsx161("ol", { role: "list", className: "overflow-hidden", children: steps2.map((step, stepIdx) => /* @__PURE__ */ jsx161(
    "li",
    {
      onClick: () => onSelect(step),
      className: classNames(
        stepIdx !== steps2.length - 1 ? "pb-10" : "",
        "relative"
      ),
      children: step.status === 1 /* Complete */ ? /* @__PURE__ */ jsxs100(Fragment46, { children: [
        stepIdx !== steps2.length - 1 ? /* @__PURE__ */ jsx161(
          "div",
          {
            className: "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-indigo-600",
            "aria-hidden": "true"
          }
        ) : null,
        /* @__PURE__ */ jsxs100("div", { className: "group relative flex items-center", children: [
          /* @__PURE__ */ jsx161("span", { className: "flex h-9 items-center", children: /* @__PURE__ */ jsx161("span", { className: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-indigo-600 group-hover:bg-indigo-800", children: /* @__PURE__ */ jsx161(
            CheckIcon8,
            {
              className: "h-5 w-5 text-white",
              "aria-hidden": "true"
            }
          ) }) }),
          /* @__PURE__ */ jsxs100("span", { className: "ml-4 flex min-w-0 flex-col", children: [
            /* @__PURE__ */ jsx161("span", { className: "text-sm font-medium", children: step.name }),
            /* @__PURE__ */ jsx161("span", { className: "text-sm text-gray-500", children: step.description })
          ] })
        ] })
      ] }) : step.key === currentStep ? /* @__PURE__ */ jsxs100(Fragment46, { children: [
        stepIdx !== steps2.length - 1 ? /* @__PURE__ */ jsx161(
          "div",
          {
            className: "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300",
            "aria-hidden": "true"
          }
        ) : null,
        /* @__PURE__ */ jsxs100(
          "div",
          {
            className: "group relative flex items-center",
            "aria-current": "step",
            children: [
              /* @__PURE__ */ jsx161("span", { className: "flex h-9 items-center", "aria-hidden": "true", children: /* @__PURE__ */ jsx161("span", { className: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-indigo-600 bg-white", children: /* @__PURE__ */ jsx161("span", { className: "h-2.5 w-2.5 rounded-full bg-indigo-600" }) }) }),
              /* @__PURE__ */ jsxs100("span", { className: "ml-4 flex min-w-0 flex-col", children: [
                /* @__PURE__ */ jsx161("span", { className: "text-sm font-medium text-indigo-600", children: step.name }),
                /* @__PURE__ */ jsx161("span", { className: "text-sm text-gray-500", children: step.description })
              ] })
            ]
          }
        )
      ] }) : /* @__PURE__ */ jsxs100(Fragment46, { children: [
        stepIdx !== steps2.length - 1 ? /* @__PURE__ */ jsx161(
          "div",
          {
            className: "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300",
            "aria-hidden": "true"
          }
        ) : null,
        /* @__PURE__ */ jsxs100("div", { className: "group relative flex items-center", children: [
          /* @__PURE__ */ jsx161("span", { className: "flex h-9 items-center", "aria-hidden": "true", children: /* @__PURE__ */ jsx161("span", { className: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-400", children: /* @__PURE__ */ jsx161("span", { className: "h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300" }) }) }),
          /* @__PURE__ */ jsxs100("span", { className: "ml-4 flex min-w-0 flex-col", children: [
            /* @__PURE__ */ jsx161("span", { className: "text-sm font-medium text-gray-500", children: step.name }),
            /* @__PURE__ */ jsx161("span", { className: "text-sm text-gray-500", children: step.description })
          ] })
        ] })
      ] })
    },
    step.key
  )) }) });
};

// src/components/iframe/Iframe.tsx
import { jsx as jsx162, jsxs as jsxs101 } from "react/jsx-runtime";
var Iframe = (props) => {
  return /* @__PURE__ */ jsxs101("div", { className: "relative bg-gray-100", children: [
    /* @__PURE__ */ jsx162("div", { className: "absolute z-10 flex h-full w-full items-center justify-center", children: /* @__PURE__ */ jsx162(Loading, { label: "Loading..." }) }),
    /* @__PURE__ */ jsx162("div", { className: "relative z-20", children: /* @__PURE__ */ jsx162("iframe", { ...props }) })
  ] });
};

// src/components/relay/PreloadedQueryHOC.tsx
import { useFragment as useFragment3, usePreloadedQuery as usePreloadedQuery2 } from "react-relay";
function PreloadedQueryHOC({
  queryDef,
  fragmentDef,
  queryRef,
  children
}) {
  const query = usePreloadedQuery2(queryDef, queryRef);
  const data = useFragment3(fragmentDef, query);
  return children({ data });
}

// src/components/table/Table.tsx
import { Fragment as Fragment47, jsx as jsx163, jsxs as jsxs102 } from "react/jsx-runtime";
function Table({
  header,
  items,
  children,
  emptyMessage = "No entries found"
}) {
  const hasItems = items !== void 0 && items.length > 0;
  return /* @__PURE__ */ jsxs102(Fragment47, { children: [
    !hasItems && /* @__PURE__ */ jsx163("div", { className: "flex w-full justify-center p-5", children: /* @__PURE__ */ jsx163("div", { children: emptyMessage }) }),
    hasItems && /* @__PURE__ */ jsxs102(Fragment47, { children: [
      /* @__PURE__ */ jsxs102(
        "div",
        {
          className: "@4xl:grid hidden p-5",
          style: {
            gridTemplateColumns: `repeat(${header.length}, 1fr)`
          },
          children: [
            /* @__PURE__ */ jsx163(TableHeader, { columns: header.length, items: header }),
            /* @__PURE__ */ jsx163(TableBody, { columns: header.length, items, children })
          ]
        }
      ),
      /* @__PURE__ */ jsx163("div", { className: "@4xl:hidden flex flex-col divide-y", children: items?.map((x, index) => /* @__PURE__ */ jsx163(
        "div",
        {
          className: "cursor-pointer p-2 hover:bg-gray-100 ",
          children: x.map((y, i) => /* @__PURE__ */ jsx163("div", { children: children({
            recordId: y.recordId,
            label: header[i % header.length],
            key: y.key,
            value: y.value,
            index
          }) }, "table" + (index + 1) * (i + 1)))
        },
        "table" + index
      )) })
    ] })
  ] });
}
var TableHeader = ({
  items,
  columns
}) => /* @__PURE__ */ jsx163(
  "div",
  {
    className: "grid",
    style: { gridTemplateColumns: "subgrid", gridColumn: `1/${columns + 1}` },
    children: items.map((x, i) => {
      return /* @__PURE__ */ jsx163(
        "div",
        {
          className: classNames(
            "mb-2 border-b py-2 font-bold",
            i % columns === columns - 1 ? "text-right" : ""
          ),
          children: x
        },
        x
      );
    })
  }
);
function TableBody({
  items,
  columns,
  children
}) {
  return /* @__PURE__ */ jsx163(
    "div",
    {
      className: "grid divide-y",
      style: {
        gridTemplateColumns: "subgrid",
        gridColumn: `1/${columns + 1}`
      },
      children: items?.map((row, i) => {
        return /* @__PURE__ */ jsx163(
          "div",
          {
            className: "grid cursor-pointer py-1 hover:bg-gray-100",
            style: {
              gridTemplateColumns: "subgrid",
              gridColumn: `1/${columns + 1}`
            },
            children: row.map((x, i2) => {
              return /* @__PURE__ */ jsx163(
                "div",
                {
                  className: classNames(
                    "my-1 w-full",
                    i2 % columns === columns - 1 ? "text-right" : ""
                  ),
                  children: children(x)
                },
                x.key + x.value
              );
            })
          },
          i
        );
      })
    }
  );
}

// src/components/@shadcn/components/ui/table.tsx
var table_exports = {};
__export(table_exports, {
  Table: () => Table2,
  TableBody: () => TableBody2,
  TableCaption: () => TableCaption,
  TableCell: () => TableCell,
  TableFooter: () => TableFooter,
  TableHead: () => TableHead,
  TableHeader: () => TableHeader2,
  TableRow: () => TableRow
});
import * as React8 from "react";
import { jsx as jsx164 } from "react/jsx-runtime";
var Table2 = React8.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx164("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ jsx164(
  "table",
  {
    ref,
    className: cn("w-full caption-bottom text-sm", className),
    ...props
  }
) }));
Table2.displayName = "Table";
var TableHeader2 = React8.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx164("thead", { ref, className: cn("[&_tr]:border-b", className), ...props }));
TableHeader2.displayName = "TableHeader";
var TableBody2 = React8.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx164(
  "tbody",
  {
    ref,
    className: cn("[&_tr:last-child]:border-0", className),
    ...props
  }
));
TableBody2.displayName = "TableBody";
var TableFooter = React8.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx164(
  "tfoot",
  {
    ref,
    className: cn(
      "border-t bg-slate-100/50 font-medium dark:bg-slate-800/50 [&>tr]:last:border-b-0",
      className
    ),
    ...props
  }
));
TableFooter.displayName = "TableFooter";
var TableRow = React8.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx164(
  "tr",
  {
    ref,
    className: cn(
      "border-b transition-colors hover:bg-slate-100/50 data-[state=selected]:bg-slate-100 dark:hover:bg-slate-800/50 dark:data-[state=selected]:bg-slate-800",
      className
    ),
    ...props
  }
));
TableRow.displayName = "TableRow";
var TableHead = React8.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx164(
  "th",
  {
    ref,
    className: cn(
      "h-12 px-4 text-left align-middle font-medium text-slate-500 dark:text-slate-400 [&:has([role=checkbox])]:pr-0",
      className
    ),
    ...props
  }
));
TableHead.displayName = "TableHead";
var TableCell = React8.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx164(
  "td",
  {
    ref,
    className: cn("p-4 align-middle [&:has([role=checkbox])]:pr-0", className),
    ...props
  }
));
TableCell.displayName = "TableCell";
var TableCaption = React8.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx164(
  "caption",
  {
    ref,
    className: cn("mt-4 text-sm text-slate-500 dark:text-slate-400", className),
    ...props
  }
));
TableCaption.displayName = "TableCaption";

// src/components/@shadcn/components/ui/scroll-area.tsx
import * as React9 from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { jsx as jsx165, jsxs as jsxs103 } from "react/jsx-runtime";
var ScrollArea = React9.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs103(
  ScrollAreaPrimitive.Root,
  {
    ref,
    className: cn("relative overflow-hidden", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx165(ScrollAreaPrimitive.Viewport, { className: "h-full w-full rounded-[inherit]", children }),
      /* @__PURE__ */ jsx165(ScrollBar, {}),
      /* @__PURE__ */ jsx165(ScrollAreaPrimitive.Corner, {})
    ]
  }
));
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
var ScrollBar = React9.forwardRef(({ className, orientation = "vertical", ...props }, ref) => /* @__PURE__ */ jsx165(
  ScrollAreaPrimitive.ScrollAreaScrollbar,
  {
    ref,
    orientation,
    className: cn(
      "flex touch-none select-none transition-colors",
      orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx165(ScrollAreaPrimitive.ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-slate-200 dark:bg-slate-800" })
  }
));
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

// src/components/@shadcn/components/ui/dropdown-menu.tsx
import * as React10 from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { Check, ChevronRight as ChevronRight3, Circle as Circle2 } from "lucide-react";
import { jsx as jsx166, jsxs as jsxs104 } from "react/jsx-runtime";
var DropdownMenu = DropdownMenuPrimitive.Root;
var DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
var DropdownMenuSubTrigger = React10.forwardRef(({ className, inset, children, ...props }, ref) => /* @__PURE__ */ jsxs104(
  DropdownMenuPrimitive.SubTrigger,
  {
    ref,
    className: cn(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-slate-100 data-[state=open]:bg-slate-100 dark:focus:bg-slate-800 dark:data-[state=open]:bg-slate-800",
      inset && "pl-8",
      className
    ),
    ...props,
    children: [
      children,
      /* @__PURE__ */ jsx166(ChevronRight3, { className: "ml-auto h-4 w-4" })
    ]
  }
));
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
var DropdownMenuSubContent = React10.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx166(
  DropdownMenuPrimitive.SubContent,
  {
    ref,
    className: cn(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] overflow-hidden rounded-md border border-slate-200 bg-white p-1 text-slate-950 shadow-lg dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      className
    ),
    ...props
  }
));
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
var DropdownMenuContent = React10.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx166(DropdownMenuPrimitive.Portal, { children: /* @__PURE__ */ jsx166(
  DropdownMenuPrimitive.Content,
  {
    ref,
    sideOffset,
    className: cn(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] overflow-hidden rounded-md border border-slate-200 bg-white p-1 text-slate-950 shadow-md dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      className
    ),
    ...props
  }
) }));
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
var DropdownMenuItem = React10.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx166(
  DropdownMenuPrimitive.Item,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50",
      inset && "pl-8",
      className
    ),
    ...props
  }
));
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
var DropdownMenuCheckboxItem = React10.forwardRef(({ className, children, checked, ...props }, ref) => /* @__PURE__ */ jsxs104(
  DropdownMenuPrimitive.CheckboxItem,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50",
      className
    ),
    checked,
    ...props,
    children: [
      /* @__PURE__ */ jsx166("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx166(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx166(Check, { className: "h-4 w-4" }) }) }),
      children
    ]
  }
));
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
var DropdownMenuRadioItem = React10.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs104(
  DropdownMenuPrimitive.RadioItem,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50",
      className
    ),
    ...props,
    children: [
      /* @__PURE__ */ jsx166("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx166(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx166(Circle2, { className: "h-2 w-2 fill-current" }) }) }),
      children
    ]
  }
));
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
var DropdownMenuLabel = React10.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx166(
  DropdownMenuPrimitive.Label,
  {
    ref,
    className: cn(
      "px-2 py-1.5 text-sm font-semibold",
      inset && "pl-8",
      className
    ),
    ...props
  }
));
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
var DropdownMenuSeparator = React10.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx166(
  DropdownMenuPrimitive.Separator,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-slate-100 dark:bg-slate-800", className),
    ...props
  }
));
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
var DropdownMenuShortcut = ({
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx166(
    "span",
    {
      className: cn("ml-auto text-xs tracking-widest opacity-60", className),
      ...props
    }
  );
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";

// src/components/@shadcn/components/ui/toast.tsx
import * as React11 from "react";
import * as ToastPrimitives from "@radix-ui/react-toast";
import { cva as cva2 } from "class-variance-authority";
import { X } from "lucide-react";
import { jsx as jsx167 } from "react/jsx-runtime";
var ToastProvider = ToastPrimitives.Provider;
var ToastViewport = React11.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx167(
  ToastPrimitives.Viewport,
  {
    ref,
    className: cn(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      className
    ),
    ...props
  }
));
ToastViewport.displayName = ToastPrimitives.Viewport.displayName;
var toastVariants = cva2(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border border-slate-200 p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full dark:border-slate-800",
  {
    variants: {
      variant: {
        default: "border bg-white text-slate-950 dark:bg-slate-950 dark:text-slate-50",
        destructive: "destructive group border-red-500 bg-red-500 text-slate-50 dark:border-red-900 dark:bg-red-900 dark:text-slate-50"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
var Toast = React11.forwardRef(({ className, variant, ...props }, ref) => {
  return /* @__PURE__ */ jsx167(
    ToastPrimitives.Root,
    {
      ref,
      className: cn(toastVariants({ variant }), className),
      ...props
    }
  );
});
Toast.displayName = ToastPrimitives.Root.displayName;
var ToastAction = React11.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx167(
  ToastPrimitives.Action,
  {
    ref,
    className: cn(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border border-slate-200 bg-transparent px-3 text-sm font-medium ring-offset-white transition-colors hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-slate-100/40 group-[.destructive]:hover:border-red-500/30 group-[.destructive]:hover:bg-red-500 group-[.destructive]:hover:text-slate-50 group-[.destructive]:focus:ring-red-500 dark:border-slate-800 dark:ring-offset-slate-950 dark:hover:bg-slate-800 dark:focus:ring-slate-300 dark:group-[.destructive]:border-slate-800/40 dark:group-[.destructive]:hover:border-red-900/30 dark:group-[.destructive]:hover:bg-red-900 dark:group-[.destructive]:hover:text-slate-50 dark:group-[.destructive]:focus:ring-red-900",
      className
    ),
    ...props
  }
));
ToastAction.displayName = ToastPrimitives.Action.displayName;
var ToastClose = React11.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx167(
  ToastPrimitives.Close,
  {
    ref,
    className: cn(
      "absolute right-2 top-2 rounded-md p-1 text-slate-950/50 opacity-0 transition-opacity hover:text-slate-950 focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600 dark:text-slate-50/50 dark:hover:text-slate-50",
      className
    ),
    "toast-close": "",
    ...props,
    children: /* @__PURE__ */ jsx167(X, { className: "h-4 w-4" })
  }
));
ToastClose.displayName = ToastPrimitives.Close.displayName;
var ToastTitle = React11.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx167(
  ToastPrimitives.Title,
  {
    ref,
    className: cn("text-sm font-semibold", className),
    ...props
  }
));
ToastTitle.displayName = ToastPrimitives.Title.displayName;
var ToastDescription = React11.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx167(
  ToastPrimitives.Description,
  {
    ref,
    className: cn("text-sm opacity-90", className),
    ...props
  }
));
ToastDescription.displayName = ToastPrimitives.Description.displayName;

// src/components/@shadcn/components/ui/toaster.tsx
import { jsx as jsx168, jsxs as jsxs105 } from "react/jsx-runtime";
function Toaster() {
  const { toasts } = useToast();
  return /* @__PURE__ */ jsxs105(ToastProvider, { children: [
    toasts.map(function({ id: id3, title, description, action, ...props }) {
      return /* @__PURE__ */ jsxs105(Toast, { ...props, children: [
        /* @__PURE__ */ jsxs105("div", { className: "grid gap-1", children: [
          title && /* @__PURE__ */ jsx168(ToastTitle, { children: title }),
          description && /* @__PURE__ */ jsx168(ToastDescription, { children: description })
        ] }),
        action,
        /* @__PURE__ */ jsx168(ToastClose, {})
      ] }, id3);
    }),
    /* @__PURE__ */ jsx168(ToastViewport, {})
  ] });
}
export {
  ActionContainer,
  AggregationTags,
  AlertMessage,
  AppSvg,
  AuditFields,
  BarChart,
  BooleanActionItem,
  BooleanIcon,
  BooleanLabel,
  BreadcrumbLink,
  Breadcrumbs,
  Button,
  ButtonList,
  ButtonTabPills,
  ButtonTabUnderline,
  CandidateShell,
  Card,
  ChartColors,
  CheckBox,
  CheckBoxList,
  CheckBoxListControl,
  CheckBoxListControlTester,
  CheckboxInput,
  CheckboxInputComponent,
  CheckboxType,
  ContentEditor,
  CronEditor,
  CronSummary,
  DataTagEditor,
  DateInput,
  DayMonthSelectorDays,
  DayOfMonthSelector,
  DebouncedInput,
  DefaultListLayoutItemHeader,
  DefaultListLayoutSectionElement,
  DependentSelect,
  DependentSelectField,
  DescriptionItem,
  DescriptionList,
  DisplayFieldEnum,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DynamicBreadcrumb,
  EdActionCell,
  EdBreadcrumbLink,
  EdButtonLink,
  EdCard,
  EdColumnCell,
  EdColumnSort,
  EdEditable,
  EdGrid,
  EdGridLayout,
  EdIconLink,
  EdLink,
  EdListHeader,
  EdMenuLink,
  EdMobileLink,
  EdPagination,
  EdRow,
  EdShellHeader,
  EdSidebarLink,
  EdSkeleton,
  EdTabLink,
  EdTable,
  EdTextLink,
  EditContainer,
  EditorBlockButton,
  EditorElement,
  EditorLeaf,
  EditorMarkButton,
  EditorToolbar,
  ElevateBox,
  ElevateCentered,
  ElevateHeader,
  Error3 as Error,
  ErrorContainer,
  ErrorField,
  ErrorModal,
  ErrorToast,
  ExpandButton,
  FieldLabel,
  FilterSectionContainer,
  FilterSectionLink,
  FlatList,
  FormBuilder,
  FormBuilderElement,
  FormDateInput,
  FormErrorCode,
  FormErrorCodes,
  FormInput,
  FormInputRow,
  FormMultiSelectWithTags,
  FormRow,
  FormTextAreaInput,
  FormWizard,
  FormattedText,
  FullTextSearch,
  FunnelChart,
  GlobalSettingsManager,
  GlobalSettingsQueryDef,
  HOTKEYS,
  Header,
  HeaderBar,
  HighlightTags,
  HorizontalWizardSteps,
  HorizontalWizardStepsPanel,
  HorizontalWizardStepsProgressBar,
  HtmlDisplay,
  Icon,
  IconJustify,
  IconText,
  Icons,
  Iframe,
  Info,
  InlineEdit,
  Input,
  InputField,
  JobDetails,
  JobDetailsComponent,
  LIST_TYPES,
  LinkButton,
  ListDirection,
  ListLayout,
  ListLayoutMobileList,
  ListLayoutRoot,
  ListSkeleton,
  Loading,
  MobileHeader,
  MobileNavigation,
  Modal,
  MultiColumn,
  MynPageTitle,
  Navigation,
  NavigationLink,
  NotificationMessageContainer,
  NotificationMessageOverlay,
  OptionalCheckBox,
  PageBuilder,
  PageBuilderElement,
  PageHeader,
  PageHeading,
  PageTitle,
  PagingLink,
  PreloadedQueryHOC,
  Progress,
  Pulse,
  RadioList,
  RadioListInput,
  RadioListOld,
  RateType,
  RendersCounter,
  ResponsiveRadar,
  RouteContent,
  Saving,
  ScrollArea,
  ScrollBar,
  SearchBox,
  Section,
  SectionHeader,
  SectionRoot,
  SectionedLayout,
  SelectLinks,
  SelectListFacet,
  SelectMenu,
  SelectMenuInput,
  Shell,
  SignalBar,
  SignalBarSize,
  SimplePagination,
  SimplePaginationCounts,
  Size,
  Slider,
  SortDir,
  SortFacet,
  Spinner,
  StepStatus,
  Steps,
  table_exports as StyledTable,
  SunburstChart,
  Suspense,
  SwitchInput,
  SwitchInputComponent,
  TEXT_ALIGN_TYPES,
  TabButton,
  TabPills,
  TabUnderline,
  Table,
  TableBody,
  TableHeader,
  Tabs,
  Tag,
  TagFacet,
  Tags,
  TagsEditor,
  TailwindGroupLayout_default as TailwindGroupRenderer,
  TailwindHorizontalLayout_default as TailwindHorizontalRenderer,
  TailwindVerticalLayout_default as TailwindVerticalRenderer,
  TextArea,
  TimeSelector,
  TimeSelectorControl,
  TimeSelectorControlTester,
  Timeline,
  Toast,
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  Toaster,
  ToolTipMessage,
  Tray,
  TwoColumnLayout,
  UncontrolledDateInput,
  VerticalWizardSteps,
  WithParams,
  WizardStageTypes,
  activeTagsAtom,
  allListObject,
  classNames,
  createButtonLinkState,
  createEmptyListItem,
  createLinkState,
  deserializeHtmlElementToEditorState,
  deserializeHtmlElementsToEditorState,
  displayList,
  elevateJsonFormsCells,
  elevateJsonFormsRenderers,
  elevateJsonFormsStyleContext,
  enumerationToListItem,
  enumerationsToListItems,
  getSortDirFromGraphQL,
  groupTester,
  horizontalLayoutTester,
  isBlockActive,
  isEmptyListItem,
  isHTMLDocument,
  isMarkActive,
  linkHOC,
  listElementMap,
  listLayoutAtom,
  mobileViewState,
  notificationMessageAtom,
  parseEditorState,
  parseHTML,
  reducer,
  removeTableColumnSort,
  selectColumn,
  serializeEditorStateToHtml,
  sortDirToGraphQL,
  sortFacetsByCount,
  sortFacetsBySelected,
  toast,
  toggleBlock,
  toggleMark,
  updateTableColumnSort,
  useEditorState,
  useListLayoutContext,
  useMobileNavigation,
  useNotificationMessage,
  useNotificationMessageState,
  useSetNotificationMessage,
  useTabs,
  useToast,
  validateHTML,
  verticalLayoutTester,
  withAll,
  workflowLabelMap
};
/*! Bundled license information:

lodash-es/lodash.js:
  (**
   * @license
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="es" -o ./`
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/
//# sourceMappingURL=index.mjs.map